var i, r, s, n;
!function (i) {
  i.Write = "write", i.Erase = "erase", i.Select = "select", i.Move = "move";
}(i || (i = {})), function (i) {
  i.Pencil = "pencil", i.Rectangle = "rectangle", i.Rhombus = "rhombus", i.Circle = "circle", i.Ellipse = "ellipse", i.Triangle = "triangle", i.Parallelogram = "parallelogram", i.Line = "line", i.Arrow = "arrow", i.DoubleArrow = "double-arrow";
}(r || (r = {})), function (i) {
  i.Guide = "guide", i.InteractElementsGroup = "interact-elements-group", i.Translate = "translate", i.Resize = "resize", i.Rotate = "rotate";
}(s || (s = {})), function (i) {
  i.North = "n-resize", i.East = "e-resize", i.South = "s-resize", i.West = "w-resize", i.NorthEast = "ne-resize", i.NorthWest = "nw-resize", i.SouthEast = "se-resize", i.SouthWest = "sw-resize";
}(n || (n = {}));
const a = 10;
class DeferredPromise {
  promise;
  resolve;
  reject;
  isFullFilled;
  isPending;
  constructor() {
    this.isFullFilled = !1, this.isPending = !0, this.promise = new Promise((i, r) => {
      this.reject = async i => (this.isFullFilled = !0, this.isPending = !1, r(i)), this.resolve = async r => (this.isFullFilled = !0, this.isPending = !1, i(r));
    });
  }
}
function isValidNumber(i) {
  return null != i && !isNaN(parseFloat(i.toString())) && isFinite(+i);
}
function isBetween(i, r, s) {
  return i >= r && i <= s;
}
function computeAverage(i) {
  return i.reduce((i, r) => i + r, 0) / (i.length || 1);
}
function computeDistance(i, r) {
  const s = Math.hypot(r.y - i.y, r.x - i.x);
  return isNaN(s) ? 0 : s;
}
function computeAngleAxeRadian(i, r) {
  return Math.atan2(r.y - i.y, r.x - i.x);
}
function createPointsOnSegment(i, r, s = 1) {
  const n = [],
    a = computeDistance(i, r);
  let l = s;
  for (; l < a;) {
    const d = {
      x: i.x + l * (r.x - i.x) / a,
      y: i.y + l * (r.y - i.y) / a
    };
    n.push(d), l += s;
  }
  return n;
}
function scalaire(i, r) {
  return i.x * r.x + i.y * r.y;
}
function computeNearestPointOnSegment(i, r) {
  const s = {
      x: i.x - r.p1.x,
      y: i.y - r.p1.y
    },
    n = {
      x: r.p2.x - r.p1.x,
      y: r.p2.y - r.p1.y
    };
  if (0 === n.x && 0 === n.y) return r.p1;
  const a = scalaire(s, n),
    l = scalaire(n, n),
    d = Math.min(1, Math.max(0, a / l));
  return {
    x: r.p1.x + n.x * d,
    y: r.p1.y + n.y * d
  };
}
function isPointInsideBox(i, r) {
  return isBetween(i.x, r.x, r.x + r.width) && isBetween(i.y, r.y, r.y + r.height);
}
function convertRadianToDegree(i) {
  return +(i % (2 * Math.PI) / Math.PI * 180).toFixed(4);
}
function convertDegreeToRadian(i) {
  return +(i % 360 / 180 * Math.PI).toFixed(4);
}
function computeRotatedPoint(i, r, s) {
  const n = i.x - r.x,
    a = i.y - r.y,
    l = Math.cos(s),
    d = Math.sin(s);
  return {
    x: +(r.x + l * n - d * a).toFixed(3),
    y: +(r.y + d * n + l * a).toFixed(3)
  };
}
function computePointOnEllipse(i, r, s, n, a) {
  const l = Math.cos(n),
    d = Math.sin(n),
    h = Math.abs(r) * Math.cos(a),
    c = Math.abs(s) * Math.sin(a);
  return {
    x: +(i.x + l * h - d * c).toFixed(3),
    y: +(i.y + d * h + l * c).toFixed(3)
  };
}
function computeDistanceBetweenPointAndSegment(i, r) {
  return computeDistance(i, computeNearestPointOnSegment(i, r));
}
function findIntersectionBetween2Segment(i, r) {
  if (i.p1.x === r.p1.x && i.p1.y === r.p1.y) return i.p1;
  if (i.p1.x === r.p2.x && i.p1.y === r.p2.y) return i.p1;
  if (i.p2.x === r.p1.x && i.p2.y === r.p1.y) return i.p2;
  if (i.p2.x === r.p2.x && i.p2.y === r.p2.y) return i.p2;
  const s = i.p2.x - i.p1.x,
    n = i.p2.y - i.p1.y,
    a = r.p2.x - r.p1.x,
    l = r.p2.y - r.p1.y,
    d = i.p1.x - r.p1.x,
    h = i.p1.y - r.p1.y,
    c = a * h - l * d,
    u = s * h - n * d,
    p = l * s - a * n;
  if (0 === c || 0 === u || 0 === p) return;
  const g = c / p,
    m = u / p;
  return isBetween(g, 0, 1) && isBetween(m, 0, 1) ? {
    x: i.p1.x + g * s,
    y: i.p1.y + g * n
  } : void 0;
}
function findIntersectBetweenSegmentAndCircle(i, r, s) {
  const n = [],
    a = Math.pow(i.p2.x - i.p1.x, 2) + Math.pow(i.p2.y - i.p1.y, 2),
    l = 2 * ((i.p2.x - i.p1.x) * (i.p1.x - r.x) + (i.p2.y - i.p1.y) * (i.p1.y - r.y)),
    d = Math.pow(r.x, 2) + Math.pow(r.y, 2) + Math.pow(i.p1.x, 2) + Math.pow(i.p1.y, 2) - 2 * (r.x * i.p1.x + r.y * i.p1.y) - Math.pow(s, 2),
    h = Math.pow(l, 2) - 4 * a * d;
  if (h <= 0) return [];
  const c = Math.sqrt(h),
    u = (-l + c) / (2 * a),
    p = (-l - c) / (2 * a);
  return (u < 0 || u > 1) && (p < 0 || p > 1) || (isBetween(u, 0, 1) && n.push({
    x: (i.p2.x - i.p1.x) * u + i.p1.x,
    y: (i.p2.y - i.p1.y) * u + i.p1.y
  }), isBetween(p, 0, 1) && n.push({
    x: (i.p2.x - i.p1.x) * p + i.p1.x,
    y: (i.p2.y - i.p1.y) * p + i.p1.y
  })), n;
}
function computeAngleRadian(i, r, s) {
  const n = Math.sqrt(Math.pow(r.x - i.x, 2) + Math.pow(r.y - i.y, 2)),
    a = Math.sqrt(Math.pow(r.x - s.x, 2) + Math.pow(r.y - s.y, 2)),
    l = Math.sqrt(Math.pow(s.x - i.x, 2) + Math.pow(s.y - i.y, 2));
  return Math.acos((a * a + n * n - l * l) / (2 * a * n));
}
function getClosestPoints(i, r) {
  let s = i[0],
    n = r[0],
    a = Number.MAX_SAFE_INTEGER;
  return i.forEach(i => {
    r.forEach(r => {
      const l = computeDistance(i, r);
      a > l && (a = l, s = i, n = r);
    });
  }), {
    p1: s,
    p2: n
  };
}
function getClosestPoint(i, r) {
  let s,
    n = Number.MAX_SAFE_INTEGER,
    a = -1;
  return i.forEach((i, l) => {
    const d = computeDistance(i, r);
    n > d && (n = d, s = i, a = l);
  }), {
    point: s,
    index: a
  };
}
function isPointInsidePolygon(i, r) {
  let s = !1;
  for (let n = 0, a = r.length - 1; n < r.length; a = n++) {
    const l = r[n],
      d = r[a];
    l.y > i.y != d.y > i.y && i.x < (d.x - l.x) * (i.y - l.y) / (d.y - l.y) + l.x && (s = !s);
  }
  return s;
}
const isVersionSuperiorOrEqual = (i, r) => {
  const s = i.split("."),
    n = r.split(".");
  for (let i = 0; i < n.length; i++) {
    const r = Number(n[i]),
      a = Number(s[i]);
    if (r > a) return !1;
    if (r < a) return !0;
  }
  return !0;
};
async function computeHmac(i, r, s) {
  const n = new TextEncoder(),
    a = n.encode(i),
    l = n.encode(r + s),
    d = await crypto.subtle.importKey("raw", l, {
      name: "HMAC",
      hash: {
        name: "SHA-512"
      }
    }, !1, ["sign"]),
    h = await crypto.subtle.sign("HMAC", d, a),
    c = new Uint8Array(h);
  return Array.prototype.map.call(c, i => i.toString(16).padStart(2, "0")).join("");
}
function convertMillimeterToPixel(i) {
  return +(96 * i / 25.4).toFixed(3);
}
function convertPixelToMillimeter(i) {
  return +(i / 96 * 25.4).toFixed(3);
}
function convertBoundingBoxMillimeterToPixel(i) {
  return i ? {
    x: convertMillimeterToPixel(i.x),
    y: convertMillimeterToPixel(i.y),
    width: convertMillimeterToPixel(i.width),
    height: convertMillimeterToPixel(i.height)
  } : {
    height: 0,
    width: 0,
    x: 0,
    y: 0
  };
}
function createUUID() {
  let i = Date.now();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (r) {
    const s = (i + 16 * Math.random()) % 16 | 0;
    return i = Math.floor(i / 16), ("x" == r ? s : 3 & s | 8).toString(16);
  });
}
const mergeDeep = (i, ...r) => {
    const isObject = i => i && "object" == typeof i && !Array.isArray(i);
    if (!r.length) return i;
    const s = r.shift();
    if (isObject(i) && isObject(s)) for (const r in s) isObject(s[r]) ? (i[r] || Object.assign(i, {
      [r]: {}
    }), mergeDeep(i[r], s[r])) : Array.isArray(i[r]) && Array.isArray(s[r]) ? i[r] = i[r].concat(s[r]) : Object.assign(i, {
      [r]: s[r]
    });else Array.isArray(i) && Array.isArray(s) ? i = i.concat(s) : s && (i = s);
    return mergeDeep(i, ...r);
  },
  isDeepEqual = (i, r) => {
    const s = Object.keys(i),
      n = Object.keys(r);
    if (s.length !== n.length) return !1;
    for (const n of s) {
      const s = i[n],
        a = r[n],
        l = isObject(s) && isObject(a);
      if (l && !isDeepEqual(s, a) || !l && s !== a) return !1;
    }
    return !0;
  },
  isObject = i => i && "object" == typeof i;
async function getAvailableFontList(i) {
  if (!i?.server?.scheme && !i?.server?.host) return Promise.reject("Failed to get fonts: configuration.server.scheme & configuration.server.host are required!");
  if (!i?.recognition?.lang) return Promise.reject("Failed to get fonts: configuration.recognition.lang is required!");
  const r = i.server,
    s = await fetch(`${r.scheme}://${r.host}/api/v4.0/iink/font/google/language/` + i.recognition.lang),
    {
      result: n
    } = await s.json();
  return n.sort();
}
async function getAvailableLanguageList(i) {
  if (i?.server?.scheme && i?.server?.host) {
    const r = i.server;
    return (await fetch(`${r.scheme}://${r.host}/api/v4.0/iink/availableLanguageList`)).json();
  }
  return Promise.reject("Failed to get languages: configuration.server.scheme & configuration.server.host are required!");
}
function computeLinksPointers(i, r, s) {
  const n = i.p * s;
  return [{
    x: +(i.x - Math.sin(r) * n).toFixed(3),
    y: +(i.y + Math.cos(r) * n).toFixed(3)
  }, {
    x: +(i.x + Math.sin(r) * n).toFixed(3),
    y: +(i.y - Math.cos(r) * n).toFixed(3)
  }];
}
function computeMiddlePointer(i, r) {
  return {
    x: +((r.x + i.x) / 2).toFixed(3),
    y: +((r.y + i.y) / 2).toFixed(3),
    p: +((r.p + i.p) / 2).toFixed(3),
    t: +((r.t + i.t) / 2).toFixed(3)
  };
}
async function getApiInfos(i) {
  try {
    if (!i?.server?.scheme && !i?.server?.host) return Promise.reject("Failed to get infos: configuration.server.scheme & configuration.server.host are required!");
    const r = await fetch(`${i.server.scheme}://${i.server.host}/api/v4.0/iink/version`);
    if (r.ok) {
      return await r.json();
    }
    return {
      version: "3.1.3",
      gitCommit: "unknown",
      nativeVersion: "<=3.1.1"
    };
  } catch {
    return {
      version: "3.1.3",
      gitCommit: "7e148bd566438ca77dc83cb4edcc6ed0f51a8a15",
      nativeVersion: "<=3.1.1"
    };
  }
}
var l, d;
!function (i) {
  i.DEBUG = "1", i.INFO = "2", i.WARN = "3", i.ERROR = "4";
}(l || (l = {})), function (i) {
  i.EDITOR = "EDITOR", i.RECOGNIZER = "RECOGNIZER", i.GRABBER = "GRABBER", i.GESTURE = "GESTURE", i.EDITOR_EVENT = "EDITOR_EVENT", i.MODEL = "MODEL", i.RENDERER = "RENDERER", i.SMARTGUIDE = "SMARTGUIDE", i.STYLE = "STYLE", i.HISTORY = "HISTORY", i.SYMBOL = "SYMBOL", i.WRITE = "WRITE", i.TRANSFORMER = "TRANSFORMER", i.CONVERTER = "CONVERTER", i.SELECTION = "SELECTION", i.SVGDEBUG = "SVGDEBUG", i.MENU = "MENU";
}(d || (d = {}));
class Logger {
  category;
  level;
  constructor(i, r) {
    this.category = i, this.level = r;
  }
  debug(i, ...r) {
    if (l.DEBUG >= this.level) {
      const s = {
        level: "debug",
        from: `${this.category}.${i}`,
        message: r
      };
      console.debug(s);
    }
  }
  info(i, ...r) {
    if (l.INFO >= this.level) {
      const s = {
        level: "info",
        from: `${this.category}.${i}`,
        message: r
      };
      console.info(s);
    }
  }
  warn(i, ...r) {
    if (l.WARN >= this.level) {
      const s = {
        level: "warn",
        from: `${this.category}.${i}`,
        message: r
      };
      console.warn(s);
    }
  }
  error(i, ...r) {
    const s = {
      level: "error",
      from: `${this.category}.${i}`,
      message: r
    };
    console.error(s);
  }
}
class LoggerManager {
  static #e = new Map();
  static getLogger(i) {
    return this.#e.has(i) || this.#e.set(i, new Logger(i, l.ERROR)), this.#e.get(i);
  }
  static setLoggerLevel(i) {
    Object.keys(i).forEach(r => {
      LoggerManager.getLogger(r).level = i[r];
    });
  }
}
const h = {
  [d.EDITOR]: l.ERROR,
  [d.RECOGNIZER]: l.ERROR,
  [d.GRABBER]: l.ERROR,
  [d.RENDERER]: l.ERROR,
  [d.EDITOR_EVENT]: l.ERROR,
  [d.MODEL]: l.ERROR,
  [d.SYMBOL]: l.ERROR,
  [d.SMARTGUIDE]: l.ERROR,
  [d.GESTURE]: l.ERROR,
  [d.STYLE]: l.ERROR,
  [d.HISTORY]: l.ERROR,
  [d.TRANSFORMER]: l.ERROR,
  [d.CONVERTER]: l.ERROR,
  [d.WRITE]: l.ERROR,
  [d.SELECTION]: l.ERROR,
  [d.SVGDEBUG]: l.ERROR,
  [d.MENU]: l.ERROR
};
var c;
!function (i) {
  i.CHANGED = "changed", i.CLEARED = "cleared", i.CONVERTED = "converted", i.ERROR = "error", i.POINTEREVENTS = "pointer_events", i.NOTIF = "notif", i.EXPORTED = "exported", i.IMPORTED = "imported", i.IDLE = "idle", i.LOADED = "loaded", i.SESSION_OPENED = "session-opened", i.SELECTED = "selected", i.TOOL_CHANGED = "tool-changed", i.UI_UPDATED = "ui-updated", i.SYNCHRONIZED = "synchronized", i.GESTURED = "gestured";
}(c || (c = {}));
class EditorEvent extends EventTarget {
  #t = LoggerManager.getLogger(d.EDITOR_EVENT);
  abortController;
  element;
  constructor(i) {
    super(), this.#t.info("constructor", {
      element: i
    }), this.abortController = new AbortController(), this.element = i;
  }
  removeAllListeners() {
    this.#t.info("removeAllListeners"), this.abortController.abort(), this.abortController = new AbortController();
  }
  emit(i, r) {
    const s = new CustomEvent(i, Object.assign({
      bubbles: !0,
      composed: !0
    }, r ? {
      detail: r
    } : void 0));
    this.dispatchEvent(s), this.element?.dispatchEvent(s);
  }
  emitSessionOpened(i) {
    this.#t.info("emitSessionOpened"), this.emit(c.SESSION_OPENED, i);
  }
  addSessionOpenedListener(i) {
    this.#t.info("addSessionOpenedListener", {
      callback: i
    }), this.addEventListener(c.SESSION_OPENED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitLoaded() {
    this.#t.info("emitLoaded"), this.emit(c.LOADED);
  }
  addLoadedListener(i) {
    this.#t.info("addLoadedListener", {
      callback: i
    }), this.addEventListener(c.LOADED, () => i(), {
      signal: this.abortController.signal
    });
  }
  emitNotif(i) {
    this.#t.info("emitNotif", {
      notif: i
    }), this.emit(c.NOTIF, i);
  }
  addNotifListener(i) {
    this.#t.info("addNotifListener", {
      callback: i
    }), this.addEventListener(c.NOTIF, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitError(i) {
    this.#t.info("emitError", {
      err: i
    }), this.emit(c.ERROR, i);
  }
  addErrorListener(i) {
    this.#t.info("addErrorListener", {
      callback: i
    }), this.addEventListener(c.ERROR, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitExported(i) {
    this.#t.info("emitExported", {
      exports: i
    }), this.emit(c.EXPORTED, i);
  }
  addExportedListener(i) {
    this.#t.info("addExportedListener", {
      callback: i
    }), this.addEventListener(c.EXPORTED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitChanged(i) {
    this.#t.info("emitChanged", {
      undoRedoContext: i
    }), this.emit(c.CHANGED, {
      ...i,
      canClear: !i.empty
    });
  }
  addChangedListener(i) {
    this.#t.info("addChangedListener", {
      callback: i
    }), this.addEventListener(c.CHANGED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitIdle(i) {
    this.#t.info("emitIdle", {
      idle: i
    }), this.emit(c.IDLE, i);
  }
  addIdleListener(i) {
    this.#t.info("addIdleListener", {
      callback: i
    }), this.addEventListener(c.IDLE, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitCleared() {
    this.#t.info("emitCleared"), this.emit(c.CLEARED);
  }
  addClearedListener(i) {
    this.#t.info("addClearedListener", {
      callback: i
    }), this.addEventListener(c.CLEARED, () => i(), {
      signal: this.abortController.signal
    });
  }
  emitConverted(i) {
    this.#t.info("emitConverted", {
      exports: i
    }), this.emit(c.CONVERTED, i);
  }
  addConvertedListener(i) {
    this.#t.info("addConvertedListener", {
      callback: i
    }), this.addEventListener(c.CONVERTED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitImported(i) {
    this.#t.info("emitImported", {
      exports: i
    }), this.emit(c.IMPORTED, i);
  }
  addImportedListener(i) {
    this.#t.info("addImportedListener", {
      callback: i
    }), this.addEventListener(c.IMPORTED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitSelected(i) {
    this.#t.info("emitSelected"), this.emit(c.SELECTED, i);
  }
  addSelectedListener(i) {
    this.#t.info("addSelectedListener", {
      callback: i
    }), this.addEventListener(c.SELECTED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitToolChanged(i) {
    this.#t.info("emitToolChanged"), this.emit(c.TOOL_CHANGED, i);
  }
  addToolChangedListener(i) {
    this.#t.info("addToolChangedListener", {
      callback: i
    }), this.addEventListener(c.TOOL_CHANGED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitUIpdated() {
    this.#t.info("emitUIpdated"), this.emit(c.UI_UPDATED);
  }
  addUIpdatedListener(i) {
    this.#t.info("addUIpdatedListener", {
      callback: i
    }), this.addEventListener(c.UI_UPDATED, () => i(), {
      signal: this.abortController.signal
    });
  }
  emitSynchronized() {
    this.#t.info("emitSynchronized"), this.emit(c.SYNCHRONIZED);
  }
  addSynchronizedListener(i) {
    this.#t.info("addSynchronizedListener", {
      callback: i
    }), this.addEventListener(c.SYNCHRONIZED, () => i(), {
      signal: this.abortController.signal
    });
  }
  emitGestured(i) {
    this.#t.info("emitSynchronized"), this.emit(c.GESTURED, i);
  }
  addGesturedListener(i) {
    this.#t.info("addSynchronizedListener", {
      callback: i
    }), this.addEventListener(c.GESTURED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
}
var u, p, g, m;
class EditorLayer {
  root;
  ui;
  rendering;
  onCloseModal;
  constructor(i, r = "ms-editor") {
    this.root = i, this.root.classList.add(r), this.rendering = this.createLayerRender(), this.ui = this.createLayerUI();
  }
  render() {
    const i = document.createElement("style");
    i.appendChild(document.createTextNode(".ms-editor{color:#1a9fff;container-name:editor;container-type:inline-size;font-family:sans-serif;height:100%;overflow:auto;position:relative;touch-action:none;width:100%;z-index:10}#editor:active,#editor:focus{-webkit-tap-highlight-color:transparent}.ms-editor.draw{cursor:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m14.363 5.652 1.48-1.48a2 2 0 0 1 2.829 0l1.414 1.414a2 2 0 0 1 0 2.828l-1.48 1.48m-4.243-4.242-9.616 9.615a2 2 0 0 0-.578 1.238l-.242 2.74a1 1 0 0 0 1.084 1.085l2.74-.242a2 2 0 0 0 1.24-.578l9.615-9.616m-4.243-4.242 4.243 4.242' stroke='%23000' fill='%23fff' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\") 5 20,pointer}.ms-editor.draw.shape{cursor:crosshair}.ms-editor.erase{cursor:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m2.893 12.607 9.193-9.193a2 2 0 0 1 2.828 0l4.95 4.95a2 2 0 0 1 0 2.828l-9.243 9.243a1.929 1.929 0 0 1-2.728 0l-5-5a2 2 0 0 1 0-2.828Z' stroke='%23000' fill='%23fff' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M21 21H9M15.889 14.89 8.464 7.463' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\") 5 20,auto}.ms-editor.move{cursor:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill='%23fff'%3E%3Cpath d='m7 10.5-2.004 2.672a2 2 0 0 0 .126 2.552l3.784 4.128c.378.413.912.648 1.473.648H15c2.4 0 4-1.5 4-4 0 0 0 0 0 0V7.929M16 8.5v-.571c0-2.286 3-2.286 3 0' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13 8.5V7.027m0-.527v.527M16 8.5V7.027c0-2.286-3-2.286-3 0' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13 8.5V7.027c0-2.286 3-2.286 3 0V8.5M10 8.5v-2c0-2.286 3-2.286 3 0 0 0 0 0 0 0v2M7 13.5v-7A1.5 1.5 0 0 1 8.5 5v0c.828 0 1.5.555 1.5 1.384V8.5' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\") 10 10,auto}.ms-editor.select{cursor:context-menu}.ms-editor .ms-layer-rendering{height:100%;width:100%}.ms-editor .ms-layer-rendering,.ms-editor [data-layer=CAPTURE],.ms-editor [data-layer=MODEL]{left:0;position:absolute;top:0;z-index:20}.ms-editor .ms-layer-rendering .ms-rendering-canvas{pointer-events:none;z-index:9}.ms-editor .ms-layer-rendering.text .ms-rendering-canvas{background-image:linear-gradient(180deg,#c8c8c8 1px,transparent 0)}.ms-editor .ms-layer-rendering.diagram .ms-rendering-canvas,.ms-editor .ms-layer-rendering.raw-content .ms-rendering-canvas,.ms-editor .ms-layer-rendering.shape .ms-rendering-canvas{background-image:linear-gradient(90deg,#c8c8c8 1px,transparent 0),linear-gradient(180deg,#c8c8c8 1px,transparent 0);background-size:40px 40px}.ms-editor .ms-layer-ui{height:100%;left:0;pointer-events:none;position:sticky;top:0;user-select:none;width:100%;z-index:25}.ms-editor .ms-layer-ui>*{cursor:auto;pointer-events:all;user-select:none}.ms-editor .loader{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite;border:16px solid #f5f6f7;border-radius:50%;border-top-color:#1a9fff;height:120px;left:calc(50% - 60px);position:absolute;top:calc(50% - 60px);width:120px;z-index:30}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}.ms-editor .state{background-color:#f5f6f7;bottom:8px;box-shadow:1px 1px 5px rgba(0,0,0,.25),-1px -1px 5px rgba(0,0,0,.25);color:#717171;cursor:auto;height:42px;left:0;position:absolute;width:42px;z-index:99}.ms-editor .state .busy{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite;border:4px solid #1a9fff;border-radius:100%;border-right-color:#f5f6f7;color:#717171;height:30px;margin-left:6px;margin-top:6px;width:30px}.ms-editor .message-container,.ms-editor .message-overlay{height:100%;position:absolute;width:100%}.ms-editor .message-overlay{background-color:hsla(0,0%,73%,.25);z-index:99}.ms-editor .message-modal{word-wrap:break-word;background-color:#fff;box-shadow:1px 1px 5px rgba(0,0,0,.25),-1px -1px 5px rgba(0,0,0,.25);font-size:16px;left:50%;max-height:calc(100% - 100px);max-width:calc(100% - 8px);overflow:auto;padding:12px;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);z-index:999}@container editor (max-width: 400px){.ms-editor .message-modal{width:100%}}@container editor (min-width: 401px) and (max-width: 800px){.ms-editor .message-modal{width:66%}}@container editor (min-width: 801px){.ms-editor .message-modal{width:50%}}.ms-editor .message-modal.error-msg:before{content:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgNzYuNSA2MTIgNDU5IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij48cGF0aCBmaWxsPSIjMUE5RkZGIiBkPSJNNDk0LjcgMjI5LjVjLTE3Ljg1MS04Ni43LTk0LjM1MS0xNTMtMTg4LjctMTUzLTM4LjI1IDAtNzMuOTUgMTAuMi0xMDIgMzAuNmwzOC4yNSAzOC4yNWMxNy44NS0xMi43NSA0MC44LTE3Ljg1IDYzLjc1LTE3Ljg1IDc2LjUgMCAxNDAuMjUgNjMuNzUgMTQwLjI1IDE0MC4yNXYxMi43NWgzOC4yNWM0My4zNSAwIDc2LjUgMzMuMTUgNzYuNSA3Ni41IDAgMjguMDUtMTUuMyA1My41NS00MC44IDY2LjNsMzguMjUgMzguMjVDNTkxLjYgNDM4LjYgNjEyIDQwMC4zNSA2MTIgMzU3YzAtNjYuMy01My41NS0xMjIuNC0xMTcuMy0xMjcuNXpNNzYuNSAxMDkuNjVsNzEuNCA2OC44NUM2Ni4zIDE4My42IDAgMjQ5LjkgMCAzMzEuNWMwIDg0LjE1IDY4Ljg1IDE1MyAxNTMgMTUzaDI5OC4zNWw1MSA1MSAzMy4xNS0zMy4xNUwxMDkuNjUgNzYuNSA3Ni41IDEwOS42NXpNMTk2LjM1IDIyOS41bDIwNCAyMDRIMTUzYy01Ni4xIDAtMTAyLTQ1LjktMTAyLTEwMnM0NS45LTEwMiAxMDItMTAyaDQzLjM1eiIvPjwvc3ZnPg==\");display:block;margin:auto;width:100px}.ms-editor .message-modal.info-msg:before{background-image:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMUE5RkZGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiLz48cGF0aCBkPSJNMTIgMTZ2LTRNMTIgOGguMDEiLz48L3N2Zz4=\");background-size:100% 100%;content:\"\";display:block;height:25px;margin:auto;padding-bottom:10px;width:25px}.ms-editor .message-modal .ms-button{background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg' color='%23000'%3E%3Cpath d='M9.172 14.828 12.001 12m2.828-2.828L12.001 12m0 0L9.172 9.172M12.001 12l2.828 2.828M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat;border:none;border-radius:4px;color:#000;cursor:pointer;font-size:inherit;height:32px;padding:0;position:absolute;right:0;top:0;width:32px}.ms-editor .message-modal .ms-button:hover{background-color:#eee}.ms-editor .collapsible-wrapper .collapsible-header{align-items:center;color:#424242;cursor:pointer;display:flex;justify-content:space-between}.ms-editor .collapsible-wrapper .collapsible-header:hover{background-color:#efefef}.ms-editor .collapsible-wrapper .collapsible-header .collapsible-header-icon{align-items:center;display:flex;height:32px;justify-content:center;padding:4px;position:relative;transition:transform .5s;width:32px}.ms-editor .collapsible-wrapper.active .collapsible-header .collapsible-header-icon{transform:rotate(180deg)}.ms-editor .collapsible-wrapper .collapsible-content{max-height:0;overflow:auto;transition:max-height .5s}.ms-editor .collapsible-wrapper.active .collapsible-content{max-height:200px}.ms-editor .removed-stroke{opacity:0;transition:opacity .1s ease-in-out}")), this.root.prepend(i), this.root.appendChild(this.rendering), this.root.appendChild(this.ui.root);
  }
  createLoader() {
    const i = document.createElement("div");
    return i.classList.add("loader"), i.style.display = "none", i;
  }
  showLoader() {
    this.ui.loader.style.display = "block";
  }
  hideLoader() {
    this.ui.loader.style.display = "none";
  }
  createMessageOverlay() {
    const i = document.createElement("div");
    return i.classList.add("message-overlay"), i;
  }
  closeMessageModal() {
    this.onCloseModal?.(this.ui.message.modal.root.classList.contains("error-msg")), this.hideMessageModal();
  }
  hideMessageModal() {
    this.ui.message.root.style.display = "none", this.ui.message.modal.text.innerText = "", this.ui.message.modal.root.classList.remove("error-msg"), this.ui.message.modal.root.classList.remove("info-msg");
  }
  createMessageModal() {
    const i = document.createElement("div");
    i.classList.add("message-modal");
    const r = document.createElement("button");
    r.classList.add("ms-button", "close"), r.addEventListener("pointerup", this.closeMessageModal.bind(this)), i.appendChild(r);
    const s = document.createElement("p");
    return i.appendChild(s), {
      root: i,
      text: s
    };
  }
  createMessage() {
    const i = document.createElement("div");
    i.classList.add("message-container"), i.style.display = "none";
    const r = this.createMessageOverlay();
    i.appendChild(r);
    const s = this.createMessageModal();
    return i.appendChild(s.root), {
      root: i,
      overlay: r,
      modal: s
    };
  }
  showMessageInfo(i) {
    this.ui.message.modal.root.classList.add("info-msg"), this.ui.message.modal.root.classList.remove("error-msg"), this.ui.message.root.style.display = "block", this.ui.message.modal.text.innerText = i.message, setTimeout(() => {
      this.closeMessageModal();
    }, i.timeout || 2500);
  }
  showMessageError(i) {
    this.ui.message.modal.root.classList.add("error-msg"), this.ui.message.modal.root.classList.remove("info-msg"), this.ui.message.root.style.display = "block", this.ui.message.modal.text.innerText = "string" == typeof i ? i : i.message;
  }
  createBusy() {
    const i = document.createElement("div");
    return i.classList.add("busy"), i;
  }
  createState() {
    const i = document.createElement("div");
    i.classList.add("state"), i.style.display = "none";
    const r = this.createBusy();
    return i.appendChild(r), {
      root: i,
      busy: r
    };
  }
  showState() {
    this.ui.state.root.style.display = "block";
  }
  hideState() {
    this.ui.state.root.style.display = "none";
  }
  updateState(i) {
    i ? this.hideState() : this.showState();
  }
  createLayerUI() {
    const i = document.createElement("div");
    i.classList.add("ms-layer-ui");
    const r = this.createLoader();
    i.appendChild(r);
    const s = this.createMessage();
    i.appendChild(s.root);
    const n = this.createState();
    return i.appendChild(n.root), {
      root: i,
      loader: r,
      message: s,
      state: n
    };
  }
  createLayerRender() {
    const i = document.createElement("div");
    return i.classList.add("ms-layer-rendering"), i;
  }
  destroy() {
    for (; this.root.lastChild;) this.root.removeChild(this.root.lastChild);
  }
}
class AbstractEditor {
  logger = LoggerManager.getLogger(d.EDITOR);
  layers;
  event;
  info;
  #i;
  constructor(i, r) {
    this.loggerConfiguration = Object.assign({}, h, r?.configuration?.logger), this.logger.info("constructor", {
      rootElement: i,
      options: r
    }), this.event = new EditorEvent(i), this.layers = new EditorLayer(i, r?.override?.cssClass || "ms-editor"), i.editor = this;
  }
  get loggerConfiguration() {
    return this.#i;
  }
  set loggerConfiguration(i) {
    this.#i = Object.assign({}, h, i), LoggerManager.setLoggerLevel(this.#i);
  }
  async loadInfo(i) {
    return this.info || (this.info = await getApiInfos({
      server: i
    })), this.info;
  }
}
!function (i) {
  i.JIIX = "application/vnd.myscript.jiix", i.TEXT = "text/plain", i.LATEX = "application/x-latex", i.MATHML = "application/mathml+xml", i.SVG = "image/svg+xml", i.OFFICE_DOCUMENT = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
}(u || (u = {})), function (i) {
  i.Text = "Text", i.Node = "Node", i.Edge = "Edge", i.RawContent = "Raw Content";
}(p || (p = {})), function (i) {
  i.Circle = "circle", i.Ellipse = "ellipse", i.Rectangle = "rectangle", i.Triangle = "triangle", i.Parallelogram = "parallelogram", i.Polygon = "polygon", i.Rhombus = "rhombus";
}(g || (g = {})), function (i) {
  i.Line = "line", i.PolyEdge = "polyedge", i.Arc = "arc";
}(m || (m = {}));
class Box {
  x;
  y;
  width;
  height;
  constructor(i) {
    if (i.width < 0) throw new Error("width must be positive");
    if (i.height < 0) throw new Error("height must be positive");
    this.height = i.height, this.width = i.width, this.x = i.x, this.y = i.y;
  }
  static createFromBoxes(i) {
    if (!i?.length) return new Box({
      height: 0,
      width: 0,
      x: 0,
      y: 0
    });
    const r = Math.min(...i.map(i => i.x)),
      s = Math.max(...i.map(i => i.x + i.width)) - r,
      n = Math.min(...i.map(i => i.y)),
      a = Math.max(...i.map(i => i.y + i.height)) - n;
    return new Box({
      x: r,
      y: n,
      width: s,
      height: a
    });
  }
  static createFromPoints(i) {
    if (!i?.length) return new Box({
      height: 0,
      width: 0,
      x: 0,
      y: 0
    });
    const r = Math.min(...i.map(i => i.x)),
      s = Math.max(...i.map(i => i.x)) - r,
      n = Math.min(...i.map(i => i.y)),
      a = Math.max(...i.map(i => i.y)) - n;
    return new Box({
      x: r,
      y: n,
      width: s,
      height: a
    });
  }
  static getCorners(i) {
    return [{
      x: i.x,
      y: i.y
    }, {
      x: i.x + i.width,
      y: i.y
    }, {
      x: i.x + i.width,
      y: i.y + i.height
    }, {
      x: i.x,
      y: i.y + i.height
    }];
  }
  static getCenter(i) {
    return {
      x: i.x + i.width / 2,
      y: i.y + i.height / 2
    };
  }
  static getSides(i) {
    const r = Box.getCorners(i);
    return r.map((i, s) => 3 === s ? {
      p1: r[0],
      p2: i
    } : {
      p1: i,
      p2: r[s + 1]
    });
  }
  static isContained(i, r) {
    return isBetween(i.x, r.x, r.x + r.width) && isBetween(i.x + i.width, r.x, r.x + r.width) && isBetween(i.y, r.y, r.y + r.height) && isBetween(i.y + i.height, r.y, r.y + r.height);
  }
  static containsPoint(i, r) {
    return isBetween(r.x, i.x, i.x + i.width) && isBetween(r.y, i.y, i.y + i.height);
  }
  static contains(i, r) {
    return isBetween(r.x, i.x, i.x + i.width) && isBetween(r.x + r.width, i.x, i.x + i.width) && isBetween(r.y, i.y, i.y + i.height) && isBetween(r.y + r.height, i.y, i.y + i.height);
  }
  static overlaps(i, r) {
    return !(i.x > r.x + r.width) && !(i.x + i.width < r.x) && !(i.y > r.y + r.height) && !(i.y + i.height < r.y);
  }
  get xMin() {
    return this.x;
  }
  get xMid() {
    return this.x + this.width / 2;
  }
  get xMax() {
    return this.x + this.width;
  }
  get yMin() {
    return this.y;
  }
  get yMid() {
    return this.y + this.height / 2;
  }
  get yMax() {
    return this.y + this.height;
  }
  get corners() {
    return Box.getCorners(this);
  }
  get center() {
    return Box.getCenter(this);
  }
  get snapPoints() {
    return [...this.corners, this.center];
  }
  isContained(i) {
    return Box.isContained(this, i);
  }
  contains(i) {
    return Box.contains(this, i);
  }
  containsPoint(i) {
    return Box.containsPoint(this, i);
  }
  overlaps(i) {
    return Box.overlaps(this, i);
  }
}
const y = {
    width: 2,
    color: "#000000"
  },
  b = {},
  f = {
    ink: {
      color: "#000000",
      width: 1,
      "-myscript-pen-width": 1,
      "-myscript-pen-fill-style": "none",
      "-myscript-pen-fill-color": "#FFFFFF00"
    },
    ".math": {
      "font-family": "STIXGeneral"
    },
    ".math-solved": {
      "font-family": "STIXGeneral",
      color: "#A8A8A8FF"
    },
    ".text": {
      "font-family": "MyScriptInter",
      "font-size": 10
    }
  };
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
var x = function createCommonjsModule(i, r) {
    return i(r = {
      exports: {}
    }, r.exports), r.exports;
  }(function (i, r) {
    i.exports = function (i) {
      function e(s) {
        if (r[s]) return r[s].exports;
        var n = r[s] = {
          i: s,
          l: !1,
          exports: {}
        };
        return i[s].call(n.exports, n, n.exports, e), n.l = !0, n.exports;
      }
      var r = {};
      return e.m = i, e.c = r, e.i = function (i) {
        return i;
      }, e.d = function (i, r, s) {
        e.o(i, r) || Object.defineProperty(i, r, {
          configurable: !1,
          enumerable: !0,
          get: s
        });
      }, e.n = function (i) {
        var r = i && i.__esModule ? function () {
          return i.default;
        } : function () {
          return i;
        };
        return e.d(r, "a", r), r;
      }, e.o = function (i, r) {
        return Object.prototype.hasOwnProperty.call(i, r);
      }, e.p = "", e(e.s = 1);
    }([function (i, r, s) {
      function o(i, r) {
        if (!(i instanceof r)) throw new TypeError("Cannot call a class as a function");
      }
      Object.defineProperty(r, "__esModule", {
        value: !0
      });
      var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (i) {
          return typeof i;
        } : function (i) {
          return i && "function" == typeof Symbol && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
        },
        a = function t(i) {
          var r = this;
          o(this, t), this.toJSON = function (i) {
            if ("string" != typeof i) return console.error("Need a CSS string but given ", void 0 === i ? "undefined" : n(i), i), "Not a valid CSS..!";
            var s = {},
              a = void 0,
              l = void 0,
              d = void 0;
            try {
              i.split("{").forEach(function (i) {
                if (l = i.trim()) if (-1 === l.indexOf("}")) s[l] = {}, a = l;else {
                  l.substring(0, l.indexOf("}")).split(";").forEach(function (i) {
                    (d = i.split(":")) && 2 === d.length && (s[a][d[0].trim().replace(/^\"|\"$/g, "")] = r._trimSemiColon(d[1].trim().replace(/^\"|\"$/g, "")));
                  });
                  try {
                    (a = l.split("}")[1].trim()) && (s[a] = {});
                  } catch (i) {}
                }
              });
            } catch (i) {
              return "Not a valid CSS..!";
            }
            return s;
          }, this.toCSS = function (i) {
            if ("object" !== (void 0 === i ? "undefined" : n(i))) return console.error("Need a JSON object but given ", void 0 === i ? "undefined" : n(i), i), "Not a valid JSON..!";
            var r = "";
            try {
              for (var s in i) if (i.hasOwnProperty(s)) {
                for (var a in r += s + " {\n", i[s]) i[s].hasOwnProperty(a) && (r += a + ": " + i[s][a] + ";\n");
                r += "}\n";
              }
            } catch (i) {
              return "Not a valid JSON..!";
            }
            return r;
          }, this._trimSemiColon = function (i) {
            return ";" === i.slice(-1) ? i.slice(0, r.length - 1) : i;
          };
        };
      r.default = a;
    }, function (i, r, s) {
      i.exports = s(0).default;
    }]);
  }),
  S = function unwrapExports(i) {
    return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
  }(x);
x.JsonCSS;
const w = new S(),
  v = {
    themeToCSS: i => w.toCSS(i),
    themeToJSON(i) {
      const r = w.toJSON(i);
      return r[".text"]["font-size"] = Number(r[".text"]["font-size"]), r.ink["-myscript-pen-width"] = Number(r.ink["-myscript-pen-width"]), r.ink.width = Number(r.ink.width), r;
    },
    penStyleToCSS(i) {
      let r = w.toCSS({
        css: i
      });
      return r = r.substring(6, r.length - 3), r;
    },
    penStyleToJSON(i) {
      const r = w.toJSON(`css {${i}}`).css;
      return r.width ? r.width = Number(r.width) : delete r.width, r["-myscript-pen-width"] ? r["-myscript-pen-width"] = Number(r["-myscript-pen-width"]) : delete r["-myscript-pen-width"], r;
    },
    stringToJSON: i => w.toJSON(`css {${i}}`).css,
    JSONToString: i => Object.entries(i).map(([i, r]) => `${i}:${r}`).join(";")
  };
class StyleManager {
  #r;
  #o;
  #s;
  #n;
  #t = LoggerManager.getLogger(d.STYLE);
  constructor(i, r) {
    this.#t.info("constructor", {
      penStyle: i,
      theme: r
    }), this.setTheme(r), this.setPenStyleClasses(), this.setPenStyle(i);
  }
  get currentPenStyle() {
    return this.#n || this.#r;
  }
  get penStyle() {
    return this.#r;
  }
  setPenStyle(i) {
    this.#t.info("setPenStyle", {
      style: i
    }), this.#r = mergeDeep(structuredClone(b), i || {}), this.#n = i || this.theme[`.${this.#s}`], this.#t.debug("setPenStyle", this.#n);
  }
  get theme() {
    return this.#o;
  }
  setTheme(i) {
    this.#t.info("setTheme", {
      theme: i
    }), this.#o = mergeDeep(structuredClone(f), i || {}), this.#t.debug("setTheme", this.#o);
  }
  get penStyleClasses() {
    return this.#s;
  }
  setPenStyleClasses(i = "") {
    this.#t.info("setPenStyleClasses", {
      penStyleClass: i
    }), this.#s = i, this.#n = this.theme[`.${this.#s}`], this.#t.debug("setPenStyleClasses", this.#n);
  }
}
var k, E, I, C, M, T;
!function (i) {
  i.Highlight = "highlight", i.Surround = "surround", i.Underline = "underline", i.Strikethrough = "strikethrough";
}(k || (k = {}));
class IIDecorator {
  id;
  kind;
  style;
  constructor(i, r) {
    this.id = `${i}-${createUUID()}`, this.style = structuredClone(mergeDeep({}, y, r)), this.kind = i;
  }
  clone() {
    const i = new IIDecorator(this.kind, structuredClone(this.style));
    return i.id = this.id, i;
  }
}
class MatrixTransform {
  xx;
  yx;
  xy;
  yy;
  tx;
  ty;
  constructor(i, r, s, n, a, l) {
    this.xx = i, this.yx = r, this.xy = s, this.yy = n, this.tx = a, this.ty = l;
  }
  static identity() {
    return new MatrixTransform(1, 0, 0, 1, 0, 0);
  }
  static applyToPoint(i, r) {
    return {
      x: i.xx * r.x + i.xy * r.y + i.tx,
      y: i.yx * r.x + i.yy * r.y + i.ty
    };
  }
  static rotation(i) {
    let r;
    if (0 !== i.xx || 0 !== i.xy) {
      const s = Math.hypot(i.xx, i.xy);
      r = Math.acos(i.xx / s) * (i.xy > 0 ? -1 : 1);
    } else if (0 !== i.yx || 0 !== i.yy) {
      const s = Math.hypot(i.yx, i.yy);
      r = Math.PI / 2 + Math.acos(i.yx / s) * (i.yy > 0 ? -1 : 1);
    } else r = 0;
    return r;
  }
  static toCssString(i) {
    return `matrix(${i.xx}, ${i.yx}, ${i.xy}, ${i.yy}, ${i.tx}, ${i.ty})`;
  }
  invert() {
    const {
        xx: i,
        yx: r,
        xy: s,
        yy: n,
        tx: a,
        ty: l
      } = this,
      d = i * n - r * s;
    return this.xx = n / d, this.yx = r / -d, this.xy = s / -d, this.yy = i / d, this.tx = (n * a - s * l) / -d, this.ty = (r * a - i * l) / d, this;
  }
  multiply(i) {
    const {
      xx: r,
      yx: s,
      xy: n,
      yy: a,
      tx: l,
      ty: d
    } = this;
    return this.xx = r * i.xx + n * i.yx, this.yx = s * i.xx + a * i.yx, this.xy = r * i.xy + n * i.yy, this.yy = s * i.xy + a * i.yy, this.tx = r * i.tx + n * i.ty + l, this.ty = s * i.tx + a * i.ty + d, this;
  }
  translate(i, r) {
    return this.multiply({
      xx: 1,
      yx: 0,
      xy: 0,
      yy: 1,
      tx: i,
      ty: r
    });
  }
  rotate(i, r) {
    r && this.translate(r.x, r.y);
    const s = Math.round(1e3 * Math.cos(i)) / 1e3,
      n = Math.round(1e3 * Math.sin(i)) / 1e3;
    return this.multiply({
      xx: s,
      yx: n,
      xy: -n,
      yy: s,
      tx: 0,
      ty: 0
    }), r && this.translate(-r.x, -r.y), this;
  }
  scale(i, r, s) {
    return s && this.translate(s.x, s.y), this.multiply({
      xx: i,
      yx: 0,
      xy: 0,
      yy: r,
      tx: 0,
      ty: 0
    }), s && this.translate(-s.x, -s.y), this;
  }
  applyToPoint(i) {
    return MatrixTransform.applyToPoint(this, i);
  }
  clone() {
    return new MatrixTransform(this.xx, this.yx, this.xy, this.yy, this.tx, this.ty);
  }
  toCssString() {
    return MatrixTransform.toCssString(this);
  }
}
class IISymbolBase {
  type;
  style;
  id;
  creationTime;
  modificationDate;
  selected;
  deleting;
  transform;
  constructor(i, r) {
    this.type = i, this.id = `${this.type}-${createUUID()}`, this.creationTime = Date.now(), this.modificationDate = this.creationTime, this.selected = !1, this.deleting = !1, this.transform = MatrixTransform.identity(), this.style = Object.assign({}, y, r), this.style.opacity && (this.style.opacity = +this.style.opacity), this.style.width = +this.style.width;
  }
  get edges() {
    return this.isClosed ? this.vertices.map((i, r) => r === this.vertices.length - 1 ? {
      p1: i,
      p2: this.vertices[0]
    } : {
      p1: i,
      p2: this.vertices[r + 1]
    }) : this.vertices.slice(0, -1).map((i, r) => ({
      p1: i,
      p2: this.vertices[r + 1]
    }));
  }
  isIntersected(i) {
    return this.edges.some(r => findIntersectionBetween2Segment(r, i));
  }
}
!function (i) {
  i.Stroke = "stroke", i.Group = "group", i.Shape = "shape", i.Edge = "edge", i.Text = "text", i.Eraser = "eraser", i.Recognized = "recognized";
}(E || (E = {})), function (i) {
  i.Line = "line", i.PolyEdge = "polyedge", i.Arc = "arc";
}(I || (I = {})), function (i) {
  i.Arrow = "arrow-head";
}(C || (C = {}));
class OIEdgeBase extends IISymbolBase {
  kind;
  isClosed = !1;
  startDecoration;
  endDecoration;
  constructor(i, r, s, n) {
    super(E.Edge, n), this.kind = i, this.startDecoration = r, this.endDecoration = s;
  }
  get bounds() {
    const i = Box.createFromPoints(this.vertices);
    return i.x -= 5, i.y -= 5, i.height += a, i.width += a, (this.startDecoration || this.endDecoration) && (i.x -= 2.5 * (this.style.width || 1), i.y -= 2.5 * (this.style.width || 1), i.height += 5 * (this.style.width || 1), i.width += 5 * (this.style.width || 1)), i;
  }
  get snapPoints() {
    return this.vertices;
  }
  overlaps(i) {
    return this.bounds.isContained(i) || this.edges.some(r => Box.getSides(i).some(i => !!findIntersectionBetween2Segment(r, i)));
  }
}
function isValidPoint(i) {
  return !!i && !!isValidNumber(i.x) && !!isValidNumber(i.y);
}
class IIEdgeArc extends OIEdgeBase {
  center;
  startAngle;
  sweepAngle;
  radiusX;
  radiusY;
  phi;
  _vertices;
  constructor(i, r, s, n, a, l, d, h, c) {
    super(I.Arc, d, h, c), this.center = i, this.startAngle = r, this.sweepAngle = s, this.radiusX = n, this.radiusY = a, this.phi = l, this._vertices = new Map(), this._vertices.set(this.verticesId, this.computedVertices());
  }
  get verticesId() {
    return `${this.center.x}-${this.center.y}-${this.startAngle}-${this.sweepAngle}-${this.radiusX}-${this.radiusY}-${this.phi}`;
  }
  computedVertices() {
    const i = Math.abs(this.sweepAngle) * Math.sqrt((Math.pow(this.radiusX, 2) + Math.pow(this.radiusY, 2)) / 2),
      r = Math.max(8, Math.round(i / a)),
      s = this.sweepAngle / r,
      n = [],
      l = this.startAngle + this.sweepAngle;
    if (this.sweepAngle > 0) for (let i = this.startAngle; i < l; i += s) n.push(computePointOnEllipse(this.center, this.radiusX, this.radiusY, this.phi, i));else for (let i = this.startAngle; i > l; i += s) n.push(computePointOnEllipse(this.center, this.radiusX, this.radiusY, this.phi, i));
    return n.push(computePointOnEllipse(this.center, this.radiusX, this.radiusY, this.phi, l)), n;
  }
  get vertices() {
    return this._vertices.has(this.verticesId) || this._vertices.set(this.verticesId, this.computedVertices()), this._vertices.get(this.verticesId);
  }
  get snapPoints() {
    return [this.vertices[0], this.vertices.at(-1)];
  }
  clone() {
    const i = new IIEdgeArc(structuredClone(this.center), this.startAngle, this.sweepAngle, this.radiusX, this.radiusY, this.phi, this.startDecoration, this.endDecoration, structuredClone(this.style));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      center: this.center,
      startAngle: this.startAngle,
      sweepAngle: this.sweepAngle,
      radiusX: this.radiusX,
      radiusY: this.radiusY,
      phi: this.phi,
      startDecoration: this.startDecoration,
      style: this.style,
      endDecoration: this.endDecoration
    };
  }
  static create(i) {
    if (!isValidPoint(i?.center)) throw new Error("Unable to create a arc, center point is invalid");
    if (!isValidNumber(i?.startAngle)) throw new Error("Unable to create a arc, startAngle is invalid");
    if (!isValidNumber(i?.sweepAngle)) throw new Error("Unable to create a arc, sweepAngle is invalid");
    if (!isValidNumber(i?.radiusX)) throw new Error("Unable to create a arc, radiusX is invalid");
    if (!isValidNumber(i?.radiusY)) throw new Error("Unable to create a arc, radiusY is invalid");
    const r = new IIEdgeArc(i?.center, i.startAngle, i.sweepAngle, i.radiusX, i.radiusY, i.phi || 0, i.startDecoration, i.endDecoration, i.style);
    return i.id && (r.id = i.id), r;
  }
}
class IIEdgeLine extends OIEdgeBase {
  start;
  end;
  constructor(i, r, s, n, a) {
    super(I.Line, s, n, a), this.start = i, this.end = r;
  }
  get vertices() {
    return [this.start, this.end];
  }
  clone() {
    const i = new IIEdgeLine(structuredClone(this.start), structuredClone(this.end), this.startDecoration, this.endDecoration, structuredClone(this.style));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      start: this.start,
      end: this.end,
      style: this.style,
      startDecoration: this.startDecoration,
      endDecoration: this.endDecoration
    };
  }
  static create(i) {
    if (!isValidPoint(i?.start)) throw new Error("Unable to create a arc, start point is invalid");
    if (!isValidPoint(i?.end)) throw new Error("Unable to create a arc, end point is invalid");
    const r = new IIEdgeLine(i?.start, i?.end, i.startDecoration, i.endDecoration, i.style);
    return i.id && (r.id = i.id), r;
  }
}
class IIEdgePolyLine extends OIEdgeBase {
  points;
  constructor(i, r, s, n) {
    super(I.PolyEdge, r, s, n), this.points = i;
  }
  get vertices() {
    return this.points;
  }
  clone() {
    const i = new IIEdgePolyLine(structuredClone(this.points), this.startDecoration, this.endDecoration, structuredClone(this.style));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      points: this.points,
      style: this.style,
      startDecoration: this.startDecoration,
      endDecoration: this.endDecoration
    };
  }
  static create(i) {
    if (!i?.points?.map(i => isValidPoint(i))) throw new Error("Unable to create a PolyLine, points are invalid");
    const r = new IIEdgePolyLine(i?.points, i.startDecoration, i.endDecoration, i.style);
    return i.id && (r.id = i.id), r;
  }
}
!function (i) {
  i.Circle = "circle", i.Ellipse = "ellipse", i.Polygon = "polygon", i.Table = "table";
}(M || (M = {}));
class OIShapeBase extends IISymbolBase {
  kind;
  isClosed = !0;
  constructor(i, r) {
    super(E.Shape, r), this.kind = i;
  }
  get bounds() {
    return Box.createFromPoints(this.vertices);
  }
  get snapPoints() {
    return this.bounds.snapPoints;
  }
  overlaps(i) {
    return this.bounds.isContained(i) || this.edges.some(r => Box.getSides(i).some(i => !!findIntersectionBetween2Segment(r, i)));
  }
}
class IIShapeCircle extends OIShapeBase {
  center;
  radius;
  _vertices;
  _bounds;
  constructor(i, r, s) {
    super(M.Circle, s), this.center = i, this.radius = r, this._vertices = new Map(), this._vertices.set(this.verticesId, this.computedVertices()), this._bounds = new Map(), this._bounds.set(this.verticesId, this.computedBondingBox());
  }
  get verticesId() {
    return `${this.center.x}-${this.center.y}-${this.radius}`;
  }
  computedVertices() {
    const i = {
        x: this.center.x,
        y: this.radius + this.center.y
      },
      r = 2 * Math.PI * this.radius,
      s = Math.max(8, Math.round(r / a)),
      n = [];
    for (let r = 0; r < s; r++) {
      const a = 2 * Math.PI * (r / s);
      n.push(computeRotatedPoint(i, this.center, a));
    }
    return n;
  }
  computedBondingBox() {
    const i = {
      x: this.center.x - this.radius,
      y: this.center.y - this.radius,
      height: 2 * this.radius,
      width: 2 * this.radius
    };
    return new Box(i);
  }
  get bounds() {
    return this._bounds.has(this.verticesId) || this._bounds.set(this.verticesId, this.computedBondingBox()), this._bounds.get(this.verticesId);
  }
  get vertices() {
    return this._vertices.has(this.verticesId) || this._vertices.set(this.verticesId, this.computedVertices()), this._vertices.get(this.verticesId);
  }
  overlaps(i) {
    return this.bounds.isContained(i) || Box.getSides(i).some(i => findIntersectBetweenSegmentAndCircle(i, this.center, this.radius).length);
  }
  clone() {
    const i = new IIShapeCircle(structuredClone(this.center), this.radius, structuredClone(this.style));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      center: this.center,
      radius: this.radius,
      style: this.style
    };
  }
  static createBetweenPoints(i, r, s) {
    const n = {
        x: (i.x + r.x) / 2,
        y: (i.y + r.y) / 2
      },
      a = Math.abs(i.x - r.x),
      l = Math.abs(i.y - r.y),
      d = Math.min(a, l) / 2;
    return new IIShapeCircle(n, d, s);
  }
  static updateBetweenPoints(i, r, s) {
    i.center = {
      x: (r.x + s.x) / 2,
      y: (r.y + s.y) / 2
    };
    const n = Math.abs(r.x - s.x),
      a = Math.abs(r.y - s.y);
    return i.radius = Math.min(n, a) / 2, i;
  }
  static create(i) {
    if (!isValidPoint(i.center)) throw new Error("Unable to create circle, center is invalid");
    if (!isValidNumber(i.radius)) throw new Error("Unable to create circle, radius is undefined");
    const r = new IIShapeCircle(i.center, i.radius, i.style);
    return i.id && (r.id = i.id), r;
  }
}
class IIShapeEllipse extends OIShapeBase {
  center;
  radiusX;
  radiusY;
  orientation;
  _vertices;
  constructor(i, r, s, n, a) {
    super(M.Ellipse, a), this.center = i, this.radiusX = r, this.radiusY = s, this.orientation = n, this._vertices = new Map();
  }
  get verticesId() {
    return `${this.center.x}-${this.center.y}-${this.radiusX}-${this.radiusY}-${this.orientation}`;
  }
  computedVertices() {
    const i = [],
      r = 2 * Math.PI * Math.sqrt((Math.pow(this.radiusX, 2) + Math.pow(this.radiusY, 2)) / 2),
      s = Math.max(8, Math.round(r / a));
    for (let r = 0; r < s; r++) {
      const n = 2 * Math.PI * (r / s);
      i.push(computePointOnEllipse(this.center, this.radiusX, this.radiusY, this.orientation, n));
    }
    return i;
  }
  get vertices() {
    return this._vertices.has(this.verticesId) || this._vertices.set(this.verticesId, this.computedVertices()), this._vertices.get(this.verticesId);
  }
  overlaps(i) {
    return this.bounds.isContained(i) || this.edges.some(r => Box.getSides(i).some(i => !!findIntersectionBetween2Segment(r, i)));
  }
  clone() {
    const i = new IIShapeEllipse(structuredClone(this.center), this.radiusX, this.radiusY, this.orientation, structuredClone(this.style));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      center: this.center,
      orientation: this.orientation,
      radiusX: this.radiusX,
      radiusY: this.radiusY,
      style: this.style
    };
  }
  static createBetweenPoints(i, r, s) {
    const n = {
        x: (i.x + r.x) / 2,
        y: (i.y + r.y) / 2
      },
      a = Math.abs(i.x - r.x) / 2,
      l = Math.abs(i.y - r.y) / 2;
    return new IIShapeEllipse(n, a, l, 0, s);
  }
  static updateBetweenPoints(i, r, s) {
    return i.center = {
      x: (r.x + s.x) / 2,
      y: (r.y + s.y) / 2
    }, i.radiusX = Math.abs(r.x - s.x) / 2, i.radiusY = Math.abs(r.y - s.y) / 2, i;
  }
  static create(i) {
    if (!isValidPoint(i.center)) throw new Error("Unable to create ellipse, center is undefined");
    if (!isValidNumber(i.radiusX)) throw new Error("Unable to create ellipse, radiusX is undefined");
    if (!isValidNumber(i.radiusY)) throw new Error("Unable to create ellipse, radiusY is undefined");
    const r = new IIShapeEllipse(i.center, i.radiusX, i.radiusY, i.orientation || 0, i.style);
    return i.id && (r.id = i.id), r;
  }
}
class IIShapePolygon extends OIShapeBase {
  points;
  constructor(i, r) {
    super(M.Polygon, r), this.points = i;
  }
  get vertices() {
    return this.points;
  }
  get bounds() {
    return Box.createFromPoints(this.vertices);
  }
  clone() {
    const i = new IIShapePolygon(structuredClone(this.points), structuredClone(this.style));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      points: this.points,
      style: this.style
    };
  }
  static create(i) {
    if (!i?.points || i?.points?.length < 3) throw new Error("Unable to create polygon at least 3 points required");
    if (i?.points?.some(i => !isValidPoint(i))) throw new Error("Unable to create a polygon, one or more points are invalid");
    const r = new IIShapePolygon(i.points, i.style);
    return i.id && (r.id = i.id), r;
  }
  static createTriangleBetweenPoints(i, r, s) {
    const n = [{
      x: i.x,
      y: i.y
    }, {
      x: r.x,
      y: i.y
    }, {
      x: (i.x + r.x) / 2,
      y: r.y
    }];
    return new IIShapePolygon(n, s);
  }
  static updateTriangleBetweenPoints(i, r, s) {
    return i.points = [{
      x: r.x,
      y: r.y
    }, {
      x: s.x,
      y: r.y
    }, {
      x: (r.x + s.x) / 2,
      y: s.y
    }], i.modificationDate = Date.now(), i;
  }
  static createParallelogramBetweenPoints(i, r, s) {
    const n = [{
      x: i.x,
      y: i.y
    }, {
      x: i.x + .75 * (r.x - i.x),
      y: i.y
    }, {
      x: r.x,
      y: r.y
    }, {
      x: i.x + .25 * (r.x - i.x),
      y: r.y
    }];
    return new IIShapePolygon(n, s);
  }
  static updateParallelogramBetweenPoints(i, r, s) {
    const n = [{
      x: r.x,
      y: r.y
    }, {
      x: r.x + .75 * (s.x - r.x),
      y: r.y
    }, {
      x: s.x,
      y: s.y
    }, {
      x: r.x + .25 * (s.x - r.x),
      y: s.y
    }];
    return i.points = n, i.modificationDate = Date.now(), i;
  }
  static createRectangleBetweenPoints(i, r, s) {
    const n = Box.createFromPoints([i, r]),
      a = [{
        x: n.xMin,
        y: n.yMin
      }, {
        x: n.xMax,
        y: n.yMin
      }, {
        x: n.xMax,
        y: n.yMax
      }, {
        x: n.xMin,
        y: n.yMax
      }];
    return new IIShapePolygon(a, s);
  }
  static updateRectangleBetweenPoints(i, r, s) {
    const n = Box.createFromPoints([r, s]),
      a = [{
        x: n.xMin,
        y: n.yMin
      }, {
        x: n.xMax,
        y: n.yMin
      }, {
        x: n.xMax,
        y: n.yMax
      }, {
        x: n.xMin,
        y: n.yMax
      }];
    return i.points = a, i.modificationDate = Date.now(), i;
  }
  static createRhombusBetweenPoints(i, r, s) {
    const n = Box.createFromPoints([i, r]),
      a = [{
        x: n.xMid,
        y: n.yMin
      }, {
        x: n.xMax,
        y: n.yMid
      }, {
        x: n.xMid,
        y: n.yMax
      }, {
        x: n.xMin,
        y: n.yMid
      }];
    return new IIShapePolygon(a, s);
  }
  static updateRhombusBetweenPoints(i, r, s) {
    const n = Box.createFromPoints([r, s]),
      a = [{
        x: n.xMid,
        y: n.yMin
      }, {
        x: n.xMax,
        y: n.yMid
      }, {
        x: n.xMid,
        y: n.yMax
      }, {
        x: n.xMin,
        y: n.yMid
      }];
    return i.points = a, i.modificationDate = Date.now(), i;
  }
}
class IIStroke extends IISymbolBase {
  isClosed = !1;
  pointerType;
  length;
  decorators;
  pointers;
  constructor(i, r = "pen") {
    super(E.Stroke, i), this.pointerType = r, this.pointers = [], this.decorators = [], this.length = 0;
  }
  get bounds() {
    return Box.createFromPoints(this.vertices);
  }
  static split(i, r) {
    const s = new IIStroke(i.style, i.pointerType);
    s.pointers = i.pointers.slice(0, r);
    const n = new IIStroke(i.style, i.pointerType);
    return n.pointers = i.pointers.slice(r), {
      before: s,
      after: n
    };
  }
  static substract(i, r) {
    if (!r.length) return {
      before: i
    };
    const s = {},
      n = {
        x: r.pointers[0].x,
        y: r.pointers[0].y
      },
      a = getClosestPoint(i.pointers, n);
    if (a.index > -1) {
      const r = IIStroke.split(i, a.index);
      s.before = r.before, s.after = r.after;
    }
    const l = s.after || i,
      d = {
        x: r.pointers.at(-1).x,
        y: r.pointers.at(-1).y
      },
      h = getClosestPoint(l.pointers, d);
    if (h.index > -1) {
      const i = IIStroke.split(l, h.index);
      s.after = i.after;
    }
    return s.before?.pointers.length || (s.before = void 0), s.after?.pointers.length || (s.after = void 0), s;
  }
  get snapPoints() {
    return this.bounds.snapPoints;
  }
  get vertices() {
    return this.pointers;
  }
  computePressure(i) {
    let r = 1;
    i === this.length ? r = 1 : i < 10 ? r = .2 + Math.pow(.1 * i, .4) : i > this.length - 10 && (r = .2 + Math.pow(.1 * (this.length - i), .4));
    const s = r * Math.max(.1, 1 - .1 * Math.sqrt(i));
    return isNaN(s) ? .5 : Math.round(100 * s) / 100;
  }
  filterPointByAcquisitionDelta(i) {
    const r = this.pointers.at(-1),
      s = 2 + (this.style.width || 1) / 4;
    return !r || Math.abs(r.x - i.x) >= s || Math.abs(r.y - i.y) >= s;
  }
  addPointer(i) {
    if (this.filterPointByAcquisitionDelta(i)) {
      const r = this.pointers.at(-1),
        s = r ? computeDistance(i, r) : 0;
      this.length += s, i.p = this.computePressure(s), this.pointers.push(i), this.modificationDate = Date.now();
    }
  }
  overlaps(i) {
    return this.pointers.some(r => r.x >= i.x && r.x <= i.x + i.width && r.y >= i.y && r.y <= i.y + i.height);
  }
  clone() {
    const i = new IIStroke(this.style, this.pointerType);
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i.pointers = structuredClone(this.pointers), i.decorators = this.decorators.map(i => i.clone()), i.length = this.length, i;
  }
  formatToSend() {
    const i = {
      id: this.id,
      pointerType: this.pointerType,
      p: [],
      t: [],
      x: [],
      y: []
    };
    return this.pointers.forEach(r => {
      i.p.push(r.p), i.t.push(r.t), i.x.push(r.x), i.y.push(r.y);
    }), i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      pointers: this.pointers,
      style: this.style,
      decorators: this.decorators.length ? this.decorators : void 0
    };
  }
  static create(i) {
    if (!i.pointers?.length) throw new Error("not pointers");
    const r = new IIStroke(i.style, i.pointerType);
    i.id && (r.id = i.id);
    const s = [];
    let n = !0;
    if (i.pointers?.forEach((i, a) => {
      if (!i) return s.push(`no pointer at ${a}`), void (n = !1);
      const l = {
        p: i.p || 1,
        t: i.t || a,
        x: 0,
        y: 0
      };
      return null == i?.x || null == i?.x ? (s.push(`no x at pointer at ${a}`), void (n = !1)) : (l.x = i.x, null == i?.y || null == i?.y ? (s.push(`no y at pointer at ${a}`), void (n = !1)) : (l.y = i.y, void (n && r.addPointer(l))));
    }), s.length) throw new Error(s.join(" and "));
    return i.decorators?.length && i.decorators.forEach(i => {
      i?.kind && r.decorators.push(new IIDecorator(i.kind, Object.assign({}, r.style, i.style)));
    }), r;
  }
}
function convertPartialStrokesToOIStrokes(i) {
  const r = [],
    s = [];
  if (i.forEach((i, n) => {
    try {
      s.push(IIStroke.create(i));
    } catch (i) {
      r.push(`stroke ${n + 1} has ${i.message}`);
    }
  }), r.length) throw new Error(r.join("\n"));
  return s;
}
!function (i) {
  i.Text = "text", i.Line = "line", i.PolyEdge = "polyedge", i.Arc = "arc", i.Circle = "circle", i.Ellipse = "ellipse", i.Polygone = "polygone";
}(T || (T = {}));
class IIRecognizedBase extends IISymbolBase {
  kind;
  strokes;
  constructor(i, r, s) {
    super(E.Recognized, s), this.kind = i, this.strokes = r;
  }
  get vertices() {
    return this.strokes.flatMap(i => i.vertices);
  }
  get bounds() {
    return Box.createFromBoxes(this.strokes.map(i => i.bounds));
  }
  get snapPoints() {
    return this.bounds.snapPoints;
  }
  updateChildrenStyle() {
    this.strokes.forEach(i => i.style = Object.assign({}, i.style, this.style));
  }
  overlaps(i) {
    return this.strokes.some(r => r.overlaps(i));
  }
  containsStroke(i) {
    return this.strokes.some(r => r.id === i);
  }
  removeStrokes(i) {
    const r = this.strokes.filter(r => i.includes(r.id));
    return this.strokes = this.strokes.filter(r => !i.includes(r.id)), r;
  }
}
class IIRecognizedArc extends IIRecognizedBase {
  isClosed = !1;
  constructor(i, r) {
    super(T.Arc, i, r);
  }
  clone() {
    const i = new IIRecognizedArc(this.strokes.map(i => i.clone()), structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      strokes: JSON.parse(JSON.stringify(this.strokes))
    };
  }
  static create(i) {
    if (!i.strokes?.length) throw new Error("no strokes");
    const r = i.strokes.map(i => IIStroke.create(i)),
      s = new IIRecognizedArc(r, i.style);
    return i.id && (s.id = i.id), s;
  }
}
class IIRecognizedCircle extends IIRecognizedBase {
  isClosed = !0;
  constructor(i, r) {
    super(T.Circle, i, r);
  }
  clone() {
    const i = new IIRecognizedCircle(this.strokes.map(i => i.clone()), structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      strokes: JSON.parse(JSON.stringify(this.strokes))
    };
  }
  static create(i) {
    if (!i.strokes?.length) throw new Error("no strokes");
    const r = i.strokes.map(i => IIStroke.create(i)),
      s = new IIRecognizedCircle(r, i.style);
    return i.id && (s.id = i.id), s;
  }
}
class IIRecognizedEllipse extends IIRecognizedBase {
  isClosed = !0;
  constructor(i, r) {
    super(T.Ellipse, i, r);
  }
  clone() {
    const i = new IIRecognizedEllipse(this.strokes.map(i => i.clone()), structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      strokes: JSON.parse(JSON.stringify(this.strokes))
    };
  }
  static create(i) {
    if (!i.strokes?.length) throw new Error("no strokes");
    const r = i.strokes.map(i => IIStroke.create(i)),
      s = new IIRecognizedEllipse(r, i.style);
    return i.id && (s.id = i.id), s;
  }
}
class IIRecognizedLine extends IIRecognizedBase {
  isClosed = !1;
  constructor(i, r) {
    super(T.Line, i, r);
  }
  clone() {
    const i = new IIRecognizedLine(this.strokes.map(i => i.clone()), structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      strokes: JSON.parse(JSON.stringify(this.strokes))
    };
  }
  static create(i) {
    if (!i.strokes?.length) throw new Error("no strokes");
    const r = i.strokes.map(i => IIStroke.create(i)),
      s = new IIRecognizedLine(r, i.style);
    return i.id && (s.id = i.id), s;
  }
}
class IIRecognizedPolyLine extends IIRecognizedBase {
  isClosed = !1;
  constructor(i, r) {
    super(T.PolyEdge, i, r);
  }
  clone() {
    const i = new IIRecognizedPolyLine(this.strokes.map(i => i.clone()), structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      strokes: JSON.parse(JSON.stringify(this.strokes))
    };
  }
  static create(i) {
    if (!i.strokes?.length) throw new Error("no strokes");
    const r = i.strokes.map(i => IIStroke.create(i)),
      s = new IIRecognizedPolyLine(r, i.style);
    return i.id && (s.id = i.id), s;
  }
}
class IIRecognizedPolygon extends IIRecognizedBase {
  isClosed = !0;
  constructor(i, r) {
    super(T.Polygone, i, r);
  }
  clone() {
    const i = new IIRecognizedPolygon(this.strokes.map(i => i.clone()), structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      strokes: JSON.parse(JSON.stringify(this.strokes))
    };
  }
  static create(i) {
    if (!i.strokes?.length) throw new Error("no strokes");
    const r = i.strokes.map(i => IIStroke.create(i)),
      s = new IIRecognizedPolygon(r, i.style);
    return i.id && (s.id = i.id), s;
  }
}
class IIRecognizedText extends IIRecognizedBase {
  isClosed = !1;
  decorators;
  baseline;
  xHeight;
  label;
  constructor(i, r, s) {
    super(T.Text, i, s), this.baseline = r.baseline, this.xHeight = r.xHeight, this.decorators = [];
  }
  clone() {
    const i = new IIRecognizedText(this.strokes.map(i => i.clone()), {
      baseline: this.baseline,
      xHeight: this.xHeight
    }, structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.label = this.label, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i.decorators = this.decorators.map(i => i.clone()), i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      kind: this.kind,
      label: this.label,
      baseline: this.baseline,
      xHeight: this.xHeight,
      strokes: JSON.parse(JSON.stringify(this.strokes)),
      decorators: this.decorators.length ? JSON.parse(JSON.stringify(this.decorators)) : void 0
    };
  }
  static create(i) {
    if (!i.strokes?.length) throw new Error("no strokes");
    const r = i.strokes.map(i => IIStroke.create(i)),
      s = {
        baseline: i.baseline || 0,
        xHeight: i.xHeight || 0
      },
      n = new IIRecognizedText(r, s, i.style);
    return i.decorators?.length && i.decorators.forEach(i => {
      i?.kind && n.decorators.push(new IIDecorator(i.kind, Object.assign({}, n.style, i.style)));
    }), i.id && (n.id = i.id), n;
  }
}
class IISymbolGroup extends IISymbolBase {
  isClosed = !1;
  children;
  decorators;
  constructor(i, r) {
    super(E.Group, r), this.children = i, this.decorators = [];
  }
  get snapPoints() {
    return this.bounds.snapPoints;
  }
  get vertices() {
    return this.children.flatMap(i => i.vertices);
  }
  get bounds() {
    return Box.createFromBoxes(this.children.map(i => i.bounds));
  }
  updateChildrenStyle() {
    this.children.forEach(i => {
      switch (i.style = Object.assign({}, i.style, this.style), i.type) {
        case E.Group:
          i.updateChildrenStyle();
          break;
        case E.Text:
          i.chars.forEach(r => {
            i.style.color && (r.color = i.style.color);
          });
          break;
        case E.Recognized:
          i.updateChildrenStyle();
      }
    });
  }
  overlaps(i) {
    return this.children.some(r => r.overlaps(i));
  }
  containsSymbol(i) {
    return IISymbolGroup.containsSymbol(this, i);
  }
  containsOnlyStroke() {
    return IISymbolGroup.containsOnlyStroke(this);
  }
  extractText() {
    return IISymbolGroup.extractText(this);
  }
  extractStrokes() {
    return IISymbolGroup.extractStrokes(this);
  }
  removeChilds(i) {
    return IISymbolGroup.removeChilds(this, i);
  }
  static containsOnlyStroke(i) {
    return i.children.every(i => i.type === E.Group ? IISymbolGroup.containsOnlyStroke(i) : i.type === E.Stroke);
  }
  static extractText(i) {
    const r = [];
    return i.children.forEach(i => {
      switch (i.type) {
        case E.Text:
          r.push(i);
          break;
        case E.Group:
          r.push(...IISymbolGroup.extractText(i));
      }
    }), r;
  }
  static extractStrokes(i) {
    const r = [];
    return i.children.forEach(i => {
      switch (i.type) {
        case E.Stroke:
          r.push(i);
          break;
        case E.Recognized:
          r.push(...i.strokes);
          break;
        case E.Group:
          r.push(...IISymbolGroup.extractStrokes(i));
      }
    }), r;
  }
  static containsSymbol(i, r) {
    return i.children.some(i => i.id === r || (i.type === E.Group ? IISymbolGroup.containsSymbol(i, r) : i.type === E.Recognized && i.containsStroke(r)));
  }
  static removeChilds(i, r) {
    i.children = i.children.filter(i => !r.includes(i.id));
    return i.children.slice().forEach(s => {
      s.type === E.Group ? s.removeChilds(r).children.length || (i.children = i.children.filter(i => i.id !== s.id)) : s.type === E.Recognized && (s.removeStrokes(r), s.strokes.length || i.removeChilds([s.id]));
    }), i;
  }
  clone() {
    const i = new IISymbolGroup(this.children.map(i => i.clone()), structuredClone({
      ...this.style
    }));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i.decorators = this.decorators.map(i => i.clone()), i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      children: JSON.parse(JSON.stringify(this.children)),
      decorators: this.decorators.length ? JSON.parse(JSON.stringify(this.decorators)) : void 0
    };
  }
}
class IIText extends IISymbolBase {
  isClosed = !0;
  point;
  chars;
  decorators;
  bounds;
  rotation;
  constructor(i, r, s, n) {
    super(E.Text, n), this.point = r, this.bounds = new Box(s), this.chars = i, this.decorators = [];
  }
  get label() {
    return this.chars.map(i => i.label).join("");
  }
  get vertices() {
    if (this.rotation) {
      const i = this.rotation.center,
        r = convertDegreeToRadian(-this.rotation.degree);
      return this.bounds.corners.map(s => computeRotatedPoint(s, i, r));
    }
    return this.bounds.corners;
  }
  get snapPoints() {
    const i = this.bounds.yMax - this.point.y,
      r = [{
        x: this.bounds.x,
        y: this.bounds.yMin + i
      }, {
        x: this.bounds.xMax,
        y: this.bounds.yMin + i
      }, {
        x: this.bounds.xMax,
        y: this.bounds.yMax - i
      }, {
        x: this.bounds.x,
        y: this.bounds.yMax - i
      }, this.bounds.center];
    if (this.rotation) {
      const i = this.rotation.center,
        s = convertDegreeToRadian(-this.rotation.degree);
      return r.map(r => computeRotatedPoint(r, i, s));
    }
    return r;
  }
  getCharCorners(i) {
    const r = new Box(i.bounds);
    if (this.rotation) {
      const i = this.rotation.center,
        s = convertDegreeToRadian(-this.rotation.degree);
      return r.corners.map(r => computeRotatedPoint(r, i, s));
    }
    return r.corners;
  }
  updateChildrenStyle() {
    this.chars.forEach(i => {
      this.style.color && (i.color = this.style.color);
    }), this.modificationDate = Date.now();
  }
  updateChildrenFont({
    fontSize: i,
    fontWeight: r
  }) {
    this.chars.forEach(s => {
      i && (s.fontSize = i), r && (s.fontWeight = r);
    }), this.modificationDate = Date.now();
  }
  getCharsOverlaps(i) {
    return this.chars.filter(r => {
      const s = this.getCharCorners(r);
      return i.some(i => isPointInsidePolygon(i, s));
    });
  }
  overlaps(i) {
    return this.vertices.some(r => Box.containsPoint(i, r)) || this.edges.some(r => Box.getSides(i).some(i => !!findIntersectionBetween2Segment(r, i)));
  }
  clone() {
    const i = new IIText(structuredClone(this.chars), structuredClone(this.point), this.bounds, structuredClone(this.style));
    return i.id = this.id, i.selected = this.selected, i.deleting = this.deleting, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i.decorators = this.decorators.map(i => i.clone()), i.rotation = this.rotation ? structuredClone(this.rotation) : void 0, i;
  }
  toJSON() {
    return {
      id: this.id,
      type: this.type,
      point: this.point,
      chars: this.chars,
      style: this.style,
      rotation: this.rotation,
      bounds: this.bounds,
      decorators: this.decorators.length ? this.decorators : void 0
    };
  }
  static create(i) {
    if (!isValidPoint(i?.point)) throw new Error("Unable to create a IIText, point are invalid");
    if (!i.chars?.length) throw new Error("Unable to create a IIText, no chars");
    if (!i.bounds) throw new Error("Unable to create a IIText, no boundingBox");
    const r = new IIText(i.chars, i.point, i.bounds, i.style);
    return i.id && (r.id = i.id), i.decorators?.length && i.decorators.forEach(i => {
      i?.kind && r.decorators.push(new IIDecorator(i.kind, Object.assign({}, r.style, i.style)));
    }), r;
  }
}
const L = {
  color: "grey",
  fill: "none",
  width: 12,
  opacity: .2
};
class IIEraser extends IISymbolBase {
  isClosed = !1;
  pointers;
  constructor() {
    super(E.Eraser, L), this.id = `${this.type}-${createUUID()}`, this.creationTime = Date.now(), this.modificationDate = this.creationTime, this.pointers = [];
  }
  get bounds() {
    return Box.createFromPoints(this.vertices);
  }
  get vertices() {
    return this.pointers;
  }
  get snapPoints() {
    return [];
  }
  clone() {
    const i = new IIEraser();
    return i.id = this.id, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i.pointers = structuredClone(this.pointers), i;
  }
  overlaps(i) {
    return this.pointers.some(r => r.x >= i.x && r.x <= i.x + i.width && r.y >= i.y && r.y <= i.y + i.height);
  }
  toJSON() {
    return {
      id: this.id,
      pointers: this.pointers,
      style: this.style
    };
  }
}
class Stroke {
  type = E.Stroke;
  id;
  creationTime;
  modificationDate;
  style;
  pointerType;
  pointers;
  length;
  constructor(i, r = "pen") {
    this.id = `${this.type}-${createUUID()}`, this.creationTime = Date.now(), this.modificationDate = this.creationTime, this.style = i, this.pointerType = r, this.pointers = [], this.length = 0;
  }
  clone() {
    const i = new Stroke(this.style, this.pointerType);
    return i.id = this.id, i.creationTime = this.creationTime, i.modificationDate = this.modificationDate, i.pointers = structuredClone(this.pointers), i.length = this.length, i;
  }
  formatToSend() {
    const i = {
      id: this.id,
      pointerType: this.pointerType,
      p: [],
      t: [],
      x: [],
      y: []
    };
    return this.pointers.forEach(r => {
      i.p.push(r.p), i.t.push(r.t), i.x.push(r.x), i.y.push(r.y);
    }), i;
  }
}
function convertPartialStrokesToStrokes(i) {
  const r = [],
    s = [];
  if (i.forEach((i, n) => {
    let a = !0;
    const l = new Stroke(i.style || b, i.pointerType);
    if (i.id && (l.id = i.id), !i.pointers?.length) return r.push(`stroke ${n + 1} has not pointers`), void (a = !1);
    i.pointers?.forEach((i, s) => {
      if (!i) return r.push(`stroke ${n + 1} has no pointer at ${s}`), void (a = !1);
      const d = {
        p: i.p || 1,
        t: i.t || s,
        x: 0,
        y: 0
      };
      return null == i?.x || null == i?.x ? (r.push(`stroke ${n + 1} has no x at pointer at ${s}`), void (a = !1)) : (d.x = i.x, null == i?.y || null == i?.y ? (r.push(`stroke ${n + 1} has no y at pointer at ${s}`), void (a = !1)) : (d.y = i.y, void (a && l.pointers.push(d))));
    }), a && s.push(l);
  }), r.length) throw new Error(r.join("\n"));
  return s;
}
class Model {
  creationTime;
  modificationDate;
  positions;
  currentSymbol;
  symbols;
  exports;
  converts;
  width;
  height;
  rowHeight;
  idle;
  #t = LoggerManager.getLogger(d.MODEL);
  constructor(i = 100, r = 100, s = 0, n = Date.now()) {
    this.#t.info("constructor", {
      width: i,
      height: r,
      creationDate: n
    }), this.creationTime = n, this.modificationDate = n, this.width = i, this.height = r, this.rowHeight = s, this.symbols = [], this.positions = {
      lastSentPosition: 0,
      lastReceivedPosition: 0
    }, this.idle = !0;
  }
  computePressure(i, r) {
    let s = 1;
    i === r ? s = 1 : i < 10 ? s = .2 + Math.pow(.1 * i, .4) : i > r - 10 && (s = .2 + Math.pow(.1 * (r - i), .4));
    const n = s * Math.max(.1, 1 - .1 * Math.sqrt(i));
    return isNaN(n) ? .5 : Math.round(100 * n) / 100;
  }
  filterPointByAcquisitionDelta(i, r, s) {
    const n = 2 + (i.style["-myscript-pen-width"] || 0) / 4;
    return !s || 0 === i.pointers.length || Math.abs(s.x - r.x) >= n || Math.abs(s.y - r.y) >= n;
  }
  getStrokeFromPoint(i) {
    this.#t.info("getStrokeFromPoint", {
      point: i
    });
    const isBetween = (i, r, s) => i >= r && i <= s,
      r = [];
    return this.symbols.forEach(s => {
      for (let n = 0; n < s.pointers.length; n++) {
        const a = s.pointers[n];
        if (isBetween(a.x, i.x - 5, i.x + 5) && isBetween(a.y, i.y - 5, i.y + 5)) {
          r.push(s);
          break;
        }
        if (computeDistance(i, a) < 10) {
          r.push(s);
          break;
        }
      }
    }), this.#t.debug("getStrokeFromPoint", {
      strokes: r
    }), r;
  }
  addPoint(i, r) {
    this.#t.debug("addPoint", {
      stroke: i,
      pointer: r
    });
    const s = i.pointers.at(-1);
    if (this.filterPointByAcquisitionDelta(i, r, s)) {
      const n = s ? computeDistance(r, s) : 0;
      i.length += n, r.p = this.computePressure(n, i.length), i.pointers.push(r), i.modificationDate = Date.now();
    }
  }
  addStroke(i) {
    this.#t.info("addStroke", {
      stroke: i
    }), this.symbols.push(i), this.modificationDate = Date.now(), this.converts = void 0, this.exports = void 0;
  }
  updateStroke(i) {
    this.#t.info("updateStroke", {
      updatedStroke: i
    });
    const r = this.symbols.findIndex(r => r.id === i.id);
    -1 !== r && (i.modificationDate = Date.now(), this.symbols.splice(r, 1, i), this.modificationDate = Date.now(), this.converts = void 0, this.exports = void 0), this.#t.debug("updateStroke", this.symbols);
  }
  removeStroke(i) {
    this.#t.info("removeStroke", {
      id: i
    });
    const r = this.symbols.findIndex(r => r.id === i);
    -1 !== r && (this.positions.lastSentPosition--, this.positions.lastReceivedPosition--, this.symbols.splice(r, 1), this.modificationDate = Date.now(), this.converts = void 0, this.exports = void 0), this.#t.debug("removeStroke", this.symbols);
  }
  removeStrokesFromPoint(i) {
    this.#t.info("removeStrokesFromPoint", {
      point: i
    });
    const r = this.getStrokeFromPoint(i);
    return r.forEach(i => {
      this.removeStroke(i.id);
    }), this.#t.debug("removeStrokesFromPoint", r.map(i => i.id)), r.map(i => i.id);
  }
  extractUnsentStrokes() {
    return this.symbols.slice(this.positions.lastSentPosition);
  }
  initCurrentStroke(i, r, s, n = 96) {
    if (this.#t.info("initCurrentStroke", {
      point: i,
      pointerType: r,
      style: s,
      dpi: n
    }), s["-myscript-pen-width"]) {
      const i = s["-myscript-pen-width"] * n / 25.4;
      s.width = i / 2;
    }
    this.modificationDate = Date.now(), this.exports = void 0, this.currentSymbol = new Stroke(s, r), this.#t.debug("initCurrentStroke", this.currentSymbol), this.addPoint(this.currentSymbol, i);
  }
  appendToCurrentStroke(i) {
    this.#t.info("appendToCurrentStroke", {
      point: i
    }), this.currentSymbol && this.addPoint(this.currentSymbol, i), this.#t.debug("appendToCurrentStroke", this.currentSymbol);
  }
  endCurrentStroke(i) {
    this.#t.info("endCurrentStroke", {
      point: i
    }), this.currentSymbol && (this.addPoint(this.currentSymbol, i), this.addStroke(this.currentSymbol), this.currentSymbol = void 0), this.#t.debug("endCurrentStroke", this.currentSymbol);
  }
  updatePositionSent(i = this.symbols.length) {
    this.#t.info("updatePositionSent", {
      position: i
    }), this.positions.lastSentPosition = i, this.#t.debug("updatePositionSent", this.positions.lastSentPosition);
  }
  updatePositionReceived() {
    this.#t.info("updatePositionReceived"), this.positions.lastReceivedPosition = this.positions.lastSentPosition, this.#t.debug("updatePositionReceived", this.positions.lastReceivedPosition);
  }
  mergeExport(i) {
    this.#t.info("mergeExport", {
      exports: i
    }), this.exports ? Object.assign(this.exports, i) : this.exports = i, this.#t.debug("mergeExport", this.exports);
  }
  mergeConvert(i) {
    this.#t.info("mergeConvert", {
      converts: i
    }), this.converts ? Object.assign(this.converts, i) : this.converts = i, this.#t.debug("mergeConvert", this.converts);
  }
  clone() {
    this.#t.info("clone");
    const i = new Model(this.width, this.height, this.rowHeight, this.creationTime);
    return i.modificationDate = JSON.parse(JSON.stringify(this.modificationDate)), i.currentSymbol = this.currentSymbol ? this.currentSymbol.clone() : void 0, i.symbols = this.symbols.map(i => i.clone()), i.positions = JSON.parse(JSON.stringify(this.positions)), i.exports = this.exports ? JSON.parse(JSON.stringify(this.exports)) : void 0, i.converts = this.converts ? JSON.parse(JSON.stringify(this.converts)) : void 0, i.idle = this.idle, this.#t.debug("clone", {
      clonedModel: i
    }), i;
  }
  clear() {
    this.#t.info("clear"), this.modificationDate = Date.now(), this.currentSymbol = void 0, this.symbols = [], this.positions.lastSentPosition = 0, this.positions.lastReceivedPosition = 0, this.exports = void 0, this.converts = void 0, this.idle = !0;
  }
}
class IIModel {
  #t = LoggerManager.getLogger(d.MODEL);
  creationTime;
  modificationDate;
  currentSymbol;
  symbols;
  exports;
  converts;
  width;
  height;
  rowHeight;
  idle;
  constructor(i = 100, r = 100, s = 0, n = Date.now()) {
    this.creationTime = n, this.modificationDate = n, this.width = i, this.height = r, this.rowHeight = s, this.symbols = [], this.exports = void 0, this.converts = void 0, this.idle = !0;
  }
  get symbolsSelected() {
    return this.symbols.filter(i => i.selected);
  }
  get symbolsToDelete() {
    return this.symbols.filter(i => i.deleting);
  }
  selectSymbol(i) {
    const r = this.symbols.find(r => r.id === i || r.type === E.Group && r.containsSymbol(i));
    r && (r.selected = !0);
  }
  unselectSymbol(i) {
    const r = this.symbols.find(r => r.id === i);
    r && (r.selected = !1);
  }
  resetSelection() {
    this.symbols.forEach(i => i.selected = !1);
  }
  getRootSymbol(i) {
    return this.symbols.find(r => r.id === i || r.type === E.Group && r.containsSymbol(i) || r.type === E.Recognized && r.containsStroke(i) ? r : void 0);
  }
  getSymbolRowIndex(i) {
    return Math.round((i.type === E.Recognized && i.kind === T.Text ? i.baseline : i.bounds.yMid) / this.rowHeight);
  }
  getSymbolsByRowOrdered() {
    const i = [];
    return this.symbols.forEach(r => {
      const s = this.getSymbolRowIndex(r),
        n = i.find(i => i.rowIndex === s);
      n ? n.symbols.push(r) : i.push({
        rowIndex: s,
        symbols: [r]
      });
    }), i.forEach(i => {
      i.symbols.sort((i, r) => i.bounds.xMid - r.bounds.xMid);
    }), i.sort((i, r) => i.rowIndex - r.rowIndex);
  }
  roundToLineGuide(i) {
    return Math.round(i / this.rowHeight) * this.rowHeight;
  }
  isSymbolAbove(i, r) {
    return this.getSymbolRowIndex(i) > this.getSymbolRowIndex(r);
  }
  isSymbolInRow(i, r) {
    return this.getSymbolRowIndex(i) === this.getSymbolRowIndex(r);
  }
  isSymbolBelow(i, r) {
    return this.getSymbolRowIndex(i) < this.getSymbolRowIndex(r);
  }
  getFirstSymbol(i) {
    if (i.length) return i.reduce((i, r) => {
      if (i) {
        if (this.getSymbolRowIndex(i) < this.getSymbolRowIndex(r)) return i;
        if (this.getSymbolRowIndex(i) == this.getSymbolRowIndex(r) && i.bounds.xMid < r.bounds.xMid) return i;
      }
      return r;
    });
  }
  getLastSymbol(i) {
    if (i.length) return i.reduce((i, r) => {
      if (i) {
        if (this.getSymbolRowIndex(i) > this.getSymbolRowIndex(r)) return i;
        if (this.getSymbolRowIndex(i) < this.getSymbolRowIndex(r)) return r;
        if (i.bounds.xMid > r.bounds.xMid) return i;
      }
      return r;
    });
  }
  addSymbol(i) {
    this.#t.info("addSymbol", {
      symbol: i
    });
    if (this.symbols.findIndex(r => r.id === i.id) > -1) throw new Error(`Symbol id already exist: ${i.id}`);
    this.symbols.push(i), this.modificationDate = Date.now(), this.converts = void 0, this.exports = void 0, this.#t.debug("addSymbol", this.symbols);
  }
  updateSymbol(i) {
    this.#t.info("updateSymbol", {
      updatedSymbol: i
    });
    const r = this.symbols.findIndex(r => r.id === i.id);
    -1 !== r && (i.modificationDate = Date.now(), this.symbols.splice(r, 1, i), this.modificationDate = Date.now(), this.converts = void 0, this.exports = void 0), this.#t.debug("updateSymbol", this.symbols);
  }
  replaceSymbol(i, r) {
    const s = this.symbols.findIndex(r => r.id === i);
    -1 !== s && (this.symbols.splice(s, 1, ...r), this.modificationDate = Date.now(), this.converts = void 0, this.exports = void 0);
  }
  changeOrderSymbol(i, r) {
    const s = this.symbols.findIndex(r => r.id === i);
    if (s > -1) {
      let i = s;
      switch (r) {
        case "first":
          i = 0;
          break;
        case "last":
          i = this.symbols.length - 1;
          break;
        case "forward":
          i = Math.min(i + 1, this.symbols.length - 1);
          break;
        case "backward":
          i = Math.max(i - 1, 0);
      }
      const n = this.symbols.splice(s, 1)[0];
      this.symbols.splice(i, 0, n);
    }
  }
  removeSymbol(i) {
    this.#t.info("removeSymbol", {
      id: i
    });
    const r = this.symbols.findIndex(r => r.id === i);
    -1 !== r && (this.symbols.splice(r, 1), this.modificationDate = Date.now(), this.converts = void 0, this.exports = void 0), this.#t.debug("removeSymbol", this.symbols);
  }
  extractDifferenceSymbols(i) {
    return {
      added: this.symbols.filter(r => -1 === i.symbols.findIndex(i => r.id === i.id && r.modificationDate === i.modificationDate)),
      removed: i.symbols.filter(i => -1 === this.symbols.findIndex(r => i.id === r.id && i.modificationDate === r.modificationDate))
    };
  }
  mergeExport(i) {
    this.#t.info("mergeExport", {
      exports: i
    }), this.exports ? Object.assign(this.exports, i) : this.exports = i, this.#t.debug("mergeExport", this.exports);
  }
  clone() {
    this.#t.info("clone");
    const i = new IIModel(this.width, this.height, this.rowHeight, this.creationTime);
    return i.modificationDate = this.modificationDate, i.symbols = this.symbols.map(i => {
      const r = i.clone();
      return r.selected = !1, r;
    }), i.exports = structuredClone(this.exports), i.idle = this.idle, this.#t.debug("clone", {
      clonedModel: i
    }), i;
  }
  clear() {
    this.#t.info("clear"), this.modificationDate = Date.now(), this.symbols = [], this.currentSymbol = void 0, this.exports = void 0, this.converts = void 0, this.idle = !0;
  }
}
const P = {
    scheme: "https",
    host: "cloud.myscript.com",
    applicationKey: "",
    hmacKey: "",
    version: ""
  },
  R = {
    ...P,
    websocket: {
      pingEnabled: !0,
      pingDelay: 15e3,
      maxPingLostCount: 20,
      autoReconnect: !0,
      maxRetryCount: 2,
      fileChunkSize: 3e5
    }
  },
  D = {
    "erase-precisely": !1
  },
  A = {
    types: ["text", "shape"],
    "match-text-size": !0
  },
  z = {
    convert: A,
    eraser: D,
    mimeTypes: ["application/vnd.myscript.jiix"]
  },
  G = {
    "bounding-box": !1,
    strokes: !1,
    ids: !1,
    "full-stroke-ids": !1,
    text: {
      chars: !1,
      words: !0,
      lines: !1
    }
  },
  B = {
    "image-resolution": 300,
    jiix: G
  },
  O = {
    top: 20,
    left: 10,
    right: 10,
    bottom: 10
  },
  N = {
    enable: !0,
    "fractional-part-digits": 3,
    "decimal-separator": ".",
    "rounding-mode": "half up",
    "angle-unit": "deg"
  },
  $ = {
    mode: "stroke"
  },
  j = {
    solver: N,
    margin: O,
    eraser: D,
    "undo-redo": $,
    mimeTypes: ["application/vnd.myscript.jiix"]
  },
  V = {
    recognition: {
      types: ["text", "math", "shape", "decoration"]
    },
    classification: {
      types: ["text", "math", "shape", "decoration", "drawing"]
    },
    eraser: D
  },
  U = {
    "draw-text-boxes": !1,
    "draw-image-boxes": !1
  },
  H = {
    debug: U
  },
  F = {
    enable: !0
  },
  W = {
    guides: F,
    eraser: D,
    margin: O,
    mimeTypes: ["application/vnd.myscript.jiix"]
  },
  _ = {
    enable: !0,
    "line-gap-mm": 100,
    "origin-y-mm": 0
  },
  Y = {
    guides: _,
    eraser: D,
    margin: O,
    mimeTypes: ["application/vnd.myscript.jiix"]
  },
  X = {
    force: {
      "on-stylesheet-change": !1
    }
  },
  J = {
    types: ["shape"],
    "match-text-size": !0
  },
  q = {
    enable: !0
  },
  Z = {
    convert: J,
    eraser: D,
    mimeTypes: ["application/vnd.myscript.jiix"],
    beautification: q
  };
var K, Q;
!function (i) {
  i.START_INITIALIZATION = "start-initialization", i.END_INITIALIZATION = "end-initialization", i.CONTENT_CHANGED = "content-changed", i.IDLE = "idle", i.EXPORTED = "exported", i.ERROR = "error", i.CONNECTION_CLOSE = "connection-close", i.SVG_PATCH = "svg-patch", i.SESSION_OPENED = "session-opened";
}(K || (K = {}));
class RecognizerEvent extends EventTarget {
  abortController;
  constructor() {
    super(), this.abortController = new AbortController();
  }
  removeAllListeners() {
    this.abortController.abort(), this.abortController = new AbortController();
  }
  emit(i, r) {
    const s = new CustomEvent(i, Object.assign({
      bubbles: !0,
      composed: !0
    }, r ? {
      detail: r
    } : void 0));
    this.dispatchEvent(s);
  }
  emitStartInitialization() {
    this.emit(K.START_INITIALIZATION);
  }
  addStartInitialization(i) {
    this.addEventListener(K.START_INITIALIZATION, () => i(), {
      signal: this.abortController.signal
    });
  }
  emitEndtInitialization() {
    this.emit(K.END_INITIALIZATION);
  }
  addEndInitialization(i) {
    this.addEventListener(K.END_INITIALIZATION, () => i(), {
      signal: this.abortController.signal
    });
  }
  emitSessionOpened(i) {
    this.emit(K.SESSION_OPENED, i);
  }
  addSessionOpenedListener(i) {
    this.addEventListener(K.SESSION_OPENED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitContentChanged(i) {
    this.emit(K.CONTENT_CHANGED, {
      ...i,
      canClear: !i.empty
    });
  }
  addContentChangedListener(i) {
    this.addEventListener(K.CONTENT_CHANGED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitIdle(i) {
    this.emit(K.IDLE, i);
  }
  addIdleListener(i) {
    this.addEventListener(K.IDLE, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitExported(i) {
    this.emit(K.EXPORTED, i);
  }
  addExportedListener(i) {
    this.addEventListener(K.EXPORTED, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitError(i) {
    this.emit(K.ERROR, i);
  }
  addErrorListener(i) {
    this.addEventListener(K.ERROR, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitConnectionClose({
    code: i,
    message: r
  }) {
    this.emit(K.CONNECTION_CLOSE, {
      code: i,
      message: r
    });
  }
  addConnectionCloseListener(i) {
    this.addEventListener(K.CONNECTION_CLOSE, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
  emitSVGPatch(i) {
    this.emit(K.SVG_PATCH, i);
  }
  addSVGPatchListener(i) {
    this.addEventListener(K.SVG_PATCH, r => i(r.detail), {
      signal: this.abortController.signal
    });
  }
}
!function (i) {
  i.NO_ACTIVITY = "Session closed due to no activity. Without a connection on your part, it will be permanently lost after an hour.", i.WRONG_CREDENTIALS = "Application credentials are invalid. Please check or regenerate your application key and hmackey.", i.TOO_OLD = "Session is too old. Max Session Duration Reached.", i.NO_SESSION_FOUND = "No sessions found. Without activation for 1 hour, sessions are deleted from the server. To avoid losing your work, use the json export, then import it this will create a new session.", i.UNKNOW = "An unknown error has occurred.", i.ABNORMAL_CLOSURE = "MyScript recognition server is not reachable.", i.CANT_ESTABLISH = "Unable to establish a connection to MyScript recognition server. Check the host and your connectivity.", i.GOING_AWAY = "MyScript recognition server is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection.", i.PROTOCOL_ERROR = "MyScript recognition server terminated the connection due to a protocol error.", i.UNSUPPORTED_DATA = "MyScript recognition server terminated the connection because the endpoint received data of a type it cannot accept. (For example, a text-only endpoint received binary data.)", i.INVALID_FRAME_PAYLOAD = "MyScript recognition server terminated the connection because a message was received that contained inconsistent data (e.g., non-UTF-8 data within a text message).", i.POLICY_VIOLATION = "MyScript recognition server terminated the connection because it received a message that violates its policy.", i.MESSAGE_TOO_BIG = "MyScript recognition server terminated the connection because a data frame was received that is too large.", i.INTERNAL_ERROR = "MyScript recognition server terminated the connection because it encountered an unexpected condition that prevented it from fulfilling the request.", i.SERVICE_RESTART = "MyScript recognition server terminated the connection because it is restarting.", i.TRY_AGAIN = "MyScript recognition server terminated the connection due to a temporary condition, e.g. it is overloaded and is casting off some of its clients.", i.BAD_GATEWAY = "MyScript recognition server was acting as a gateway or proxy and received an invalid response from the upstream server.", i.TLS_HANDSHAKE = "MyScript recognition server connection was closed due to a failure to perform a TLS handshake";
}(Q || (Q = {}));
const ee = {
    export: B,
    math: j,
    diagram: z,
    "raw-content": V,
    renderer: H,
    text: W,
    type: "TEXT",
    lang: "en_US"
  },
  te = {
    server: P,
    recognition: ee
  };
class RecognizerHTTPV1Configuration {
  recognition;
  server;
  constructor(i) {
    this.server = mergeDeep({}, te.server, i?.server), this.recognition = mergeDeep({}, te.recognition, i?.recognition), i?.recognition?.text?.mimeTypes && (this.recognition.text.mimeTypes = i.recognition.text.mimeTypes), this.recognition.text.mimeTypes = [...new Set(this.recognition.text.mimeTypes)], i?.recognition?.math?.mimeTypes && (this.recognition.math.mimeTypes = i.recognition.math.mimeTypes), this.recognition.math.mimeTypes = [...new Set(this.recognition.math.mimeTypes)], i?.recognition?.diagram?.mimeTypes && (this.recognition.diagram.mimeTypes = i.recognition.diagram.mimeTypes), this.recognition.diagram.mimeTypes = [...new Set(this.recognition.diagram.mimeTypes)], i?.recognition?.diagram?.convert?.types && (this.recognition.diagram.convert.types = i.recognition.diagram.convert.types), i?.recognition?.["raw-content"]?.recognition?.types && (this.recognition["raw-content"].recognition.types = i?.recognition?.["raw-content"]?.recognition?.types), this.recognition["raw-content"].recognition.types = [...new Set(this.recognition["raw-content"].recognition.types.filter(i => "decoration" !== i))], i?.recognition?.["raw-content"]?.classification?.types && (this.recognition["raw-content"].classification.types = i?.recognition?.["raw-content"]?.classification?.types), this.server.version && (isVersionSuperiorOrEqual(this.server.version, "2.3.0") || delete this.recognition.convert, isVersionSuperiorOrEqual(this.server.version, "3.2.0") || delete this.recognition.export.jiix.text.lines);
  }
}
class RecognizerHTTPV1 {
  #t = LoggerManager.getLogger(d.RECOGNIZER);
  configuration;
  constructor(i) {
    this.#t.info("constructor", {
      config: i
    }), this.configuration = new RecognizerHTTPV1Configuration(i);
  }
  get url() {
    return `${this.configuration.server.scheme}://${this.configuration.server.host}/api/v4.0/iink/batch`;
  }
  get postConfig() {
    switch (this.configuration.recognition.type) {
      case "DIAGRAM":
        return {
          lang: this.configuration.recognition.lang,
          diagram: this.configuration.recognition.diagram,
          export: this.configuration.recognition.export
        };
      case "MATH":
        return {
          lang: this.configuration.recognition.lang,
          math: this.configuration.recognition.math,
          export: this.configuration.recognition.export
        };
      case "Raw Content":
        return {
          lang: this.configuration.recognition.lang,
          "raw-content": this.configuration.recognition["raw-content"],
          export: this.configuration.recognition.export
        };
      case "TEXT":
        return {
          lang: this.configuration.recognition.lang,
          text: this.configuration.recognition.text,
          export: this.configuration.recognition.export
        };
      default:
        throw new Error(`get postConfig error Recognition type unkow "${this.configuration.recognition.type}"`);
    }
  }
  buildData(i) {
    this.#t.info("buildData", {
      model: i
    });
    const r = [];
    i.symbols.forEach(i => {
      const s = r.findIndex(r => {
        return s = r.penStyle, n = i.style, s && n && s["-myscript-pen-fill-color"] === n["-myscript-pen-fill-color"] && s["-myscript-pen-fill-style"] === n["-myscript-pen-fill-style"] && s["-myscript-pen-width"] === n["-myscript-pen-width"] && s.color === n.color && s.width === n.width;
        var s, n;
      });
      s > -1 ? r[s].strokes.push(i) : r.push({
        penStyle: i.style,
        strokes: [i]
      });
    });
    const s = [];
    r.forEach(i => {
      const r = {
        penStyle: "{}" === JSON.stringify(i.penStyle) ? void 0 : v.penStyleToCSS(i.penStyle),
        strokes: i.strokes.map(i => i.formatToSend())
      };
      s.push(r);
    });
    const n = "Raw Content" === this.configuration.recognition.type ? "Raw Content" : this.configuration.recognition.type.charAt(0).toUpperCase() + this.configuration.recognition.type.slice(1).toLowerCase(),
      a = {
        configuration: this.postConfig,
        xDPI: 96,
        yDPI: 96,
        contentType: n,
        height: i.height,
        width: i.width,
        strokeGroups: s
      };
    return this.#t.debug("buildData", {
      data: a
    }), a;
  }
  async post(i, r) {
    this.#t.info("post", {
      data: i,
      mimeType: r
    });
    const s = new Headers();
    s.append("Accept", "application/json," + r), s.append("applicationKey", this.configuration.server.applicationKey);
    try {
      const r = await computeHmac(JSON.stringify(i), this.configuration.server.applicationKey, this.configuration.server.hmacKey);
      s.append("hmac", r);
    } catch (i) {
      this.#t.error("post.computeHmac", i);
    }
    s.append("Content-Type", "application/json"), this.configuration.server.version || (this.configuration.server.version = (await getApiInfos(this.configuration)).version), isVersionSuperiorOrEqual(this.configuration.server.version, "2.0.4") && (s.append("myscript-client-name", "iink-ts"), s.append("myscript-client-version", "3.0.1")), isVersionSuperiorOrEqual(this.configuration.server.version, "2.3.0") || delete this.configuration.recognition.convert, isVersionSuperiorOrEqual(this.configuration.server.version, "3.2.0") || delete this.configuration.recognition.export.jiix.text.lines;
    const n = {
        method: "POST",
        headers: s,
        body: JSON.stringify(i)
      },
      a = new Request(this.url, n),
      l = await fetch(a);
    if (l.ok) {
      let i;
      switch (l.headers.get("content-type")) {
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        case "image/png":
        case "image/jpeg":
          i = await l.blob();
          break;
        case "application/json":
          i = await l.json();
          break;
        case "application/vnd.myscript.jiix":
          i = await l.clone().json().catch(async () => await l.text());
          break;
        default:
          i = await l.text();
      }
      return this.#t.debug("post", {
        result: i
      }), i;
    }
    {
      const i = await l.json();
      throw this.#t.error("post", {
        err: i
      }), i;
    }
  }
  async tryFetch(i, r) {
    return this.#t.debug("tryFetch", {
      data: i,
      mimeType: r
    }), this.post(i, r).then(i => {
      const s = {};
      return s[r] = i, this.#t.debug("tryFetch", {
        exports: s
      }), s;
    }).catch(s => {
      this.#t.error("tryFetch", {
        data: i,
        mimeType: r,
        err: s
      });
      let n = s.message || Q.UNKNOW;
      s.code ? "access.not.granted" === s.code && (n = Q.WRONG_CREDENTIALS) : n = Q.CANT_ESTABLISH;
      throw new Error(n);
    });
  }
  getMimeTypes(i) {
    this.#t.info("getMimeTypes", {
      requestedMimeTypes: i
    });
    let r = i || [];
    if (!r.length) switch (this.configuration.recognition.type) {
      case "DIAGRAM":
        r = this.configuration.recognition.diagram.mimeTypes;
        break;
      case "MATH":
        r = this.configuration.recognition.math.mimeTypes;
        break;
      case "Raw Content":
        r = ["application/vnd.myscript.jiix"];
        break;
      case "TEXT":
        r = this.configuration.recognition.text.mimeTypes;
        break;
      default:
        throw new Error(`Recognition type "${this.configuration.recognition.type}" is unknown.\n Possible types are:\n -DIAGRAM\n -MATH\n -Raw Content\n -TEXT`);
    }
    return r;
  }
  async convert(i, r, s) {
    this.#t.info("convert", {
      model: i,
      conversionState: r,
      requestedMimeTypes: s
    });
    const n = i.clone(),
      a = this.getMimeTypes(s),
      l = this.buildData(n);
    l.conversionState = r;
    const d = a.map(i => this.tryFetch(l, i));
    return (await Promise.all(d)).forEach(i => {
      n.mergeConvert(i);
    }), this.#t.debug("convert", {
      model: n
    }), n;
  }
  async export(i, r) {
    this.#t.info("export", {
      model: i,
      requestedMimeTypes: r
    });
    const s = i.clone();
    if (0 === s.symbols.length) return Promise.resolve(s);
    const n = this.getMimeTypes(r);
    if (!n.length) return this.#t.error("export", {
      model: i,
      requestedMimeTypes: r,
      "Export failed, no mimeTypes define in recognition configuration": String
    }), Promise.reject(new Error("Export failed, no mimeTypes define in recognition configuration"));
    const a = n.filter(i => !s.exports || !s.exports[i]),
      l = this.buildData(i);
    return (await Promise.all(a.map(i => this.tryFetch(l, i)))).forEach(i => {
      s.mergeExport(i);
    }), this.#t.debug("export", {
      model: s
    }), s;
  }
  async resize(i) {
    return this.#t.info("resize", {
      model: i
    }), this.export(i);
  }
}
const ie = {
    export: B,
    math: j,
    shape: Z,
    "raw-content": V,
    text: Y,
    type: "TEXT",
    lang: "en_US"
  },
  re = {
    server: P,
    recognition: ie
  };
class RecognizerHTTPV2Configuration {
  recognition;
  server;
  constructor(i) {
    this.server = mergeDeep({}, re.server, i?.server), this.recognition = mergeDeep({}, re.recognition, i?.recognition), i?.recognition?.text?.mimeTypes && (this.recognition.text.mimeTypes = i.recognition.text.mimeTypes), this.recognition.text.mimeTypes = [...new Set(this.recognition.text.mimeTypes)], i?.recognition?.math?.mimeTypes && (this.recognition.math.mimeTypes = i.recognition.math.mimeTypes), this.recognition.math.mimeTypes = [...new Set(this.recognition.math.mimeTypes)], i?.recognition?.shape?.mimeTypes && (this.recognition.shape.mimeTypes = i.recognition.shape.mimeTypes), this.recognition.shape.mimeTypes = [...new Set(this.recognition.shape.mimeTypes)], i?.recognition?.["raw-content"]?.recognition?.types && (this.recognition["raw-content"].recognition.types = i?.recognition?.["raw-content"]?.recognition?.types), i?.recognition?.["raw-content"]?.classification?.types && (this.recognition["raw-content"].classification.types = i?.recognition?.["raw-content"]?.classification?.types), this.server.version && (isVersionSuperiorOrEqual(this.server.version, "2.3.0") || delete this.recognition.convert, isVersionSuperiorOrEqual(this.server.version, "3.2.0") || delete this.recognition.export.jiix.text.lines);
  }
}
class RecognizerHTTPV2 {
  #t = LoggerManager.getLogger(d.RECOGNIZER);
  configuration;
  constructor(i) {
    this.#t.info("constructor", {
      config: i
    }), this.configuration = new RecognizerHTTPV2Configuration(i);
  }
  get url() {
    return `${this.configuration.server.scheme}://${this.configuration.server.host}/api/v4.0/iink/recognize`;
  }
  get postConfig() {
    switch (this.configuration.recognition.type) {
      case "SHAPE":
        return {
          lang: this.configuration.recognition.lang,
          diagram: this.configuration.recognition.shape,
          export: this.configuration.recognition.export
        };
      case "MATH":
        return {
          lang: this.configuration.recognition.lang,
          math: this.configuration.recognition.math,
          export: this.configuration.recognition.export
        };
      case "Raw Content":
        return {
          lang: this.configuration.recognition.lang,
          "raw-content": this.configuration.recognition["raw-content"],
          export: this.configuration.recognition.export
        };
      case "TEXT":
        return {
          lang: this.configuration.recognition.lang,
          text: this.configuration.recognition.text,
          export: this.configuration.recognition.export
        };
      default:
        throw new Error(`get postConfig error Recognition type unkow "${this.configuration.recognition.type}"`);
    }
  }
  formatStrokes(i) {
    return i.map(i => ({
      id: i.id,
      pointerType: i.pointerType,
      p: i.pointers.map(i => i.p),
      t: i.pointers.map(i => i.t),
      x: i.pointers.map(i => i.x),
      y: i.pointers.map(i => i.y)
    }));
  }
  buildData(i) {
    this.#t.info("buildData", {
      strokes: i
    });
    const r = "Raw Content" === this.configuration.recognition.type ? "Raw Content" : this.configuration.recognition.type.charAt(0).toUpperCase() + this.configuration.recognition.type.slice(1).toLowerCase(),
      s = {
        configuration: this.postConfig,
        scaleX: .265,
        scaleY: .265,
        contentType: r,
        strokes: this.formatStrokes(i)
      };
    return this.#t.debug("buildData", {
      data: s
    }), s;
  }
  async post(i, r) {
    this.#t.info("post", {
      data: i,
      mimeType: r
    });
    const s = new Headers();
    s.append("Accept", r), s.append("applicationKey", this.configuration.server.applicationKey);
    try {
      const r = await computeHmac(JSON.stringify(i), this.configuration.server.applicationKey, this.configuration.server.hmacKey);
      s.append("hmac", r);
    } catch (i) {
      this.#t.error("post.computeHmac", i);
    }
    s.append("Content-Type", "application/json"), this.configuration.server.version || (this.configuration.server.version = (await getApiInfos(this.configuration)).version), this.configuration.server.version && isVersionSuperiorOrEqual(this.configuration.server.version, "2.0.4") && (s.append("myscript-client-name", "iink-ts"), s.append("myscript-client-version", "3.0.1"));
    const n = {
        method: "POST",
        headers: s,
        body: JSON.stringify(i)
      },
      a = new Request(this.url, n),
      l = await fetch(a);
    if (l.ok) {
      let i;
      switch (l.headers.get("content-type")) {
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        case "image/png":
        case "image/jpeg":
          i = await l.blob();
          break;
        case "application/json":
          i = await l.json();
          break;
        case "application/vnd.myscript.jiix":
          i = await l.clone().json().catch(async () => await l.text());
          break;
        default:
          i = await l.text();
      }
      return this.#t.debug("post", {
        result: i
      }), i;
    }
    {
      const i = await l.json();
      throw this.#t.error("post", {
        err: i
      }), i;
    }
  }
  async tryFetch(i, r) {
    return this.#t.debug("tryFetch", {
      data: i,
      mimeType: r
    }), this.post(i, r).then(i => {
      const s = {};
      return s[r] = i, this.#t.debug("tryFetch", {
        exports: s
      }), s;
    }).catch(s => {
      this.#t.error("tryFetch", {
        data: i,
        mimeType: r,
        err: s
      });
      let n = s.message || Q.UNKNOW;
      s.code ? "access.not.granted" === s.code && (n = Q.WRONG_CREDENTIALS) : n = Q.CANT_ESTABLISH;
      throw new Error(n);
    });
  }
  getMimeTypes(i) {
    this.#t.info("getMimeTypes", {
      requestedMimeTypes: i
    });
    let r = i || [];
    if (!r.length) switch (this.configuration.recognition.type) {
      case "SHAPE":
        r = this.configuration.recognition.shape.mimeTypes;
        break;
      case "MATH":
        r = this.configuration.recognition.math.mimeTypes;
        break;
      case "Raw Content":
        r = ["application/vnd.myscript.jiix"];
        break;
      case "TEXT":
        r = this.configuration.recognition.text.mimeTypes;
        break;
      default:
        throw new Error(`Recognition type "${this.configuration.recognition.type}" is unknown.\n Possible types are:\n -DIAGRAM\n -MATH\n -Raw Content\n -TEXT\n -SHAPE`);
    }
    return r;
  }
  async send(i) {
    this.#t.info("send", i);
    let r = {};
    if (0 === i.length) return Promise.resolve(r);
    if (this.configuration.recognition.type) {
      const s = this.getMimeTypes();
      if (!s.length) {
        const i = new Error("send failed, no mimeTypes define in recognition configuration");
        return this.#t.error("send", i), Promise.reject(i);
      }
      const n = this.buildData(i);
      (await Promise.all(s.map(i => this.tryFetch(n, i)))).forEach(i => {
        Object.assign(r, i);
      });
    } else {
      const s = this.buildData(i);
      r = await this.tryFetch(s, "application/vnd.myscript.jiix");
    }
    return this.#t.debug("send", r), r;
  }
}
var oe;
!function (i) {
  i.HMAC_Challenge = "hmacChallenge", i.Authenticated = "authenticated", i.SessionDescription = "sessionDescription", i.NewPart = "newPart", i.PartChanged = "partChanged", i.ContentChanged = "contentChanged", i.Idle = "idle", i.Pong = "pong", i.Exported = "exported", i.GestureDetected = "gestureDetected", i.ContextlessGesture = "contextlessGesture", i.Error = "error";
}(oe || (oe = {}));
var se = null;
try {
  var ne = "undefined" != typeof module && "function" == typeof module.require && module.require("worker_threads") || "function" == typeof __non_webpack_require__ && __non_webpack_require__("worker_threads") || "function" == typeof require && require("worker_threads");
  se = ne.Worker;
} catch (i) {}
function createBase64WorkerFactory$2(i, r, s) {
  var n = function decodeBase64$1(i, r) {
      return Buffer.from(i, "base64").toString("utf8");
    }(i),
    a = n.indexOf("\n", 10) + 1,
    l = n.substring(a) + "";
  return function WorkerFactory(i) {
    return new se(l, Object.assign({}, i, {
      eval: !0
    }));
  };
}
function createURL(i, r, s) {
  var n = function decodeBase64(i, r) {
      return atob(i);
    }(i),
    a = n.indexOf("\n", 10) + 1,
    l = n.substring(a) + "",
    d = new Blob([l], {
      type: "application/javascript"
    });
  return URL.createObjectURL(d);
}
var ae = "[object process]" === Object.prototype.toString.call("undefined" != typeof process ? process : 0);
var le = function createBase64WorkerFactory(i, r, s) {
  return function isNodeJS() {
    return ae;
  }() ? createBase64WorkerFactory$2(i) : function createBase64WorkerFactory$1(i, r, s) {
    var n;
    return function WorkerFactory(r) {
      return n = n || createURL(i), new Worker(n, r);
    };
  }(i);
}("Lyogcm9sbHVwLXBsdWdpbi13ZWItd29ya2VyLWxvYWRlciAqLwohZnVuY3Rpb24oKXsidXNlIHN0cmljdCI7c2VsZi5hZGRFdmVudExpc3RlbmVyKCJtZXNzYWdlIiwoZT0+e3NldEludGVydmFsKCgoKT0+e3Bvc3RNZXNzYWdlKHt0eXBlOiJwaW5nIn0pfSksZS5kYXRhLnBpbmdEZWxheSl9KSl9KCk7Ci8vIyBzb3VyY2VNYXBwaW5nVVJMPXBpbmcud29ya2VyLmpzLm1hcAoK");
const de = {
    export: {
      jiix: {
        "bounding-box": !0,
        "full-stroke-ids": !0,
        ids: !0,
        strokes: !1,
        text: {
          chars: !0,
          words: !0,
          lines: !0
        }
      }
    },
    "raw-content": {
      recognition: {
        types: ["text", "shape"]
      },
      classification: {
        types: ["text", "shape"]
      },
      gestures: ["underline", "scratch-out", "join", "insert", "strike-through", "surround"]
    },
    lang: "en_US",
    gesture: {
      enable: !0,
      ignoreGestureStrokes: !1
    }
  },
  he = {
    server: R,
    recognition: de
  };
class RecognizerWebSocketConfiguration {
  server;
  recognition;
  constructor(i) {
    this.server = mergeDeep({}, he.server, i?.server), this.recognition = mergeDeep({}, he.recognition, i?.recognition), this.recognition.export.jiix["full-stroke-ids"] = !0, this.recognition.export.jiix.ids = !0, this.recognition.export.jiix.text.words = !0, this.recognition.export.jiix.text.chars = !0, this.recognition.export.jiix.text.lines = !0, this.recognition.export.jiix["bounding-box"] = !0, i?.recognition?.["raw-content"]?.recognition?.types && (this.recognition["raw-content"].recognition.types = i.recognition["raw-content"].recognition.types), i?.recognition?.["raw-content"]?.classification?.types && (this.recognition["raw-content"].classification.types = i.recognition["raw-content"].classification.types), i?.recognition?.["raw-content"]?.gestures && (this.recognition["raw-content"].gestures = i.recognition["raw-content"].gestures), this.server.version && !isVersionSuperiorOrEqual(this.server.version, "3.2.0") && (delete this.recognition.export.jiix.text.lines, delete this.recognition["raw-content"].classification);
  }
}
class RecognizerWebSocket {
  #t = LoggerManager.getLogger(d.RECOGNIZER);
  socket;
  pingWorker;
  pingCount = 0;
  reconnectionCount = 0;
  sessionId;
  currentPartId;
  currentErrorCode;
  addStrokeDeferred;
  contextlessGestureDeferred;
  transformStrokeDeferred;
  eraseStrokeDeferred;
  replaceStrokeDeferred;
  exportDeferredMap;
  closeDeferred;
  waitForIdleDeferred;
  undoDeferred;
  redoDeferred;
  clearDeferred;
  configuration;
  initialized;
  url;
  event;
  constructor(i, r) {
    this.#t.info("constructor", {
      config: i
    }), this.configuration = new RecognizerWebSocketConfiguration(i);
    const s = "https" === this.configuration.server.scheme ? "wss" : "ws";
    this.url = `${s}://${this.configuration.server.host}/api/v4.0/iink/offscreen?applicationKey=${this.configuration.server.applicationKey}`, this.event = r || new RecognizerEvent(), this.initialized = new DeferredPromise(), this.exportDeferredMap = new Map(), this.contextlessGestureDeferred = new Map();
  }
  get mimeTypes() {
    return ["application/vnd.myscript.jiix"];
  }
  async #a(i) {
    if (!this.socket) throw new Error("Recognizer must be initilized");
    if (this.socket.readyState !== this.socket.OPEN) throw new Error(`Can not send message: ${i.type}, connection not ready, state: ${this.socket.readyState}`);
    this.socket.send(JSON.stringify(i));
  }
  rejectDeferredPending(i) {
    this.initialized.reject(i), this.addStrokeDeferred?.reject(i), this.transformStrokeDeferred?.reject(i), this.eraseStrokeDeferred?.reject(i), this.replaceStrokeDeferred?.reject(i), this.undoDeferred?.reject(i), this.redoDeferred?.reject(i), this.clearDeferred?.reject(i), Array.from(this.contextlessGestureDeferred.values()).forEach(r => {
      r.reject(i);
    }), Array.from(this.exportDeferredMap.values()).forEach(r => {
      r.reject(i);
    }), this.waitForIdleDeferred?.reject(i);
  }
  resetAllDeferred() {
    this.initialized = new DeferredPromise(), this.addStrokeDeferred = void 0, this.contextlessGestureDeferred.clear(), this.transformStrokeDeferred = void 0, this.eraseStrokeDeferred = void 0, this.replaceStrokeDeferred = void 0, this.exportDeferredMap.clear(), this.waitForIdleDeferred = void 0, this.closeDeferred = void 0;
  }
  clearSocketListener() {
    this.socket.removeEventListener("open", this.openCallback.bind(this)), this.socket.removeEventListener("close", this.closeCallback.bind(this)), this.socket.removeEventListener("message", this.messageCallback.bind(this));
  }
  closeCallback(i) {
    this.#t.info("closeCallback", {
      evt: i
    });
    let r = i.reason;
    if (!this.currentErrorCode) switch (i.code) {
      case 1e3:
        break;
      case 1001:
        r = Q.GOING_AWAY;
        break;
      case 1002:
        r = Q.PROTOCOL_ERROR;
        break;
      case 1003:
        r = Q.UNSUPPORTED_DATA;
        break;
      case 1006:
        r = Q.ABNORMAL_CLOSURE;
        break;
      case 1007:
        r = Q.INVALID_FRAME_PAYLOAD;
        break;
      case 1008:
        r = Q.POLICY_VIOLATION;
        break;
      case 1009:
        r = Q.MESSAGE_TOO_BIG;
        break;
      case 1011:
        r = Q.INTERNAL_ERROR;
        break;
      case 1012:
        r = Q.SERVICE_RESTART;
        break;
      case 1013:
        r = Q.TRY_AGAIN;
        break;
      case 1014:
        r = Q.BAD_GATEWAY;
        break;
      case 1015:
        r = Q.TLS_HANDSHAKE;
        break;
      default:
        r = Q.CANT_ESTABLISH;
    }
    if (this.clearSocketListener(), this.closeDeferred?.resolve(), !this.currentErrorCode && 1e3 !== i.code) {
      const i = new Error(r);
      this.event.emitError(i), this.rejectDeferredPending(r);
    }
    this.pingWorker?.terminate(), this.resetAllDeferred();
  }
  openCallback() {
    this.reconnectionCount = 0, this.#a({
      type: "authenticate",
      "myscript-client-name": "iink-ts",
      "myscript-client-version": "3.0.1"
    });
  }
  async manageHMACChallenge(i) {
    this.#a({
      type: "hmac",
      hmac: await computeHmac(i.hmacChallenge, this.configuration.server.applicationKey, this.configuration.server.hmacKey)
    });
  }
  initPing() {
    this.pingWorker = new le(), this.pingWorker.postMessage({
      pingDelay: this.configuration.server.websocket.pingDelay
    }), this.pingWorker.onmessage = () => {
      this.socket.readyState <= 1 && (this.pingCount < this.configuration.server.websocket.maxPingLostCount ? this.send({
        type: "ping"
      }) : (this.close(1e3, "MAXIMUM_PING_REACHED"), this.pingWorker?.terminate()), this.pingCount++);
    };
  }
  manageAuthenticated() {
    isVersionSuperiorOrEqual(this.configuration.server.version, "3.2.0") || (delete this.configuration.recognition.export.jiix.text.lines, delete this.configuration.recognition["raw-content"].classification);
    const i = 25.4 / 96;
    this.#a({
      type: this.sessionId ? "restoreSession" : "initSession",
      iinkSessionId: this.sessionId,
      scaleX: i,
      scaleY: i,
      configuration: this.configuration.recognition
    });
  }
  manageSessionDescriptionMessage(i) {
    i.iinkSessionId && (this.sessionId = i.iinkSessionId, this.event.emitSessionOpened(this.sessionId)), this.currentPartId ? this.#a({
      type: "openContentPart",
      id: this.currentPartId
    }) : this.#a({
      type: "newContentPart",
      contentType: "Raw Content",
      mimeTypes: this.mimeTypes
    });
  }
  manageNewPartMessage(i) {
    this.initialized.resolve(), this.currentPartId = i.id;
  }
  managePartChangeMessage(i) {
    this.initialized.resolve(), this.currentPartId = i.partId;
  }
  manageContentChangedMessage(i) {
    this.initialized.resolve(), this.replaceStrokeDeferred?.resolve(), this.transformStrokeDeferred?.resolve(), this.eraseStrokeDeferred?.resolve(), this.undoDeferred?.resolve(), this.redoDeferred?.resolve(), this.clearDeferred?.resolve(), this.event.emitContentChanged({
      canRedo: i.canRedo,
      canUndo: i.canRedo
    });
  }
  manageExportMessage(i) {
    i.exports["application/vnd.myscript.jiix"] && (i.exports["application/vnd.myscript.jiix"] = JSON.parse(i.exports["application/vnd.myscript.jiix"].toString())), Object.keys(i.exports).forEach(r => {
      this.exportDeferredMap.has(r) && this.exportDeferredMap.get(r).resolve(i.exports);
    }), this.event.emitExported(i.exports);
  }
  manageWaitForIdle() {
    this.waitForIdleDeferred?.resolve(), this.event.emitIdle(!0);
  }
  manageErrorMessage(i) {
    this.currentErrorCode = i.data?.code || i.code;
    let r = i.data?.message || i.message || Q.UNKNOW;
    if ("no.activity" === this.currentErrorCode) this.rejectDeferredPending(r), this.event.emitConnectionClose({
      code: 1e3,
      message: Q.NO_ACTIVITY
    });else {
      switch (this.currentErrorCode) {
        case "access.not.granted":
          r = Q.WRONG_CREDENTIALS;
          break;
        case "session.too.old":
          r = Q.TOO_OLD;
          break;
        case "restore.session.not.found":
          r = Q.NO_SESSION_FOUND;
      }
      this.rejectDeferredPending(r), this.event.emitError(new Error(r));
    }
  }
  manageGestureDetected(i) {
    this.addStrokeDeferred?.resolve(i);
  }
  manageContextlessGesture(i) {
    this.contextlessGestureDeferred.get(i.strokeId)?.resolve(i);
  }
  messageCallback(i) {
    this.currentErrorCode = void 0;
    try {
      const r = JSON.parse(i.data);
      if (r.type === oe.Pong) return;
      switch (this.pingCount = 0, r.type) {
        case oe.HMAC_Challenge:
          this.manageHMACChallenge(r);
          break;
        case oe.Authenticated:
          this.manageAuthenticated();
          break;
        case oe.SessionDescription:
          this.manageSessionDescriptionMessage(r);
          break;
        case oe.NewPart:
          this.manageNewPartMessage(r);
          break;
        case oe.PartChanged:
          this.managePartChangeMessage(r);
          break;
        case oe.ContentChanged:
          this.manageContentChangedMessage(r);
          break;
        case oe.Exported:
          this.manageExportMessage(r);
          break;
        case oe.GestureDetected:
          this.manageGestureDetected(r);
          break;
        case oe.ContextlessGesture:
          this.manageContextlessGesture(r);
          break;
        case oe.Error:
          this.manageErrorMessage(r);
          break;
        case oe.Idle:
          this.manageWaitForIdle();
          break;
        default:
          this.#t.warn("messageCallback", `Message type unknow: "${r}".`);
      }
    } catch {
      this.event.emitError(new Error(i.data));
    }
  }
  async newSession(i) {
    await this.close(1e3, "new-session"), this.configuration = mergeDeep({}, this.configuration, i), this.sessionId = void 0, this.currentPartId = void 0, await this.init();
  }
  async init() {
    this.event.emitStartInitialization(), "restore.session.not.found" === this.currentErrorCode && (this.currentErrorCode = void 0, this.sessionId = void 0, this.currentPartId = void 0), this.initialized = new DeferredPromise(), this.configuration.server.version || (this.configuration.server.version = (await getApiInfos(this.configuration)).version), this.socket = new WebSocket(this.url), this.clearSocketListener(), this.socket.addEventListener("open", this.openCallback.bind(this)), this.socket.addEventListener("close", this.closeCallback.bind(this)), this.socket.addEventListener("message", this.messageCallback.bind(this)), await this.initialized.promise, this.configuration.server.websocket.pingEnabled && (this.pingCount = 0, this.initPing()), this.event.emitEndtInitialization();
  }
  async send(i) {
    if (!this.socket) return Promise.reject(new Error("Recognizer must be initilized"));
    switch (this.socket.readyState) {
      case this.socket.CONNECTING:
      case this.socket.OPEN:
        return await this.initialized.promise, this.#a(i), Promise.resolve();
      case this.socket.CLOSING:
      case this.socket.CLOSED:
        return this.configuration.server.websocket.autoReconnect ? (this.reconnectionCount++, this.configuration.server.websocket.maxRetryCount > this.reconnectionCount ? (await this.init(), await this.waitForIdle(), this.#a(i)) : Promise.reject(new Error("Unable to send message. The maximum number of connection attempts has been reached."))) : Promise.reject(new Error("Unable to send message. Connection closed and automatic reconnection disabled"));
    }
  }
  buildAddStrokesMessage(i, r = !0) {
    return {
      type: "addStrokes",
      processGestures: r,
      strokes: i.map(i => i.formatToSend())
    };
  }
  async addStrokes(i, r = !0) {
    return this.addStrokeDeferred = new DeferredPromise(), 0 === i.length ? (this.addStrokeDeferred.resolve(void 0), this.addStrokeDeferred?.promise) : (await this.send(this.buildAddStrokesMessage(i, r)), this.addStrokeDeferred?.promise);
  }
  buildReplaceStrokesMessage(i, r) {
    return {
      type: "replaceStrokes",
      oldStrokeIds: i,
      newStrokes: r.map(i => i.formatToSend())
    };
  }
  async replaceStrokes(i, r) {
    return this.replaceStrokeDeferred = new DeferredPromise(), 0 === i.length ? (this.replaceStrokeDeferred.resolve(), this.replaceStrokeDeferred?.promise) : (await this.send(this.buildReplaceStrokesMessage(i, r)), this.replaceStrokeDeferred?.promise);
  }
  buildTransformTranslateMessage(i, r, s) {
    return {
      type: "transform",
      transformationType: "TRANSLATE",
      strokeIds: i,
      tx: r,
      ty: s
    };
  }
  async transformTranslate(i, r, s) {
    return this.transformStrokeDeferred = new DeferredPromise(), 0 === i.length ? (this.transformStrokeDeferred.resolve(), this.transformStrokeDeferred?.promise) : (await this.send(this.buildTransformTranslateMessage(i, r, s)), this.transformStrokeDeferred?.promise);
  }
  buildTransformRotateMessage(i, r, s = 0, n = 0) {
    return {
      type: "transform",
      transformationType: "ROTATE",
      strokeIds: i,
      angle: r,
      x0: s,
      y0: n
    };
  }
  async transformRotate(i, r, s = 0, n = 0) {
    return this.transformStrokeDeferred = new DeferredPromise(), 0 === i.length ? (this.transformStrokeDeferred.resolve(), this.transformStrokeDeferred?.promise) : (await this.send(this.buildTransformRotateMessage(i, r, s, n)), this.transformStrokeDeferred?.promise);
  }
  buildTransformScaleMessage(i, r, s, n = 0, a = 0) {
    return {
      type: "transform",
      transformationType: "SCALE",
      strokeIds: i,
      scaleX: r,
      scaleY: s,
      x0: n,
      y0: a
    };
  }
  async transformScale(i, r, s, n = 0, a = 0) {
    return this.transformStrokeDeferred = new DeferredPromise(), 0 === i.length ? (this.transformStrokeDeferred.resolve(), this.transformStrokeDeferred?.promise) : (await this.send(this.buildTransformScaleMessage(i, r, s, n, a)), this.transformStrokeDeferred?.promise);
  }
  buildTransformMatrixMessage(i, r) {
    return {
      type: "transform",
      transformationType: "MATRIX",
      strokeIds: i,
      ...r
    };
  }
  async transformMatrix(i, r) {
    return this.transformStrokeDeferred = new DeferredPromise(), 0 === i.length ? (this.transformStrokeDeferred.resolve(), this.transformStrokeDeferred?.promise) : (await this.send(this.buildTransformMatrixMessage(i, r)), this.transformStrokeDeferred?.promise);
  }
  buildEraseStrokesMessage(i) {
    return {
      type: "eraseStrokes",
      strokeIds: i
    };
  }
  async eraseStrokes(i) {
    return this.eraseStrokeDeferred = new DeferredPromise(), 0 === i.length ? (this.eraseStrokeDeferred.resolve(), this.eraseStrokeDeferred?.promise) : (await this.send(this.buildEraseStrokesMessage(i)), this.eraseStrokeDeferred?.promise);
  }
  async recognizeGesture(i) {
    if (!i) return;
    this.contextlessGestureDeferred.set(i.id, new DeferredPromise());
    const r = 25.4 / 96;
    return await this.send({
      type: "contextlessGesture",
      scaleX: r,
      scaleY: r,
      stroke: i.formatToSend()
    }), this.contextlessGestureDeferred.get(i.id).promise;
  }
  async waitForIdle() {
    this.waitForIdleDeferred && !this.waitForIdleDeferred.isFullFilled || (this.waitForIdleDeferred = new DeferredPromise());
    return await this.send({
      type: "waitForIdle"
    }), this.waitForIdleDeferred?.promise;
  }
  buildUndoRedoChanges(i) {
    const r = [];
    return i.added?.length && r.push(this.buildAddStrokesMessage(i.added, !1)), i.erased?.length && r.push(this.buildEraseStrokesMessage(i.erased.map(i => i.id))), i.replaced?.newStrokes.length && r.push(this.buildReplaceStrokesMessage(i.replaced.oldStrokes.map(i => i.id), i.replaced.newStrokes)), i.matrix?.strokes.length && r.push(this.buildTransformMatrixMessage(i.matrix.strokes.map(i => i.id), i.matrix.matrix)), i.translate?.length && i.translate.forEach(i => {
      r.push(this.buildTransformTranslateMessage(i.strokes.map(i => i.id), i.tx, i.ty));
    }), i.rotate?.length && i.rotate.forEach(i => {
      r.push(this.buildTransformRotateMessage(i.strokes.map(i => i.id), i.angle, i.center.x, i.center.y));
    }), i.scale?.length && i.scale.forEach(i => {
      r.push(this.buildTransformScaleMessage(i.strokes.map(i => i.id), i.scaleX, i.scaleY, i.origin.x, i.origin.y));
    }), r;
  }
  async undo(i) {
    const r = this.buildUndoRedoChanges(i);
    if (0 === r.length) return;
    this.undoDeferred = new DeferredPromise();
    const s = {
      type: "undo",
      changes: r
    };
    return await this.send(s), this.undoDeferred?.promise;
  }
  async redo(i) {
    const r = this.buildUndoRedoChanges(i);
    if (0 === r.length) return;
    this.redoDeferred = new DeferredPromise();
    const s = {
      type: "redo",
      changes: r
    };
    return await this.send(s), this.redoDeferred?.promise;
  }
  async export(i) {
    const r = i || this.mimeTypes.slice();
    await Promise.all(r.map(i => this.exportDeferredMap.get(i)?.promise)), r.forEach(i => {
      this.exportDeferredMap.set(i, new DeferredPromise());
    });
    const s = {
      type: "export",
      partId: this.currentPartId,
      mimeTypes: r
    };
    await this.send(s);
    const n = await Promise.all(r.map(i => this.exportDeferredMap.get(i).promise));
    return Object.assign({}, ...n);
  }
  async clear() {
    return this.clearDeferred = new DeferredPromise(), await this.send({
      type: "clear"
    }), this.clearDeferred?.promise;
  }
  async close(i, r) {
    this.resetAllDeferred(), this.closeDeferred = new DeferredPromise(), this.socket.readyState === this.socket.OPEN || this.socket.readyState === this.socket.CONNECTING ? this.socket.close(i, r) : this.closeDeferred.resolve(), await this.closeDeferred.promise;
  }
  async destroy() {
    this.socket && (await this.close(1e3, "Recognizer destroyed"));
  }
}
const ce = {
    export: B,
    math: j,
    renderer: H,
    text: W,
    type: "TEXT",
    lang: "en_US"
  },
  ue = {
    server: R,
    recognition: ce
  };
class RecognizerWebSocketSSRConfiguration {
  recognition;
  server;
  constructor(i) {
    this.server = mergeDeep({}, ue.server, i?.server), this.recognition = mergeDeep({}, ue.recognition, i?.recognition), i?.recognition?.text?.mimeTypes && (this.recognition.text.mimeTypes = i.recognition.text.mimeTypes), this.recognition.text.mimeTypes = [...new Set(this.recognition.text.mimeTypes)], i?.recognition?.math?.mimeTypes && (this.recognition.math.mimeTypes = i.recognition.math.mimeTypes), this.recognition.math.mimeTypes = [...new Set(this.recognition.math.mimeTypes)], this.server.version && (isVersionSuperiorOrEqual(this.server.version, "2.3.0") || delete this.recognition.convert, isVersionSuperiorOrEqual(this.server.version, "3.2.0") || delete this.recognition.export.jiix.text.lines);
  }
}
class RecognizerWebSocketSSR {
  #t = LoggerManager.getLogger(d.RECOGNIZER);
  socket;
  pingCount = 0;
  reconnectionCount = 0;
  viewSizeHeight;
  viewSizeWidth;
  sessionId;
  currentPartId;
  currentErrorCode;
  penStyle;
  penStyleClasses;
  theme;
  connected;
  ackDeferred;
  addStrokeDeferred;
  exportDeferred;
  convertDeferred;
  importDeferred;
  resizeDeferred;
  undoDeferred;
  redoDeferred;
  clearDeferred;
  importPointEventsDeferred;
  waitForIdleDeferred;
  configuration;
  initialized;
  url;
  event;
  constructor(i) {
    this.#t.info("constructor", {
      config: i
    }), this.configuration = new RecognizerWebSocketSSRConfiguration(i);
    const r = "https" === this.configuration.server.scheme ? "wss" : "ws";
    this.url = `${r}://${this.configuration.server.host}/api/v4.0/iink/document?applicationKey=${this.configuration.server.applicationKey}`, this.event = new RecognizerEvent(), this.initialized = new DeferredPromise();
  }
  get mimeTypes() {
    switch (this.configuration.recognition.type.toLocaleLowerCase()) {
      case "text":
        return this.configuration.recognition.text.mimeTypes;
      case "math":
        return this.configuration.recognition.math.mimeTypes;
      default:
        throw new Error(`Unauthorized recognition type: "${this.configuration.recognition.type}"`);
    }
  }
  infinitePing() {
    this.pingCount++, this.configuration.server.websocket.maxPingLostCount < this.pingCount ? this.socket.close(1e3, "MAXIMUM_PING_REACHED") : this.socket.readyState <= 1 && setTimeout(() => {
      this.socket.readyState <= 1 && (this.socket.send(JSON.stringify({
        type: "ping"
      })), this.infinitePing());
    }, this.configuration.server.websocket.pingDelay);
  }
  openCallback() {
    this.connected?.resolve();
    const i = {
      type: this.sessionId ? "restoreIInkSession" : "newContentPackage",
      iinkSessionId: this.sessionId,
      applicationKey: this.configuration.server.applicationKey,
      xDpi: 96,
      yDpi: 96,
      viewSizeHeight: this.viewSizeHeight,
      viewSizeWidth: this.viewSizeWidth
    };
    isVersionSuperiorOrEqual(this.configuration.server.version, "2.0.4") && (i["myscript-client-name"] = "iink-ts", i["myscript-client-version"] = "3.0.1"), this.send(i);
  }
  rejectDeferredPending(i) {
    this.connected?.isPending && this.connected?.reject(i), this.initialized.isPending && this.initialized.reject(i), this.addStrokeDeferred?.isPending && this.addStrokeDeferred?.reject(i), this.exportDeferred?.isPending && this.exportDeferred?.reject(i), this.importPointEventsDeferred?.isPending && this.importPointEventsDeferred?.reject(i), this.convertDeferred?.isPending && this.convertDeferred?.reject(i), this.importDeferred?.isPending && this.importDeferred?.reject(i), this.resizeDeferred?.isPending && this.resizeDeferred?.reject(i), this.waitForIdleDeferred?.isPending && this.waitForIdleDeferred?.reject(i), this.undoDeferred?.isPending && this.undoDeferred?.reject(i), this.redoDeferred?.isPending && this.redoDeferred?.reject(i), this.clearDeferred?.isPending && this.clearDeferred.reject(i), this.waitForIdleDeferred?.isPending && this.waitForIdleDeferred.reject(i);
  }
  closeCallback(i) {
    let r = "";
    if (!this.currentErrorCode) switch (i.code) {
      case 1e3:
        break;
      case 1001:
        r = Q.GOING_AWAY;
        break;
      case 1002:
        r = Q.PROTOCOL_ERROR;
        break;
      case 1003:
        r = Q.UNSUPPORTED_DATA;
        break;
      case 1006:
        r = Q.ABNORMAL_CLOSURE;
        break;
      case 1007:
        r = Q.INVALID_FRAME_PAYLOAD;
        break;
      case 1008:
        r = Q.POLICY_VIOLATION;
        break;
      case 1009:
        r = Q.MESSAGE_TOO_BIG;
        break;
      case 1011:
        r = Q.INTERNAL_ERROR;
        break;
      case 1012:
        r = Q.SERVICE_RESTART;
        break;
      case 1013:
        r = Q.TRY_AGAIN;
        break;
      case 1014:
        r = Q.BAD_GATEWAY;
        break;
      case 1015:
        r = Q.TLS_HANDSHAKE;
        break;
      default:
        this.#t.warn("closeCallback", "unknow CloseEvent.code", {
          evt: i
        }), r = Q.CANT_ESTABLISH;
    }
    if (!this.currentErrorCode && 1e3 !== i.code) {
      const s = new Error(r || i.reason);
      this.rejectDeferredPending(s), this.event.emitError(s);
    }
  }
  async manageAckMessage(i) {
    this.#t.info("manageAckMessage", {
      websocketMessage: i
    });
    const r = i;
    r.hmacChallenge && this.send({
      type: "hmac",
      hmac: await computeHmac(r.hmacChallenge, this.configuration.server.applicationKey, this.configuration.server.hmacKey)
    }), r.iinkSessionId && (this.sessionId = r.iinkSessionId), isVersionSuperiorOrEqual(this.configuration.server.version, "2.3.0") || delete this.configuration.recognition.convert, isVersionSuperiorOrEqual(this.configuration.server.version, "3.2.0") || delete this.configuration.recognition.export.jiix.text.lines, this.send({
      ...this.configuration.recognition,
      type: "configuration"
    }), this.ackDeferred?.resolve();
  }
  async manageContentPackageDescriptionMessage() {
    this.reconnectionCount = 0, await this.ackDeferred?.promise, this.#t.info("manageContentPackageDescriptionMessage"), this.currentPartId ? this.send({
      type: "openContentPart",
      id: this.currentPartId,
      mimeTypes: this.mimeTypes
    }) : this.send({
      type: "newContentPart",
      contentType: this.configuration.recognition.type,
      mimeTypes: this.mimeTypes
    });
  }
  managePartChangeMessage(i) {
    this.#t.info("managePartChangeMessage", {
      websocketMessage: i
    });
    const r = i;
    this.currentPartId = r.partId, this.initialized.resolve();
  }
  manageExportMessage(i) {
    this.#t.info("manageExportMessage", {
      websocketMessage: i
    });
    const r = i;
    r.exports["application/vnd.myscript.jiix"] && (r.exports["application/vnd.myscript.jiix"] = JSON.parse(r.exports["application/vnd.myscript.jiix"].toString())), this.initialized.resolve(), this.addStrokeDeferred?.resolve(r.exports), this.exportDeferred?.resolve(r.exports), this.convertDeferred?.resolve(r.exports), this.importDeferred?.resolve(r.exports), this.undoDeferred?.resolve(r.exports), this.redoDeferred?.resolve(r.exports), this.clearDeferred?.resolve(r.exports), this.importPointEventsDeferred?.resolve(r.exports), this.event.emitExported(r.exports);
  }
  async manageWaitForIdle() {
    this.event.emitIdle(!0), this.waitForIdleDeferred?.resolve();
  }
  manageErrorMessage(i) {
    const r = i;
    this.currentErrorCode = r.data?.code || r.code;
    let s = r.data?.message || r.message || Q.UNKNOW;
    switch (this.currentErrorCode) {
      case "no.activity":
        s = Q.NO_ACTIVITY;
        break;
      case "access.not.granted":
        s = Q.WRONG_CREDENTIALS;
        break;
      case "session.too.old":
        s = Q.TOO_OLD;
    }
    const n = new Error(s);
    this.rejectDeferredPending(n), this.event.emitError(n);
  }
  manageContentChangeMessage(i) {
    this.#t.info("manageContentChangeMessage", {
      websocketMessage: i
    });
    const r = i,
      s = {
        canRedo: r.canRedo,
        canUndo: r.canUndo,
        empty: r.empty,
        stackIndex: r.undoStackIndex,
        possibleUndoCount: r.possibleUndoCount
      };
    this.event.emitContentChanged(s);
  }
  manageSVGPatchMessage(i) {
    this.#t.info("manageSVGPatchMessage", {
      websocketMessage: i
    }), this.resizeDeferred?.resolve();
    const r = i;
    this.event.emitSVGPatch(r);
  }
  messageCallback(i) {
    this.#t.debug("messageCallback", {
      message: i
    }), this.currentErrorCode = void 0;
    const r = JSON.parse(i.data);
    if ("pong" !== r.type) switch (this.pingCount = 0, r.type) {
      case "ack":
        this.manageAckMessage(r);
        break;
      case "contentPackageDescription":
        this.manageContentPackageDescriptionMessage();
        break;
      case "partChanged":
        this.managePartChangeMessage(r);
        break;
      case "newPart":
        this.initialized.resolve();
        break;
      case "contentChanged":
        this.manageContentChangeMessage(r);
        break;
      case "exported":
        this.manageExportMessage(r);
        break;
      case "svgPatch":
        this.manageSVGPatchMessage(r);
        break;
      case "error":
        this.manageErrorMessage(r);
        break;
      case "idle":
        this.manageWaitForIdle();
        break;
      default:
        this.#t.warn("messageCallback", `Message type unknow: "${r.type}".`);
    }
  }
  async init(i, r) {
    try {
      this.event.emitStartInitialization(), this.#t.info("init", {
        height: i,
        width: r
      }), this.destroy(), this.configuration.server.version || (this.configuration.server.version = (await getApiInfos(this.configuration)).version), this.connected = new DeferredPromise(), this.initialized = new DeferredPromise(), this.ackDeferred = new DeferredPromise(), this.viewSizeHeight = i, this.viewSizeWidth = r, this.pingCount = 0, this.socket = new WebSocket(this.url), this.configuration.server.websocket.pingEnabled && this.infinitePing(), this.socket.addEventListener("open", this.openCallback.bind(this)), this.socket.addEventListener("close", this.closeCallback.bind(this)), this.socket.addEventListener("message", this.messageCallback.bind(this)), this.event.emitEndtInitialization(), await this.connected.promise, await this.initialized.promise;
    } catch (i) {
      return this.rejectDeferredPending(i), this.initialized.promise;
    }
  }
  async send(i) {
    return this.socket ? (await this.connected?.promise, this.socket.readyState === this.socket.OPEN ? (this.#t.debug("send", {
      message: i
    }), this.socket.send(JSON.stringify(i)), Promise.resolve()) : this.socket.readyState != this.socket.CONNECTING && this.configuration.server.websocket.autoReconnect ? (this.reconnectionCount++, this.configuration.server.websocket.maxRetryCount >= this.reconnectionCount ? (this.#t.debug("send", `try to reconnect number: ${this.reconnectionCount}.`), await this.init(this.viewSizeHeight, this.viewSizeWidth), await this.setPenStyle(this.penStyle), await this.setPenStyleClasses(this.penStyleClasses), await this.setTheme(this.theme), this.send(i)) : Promise.reject(new Error("Unable to send message. The maximum number of connection attempts has been reached."))) : void 0) : Promise.reject(new Error("Recognizer must be initilized"));
  }
  async addStrokes(i) {
    return this.#t.info("addStrokes", {
      strokes: i
    }), await this.initialized.promise, this.addStrokeDeferred = new DeferredPromise(), 0 === i.length ? this.addStrokeDeferred.resolve({}) : await this.send({
      type: "addStrokes",
      strokes: i.map(i => i.formatToSend())
    }), this.addStrokeDeferred?.promise;
  }
  async setPenStyle(i) {
    this.#t.info("setPenStyle", {
      penStyle: i
    }), await this.initialized.promise, this.penStyle = i;
    const r = {
      type: "setPenStyle",
      style: v.penStyleToCSS(i)
    };
    return this.send(r);
  }
  async setPenStyleClasses(i) {
    await this.initialized.promise, this.penStyleClasses = i, this.#t.info("setPenStyleClasses", {
      penStyleClasses: i
    });
    const r = {
      type: "setPenStyleClasses",
      styleClasses: i
    };
    return this.send(r);
  }
  async setTheme(i) {
    this.#t.info("setTheme", {
      theme: i
    }), await this.initialized.promise, this.theme = i;
    const r = {
      type: "setTheme",
      theme: v.themeToCSS(i)
    };
    return this.send(r);
  }
  async export(i, r) {
    this.#t.info("export", {
      model: i,
      requestedMimeTypes: r
    }), await this.initialized.promise, this.exportDeferred = new DeferredPromise();
    const s = i.clone();
    let n = r || [];
    if (!n.length) switch (this.configuration.recognition.type) {
      case "MATH":
        n = this.configuration.recognition.math.mimeTypes;
        break;
      case "TEXT":
        n = this.configuration.recognition.text.mimeTypes;
        break;
      default:
        throw new Error(`Recognition type "${this.configuration.recognition.type}" is unknown.\n Possible types are:\n -MATH\n -TEXT`);
    }
    if (!n.length) return Promise.reject(new Error(`Export failed, no mimeTypes define in recognition ${this.configuration.recognition.type} configuration`));
    const a = {
      type: "export",
      partId: this.currentPartId,
      mimeTypes: n
    };
    await this.send(a);
    const l = await this.exportDeferred?.promise;
    return s.updatePositionReceived(), s.mergeExport(l), this.#t.debug("export", {
      model: s
    }), s;
  }
  async import(i, r, s) {
    this.#t.info("import", {
      data: r,
      mimeType: s
    }), await this.initialized.promise;
    const n = i.clone(),
      a = this.configuration.server.websocket.fileChunkSize,
      l = Math.random().toString(10).substring(2, 6);
    this.importDeferred = new DeferredPromise();
    const readBlob = i => {
        const r = new FileReader();
        return new Promise((s, n) => {
          r.onloadend = i => s(i.target?.result), r.onerror = () => n(), r.readAsText(i);
        });
      },
      d = {
        type: "importFile",
        importFileId: l,
        mimeType: s
      };
    await this.send(d);
    for (let i = 0; i < r.size; i += a) {
      const s = r.slice(i, i + a, r.type),
        n = {
          type: "fileChunk",
          importFileId: l,
          data: await readBlob(s),
          lastChunk: i + a > r.size
        };
      await this.send(n);
    }
    const h = await this.importDeferred?.promise;
    return this.importDeferred = void 0, n.mergeExport(h), n;
  }
  async resize(i) {
    this.#t.info("resize", {
      model: i
    }), await this.initialized.promise, this.resizeDeferred = new DeferredPromise();
    const r = i.clone();
    this.viewSizeHeight = r.height, this.viewSizeWidth = r.width;
    const s = {
      type: "changeViewSize",
      height: this.viewSizeHeight,
      width: this.viewSizeWidth
    };
    return await this.send(s), await this.resizeDeferred?.promise, r;
  }
  async importPointEvents(i) {
    this.#t.info("importPointsEvents", {
      strokes: i
    }), await this.initialized.promise, this.importPointEventsDeferred = new DeferredPromise();
    const r = {
      type: "pointerEvents",
      events: i.map(i => i.formatToSend())
    };
    return await this.send(r), this.importPointEventsDeferred?.promise;
  }
  async convert(i, r) {
    this.#t.info("convert", {
      model: i,
      conversionState: r
    }), await this.initialized.promise, this.convertDeferred = new DeferredPromise();
    const s = i.clone(),
      n = {
        type: "convert",
        conversionState: r
      };
    await this.send(n);
    const a = await this.convertDeferred?.promise;
    return s.updatePositionReceived(), s.mergeConvert(a), this.#t.debug("convert", {
      model: s
    }), s;
  }
  async waitForIdle() {
    await this.initialized.promise, this.waitForIdleDeferred = new DeferredPromise();
    return await this.send({
      type: "waitForIdle"
    }), this.waitForIdleDeferred?.promise;
  }
  async undo(i) {
    this.#t.info("undo", {
      model: i
    }), await this.initialized.promise;
    const r = i.clone();
    this.undoDeferred = new DeferredPromise();
    await this.send({
      type: "undo"
    });
    const s = await this.undoDeferred?.promise;
    return r.updatePositionReceived(), r.mergeExport(s), this.#t.debug("undo", {
      model: r
    }), this.undoDeferred = void 0, r;
  }
  async redo(i) {
    this.#t.info("redo", {
      model: i
    }), await this.initialized.promise;
    const r = i.clone();
    this.redoDeferred = new DeferredPromise();
    await this.send({
      type: "redo"
    });
    const s = await this.redoDeferred?.promise;
    return r.updatePositionReceived(), r.mergeExport(s), this.#t.debug("redo", {
      model: s
    }), this.redoDeferred = void 0, r;
  }
  async clear(i) {
    this.#t.info("clear", {
      model: i
    }), await this.initialized.promise;
    const r = i.clone();
    r.modificationDate = Date.now(), this.clearDeferred = new DeferredPromise();
    await this.send({
      type: "clear"
    });
    const s = await this.clearDeferred?.promise;
    return r.updatePositionReceived(), r.mergeExport(s), this.clearDeferred = void 0, this.#t.info("clear", {
      model: r
    }), r;
  }
  close(i, r) {
    this.socket.readyState !== this.socket.OPEN && this.socket.readyState !== this.socket.CONNECTING || (this.#t.info("close", {
      code: i,
      reason: r
    }), this.socket.removeEventListener("close", this.closeCallback), this.socket.removeEventListener("message", this.messageCallback), this.socket.removeEventListener("open", this.openCallback), this.socket.close(i, r));
  }
  destroy() {
    this.#t.info("destroy"), this.connected = void 0, this.ackDeferred = void 0, this.addStrokeDeferred = void 0, this.exportDeferred = void 0, this.convertDeferred = void 0, this.importDeferred = void 0, this.importPointEventsDeferred = void 0, this.waitForIdleDeferred = void 0, this.resizeDeferred = void 0, this.undoDeferred = void 0, this.redoDeferred = void 0, this.clearDeferred = void 0, this.socket && (this.socket.removeEventListener("close", this.closeCallback), this.socket.removeEventListener("message", this.messageCallback), this.socket.removeEventListener("open", this.openCallback), this.close(1e3, "Recognizer destroyed"));
  }
}
class CanvasRendererShape {
  #t = LoggerManager.getLogger(d.RENDERER);
  symbols = {
    table: "table",
    ellipse: "ellipse",
    line: "line"
  };
  phi(i) {
    let r = (i + Math.PI) % (2 * Math.PI) - Math.PI;
    return r < -Math.PI && (r += 2 * Math.PI), this.#t.debug("phi", {
      angle: i,
      returnedAngle: r
    }), r;
  }
  drawEllipseArc(i, r) {
    this.#t.debug("drawEllipseArc", {
      context2D: i,
      shapeEllipse: r
    });
    const {
        centerPoint: s,
        maxRadius: n,
        minRadius: a,
        orientation: l,
        startAngle: d,
        sweepAngle: h
      } = r,
      c = Math.cos(l) * n,
      u = Math.cos(l) * a,
      p = Math.sin(l) * n,
      g = Math.sin(l) * a,
      m = Math.floor(Math.abs(h) / .02),
      y = [];
    i.save();
    try {
      i.beginPath();
      for (let r = 0; r <= m; r++) {
        const l = d + r / m * h,
          b = Math.atan2(Math.sin(l) / a, Math.cos(l) / n),
          f = Math.cos(b),
          x = Math.sin(b),
          S = s.x + c * f - g * x,
          w = s.y + u * x + p * f;
        0 === r ? i.moveTo(S, w) : i.lineTo(S, w), 0 !== r && r !== m || y.push({
          x: S,
          y: w
        });
      }
      i.stroke();
    } catch (i) {
      this.#t.error("drawEllipseArc", {
        error: i
      });
    } finally {
      i.restore();
    }
    return y;
  }
  drawLine(i, r, s) {
    this.#t.debug("drawLine", {
      context2D: i,
      p1: r,
      p2: s
    }), i.save();
    try {
      i.beginPath(), i.moveTo(r.x, r.y), i.lineTo(s.x, s.y), i.stroke();
    } catch (i) {
      this.#t.error("drawLine", {
        error: i
      });
    } finally {
      i.restore();
    }
  }
  drawArrowHead(i, r, s, n) {
    this.#t.debug("drawArrowHead", {
      context2D: i,
      headPoint: r,
      angle: s,
      length: n
    });
    const a = this.phi(s + Math.PI * (7 / 8)),
      l = this.phi(s - Math.PI * (7 / 8));
    i.save();
    try {
      i.fillStyle = i.strokeStyle, i.moveTo(r.x, r.y), i.beginPath(), i.lineTo(r.x + n * Math.cos(a), r.y + n * Math.sin(a)), i.lineTo(r.x + n * Math.cos(l), r.y + n * Math.sin(l)), i.lineTo(r.x, r.y), i.fill();
    } catch (i) {
      this.#t.error("drawArrowHead", {
        error: i
      });
    } finally {
      i.restore();
    }
  }
  drawShapeEllipse(i, r) {
    this.#t.debug("drawShapeEllipse", {
      context2D: i,
      shapeEllipse: r
    });
    const s = this.drawEllipseArc(i, r);
    "ARROW_HEAD" === r?.beginDecoration && this.drawArrowHead(i, s[0], r.beginTangentAngle, 12), "ARROW_HEAD" === r?.endDecoration && this.drawArrowHead(i, s[1], r.endTangentAngle, 12);
  }
  drawShapeLine(i, r) {
    this.#t.debug("drawShapeLine", {
      context2D: i,
      shapeLine: r
    }), this.drawLine(i, r.firstPoint, r.lastPoint), "ARROW_HEAD" === r.beginDecoration && this.drawArrowHead(i, r.firstPoint, r.beginTangentAngle, 12), "ARROW_HEAD" === r.endDecoration && this.drawArrowHead(i, r.lastPoint, r.endTangentAngle, 12);
  }
  draw(i, r) {
    switch (this.#t.info("draw", {
      context2D: i,
      symbol: r
    }), i.save(), i.lineWidth = r.style.width, i.strokeStyle = r.style.color, r.type) {
      case this.symbols.table:
        r.lines.forEach(r => this.drawLine(i, r.p1, r.p2));
        break;
      case this.symbols.ellipse:
        this.drawShapeEllipse(i, r);
        break;
      case this.symbols.line:
        this.drawShapeLine(i, r);
        break;
      default:
        this.#t.warn("draw", `${r.type} not implemented`);
    }
  }
}
class CanvasRendererStroke {
  #t = LoggerManager.getLogger(d.RENDERER);
  renderArc(i, r, s) {
    this.#t.debug("renderArc", {
      context2d: i,
      center: r,
      radius: s
    }), i.arc(r.x, r.y, s, 0, 2 * Math.PI, !0);
  }
  renderLine(i, r, s, n) {
    this.#t.debug("renderLine", {
      context2d: i,
      begin: r,
      end: s,
      width: n
    });
    const a = computeLinksPointers(r, computeAngleAxeRadian(r, s), n),
      l = computeLinksPointers(s, computeAngleAxeRadian(r, s), n);
    i.moveTo(a[0].x, a[0].y), i.lineTo(l[0].x, l[0].y), i.lineTo(l[1].x, l[1].y), i.lineTo(a[1].x, a[1].y);
  }
  renderFinal(i, r, s, n) {
    this.#t.debug("renderFinal", {
      context2d: i,
      begin: r,
      end: s,
      width: n
    });
    const a = computeAngleAxeRadian(r, s),
      l = computeLinksPointers(s, a, n);
    i.moveTo(l[0].x, l[0].y);
    for (let r = 1; r <= 6; r++) {
      const l = a - r * Math.PI / 6;
      i.lineTo(s.x - s.p * n * Math.sin(l), s.y + s.p * n * Math.cos(l));
    }
  }
  renderQuadratic(i, r, s, n, a) {
    this.#t.debug("renderQuadratic", {
      context2d: i,
      begin: r,
      end: s,
      ctrl: n,
      width: a
    });
    const l = computeLinksPointers(r, computeAngleAxeRadian(r, n), a),
      d = computeLinksPointers(s, computeAngleAxeRadian(n, s), a),
      h = computeLinksPointers(n, computeAngleAxeRadian(r, s), a);
    i.moveTo(l[0].x, l[0].y), i.quadraticCurveTo(h[0].x, h[0].y, d[0].x, d[0].y), i.lineTo(d[1].x, d[1].y), i.quadraticCurveTo(h[1].x, h[1].y, l[1].x, l[1].y);
  }
  draw(i, r) {
    this.#t.info("draw", {
      context2d: i,
      stroke: r
    });
    const s = r.pointers.length,
      n = s - 2,
      a = r.style.width > 0 ? r.style.width : i.lineWidth,
      l = r.style.color ? r.style.color : i.strokeStyle,
      d = r.pointers[0];
    i.save();
    try {
      if (i.beginPath(), s < 3) this.renderArc(i, d, .6 * a);else {
        this.renderArc(i, d, a * d.p);
        const l = computeMiddlePointer(d, r.pointers[1]);
        this.renderLine(i, d, l, a);
        for (let s = 0; s < n; s++) {
          const n = computeMiddlePointer(r.pointers[s], r.pointers[s + 1]),
            l = computeMiddlePointer(r.pointers[s + 1], r.pointers[s + 2]),
            d = r.pointers[s + 1];
          this.renderQuadratic(i, n, l, d, a);
        }
        const h = computeMiddlePointer(r.pointers[s - 2], r.pointers[s - 1]),
          c = r.pointers[s - 1];
        this.renderLine(i, h, c, a);
        const u = r.pointers[s - 2],
          p = r.pointers[s - 1];
        this.renderFinal(i, u, p, a);
      }
      i.closePath(), void 0 !== l && (i.fillStyle = l, i.fill()), i.save();
    } catch (i) {
      this.#t.error("draw", {
        error: i
      });
    } finally {
      i.restore();
    }
  }
}
class CanvasRendererText {
  #t = LoggerManager.getLogger(d.RENDERER);
  symbols = {
    char: "char",
    string: "string",
    textLine: "textLine"
  };
  drawUnderline(i, r, s) {
    this.#t.debug("#drawUnderline", {
      context2D: i,
      textUnderline: r,
      underline: s
    }), i.save();
    try {
      const n = r.data.width / r.label.length,
        a = {
          x: r.data.topLeftPoint.x + s.data.firstCharacter * n,
          y: r.data.topLeftPoint.y + r.data.height
        },
        l = {
          x: r.data.topLeftPoint.x + s.data.lastCharacter * n,
          y: r.data.topLeftPoint.y + r.data.height
        };
      i.beginPath(), i.moveTo(a.x, a.y), i.lineTo(l.x, l.y), i.stroke();
    } catch (i) {
      this.#t.error("#drawUnderline", {
        error: i
      });
    } finally {
      i.restore();
    }
  }
  drawText(i, r) {
    this.#t.debug("#drawText", {
      context2D: i,
      text: r
    }), i.save();
    try {
      i.font = `${r.data.textHeight}px serif`, i.textAlign = "CENTER" === r.data.justificationType ? "center" : "left", i.textBaseline = "bottom", i.fillStyle = i.strokeStyle, i.fillText(r.label, r.data.topLeftPoint.x, r.data.topLeftPoint.y + r.data.height);
    } catch (i) {
      this.#t.error("#drawText", {
        error: i
      });
    } finally {
      i.restore();
    }
  }
  drawTextLine(i, r) {
    this.#t.debug("#drawTextLine", {
      context2D: i,
      textUnderline: r
    }), this.drawText(i, r), r.underlineList.forEach(s => {
      this.drawUnderline(i, r, s);
    });
  }
  draw(i, r) {
    switch (this.#t.info("draw", {
      context2D: i,
      symbol: r
    }), i.lineWidth = r.style.width, i.strokeStyle = r.style.color, r.type) {
      case this.symbols.char:
      case this.symbols.string:
        this.drawText(i, r);
        break;
      case this.symbols.textLine:
        this.drawTextLine(i, r);
        break;
      default:
        this.#t.warn("draw", `${r.type} not implemented`);
    }
  }
}
class CanvasRenderer {
  #t = LoggerManager.getLogger(d.RENDERER);
  configuration;
  strokeRenderer;
  shapeRenderer;
  textRenderer;
  context;
  constructor(i) {
    this.#t.info("constructor", {
      config: i
    }), this.configuration = i, this.strokeRenderer = new CanvasRendererStroke(), this.shapeRenderer = new CanvasRendererShape(), this.textRenderer = new CanvasRendererText();
  }
  createCanvas(i) {
    this.#t.debug("createCanvas", {
      type: i
    });
    const r = document.createElement("canvas");
    return r.id = i, r.classList.add(i), r.classList.add("ms-canvas"), r;
  }
  resizeContent() {
    const i = window.devicePixelRatio;
    [this.context.renderingCanvas, this.context.capturingCanvas].forEach(r => {
      const s = r.parentNode,
        n = Math.max(this.configuration.minWidth, s.clientWidth),
        a = Math.max(this.configuration.minHeight, s.clientHeight);
      r.width = n * i, r.height = a * i, r.getContext("2d")?.scale(i, i), r.style.width = `${n}px`, r.style.height = `${a}px`;
    });
  }
  drawSymbol(i, r) {
    if (this.#t.debug("drawSymbol", {
      symbol: r
    }), "stroke" === r.type) {
      const s = r;
      "eraser" !== s.pointerType && this.strokeRenderer.draw(i, s);
    } else Object.keys(this.textRenderer.symbols).includes(r.type) ? this.textRenderer.draw(i, r) : Object.keys(this.shapeRenderer.symbols).includes(r.type) ? this.shapeRenderer.draw(i, r) : this.#t.warn("drawSymbol", `symbol type unknow: ${r.type}`);
  }
  init(i, r) {
    this.#t.info("init", {
      element: i
    });
    const s = this.createCanvas("ms-rendering-canvas");
    s.setAttribute("data-layer", "MODEL"), r && (s.style.backgroundSize = `${r.x || 1}px ${r.y || 1}px`), i.appendChild(s);
    const n = this.createCanvas("ms-capture-canvas");
    n.setAttribute("data-layer", "CAPTURE"), i.appendChild(n), this.context = {
      parent: i,
      renderingCanvas: s,
      renderingCanvasContext: s.getContext("2d"),
      capturingCanvas: n,
      capturingCanvasContext: n.getContext("2d")
    }, this.resizeContent();
  }
  drawModel(i) {
    this.#t.info("drawModel", {
      model: i
    }), this.context.renderingCanvasContext?.clearRect(0, 0, this.context.renderingCanvas.width, this.context.renderingCanvas.height), i.symbols.forEach(i => this.drawSymbol(this.context.renderingCanvasContext, i)), this.context.capturingCanvasContext.clearRect(0, 0, this.context.capturingCanvas.width, this.context.capturingCanvas.height);
  }
  drawPendingStroke(i) {
    this.#t.info("drawPendingStroke", {
      stroke: i
    }), this.context.capturingCanvasContext.clearRect(0, 0, this.context.capturingCanvas.width, this.context.capturingCanvas.height), i && "eraser" !== i?.pointerType && this.strokeRenderer.draw(this.context.capturingCanvasContext, i);
  }
  resize(i) {
    this.#t.info("resize", {
      model: i
    }), this.resizeContent(), this.drawModel(i);
  }
  destroy() {
    this.#t.info("destroy"), this.context.parent && (this.context.parent.innerHTML = "");
  }
}
const pe = {
    arrowHeadStartMarker: "arrow-head-start",
    arrowHeadEndMaker: "arrow-head-end",
    selectionFilterId: "selection-filter",
    removalFilterId: "removal-filter",
    crossMarker: "cross-marker",
    noSelection: "pointer-events: none; -webkit-touch-callout: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none;"
  },
  ge = "http://www.w3.org/2000/svg";
class SVGBuilder {
  static createLayer(i, r = {}) {
    const s = document.createElementNS(ge, "svg");
    return s.setAttribute("width", `${i.width}px`), s.setAttribute("height", `${i.height}px`), s.setAttribute("viewBox", `${i.x}, ${i.y}, ${i.width}, ${i.height}`), Object.keys(r).forEach(i => {
      s.setAttribute(i, r[i]);
    }), s;
  }
  static createFilter(i, r = {}) {
    const s = document.createElementNS(ge, "filter");
    return s.id = i, Object.keys(r).forEach(i => {
      s.setAttribute(i, r[i]);
    }), s;
  }
  static createDefs() {
    return document.createElementNS(ge, "defs");
  }
  static createMarker(i, r = {}) {
    const s = document.createElementNS(ge, "marker");
    return s.setAttribute("id", i), Object.keys(r).forEach(i => {
      s.setAttribute(i, r[i]);
    }), s;
  }
  static createComponentTransfert() {
    return document.createElementNS(ge, "feComponentTransfer");
  }
  static createDropShadow({
    dx: i = 0,
    dy: r = 0,
    deviation: s = 0,
    color: n = "#3e68ff",
    opacity: a = 1
  }) {
    const l = document.createElementNS(ge, "feDropShadow");
    return l.setAttribute("dx", i.toString()), l.setAttribute("dy", r.toString()), l.setAttribute("stdDeviation", s.toString()), l.setAttribute("flood-color", n), l.setAttribute("flood-opacity", a.toString()), l;
  }
  static createTransfertFunctionTable(i, r) {
    const s = document.createElementNS(ge, i);
    return s.setAttribute("type", "table"), s.setAttribute("tableValues", r), s;
  }
  static createGroup(i = {}) {
    const r = document.createElementNS(ge, "g");
    return Object.keys(i).forEach(s => {
      r.setAttribute(s, i[s]);
    }), r;
  }
  static createLine(i, r, s = {}) {
    const n = document.createElementNS(ge, "line");
    return n.setAttribute("x1", i.x.toString()), n.setAttribute("y1", i.y.toString()), n.setAttribute("x2", r.x.toString()), n.setAttribute("y2", r.y.toString()), Object.keys(s).forEach(i => {
      n.setAttribute(i, s[i]);
    }), n;
  }
  static createCircle(i, r, s = {}) {
    const n = document.createElementNS(ge, "circle");
    return n.setAttribute("cx", i.x.toString()), n.setAttribute("cy", i.y.toString()), n.setAttribute("r", r.toString()), Object.keys(s).forEach(i => {
      n.setAttribute(i, s[i]);
    }), n;
  }
  static createPath(i = {}) {
    const r = document.createElementNS(ge, "path");
    return Object.keys(i).forEach(s => {
      r.setAttribute(s, i[s]);
    }), r;
  }
  static createPolygon(i, r = {}) {
    const s = document.createElementNS(ge, "polygon");
    return s.setAttribute("points", i.join(",")), Object.keys(r).forEach(i => {
      s.setAttribute(i, r[i]);
    }), s;
  }
  static createRect(i, r = {}) {
    const s = document.createElementNS(ge, "rect");
    return s.setAttribute("x", i.x.toString()), s.setAttribute("y", i.y.toString()), s.setAttribute("width", i.width.toString()), s.setAttribute("height", i.height.toString()), Object.keys(r).forEach(i => {
      s.setAttribute(i, r[i]);
    }), s;
  }
  static createTSpan(i, r = {}) {
    const s = document.createElementNS(ge, "tspan");
    return s.textContent = i, Object.keys(r).forEach(i => {
      s.setAttribute(i, r[i]);
    }), s;
  }
  static createForeignObject(i, r, s = {}) {
    const n = document.createElementNS(ge, "foreignObject");
    return n.setAttribute("x", i.x.toString()), n.setAttribute("y", i.y.toString()), n.setAttribute("width", i.width.toString()), n.setAttribute("height", i.height.toString()), Object.keys(s).forEach(i => {
      n.setAttribute(i, s[i]);
    }), n.appendChild(r), n;
  }
  static createText(i, r, s = {}) {
    const n = document.createElementNS(ge, "text");
    return n.textContent = r, n.setAttribute("x", i.x.toString()), n.setAttribute("y", i.y.toString()), Object.keys(s).forEach(i => {
      n.setAttribute(i, s[i]);
    }), n;
  }
}
class IISVGRendererEdgeUtil {
  static getLinePath(i) {
    return `M ${i.start.x} ${i.start.y} L ${i.end.x} ${i.end.y}`;
  }
  static getPolyLinePath(i) {
    return `M ${i.vertices[0].x} ${i.vertices[0].y} ${i.vertices.map(i => `L ${i.x} ${i.y}`).join(" ")}`;
  }
  static getArcPath(i) {
    return `M ${i.vertices[0].x} ${i.vertices[0].y} Q ${i.vertices.map(i => `${i.x} ${i.y}`).join(" ")}`;
  }
  static getSVGPath(i) {
    switch (i.kind) {
      case I.Line:
        return IISVGRendererEdgeUtil.getLinePath(i);
      case I.PolyEdge:
        return IISVGRendererEdgeUtil.getPolyLinePath(i);
      case I.Arc:
        return IISVGRendererEdgeUtil.getArcPath(i);
      default:
        throw new Error(`Can't getSVGPath for edge cause kind is unknow: "${JSON.stringify(i)}"`);
    }
  }
  static getSVGElement(i) {
    const r = {
      id: i.id,
      type: i.type,
      kind: i.kind,
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    };
    i.selected && (r.filter = `url(#${pe.selectionFilterId})`), i.deleting && (r.filter = `url(#${pe.removalFilterId})`);
    const s = SVGBuilder.createGroup(r),
      n = {
        fill: "transparent",
        stroke: i.style.color || y.color,
        "stroke-width": (i.style.width || y.width).toString(),
        d: IISVGRendererEdgeUtil.getSVGPath(i)
      };
    return i.style.opacity && (n.opacity = i.style.opacity.toString()), i.startDecoration === C.Arrow && (n["marker-start"] = `url(#${pe.arrowHeadStartMarker})`), i.endDecoration === C.Arrow && (n["marker-end"] = `url(#${pe.arrowHeadEndMaker})`), s.appendChild(SVGBuilder.createPath(n)), s;
  }
}
class IISVGRendererEraserUtil {
  static getSVGPath(i) {
    if (i.pointers.length < 1) return "";
    const r = i.pointers.at(0),
      s = `M ${r.x} ${r.y}`;
    if (1 === i.pointers.length) {
      const n = i.style.width || 4;
      return `${s} L ${r.x + n / 2} ${r.y}`;
    }
    return i.pointers.slice(1).reduce((i, r) => `${i} L ${r.x} ${r.y}`, s);
  }
  static getSVGElement(i) {
    const r = {
      id: i.id,
      type: "eraser",
      "stroke-width": "12",
      stroke: "grey",
      opacity: "0.2",
      shadowBlur: "5",
      "stroke-linecap": "round",
      fill: "transparent",
      d: IISVGRendererEraserUtil.getSVGPath(i)
    };
    return SVGBuilder.createPath(r);
  }
}
class IISVGRendererDecoratorUtil {
  static getSVGElement(i, r) {
    const s = {
      id: i.id,
      type: "decorator",
      kind: i.kind,
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    };
    let n;
    switch (i.style.opacity && (s.opacity = i.style.opacity.toString()), r.deleting && (s.opacity = (.5 * (i.style.opacity || 1)).toString()), i.kind) {
      case k.Highlight:
        {
          s.opacity = r.deleting ? "0.25" : "0.5", s.stroke = "transparent", s.fill = i.style.color || y.color;
          const a = {
            x: r.bounds.x - +(r.style.width || y.width),
            y: r.bounds.y - +(r.style.width || y.width),
            height: r.bounds.height + 2 * +(r.style.width || y.width),
            width: r.bounds.width + 2 * +(r.style.width || y.width)
          };
          n = SVGBuilder.createRect(a, s);
          break;
        }
      case k.Surround:
        {
          s.fill = "transparent", s.stroke = i.style.color || y.color, s["stroke-width"] = (i.style.width || y.width).toString();
          const a = {
            x: r.bounds.x - +(r.style.width || y.width),
            y: r.bounds.y - +(r.style.width || y.width),
            height: r.bounds.height + 2 * +(r.style.width || y.width),
            width: r.bounds.width + 2 * +(r.style.width || y.width)
          };
          n = SVGBuilder.createRect(a, s);
          break;
        }
      case k.Strikethrough:
        {
          s.fill = "transparent", s.stroke = i.style.color || y.color, s["stroke-width"] = (i.style.width || y.width).toString();
          const a = {
              x: r.bounds.xMin,
              y: r.bounds.yMid
            },
            l = {
              x: r.bounds.xMax,
              y: r.bounds.yMid
            };
          r.type === E.Recognized && r.kind === T.Text && (a.y = r.baseline - r.xHeight / 2, l.y = r.baseline - r.xHeight / 2), n = SVGBuilder.createLine(a, l, s);
          break;
        }
      case k.Underline:
        {
          s.fill = "transparent", s.stroke = i.style.color || y.color, s["stroke-width"] = (i.style.width || y.width).toString();
          const a = {
              x: r.bounds.xMin,
              y: r.bounds.yMax + +(r.style.width || y.width)
            },
            l = {
              x: r.bounds.xMax,
              y: r.bounds.yMax + +(r.style.width || y.width)
            };
          r.type === E.Recognized && r.kind === T.Text && (a.y = r.baseline + r.xHeight / 2, l.y = r.baseline + r.xHeight / 2), n = SVGBuilder.createLine(a, l, s);
          break;
        }
    }
    return n;
  }
}
class IISVGRendererShapeUtil {
  static getPolygonePath(i) {
    return `M ${i.points[0].x} ${i.points[0].y} ${i.points.slice(1).map(i => `L ${i.x} ${i.y}`).join(" ")} Z`;
  }
  static getCirclePath(i) {
    return `M ${i.center.x - i.radius} ${i.center.y} a ${i.radius} ${i.radius} 0 1 1 ${2 * i.radius} 0 a ${i.radius} ${i.radius} 0 1 1 -${2 * i.radius} 0 Z`;
  }
  static getEllipsePath(i) {
    return `M ${i.center.x - i.radiusX} ${i.center.y} a ${i.radiusX} ${i.radiusY} 0 1 1 ${2 * i.radiusX} 0 a ${i.radiusX} ${i.radiusY} 0 1 1 -${2 * i.radiusX} 0 Z`;
  }
  static getSVGPath(i) {
    switch (i.kind) {
      case M.Polygon:
        return IISVGRendererShapeUtil.getPolygonePath(i);
      case M.Circle:
        return IISVGRendererShapeUtil.getCirclePath(i);
      case M.Ellipse:
        return IISVGRendererShapeUtil.getEllipsePath(i);
      default:
        throw new Error(`Can't getSVGPath for shape cause kind is unknow: "${JSON.stringify(i)}"`);
    }
  }
  static getSVGElement(i) {
    const r = {
      id: i.id,
      type: i.type,
      kind: i.kind,
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    };
    i.selected && (r.filter = `url(#${pe.selectionFilterId})`), i.deleting && (r.filter = `url(#${pe.removalFilterId})`);
    const s = SVGBuilder.createGroup(r),
      n = {
        fill: i.style.fill || "transparent",
        stroke: i.style.color || y.color,
        "stroke-width": (i.style.width || y.width).toString(),
        d: IISVGRendererShapeUtil.getSVGPath(i)
      };
    return i.style.opacity && (n.opacity = i.style.opacity.toString()), i.kind === M.Ellipse && (n.transform = `rotate(${convertRadianToDegree(i.orientation)}, ${i.center.x}, ${i.center.y})`), s.appendChild(SVGBuilder.createPath(n)), s;
  }
}
class IISVGRendererStrokeUtil {
  static getArcPath(i, r) {
    return [`M ${i.x} ${i.y}`, `m ${-r} 0`, `a ${r} ${r} 0 1 0 ${2 * r} 0`, `a ${r} ${r} 0 1 0 ${-2 * r} 0`].join(" ");
  }
  static getLinePath(i, r, s) {
    const n = computeLinksPointers(i, computeAngleAxeRadian(i, r), s),
      a = computeLinksPointers(r, computeAngleAxeRadian(i, r), s);
    return [`M ${n[0].x} ${n[0].y}`, `L ${a[0].x} ${a[0].y}`, `L ${a[1].x} ${a[1].y}`, `L ${n[1].x} ${n[1].y}`].join(" ");
  }
  static getFinalPath(i, r, s) {
    const n = computeAngleAxeRadian(i, r),
      a = computeLinksPointers(r, n, s),
      l = [`M ${a[0].x} ${a[0].y}`];
    for (let i = 1; i <= 6; i++) {
      const a = n - i * (Math.PI / 6),
        d = +(r.x - r.p * s * Math.sin(a)).toFixed(3),
        h = +(r.y + r.p * s * Math.cos(a)).toFixed(3);
      l.push(`L ${d} ${h}`);
    }
    return l.join(" ");
  }
  static getQuadraticPath(i, r, s, n) {
    const a = computeLinksPointers(i, computeAngleAxeRadian(i, s), n),
      l = computeLinksPointers(r, computeAngleAxeRadian(s, r), n),
      d = computeLinksPointers(s, computeAngleAxeRadian(i, r), n);
    return [`M ${a[0].x} ${a[0].y}`, `Q ${d[0].x} ${d[0].y} ${l[0].x} ${l[0].y}`, `L ${l[1].x} ${l[1].y}`, `Q ${d[1].x} ${d[1].y} ${a[1].x} ${a[1].y}`].join(" ");
  }
  static getSVGPath(i) {
    const r = i.pointers.length;
    if (!r) return "";
    const s = i.style.width,
      n = r - 2,
      a = i.pointers[0],
      l = [];
    if (r < 3) l.push(this.getArcPath(a, .6 * s));else {
      l.push(this.getArcPath(a, s * a.p)), l.push(this.getLinePath(a, computeMiddlePointer(a, i.pointers[1]), s));
      for (let r = 0; r < n; r++) {
        const n = computeMiddlePointer(i.pointers[r], i.pointers[r + 1]),
          a = computeMiddlePointer(i.pointers[r + 1], i.pointers[r + 2]),
          d = i.pointers[r + 1];
        l.push(this.getQuadraticPath(n, a, d, s));
      }
      const d = i.pointers[r - 2],
        h = i.pointers[r - 1];
      l.push(this.getLinePath(computeMiddlePointer(d, h), h, s)), l.push(this.getFinalPath(d, h, s));
    }
    return l.join(" ");
  }
  static getSVGElement(i) {
    const r = {
      id: i.id,
      type: "stroke",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    };
    i.selected && (r.filter = `url(#${pe.selectionFilterId})`), i.deleting && (r.filter = `url(#${pe.removalFilterId})`);
    const s = SVGBuilder.createGroup(r),
      n = {
        fill: i.style.color || y.color,
        "stroke-width": i.style.width.toString(),
        d: IISVGRendererStrokeUtil.getSVGPath(i)
      };
    return i.style.opacity && (n.opacity = i.style.opacity.toString()), s.append(SVGBuilder.createPath(n)), i.decorators.forEach(r => {
      const n = IISVGRendererDecoratorUtil.getSVGElement(r, i);
      n && (r.kind === k.Highlight ? s.prepend(n) : s.append(n));
    }), s;
  }
}
class IISVGRendererTextUtil {
  static getSVGElement(i) {
    const r = {
      id: i.id,
      type: i.type,
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      style: pe.noSelection
    };
    i.style.opacity && (r.opacity = i.style.opacity.toString()), i.rotation && (r.transform = `rotate(${i.rotation.degree}, ${i.rotation.center.x}, ${i.rotation.center.y})`), i.selected && (r.filter = `url(#${pe.selectionFilterId})`), i.deleting && (r.filter = `url(#${pe.removalFilterId})`);
    const s = SVGBuilder.createGroup(r),
      n = SVGBuilder.createText(i.point, "");
    return i.chars.forEach(i => {
      const r = {
        id: i.id,
        fill: i.color,
        "font-size": `${i.fontSize}px`,
        "font-weight": i.fontWeight.toString()
      };
      n.appendChild(SVGBuilder.createTSpan(i.label, r));
    }), s.append(n), i.decorators.forEach(r => {
      const n = IISVGRendererDecoratorUtil.getSVGElement(r, i);
      n && (r.kind === k.Highlight ? s.prepend(n) : s.append(n));
    }), s;
  }
}
class IISVGRendererRecognizedUtil {
  static getSVGElement(i) {
    const r = {
      id: i.id,
      type: i.type,
      kind: i.kind,
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      fill: i.style.color || y.color,
      "stroke-width": (i.style.width || y.width).toString()
    };
    i.style.opacity && (r.opacity = i.style.opacity.toString()), i.selected && (r.filter = `url(#${pe.selectionFilterId})`), i.deleting && (r.filter = `url(#${pe.removalFilterId})`);
    const s = SVGBuilder.createGroup(r);
    return i.strokes.forEach(i => {
      s.append(IISVGRendererStrokeUtil.getSVGElement(i));
    }), i.kind === T.Text && i.decorators.forEach(r => {
      const n = IISVGRendererDecoratorUtil.getSVGElement(r, i);
      n && (r.kind === k.Highlight ? s.prepend(n) : s.append(n));
    }), s;
  }
}
class IISVGRendererGroupUtil {
  static getChildElement(i) {
    let r;
    switch (i.type) {
      case E.Stroke:
        r = IISVGRendererStrokeUtil.getSVGElement(i);
        break;
      case E.Shape:
        r = IISVGRendererShapeUtil.getSVGElement(i);
        break;
      case E.Edge:
        r = IISVGRendererEdgeUtil.getSVGElement(i);
        break;
      case E.Text:
        r = IISVGRendererTextUtil.getSVGElement(i);
        break;
      case E.Group:
        r = IISVGRendererGroupUtil.getSVGElement(i);
        break;
      case E.Recognized:
        r = IISVGRendererRecognizedUtil.getSVGElement(i);
    }
    return r;
  }
  static getSVGElement(i) {
    const r = {
      id: i.id,
      type: "group",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      fill: i.style.color || y.color,
      "stroke-width": (i.style.width || y.width).toString()
    };
    i.style.opacity && (r.opacity = i.style.opacity.toString()), i.selected && (r.filter = `url(#${pe.selectionFilterId})`), i.deleting && (r.filter = `url(#${pe.removalFilterId})`);
    const s = SVGBuilder.createGroup(r);
    return i.children.forEach(i => {
      s.append(IISVGRendererGroupUtil.getChildElement(i));
    }), i.decorators.forEach(r => {
      const n = IISVGRendererDecoratorUtil.getSVGElement(r, i);
      n && (r.kind === k.Highlight ? s.prepend(n) : s.append(n));
    }), s;
  }
}
class IISVGRenderer {
  #t = LoggerManager.getLogger(d.RENDERER);
  groupGuidesId = "guides-wrapper";
  configuration;
  parent;
  layer;
  definitionGroup;
  verticalGuides = [];
  horizontalGuides = [];
  constructor(i) {
    this.#t.info("constructor", {
      configuration: i
    }), this.configuration = i;
  }
  initLayer() {
    const i = Math.max(this.configuration.minWidth, this.parent.clientWidth),
      r = Math.max(this.configuration.minHeight, this.parent.clientHeight);
    this.layer = SVGBuilder.createLayer({
      x: 0,
      y: 0,
      width: i,
      height: r
    }), this.layer.style.setProperty("height", "auto"), this.layer.style.setProperty("width", "auto"), this.layer.appendChild(this.createSVGTools()), this.parent.style.setProperty("overflow", "auto"), this.parent.appendChild(this.layer);
  }
  createDefs() {
    const i = SVGBuilder.createDefs(),
      r = 4,
      s = 2.5,
      n = {
        style: pe.noSelection,
        fill: "context-stroke",
        markerWidth: 5..toString(),
        markerHeight: 5..toString(),
        refX: r.toString(),
        refY: s.toString()
      },
      a = SVGBuilder.createMarker(pe.arrowHeadStartMarker, {
        ...n,
        orient: "auto-start-reverse"
      });
    a.appendChild(SVGBuilder.createPolygon([0, 0, 5, s, 0, 5], n)), i.appendChild(a);
    const l = SVGBuilder.createMarker(pe.arrowHeadEndMaker, {
      ...n,
      orient: "auto"
    });
    l.appendChild(SVGBuilder.createPolygon([0, 0, 5, s, 0, 5], n)), i.appendChild(l);
    const d = {
        style: pe.noSelection,
        markerWidth: "5",
        markerHeight: "5",
        refX: "0",
        refY: "0",
        viewBox: "-5 -5 10 10"
      },
      h = SVGBuilder.createMarker(pe.crossMarker, d);
    return h.appendChild(SVGBuilder.createPath({
      d: "M -4,-4 L 4,4 M -4,4 L 4,-4",
      stroke: "white",
      "stroke-width": "3"
    })), h.appendChild(SVGBuilder.createPath({
      d: "M -4,-4 L 4,4 M -4,4 L 4,-4",
      stroke: "context-stroke",
      "stroke-width": "2"
    })), i.appendChild(h), i;
  }
  createFilters() {
    const i = SVGBuilder.createGroup({
        id: "definition-group"
      }),
      r = SVGBuilder.createFilter(pe.removalFilterId, {
        filterUnits: "userSpaceOnUse"
      }),
      s = SVGBuilder.createComponentTransfert(),
      n = SVGBuilder.createTransfertFunctionTable("feFuncA", "0 0.25");
    s.appendChild(n), r.appendChild(s), i.appendChild(r);
    const a = SVGBuilder.createFilter(pe.selectionFilterId, {
      filterUnits: "userSpaceOnUse"
    });
    return a.appendChild(SVGBuilder.createDropShadow({
      dx: -1,
      dy: -1,
      deviation: 1
    })), i.appendChild(a), i;
  }
  drawGuides() {
    this.verticalGuides = [], this.horizontalGuides = [];
    const i = Number(this.layer.getAttribute("height")?.replace("px", "")),
      r = Number(this.layer.getAttribute("width")?.replace("px", "")),
      n = this.configuration.guides.gap,
      a = this.configuration.guides.gap / 5,
      l = {
        id: this.groupGuidesId,
        stroke: "grey",
        opacity: "0.5",
        style: pe.noSelection,
        role: s.Guide
      },
      d = SVGBuilder.createGroup(l);
    switch (this.configuration.guides.type) {
      case "line":
        for (let s = n; s < i; s += n) {
          const i = {
              x: n,
              y: s
            },
            a = {
              x: r - n,
              y: s
            };
          this.horizontalGuides.push(s);
          const l = SVGBuilder.createLine(i, a, {
            "stroke-width": "1",
            style: pe.noSelection
          });
          d.appendChild(l);
        }
        break;
      case "grid":
        for (let s = 0; s < i; s += n) {
          const i = {
              x: 0,
              y: s
            },
            l = {
              x: r,
              y: s
            },
            h = SVGBuilder.createLine(i, l, {
              "stroke-width": "1",
              style: pe.noSelection
            });
          d.appendChild(h), this.horizontalGuides.push(s);
          for (let i = s + a; i < s + n; i += a) {
            this.horizontalGuides.push(i);
            const s = SVGBuilder.createLine({
              x: 0,
              y: i
            }, {
              x: r,
              y: i
            }, {
              "stroke-width": "0.25",
              style: pe.noSelection
            });
            d.appendChild(s);
          }
        }
        for (let s = 0; s < r; s += n) {
          const r = {
              x: s,
              y: 0
            },
            l = {
              x: s,
              y: i
            },
            h = SVGBuilder.createLine(r, l, {
              "stroke-width": "1",
              style: pe.noSelection
            });
          d.appendChild(h), this.verticalGuides.push(s);
          for (let r = s + a; r < s + n; r += a) {
            this.verticalGuides.push(r);
            const s = SVGBuilder.createLine({
              x: r,
              y: 0
            }, {
              x: r,
              y: i
            }, {
              "stroke-width": "0.25",
              style: pe.noSelection
            });
            d.appendChild(s);
          }
        }
        break;
      case "point":
        for (let s = n; s < r; s += n) {
          this.verticalGuides.push(s);
          for (let r = n; r < i; r += n) {
            this.horizontalGuides.push(r);
            const i = SVGBuilder.createCircle({
              x: s,
              y: r
            }, 1);
            d.appendChild(i);
          }
        }
        break;
      default:
        this.#t.error("drawGuides", `Guide type unknow: ${this.configuration.guides.type}`);
    }
    this.horizontalGuides = [...new Set(this.horizontalGuides)], this.verticalGuides = [...new Set(this.verticalGuides)], this.definitionGroup.appendChild(d);
  }
  removeGuides() {
    this.verticalGuides = [], this.horizontalGuides = [], this.layer.querySelector(`#${this.groupGuidesId}`)?.remove();
  }
  createSVGTools() {
    return this.definitionGroup = SVGBuilder.createGroup({
      id: "definition-group"
    }), this.definitionGroup.appendChild(this.createDefs()), this.definitionGroup.appendChild(this.createFilters()), this.configuration.guides.enable && this.drawGuides(), this.definitionGroup;
  }
  init(i) {
    this.#t.info("init", {
      element: i
    }), this.parent = i, this.parent.oncontextmenu = () => !1, this.initLayer();
  }
  getAttribute(i, r) {
    const s = this.layer.querySelector(`#${i}`);
    return s?.getAttribute(r);
  }
  setAttribute(i, r, s) {
    const n = this.layer.querySelector(`#${i}`);
    n?.setAttribute(r, s);
  }
  buildElementFromSymbol(i) {
    let r;
    switch (i.type) {
      case E.Stroke:
        r = IISVGRendererStrokeUtil.getSVGElement(i);
        break;
      case E.Eraser:
        r = IISVGRendererEraserUtil.getSVGElement(i);
        break;
      case E.Shape:
        r = IISVGRendererShapeUtil.getSVGElement(i);
        break;
      case E.Edge:
        r = IISVGRendererEdgeUtil.getSVGElement(i);
        break;
      case E.Text:
        r = IISVGRendererTextUtil.getSVGElement(i);
        break;
      case E.Group:
        r = IISVGRendererGroupUtil.getSVGElement(i);
        break;
      case E.Recognized:
        r = IISVGRendererRecognizedUtil.getSVGElement(i);
        break;
      default:
        this.#t.error("buildElementFromSymbol", `symbol unknow: "${JSON.stringify(i)}"`);
    }
    return r;
  }
  prependElement(i) {
    this.layer.prepend(i);
  }
  changeOrderSymbol(i, r) {
    const s = this.layer.querySelector(`#${i.id}`);
    if (s) switch (r) {
      case "first":
        this.definitionGroup.insertAdjacentElement("afterend", s);
        break;
      case "last":
        this.layer.insertAdjacentElement("beforeend", s);
        break;
      case "forward":
        s.nextElementSibling?.insertAdjacentElement("afterend", s);
        break;
      case "backward":
        s.previousElementSibling !== this.definitionGroup && s.previousElementSibling?.insertAdjacentElement("beforebegin", s);
    }
  }
  appendElement(i) {
    this.layer.appendChild(i);
  }
  removeElement(i) {
    this.#t.debug("Element", {
      id: i
    });
    const r = this.layer.querySelector(`#${i}`);
    r && r.remove();
  }
  drawSymbol(i) {
    this.#t.debug("drawSymbol", {
      symbol: i
    });
    const r = this.layer.querySelector(`#${i?.id}`),
      s = this.buildElementFromSymbol(i);
    return s && (r ? r.replaceWith(s) : this.layer.appendChild(s)), s;
  }
  replaceSymbol(i, r) {
    this.#t.debug("drawSymbol", {
      symbols: r
    });
    const s = this.layer.querySelector(`#${i}`),
      n = r.map(i => this.buildElementFromSymbol(i)).filter(i => !!i);
    return n.length && (s ? (n.forEach(i => s.insertAdjacentElement("beforebegin", i)), s.remove()) : n.forEach(i => this.layer.appendChild(i))), n;
  }
  removeSymbol(i) {
    this.#t.debug("removeSymbol", {
      id: i
    }), this.removeElement(i);
  }
  drawCircle(i, r, s = {}) {
    this.#t.info("drawCircle", {
      point: i,
      radius: r,
      attrs: s
    }), this.layer.appendChild(SVGBuilder.createCircle(i, r, s));
  }
  drawRect(i, r = {}) {
    this.#t.info("drawCircle", {
      box: i,
      attrs: r
    }), this.layer.appendChild(SVGBuilder.createRect(i, r));
  }
  drawLine(i, r, s = {}) {
    this.#t.info("drawLine", {
      p1: i,
      p2: r,
      attrs: s
    }), this.layer.appendChild(SVGBuilder.createLine(i, r, s));
  }
  drawConnectionBetweenBox(i, r, s, n) {
    const a = new Box(r).corners,
      l = new Box(s).corners,
      {
        p1: d,
        p2: h
      } = getClosestPoints(a, l),
      c = {
        id: i,
        fill: "transparent",
        style: pe.noSelection,
        ...n
      };
    this.drawLine(d, h, c);
  }
  resize(i, r) {
    this.#t.info("resize", {
      height: i,
      width: r
    }), this.layer.setAttribute("width", `${r}px`), this.layer.setAttribute("height", `${i}px`), this.layer.setAttribute("viewBox", `0, 0, ${r}, ${i}`), this.removeGuides(), this.configuration.guides.enable && this.drawGuides();
  }
  getElementById(i) {
    return this.layer.querySelector(`#${i}`);
  }
  getElements({
    tagName: i,
    attrs: r
  }) {
    this.#t.info("getElements", {
      tagName: i,
      attrs: r
    });
    let s = i || "*";
    return r && Object.keys(r).forEach(i => {
      s += `[${i}=${r[i]}]`;
    }), this.layer.querySelectorAll(s);
  }
  clearElements({
    tagName: i,
    attrs: r
  }) {
    this.#t.info("clearElements", {
      tagName: i,
      attrs: r
    }), this.getElements({
      tagName: i,
      attrs: r
    }).forEach(i => i.remove());
  }
  clear() {
    if (this.#t.info("clear"), this.layer) {
      for (; this.layer.firstChild;) this.layer.firstChild.remove();
      this.layer.appendChild(this.createSVGTools());
    }
  }
  destroy() {
    this.layer && this.layer.remove();
  }
}
class SVGStroker {
  getArcPath(i, r) {
    return [`M ${i.x},${i.y}`, `m ${-r},0`, `a ${r},${r} 0 1 0 ${2 * r},0`, `a ${r},${r} 0 1 0 ${-2 * r},0`].join(" ");
  }
  getLinePath(i, r, s) {
    const n = computeLinksPointers(i, computeAngleAxeRadian(i, r), s),
      a = computeLinksPointers(r, computeAngleAxeRadian(i, r), s);
    return [`M ${n[0].x},${n[0].y}`, `L ${a[0].x},${a[0].y}`, `L ${a[1].x},${a[1].y}`, `L ${n[1].x},${n[1].y}`].join(" ");
  }
  getFinalPath(i, r, s) {
    const n = computeAngleAxeRadian(i, r),
      a = computeLinksPointers(r, n, s),
      l = [`M ${a[0].x},${a[0].y}`];
    for (let i = 1; i <= 6; i++) {
      const a = n - i * (Math.PI / 6);
      l.push(`L ${r.x - r.p * s * Math.sin(a)},${r.y + r.p * s * Math.cos(a)}`);
    }
    return l.join(" ");
  }
  getQuadraticPath(i, r, s, n) {
    const a = computeLinksPointers(i, computeAngleAxeRadian(i, s), n),
      l = computeLinksPointers(r, computeAngleAxeRadian(s, r), n),
      d = computeLinksPointers(s, computeAngleAxeRadian(i, r), n);
    return [`M ${a[0].x},${a[0].y}`, `Q ${d[0].x},${d[0].y} ${l[0].x},${l[0].y}`, `L ${l[1].x},${l[1].y}`, `Q ${d[1].x},${d[1].y} ${a[1].x},${a[1].y}`].join(" ");
  }
  buildSVGPath(i) {
    const r = i.pointers.length,
      s = i.style.width,
      n = r - 2,
      a = i.pointers[0],
      l = [];
    if (r < 3) l.push(this.getArcPath(a, .6 * s));else {
      l.push(this.getArcPath(a, s * a.p)), l.push(this.getLinePath(a, computeMiddlePointer(a, i.pointers[1]), s));
      for (let r = 0; r < n; r++) {
        const n = computeMiddlePointer(i.pointers[r], i.pointers[r + 1]),
          a = computeMiddlePointer(i.pointers[r + 1], i.pointers[r + 2]),
          d = i.pointers[r + 1];
        l.push(this.getQuadraticPath(n, a, d, s));
      }
      const d = i.pointers[r - 2],
        h = i.pointers[r - 1];
      l.push(this.getLinePath(computeMiddlePointer(d, h), h, s)), l.push(this.getFinalPath(d, h, s));
    }
    return l.join(" ");
  }
  drawStroke(i, r, s) {
    const n = document.createElementNS("http://www.w3.org/2000/svg", "path");
    n.classList.add("pending-stroke"), n.setAttribute("id", r.id), n.setAttribute("type", r.pointerType), s?.forEach(i => {
      n.setAttribute(i.name, i.value);
    });
    const a = this.buildSVGPath(r);
    n.setAttribute("d", `${a}Z`), i.appendChild(n);
  }
}
class InteractiveInkSSRSVGRenderer {
  #t = LoggerManager.getLogger(d.RENDERER);
  config;
  stroker;
  context;
  constructor(i) {
    this.#t.info("constructor", {
      config: i
    }), this.config = i, this.stroker = new SVGStroker();
  }
  init(i) {
    this.#t.info("init", {
      element: i
    }), i.style.fontSize = "10px", this.context = {
      parent: i
    };
  }
  drawStroke(i, r) {
    let s;
    "eraser" === r.pointerType ? (r.style.width = 12, s = "fill:grey;stroke:transparent;shadowBlur:5;opacity:0.2;") : s = `fill:${r.style.color};stroke:transparent;`, this.stroker.drawStroke(i, r, [{
      name: "style",
      value: s
    }]);
  }
  replaceAll(i, r) {
    const s = this.context.parent.querySelector(`svg[data-layer="${i}"]`);
    s?.remove(), this.context.parent.insertAdjacentHTML("beforeend", r.svg);
    const n = this.context.parent.querySelector(`svg[data-layer="${i}"]`);
    if ("MODEL" === i) {
      const i = document.createElementNS("http://www.w3.org/2000/svg", "g");
      i.id = "pendingStrokes", n.appendChild(i);
    }
  }
  replaceElement(i) {
    const r = this.context.parent.querySelector(`#${i.id}`);
    if (r) {
      const s = r.parentNode;
      r?.remove(), s?.insertAdjacentHTML("beforeend", i.svg);
    }
  }
  appendChild(i, r) {
    const s = r.parentId ? `#${r.parentId}` : `svg[data-layer="${i}"]`,
      n = this.context.parent.querySelector(s);
    n?.insertAdjacentHTML("beforeend", r.svg);
  }
  removeChild(i) {
    this.context.parent.querySelector(`#${i.parentId} > *:nth-child(${i.index + 1})`)?.remove();
  }
  removeElement(i) {
    const r = this.context.parent.querySelector(`#${i.id}`);
    r && (i.id.includes("s") || i.id.includes("MODEL") ? r.remove() : (r.setAttribute("class", "removed-stroke"), setTimeout(() => {
      r?.remove();
    }, 100)));
  }
  insertBefore(i) {
    const r = this.context.parent.querySelector(`#${i.refId}`);
    r?.insertAdjacentHTML("beforebegin", i.svg);
  }
  setAttribute(i) {
    const r = i.id ? `#${i.id}` : "svg",
      s = this.context.parent.querySelector(r);
    s?.setAttribute(i.name, i.value);
  }
  removeAttribute(i) {
    const r = i.id ? `#${i.id}` : "svg",
      s = this.context.parent.querySelector(r);
    s?.removeAttribute(i.name);
  }
  updateLayer(i, r) {
    switch (this.#t.info("updateLayer", {
      layerName: i,
      update: r
    }), r.type) {
      case "REPLACE_ALL":
        this.replaceAll(i, r);
        break;
      case "REPLACE_ELEMENT":
        this.replaceElement(r);
        break;
      case "APPEND_CHILD":
        this.appendChild(i, r);
        break;
      case "REMOVE_ELEMENT":
        this.removeElement(r);
        break;
      case "REMOVE_CHILD":
        this.removeChild(r);
        break;
      case "INSERT_BEFORE":
        this.insertBefore(r);
        break;
      case "SET_ATTRIBUTE":
        this.setAttribute(r);
        break;
      case "REMOVE_ATTRIBUTE":
        this.removeAttribute(r);
        break;
      default:
        this.#t.warn("updateLayer", `update.type unknow ${r.type}`);
    }
  }
  updatesLayer(i, r) {
    this.#t.info("updatesLayer", {
      layerName: i,
      updates: r
    }), r.forEach(r => this.updateLayer(i, r)), this.clearPendingStroke();
  }
  clearPendingStroke() {
    this.#t.info("clearPendingStroke");
    const i = this.context.parent.querySelector("#pendingStrokes");
    i && (i.innerHTML = "");
  }
  drawPendingStroke(i) {
    if (this.#t.info("drawPendingStroke", {
      stroke: i
    }), i) {
      const r = this.context.parent.querySelector("#pendingStrokes");
      if (r) {
        const s = r.querySelector(`#${i?.id}`);
        s && s.remove(), this.drawStroke(r, i);
      }
    }
  }
  clearErasingStrokes() {
    this.context.parent.querySelectorAll("[type=eraser]").forEach(i => {
      i.remove();
    });
  }
  resize(i) {
    this.#t.info("resize", {
      model: i
    });
    const r = this.context.parent.getBoundingClientRect(),
      s = this.context.parent.querySelectorAll("svg"),
      n = Math.max(r.width, i.width),
      a = Math.max(r.height, i.height);
    s.forEach(i => {
      i.setAttribute("viewBox", `0 0 ${n}, ${a}`), i.setAttribute("width", `${n}px`), i.setAttribute("height", `${a}px`);
    });
  }
  destroy() {
    this.#t.info("destroy", {
      context: this.context
    }), this.context?.parent && this.context.parent.querySelectorAll("svg").forEach(i => i.remove());
  }
}
const me = {
    enable: !0,
    gap: 50
  },
  ye = {
    guides: me,
    minHeight: 100,
    minWidth: 100
  },
  be = {
    guides: {
      enable: !0,
      gap: 50,
      type: "point"
    },
    minHeight: 100,
    minWidth: 100
  };
class IIConversionManager {
  #t = LoggerManager.getLogger(d.CONVERTER);
  editor;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i;
  }
  get configuration() {
    return this.editor.configuration.fontStyle;
  }
  get model() {
    return this.editor.model;
  }
  get rowHeight() {
    return this.editor.configuration.rendering.guides.gap;
  }
  computeFontSize(i) {
    if (i.some(i => i["bounding-box"])) {
      const r = convertMillimeterToPixel(computeAverage(i.map(i => i["bounding-box"]?.height || 1)));
      return 2 * Math.round(Math.round(r * this.rowHeight) / this.rowHeight / 2);
    }
    return Math.round(this.rowHeight / 2);
  }
  buildChar(i, r, s) {
    const n = i.grid.map(i => ({
      x: convertMillimeterToPixel(i.x),
      y: convertMillimeterToPixel(i.y)
    }));
    let a = this.configuration.weight;
    "auto" === a && (a = (r[0].style.width || 1) > 2 ? "bold" : "normal");
    const l = r[0].style.color || "black";
    return {
      id: `text-char-${createUUID()}`,
      label: i.label,
      color: l,
      fontSize: s,
      fontWeight: a,
      bounds: Box.createFromPoints(n)
    };
  }
  buildText(i, r, s, n) {
    const a = Box.createFromBoxes([convertBoundingBoxMillimeterToPixel(i["bounding-box"])]),
      l = [],
      d = "auto" === n ? this.computeFontSize(r) : n;
    r.forEach(i => {
      const r = s.filter(r => i.items?.some(i => i["full-id"] === r.id));
      r.length && l.push(this.buildChar(i, r, d));
    });
    const h = {
        x: a.xMin,
        y: a.yMax
      },
      c = new IIText(l, h, a, s[0].style),
      u = s.flatMap(i => i.decorators);
    if (s.forEach(i => {
      const r = this.model.getRootSymbol(i.id);
      if (r?.type === E.Recognized && r.kind === T.Text || r?.type === E.Group) {
        const i = r.decorators.find(i => i.kind === k.Highlight);
        i && u.push(i);
        const s = r.decorators.find(i => i.kind === k.Strikethrough);
        s && u.push(s);
        const n = r.decorators.find(i => i.kind === k.Surround);
        n && u.push(n);
        const a = r.decorators.find(i => i.kind === k.Underline);
        a && u.push(a);
      }
    }), u.length) {
      const i = u.find(i => i.kind === k.Highlight);
      i && c.decorators.push(new IIDecorator(k.Highlight, i.style));
      const r = u.find(i => i.kind === k.Strikethrough);
      r && c.decorators.push(new IIDecorator(k.Strikethrough, r.style));
      const s = u.find(i => i.kind === k.Surround);
      s && c.decorators.push(new IIDecorator(k.Surround, s.style));
      const n = u.find(i => i.kind === k.Underline);
      n && c.decorators.push(new IIDecorator(k.Underline, n.style));
    }
    return c;
  }
  convertText(i, r, s) {
    if (!i.lines) throw new Error("You need to active configuration.recognition.export.jiix.text.lines = true");
    if (!i.words) throw new Error("You need to active configuration.recognition.export.jiix.text.words = true");
    if (!i.chars) throw new Error("You need to active configuration.recognition.export.jiix.text.chars = true");
    if (!i.chars.some(i => i.items)) throw new Error("You need to active configuration.recognition.export.jiix.strokes = true");
    const n = i.words,
      a = i.chars,
      l = [];
    let d = this.configuration.size;
    s && "auto" === d ? d = 2 * Math.round(this.computeFontSize(a.filter(i => i.items?.length)) / 2) : "auto" !== this.configuration.size && (d = this.configuration.size * this.rowHeight);
    let h = !1,
      c = convertMillimeterToPixel(i.lines[0]["baseline-y"]);
    const u = convertMillimeterToPixel(i["bounding-box"]?.x || 0);
    let p = convertMillimeterToPixel(n[0]["bounding-box"]?.x || 0);
    return n.forEach(i => {
      if (" " === i.label) return void (p += this.editor.texter.getSpaceWidth(l.at(-1)?.symbol.chars[0].fontSize || this.rowHeight / 2));
      const n = r.filter(r => i.items?.some(i => i["full-id"] === r.id));
      if (n.length) {
        const r = a.slice(i["first-char"], (i["last-char"] || 0) + 1),
          g = this.buildText(i, r, n, d);
        if (s) {
          if (h) {
            h = !1;
            const i = Math.round((g.point.y - c) / this.rowHeight) || 1;
            c += i * this.rowHeight, p = Math.abs(g.point.x - u) < this.rowHeight ? u : g.point.x;
          }
          g.point.x = p, g.point.y = this.model.roundToLineGuide(c);
        }
        this.editor.texter.setBounds(g), p += g.bounds.width, l.push({
          symbol: g,
          strokes: n
        });
      }
      h = "\n" === i.label;
    }), l;
  }
  buildCircle(i, r) {
    const s = {
      x: convertMillimeterToPixel(i.cx),
      y: convertMillimeterToPixel(i.cy)
    };
    return new IIShapeCircle(s, convertMillimeterToPixel(i.r), r[0]?.style);
  }
  buildEllipse(i, r) {
    const s = {
      x: convertMillimeterToPixel(i.cx),
      y: convertMillimeterToPixel(i.cy)
    };
    return new IIShapeEllipse(s, convertMillimeterToPixel(i.rx), convertMillimeterToPixel(i.ry), i.orientation, r[0]?.style);
  }
  buildRectangle(i, r) {
    const s = convertMillimeterToPixel(i.height),
      n = convertMillimeterToPixel(i.width),
      a = convertMillimeterToPixel(i.x),
      l = convertMillimeterToPixel(i.y);
    return new IIShapePolygon([{
      x: a,
      y: l
    }, {
      x: a + n,
      y: l
    }, {
      x: a + n,
      y: l + s
    }, {
      x: a,
      y: l + s
    }], r[0]?.style);
  }
  buildPolygon(i, r) {
    const s = [];
    for (let r = 0; r < i.points.length; r += 2) s.push({
      x: convertMillimeterToPixel(i.points[r]),
      y: convertMillimeterToPixel(i.points[r + 1])
    });
    return new IIShapePolygon(s, r[0]?.style);
  }
  buildRhombus(i, r) {
    const s = [];
    for (let r = 0; r < i.points.length; r += 2) s.push({
      x: convertMillimeterToPixel(i.points[r]),
      y: convertMillimeterToPixel(i.points[r + 1])
    });
    return new IIShapePolygon(s, r[0]?.style);
  }
  buildTriangle(i, r) {
    const s = [];
    for (let r = 0; r < i.points.length; r += 2) s.push({
      x: convertMillimeterToPixel(i.points[r]),
      y: convertMillimeterToPixel(i.points[r + 1])
    });
    return new IIShapePolygon(s, r[0]?.style);
  }
  buildParallelogram(i, r) {
    const s = [];
    for (let r = 0; r < i.points.length; r += 2) s.push({
      x: convertMillimeterToPixel(i.points[r]),
      y: convertMillimeterToPixel(i.points[r + 1])
    });
    return new IIShapePolygon(s, r[0]?.style);
  }
  convertNode(i, r) {
    const s = r.filter(r => i.items?.some(i => i["full-id"] === r.id));
    if (!s.length) return;
    const n = s.filter((i, r) => s.findIndex(r => i.id === r.id) === r);
    let a;
    switch (i.kind) {
      case g.Circle:
        a = this.buildCircle(i, n);
        break;
      case g.Ellipse:
        a = this.buildEllipse(i, n);
        break;
      case g.Rectangle:
        a = this.buildRectangle(i, n);
        break;
      case g.Triangle:
        a = this.buildTriangle(i, n);
        break;
      case g.Parallelogram:
        a = this.buildParallelogram(i, n);
        break;
      case g.Polygon:
        a = this.buildPolygon(i, n);
        break;
      case g.Rhombus:
        a = this.buildRhombus(i, n);
        break;
      default:
        return void this.#t.warn("convertNode", `Conversion of Node with kind equal to ${JSON.stringify(i)} is unknow`);
    }
    return {
      symbol: a,
      strokes: n
    };
  }
  buildLine(i, r) {
    const s = {
        x: convertMillimeterToPixel(i.x1),
        y: convertMillimeterToPixel(i.y1)
      },
      n = {
        x: convertMillimeterToPixel(i.x2),
        y: convertMillimeterToPixel(i.y2)
      },
      a = computeAngleAxeRadian(s, n);
    return Math.abs(a % Math.PI) < .1 ? (s.y = +((s.y + n.y) / 2).toFixed(3), n.y = s.y) : Math.abs(a % (Math.PI / 2)) < .1 && (s.x = +((s.x + n.x) / 2).toFixed(3), n.x = s.x), new IIEdgeLine(s, n, i.p1Decoration, i.p2Decoration, r[0]?.style);
  }
  buildPolyEdge(i, r) {
    const s = {
        x: convertMillimeterToPixel(i.edges[0].x1),
        y: convertMillimeterToPixel(i.edges[0].y1)
      },
      n = i.edges.map(i => ({
        x: convertMillimeterToPixel(i.x2),
        y: convertMillimeterToPixel(i.y2)
      }));
    n.unshift(s);
    for (let i = 0; i < n.length - 1; i++) {
      const r = n[i],
        s = n[i + 1],
        a = computeAngleAxeRadian(r, s);
      Math.abs(a % Math.PI) < .1 ? (r.y = +((r.y + s.y) / 2).toFixed(3), s.y = r.y) : Math.abs(a % (Math.PI / 2)) < .1 && (r.x = +((r.x + s.x) / 2).toFixed(3), s.x = r.x);
    }
    return new IIEdgePolyLine(n, i.edges[0].p1Decoration, i.edges.at(-1).p2Decoration, r[0]?.style);
  }
  buildArc(i, r) {
    const s = {
        x: convertMillimeterToPixel(i.cx),
        y: convertMillimeterToPixel(i.cy)
      },
      n = convertMillimeterToPixel(i.rx),
      a = convertMillimeterToPixel(i.ry);
    return new IIEdgeArc(s, i.startAngle, i.sweepAngle, n, a, i.phi, i.startDecoration, i.endDecoration, r[0]?.style);
  }
  convertEdge(i, r) {
    switch (i.kind) {
      case m.Line:
        {
          const s = r.filter(r => i.items?.some(i => i["full-id"] === r.id));
          if (!s.length) return;
          const n = s.filter((i, r) => s.findIndex(r => i.id === r.id) === r);
          return {
            symbol: this.buildLine(i, n),
            strokes: n
          };
        }
      case m.Arc:
        {
          const s = r.filter(r => i.items?.some(i => i["full-id"] === r.id));
          if (!s.length) return;
          const n = s.filter((i, r) => s.findIndex(r => i.id === r.id) === r);
          return {
            symbol: this.buildArc(i, n),
            strokes: n
          };
        }
      case m.PolyEdge:
        {
          const s = r.filter(r => i.edges.flatMap(i => i.items)?.some(i => i["full-id"] === r.id));
          if (!s.length) return;
          const n = s.filter((i, r) => s.findIndex(r => i.id === r.id) === r);
          return {
            symbol: this.buildPolyEdge(i, n),
            strokes: n
          };
        }
      default:
        return void this.#t.error("convertEdge", `Conversion of Edge with kind equal to ${JSON.stringify(i)} is unknow`);
    }
  }
  async apply(i = []) {
    this.#t.info("convert"), this.model.exports?.["application/vnd.myscript.jiix"] || (await this.editor.export(["application/vnd.myscript.jiix"])), this.editor.selector.removeSelectedGroup();
    const r = this.model.exports?.["application/vnd.myscript.jiix"];
    if (r?.elements?.length) {
      const s = this.editor.extractStrokesFromSymbols(i.length ? i : this.model.symbols),
        n = !r.elements?.some(i => "Text" !== i.type),
        a = [];
      r.elements.forEach(i => {
        switch (i.type) {
          case "Text":
            {
              const r = this.convertText(i, s, n);
              r && a.push(...r);
              break;
            }
          case "Node":
            {
              const r = this.convertNode(i, s);
              r && a.push(r);
              break;
            }
          case "Edge":
            {
              const r = this.convertEdge(i, s);
              r && a.push(r);
              break;
            }
          default:
            this.#t.warn("buildConversions", `Unknow jiix element type: ${i.type}`);
        }
      }), this.editor.addSymbols(a.map(i => i.symbol), !1), this.editor.removeSymbols(a.flatMap(i => i.strokes.map(i => i.id)), !1), this.editor.history.push(this.model, {
        added: a.map(i => i.symbol),
        erased: a.flatMap(i => i.strokes)
      });
    }
  }
}
class IIResizeManager {
  #t = LoggerManager.getLogger(d.TRANSFORMER);
  editor;
  interactElementsGroup;
  direction;
  boundingBox;
  transformOrigin;
  keepRatio = !1;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i;
  }
  get model() {
    return this.editor.model;
  }
  applyToStroke(i, r, s, n) {
    return this.#t.debug("applyToStroke", {
      stroke: i,
      origin: r,
      scaleX: s,
      scaleY: n
    }), i.pointers.forEach(i => {
      i.x = +(r.x + s * (i.x - r.x)).toFixed(3), i.y = +(r.y + n * (i.y - r.y)).toFixed(3);
    }), i;
  }
  applyToShape(i, r, s, n) {
    switch (this.#t.debug("applyToShape", {
      shape: i,
      origin: r,
      scaleX: s,
      scaleY: n
    }), i.kind) {
      case M.Ellipse:
        {
          const a = Math.cos(i.orientation),
            l = Math.sin(i.orientation);
          return i.center.x = +(i.center.x + ((s - 1) * a + (n - 1) * l) * (i.center.x - r.x)).toFixed(3), i.center.y = +(i.center.y + ((s - 1) * -l + (n - 1) * a) * (i.center.y - r.y)).toFixed(3), i.radiusX = +Math.abs(i.radiusX * (s * a - n * l)).toFixed(3), i.radiusY = +Math.abs(i.radiusY * (s * l + n * a)).toFixed(3), i;
        }
      case M.Circle:
        return i.radius = +(i.radius * (s + n) / 2).toFixed(3), i.center.x = +(r.x + s * (i.center.x - r.x)).toFixed(3), i.center.y = +(r.y + n * (i.center.y - r.y)).toFixed(3), i;
      case M.Polygon:
        return i.points.forEach(i => {
          i.x = +(r.x + s * (i.x - r.x)).toFixed(3), i.y = +(r.y + n * (i.y - r.y)).toFixed(3);
        }), i;
      default:
        throw new Error(`Can't apply resize on shape, kind unknow: ${JSON.stringify(i)}`);
    }
  }
  applyToEdge(i, r, s, n) {
    switch (this.#t.debug("applyToEdge", {
      edge: i,
      origin: r,
      scaleX: s,
      scaleY: n
    }), i.kind) {
      case I.Arc:
        {
          const a = Math.cos(i.phi),
            l = Math.sin(i.phi);
          return i.center.x = +(i.center.x + ((s - 1) * a + (n - 1) * l) * (i.center.x - r.x)).toFixed(3), i.center.y = +(i.center.y + ((s - 1) * -l + (n - 1) * a) * (i.center.y - r.y)).toFixed(3), i.radiusX = +(i.radiusX * Math.abs(s * a + n * l)).toFixed(3), i.radiusY = +(i.radiusY * Math.abs(s * l + n * a)).toFixed(3), s < 0 ? (i.startAngle = +(Math.PI - i.startAngle).toFixed(3), i.sweepAngle *= -1) : n < 0 && (i.sweepAngle *= -1), i;
        }
      case I.Line:
        return i.start.x = +(r.x + s * (i.start.x - r.x)).toFixed(3), i.start.y = +(r.y + n * (i.start.y - r.y)).toFixed(3), i.end.x = +(r.x + s * (i.end.x - r.x)).toFixed(3), i.end.y = +(r.y + n * (i.end.y - r.y)).toFixed(3), i;
      case I.PolyEdge:
        return i.points.forEach(i => (i.x = +(r.x + s * (i.x - r.x)).toFixed(3), i.y = +(r.y + n * (i.y - r.y)).toFixed(3), i)), i;
      default:
        throw new Error(`Can't apply resize on edge, kind unknow: ${JSON.stringify(i)}`);
    }
  }
  applyOnText(i, r, s, n) {
    return i.point.x = +(r.x + s * (i.point.x - r.x)).toFixed(3), i.point.y = +(r.y + n * (i.point.y - r.y)).toFixed(3), i.chars.forEach(i => {
      i.fontSize = +(i.fontSize * (s + n) / 2).toFixed(3);
    }), this.editor.texter.updateBounds(i);
  }
  applyOnGroup(i, r, s, n) {
    return i.children.forEach(i => this.applyToSymbol(i, r, s, n)), i;
  }
  applyOnRecognizedSymbol(i, r, s, n) {
    return i.strokes.forEach(i => this.applyToStroke(i, r, s, n)), i.kind === T.Text && (i.xHeight *= n), i;
  }
  applyToSymbol(i, r, s, n) {
    switch (this.#t.info("applyToSymbol", {
      symbol: i,
      scaleX: s,
      scaleY: n
    }), i.type) {
      case E.Stroke:
        return this.applyToStroke(i, r, s, n);
      case E.Shape:
        return this.applyToShape(i, r, s, n);
      case E.Edge:
        return this.applyToEdge(i, r, s, n);
      case E.Text:
        return this.applyOnText(i, r, s, n);
      case E.Group:
        return this.applyOnGroup(i, r, s, n);
      case E.Recognized:
        return this.applyOnRecognizedSymbol(i, r, s, n);
      default:
        throw new Error(`Can't apply resize on symbol, type unknow: ${JSON.stringify(i)}`);
    }
  }
  setTransformOrigin(i, r, s) {
    this.editor.renderer.setAttribute(i, "transform-origin", `${r}px ${s}px`);
  }
  scaleElement(i, r, s) {
    this.#t.info("scaleElement", {
      id: i,
      sx: r,
      sy: s
    }), this.editor.renderer.setAttribute(i, "transform", `scale(${r},${s})`);
  }
  start(i, r) {
    this.#t.info("start", {
      target: i
    }), this.interactElementsGroup = i.closest(`[role=${s.InteractElementsGroup}]`), this.direction = i.getAttribute("resize-direction"), this.keepRatio = this.model.symbolsSelected.some(i => i.type === E.Text || i.type === E.Shape && i.kind === M.Circle), this.transformOrigin = r, this.boundingBox = Box.createFromPoints(this.model.symbolsSelected.flatMap(i => i.vertices)), this.setTransformOrigin(this.interactElementsGroup.id, this.transformOrigin.x, this.transformOrigin.y), this.model.symbolsSelected.forEach(i => {
      this.setTransformOrigin(i.id, this.transformOrigin.x, this.transformOrigin.y);
    });
  }
  continue(i) {
    if (this.#t.info("continue", {
      point: i
    }), !this.interactElementsGroup) throw new Error("Can't resize, you must call start before");
    const r = i,
      s = ["e-resize", "ne-resize", "se-resize", "w-resize", "nw-resize", "sw-resize"].includes(this.direction),
      n = ["n-resize", "ne-resize", "nw-resize", "s-resize", "se-resize", "sw-resize"].includes(this.direction),
      {
        x: a,
        y: l
      } = this.editor.snaps.snapResize(i, s, n);
    r.x = a, r.y = l;
    let d = 0,
      h = 0;
    ["e-resize", "ne-resize", "se-resize"].includes(this.direction) ? d = r.x - this.boundingBox.xMax : ["w-resize", "nw-resize", "sw-resize"].includes(this.direction) && (d = this.boundingBox.xMin - r.x), ["n-resize", "ne-resize", "nw-resize"].includes(this.direction) ? h = this.boundingBox.yMin - r.y : ["s-resize", "se-resize", "sw-resize"].includes(this.direction) && (h = r.y - this.boundingBox.yMax);
    let c = this.boundingBox.width ? 1 + d / this.boundingBox.width : 1,
      u = this.boundingBox.height ? 1 + h / this.boundingBox.height : 1;
    return this.keepRatio && (["n-resize", "s-resize"].includes(this.direction) ? c = u : (["e-resize", "w-resize"].includes(this.direction) || (c = Math.max(c, u)), u = c)), this.scaleElement(this.interactElementsGroup.id, c, u), this.model.symbolsSelected.forEach(i => {
      this.scaleElement(i.id, c, u);
    }), {
      scaleX: c,
      scaleY: u
    };
  }
  async end(i) {
    this.#t.info("end", {
      point: i
    });
    const {
      scaleX: r,
      scaleY: s
    } = this.continue(i);
    this.editor.snaps.clearSnapToElementLines();
    const n = this.model.symbolsSelected.map(i => i.clone());
    this.model.symbolsSelected.forEach(i => {
      this.applyToSymbol(i, this.transformOrigin, r, s), this.editor.renderer.drawSymbol(i), this.model.updateSymbol(i);
    });
    const a = this.editor.extractStrokesFromSymbols(this.model.symbolsSelected);
    this.editor.recognizer.transformScale(a.map(i => i.id), r, s, this.transformOrigin.x, this.transformOrigin.y), this.editor.history.push(this.model, {
      scale: [{
        symbols: n,
        origin: {
          ...this.transformOrigin
        },
        scaleX: r,
        scaleY: s
      }]
    }), this.interactElementsGroup = void 0, this.editor.svgDebugger.apply();
  }
}
class IIRotationManager {
  #t = LoggerManager.getLogger(d.TRANSFORMER);
  editor;
  interactElementsGroup;
  center;
  origin;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i;
  }
  get model() {
    return this.editor.model;
  }
  applyToStroke(i, r, s) {
    return i.pointers.forEach(i => {
      const {
        x: n,
        y: a
      } = computeRotatedPoint(i, r, s);
      i.x = n, i.y = a;
    }), i;
  }
  applyToShape(i, r, s) {
    switch (i.kind) {
      case M.Ellipse:
        return i.center = computeRotatedPoint(i.center, r, s), i.orientation = (i.orientation + s) % (2 * Math.PI), i;
      case M.Circle:
        return i.center = computeRotatedPoint(i.center, r, s), i;
      case M.Polygon:
        return i.points.forEach(i => {
          const {
            x: n,
            y: a
          } = computeRotatedPoint(i, r, s);
          i.x = n, i.y = a;
        }), i;
      default:
        throw new Error(`Can't apply rotate on shape, kind unknow: ${JSON.stringify(i)}`);
    }
  }
  applyToEdge(i, r, s) {
    switch (i.kind) {
      case I.Arc:
        return i.phi = (i.phi - s) % (2 * Math.PI), i.center = computeRotatedPoint(i.center, r, s), i;
      case I.Line:
        return i.start = computeRotatedPoint(i.start, r, s), i.end = computeRotatedPoint(i.end, r, s), i;
      case I.PolyEdge:
        return i.points = i.points.map(i => computeRotatedPoint(i, r, s)), i;
      default:
        throw new Error(`Can't apply rotate on edge, kind unknow: ${JSON.stringify(i)}`);
    }
  }
  applyOnText(i, r, s) {
    return i.rotation = {
      degree: convertRadianToDegree(s) + (i.rotation?.degree || 0),
      center: r
    }, this.editor.texter.updateBounds(i);
  }
  applyOnGroup(i, r, s) {
    return i.children.forEach(i => this.applyToSymbol(i, r, s)), i;
  }
  applyOnRecognizedSymbol(i, r, s) {
    return i.strokes.forEach(i => this.applyToStroke(i, r, s)), i;
  }
  applyToSymbol(i, r, s) {
    switch (i.type) {
      case E.Stroke:
        return this.applyToStroke(i, r, s);
      case E.Shape:
        return this.applyToShape(i, r, s);
      case E.Edge:
        return this.applyToEdge(i, r, s);
      case E.Text:
        return this.applyOnText(i, r, s);
      case E.Group:
        return this.applyOnGroup(i, r, s);
      case E.Recognized:
        return this.applyOnRecognizedSymbol(i, r, s);
      default:
        throw new Error(`Can't apply rotate on symbol, type unknow: ${JSON.stringify(i)}`);
    }
  }
  setTransformOrigin(i, r, s) {
    this.editor.renderer.setAttribute(i, "transform-origin", `${r}px ${s}px`);
  }
  rotateElement(i, r) {
    this.#t.info("rotateElement", {
      id: i,
      degree: r
    }), this.editor.renderer.setAttribute(i, "transform", `rotate(${r})`);
  }
  start(i, r) {
    this.#t.info("start", {
      target: i
    }), this.interactElementsGroup = i.closest(`[role=${s.InteractElementsGroup}]`);
    const n = Box.createFromPoints(this.model.symbolsSelected.flatMap(i => i.vertices));
    this.center = {
      x: n.xMin + n.width / 2,
      y: n.yMid
    }, this.origin = r, this.setTransformOrigin(this.interactElementsGroup.id, this.center.x, this.center.y), this.model.symbolsSelected.forEach(i => {
      this.setTransformOrigin(i.id, this.center.x, this.center.y);
    });
  }
  continue(i) {
    if (this.#t.info("continue", {
      point: i
    }), !this.interactElementsGroup) throw new Error("Can't rotate, you must call start before");
    let r = Math.round(convertRadianToDegree(computeAngleRadian(this.origin, this.center, i)));
    return r = this.editor.snaps.snapRotation(r), i.x - this.center.x < 0 && (r = 360 - r), this.rotateElement(this.interactElementsGroup.id, r), this.model.symbolsSelected.forEach(i => {
      this.rotateElement(i.id, r);
    }), r;
  }
  async end(i) {
    this.#t.info("end", {
      point: i
    });
    const r = convertDegreeToRadian(this.continue(i)) % (2 * Math.PI),
      s = this.model.symbolsSelected.map(i => i.clone());
    this.model.symbolsSelected.forEach(i => {
      this.applyToSymbol(i, this.center, r), this.editor.renderer.drawSymbol(i), this.model.updateSymbol(i);
    });
    const n = this.editor.extractStrokesFromSymbols(this.model.symbolsSelected);
    this.editor.recognizer.transformRotate(n.map(i => i.id), r, this.center.x, this.center.y), this.editor.history.push(this.model, {
      rotate: [{
        symbols: s,
        angle: r,
        center: {
          ...this.center
        }
      }]
    }), this.interactElementsGroup = void 0, this.editor.svgDebugger.apply();
  }
}
const fe = {
    capture: !1,
    passive: !0
  },
  xe = {
    listenerOptions: fe,
    xyFloatPrecision: 0,
    timestampFloatPrecision: 0,
    delayLongTouch: 500
  };
class PointerEventGrabber {
  #t = LoggerManager.getLogger(d.GRABBER);
  configuration;
  layerCapture;
  capturing = !1;
  pointerType;
  prevent = i => i.preventDefault();
  onPointerDown;
  onPointerMove;
  onPointerUp;
  onContextMenu;
  constructor(i) {
    this.#t.info("constructor", {
      configuration: i
    }), this.configuration = i;
  }
  roundFloat(i, r) {
    if (r >= 0) {
      const s = Math.pow(10, r);
      return Math.round(i / s) * s;
    }
    return this.#t.debug("roundFloat", {
      oneFloat: i,
      requestedFloatPrecision: r
    }), i;
  }
  extractPointer(i) {
    let r, s;
    ({
      clientX: r,
      clientY: s
    } = "changedTouches" in i ? i.changedTouches[0] : i);
    const n = this.layerCapture.getBoundingClientRect(),
      a = {
        x: this.roundFloat(r - n.left - this.layerCapture.clientLeft + this.layerCapture.scrollLeft, this.configuration.xyFloatPrecision),
        y: this.roundFloat(s - n.top - this.layerCapture.clientTop + this.layerCapture.scrollTop, this.configuration.xyFloatPrecision),
        t: this.roundFloat(Date.now(), this.configuration.timestampFloatPrecision),
        p: i.pressure
      };
    return this.#t.debug("extractPointer", {
      event: i,
      pointer: a
    }), a;
  }
  getPointerInfos(i) {
    return {
      clientX: i.clientX,
      clientY: i.clientY,
      isPrimary: i.isPrimary,
      type: i.type,
      target: i.target,
      pointerType: i.pointerType,
      pointer: this.extractPointer(i),
      button: i.button,
      buttons: i.buttons
    };
  }
  pointerDownHandler = i => {
    const r = this.getPointerInfos(i);
    this.#t.debug("pointerDownHandler", r), 0 === r.button && 1 === i.buttons && (this.capturing = !0, this.pointerType = i.pointerType, this.#t.level === l.INFO && this.#t.info("pointerDownHandler", r), this.onPointerDown && this.onPointerDown(r));
  };
  pointerMoveHandler = i => {
    const r = this.getPointerInfos(i);
    this.#t.debug("pointerMoveHandler", r), this.capturing && this.pointerType === i.pointerType && (this.#t.level === l.INFO && this.#t.info("pointerMoveHandler", r), this.onPointerMove && this.onPointerMove(r));
  };
  pointerUpHandler = i => {
    const r = this.getPointerInfos(i);
    this.#t.debug("pointerUpHandler", r), this.capturing && this.pointerType === i.pointerType && (this.#t.level === l.INFO && this.#t.info("pointerUpHandler", r), this.pointerType = void 0, this.capturing = !1, this.onPointerUp && this.onPointerUp(r));
  };
  pointerOutHandler = i => {
    const r = this.getPointerInfos(i);
    this.#t.debug("pointerOutHandler", r), this.capturing && this.pointerType === i.pointerType && !this.layerCapture.contains(i.target) && (this.#t.level === l.INFO && this.#t.info("pointerOutHandler", r), this.pointerType = void 0, this.capturing = !1, this.onPointerUp && this.onPointerUp(r));
  };
  contextMenuHandler = i => {
    const r = this.getPointerInfos(i);
    this.#t.debug("contextMenuHandler", r), i.target && this.onContextMenu && (this.#t.level === l.INFO && this.#t.info("contextMenuHandler", r), this.onContextMenu(r));
  };
  stopPointerEvent() {
    this.capturing = !1, this.pointerType = void 0;
  }
  attach(i) {
    this.#t.info("attach", {
      domElement: i
    }), this.layerCapture && this.detach(), this.layerCapture = i, this.layerCapture.style.setProperty("touch-action", "none"), this.layerCapture.addEventListener("pointerdown", this.pointerDownHandler, this.configuration.listenerOptions), this.layerCapture.addEventListener("pointermove", this.pointerMoveHandler, this.configuration.listenerOptions), this.layerCapture.addEventListener("pointerup", this.pointerUpHandler, this.configuration.listenerOptions), this.layerCapture.addEventListener("pointercancel", this.pointerUpHandler, this.configuration.listenerOptions), this.layerCapture.addEventListener("pointerleave", this.pointerUpHandler, this.configuration.listenerOptions), this.layerCapture.addEventListener("pointerout", this.pointerOutHandler, this.configuration.listenerOptions), this.layerCapture.addEventListener("contextmenu", this.contextMenuHandler);
  }
  detach() {
    this.#t.info("detach"), this.layerCapture?.style.removeProperty("touch-action"), this.layerCapture?.removeEventListener("pointerdown", this.pointerDownHandler, this.configuration.listenerOptions), this.layerCapture?.removeEventListener("pointermove", this.pointerMoveHandler, this.configuration.listenerOptions), this.layerCapture?.removeEventListener("pointerup", this.pointerUpHandler, this.configuration.listenerOptions), this.layerCapture?.removeEventListener("pointerleave", this.pointerUpHandler, this.configuration.listenerOptions), this.layerCapture?.removeEventListener("pointercancel", this.pointerUpHandler, this.configuration.listenerOptions), this.layerCapture?.removeEventListener("pointerout", this.pointerOutHandler, this.configuration.listenerOptions), this.layerCapture?.removeEventListener("contextmenu", this.contextMenuHandler);
  }
}
class IISelectionManager {
  #t = LoggerManager.getLogger(d.SELECTION);
  grabber;
  editor;
  #l = "selecting-rect";
  startSelectionPoint;
  endSelectionPoint;
  selectedGroup;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i, this.grabber = new PointerEventGrabber(i.configuration.grabber), this.grabber.onPointerDown = this.start.bind(this), this.grabber.onPointerMove = this.continue.bind(this), this.grabber.onPointerUp = this.end.bind(this), this.grabber.onContextMenu = this.onContextMenu.bind(this);
  }
  get model() {
    return this.editor.model;
  }
  get renderer() {
    return this.editor.renderer;
  }
  get rotator() {
    return this.editor.rotator;
  }
  get translator() {
    return this.editor.translator;
  }
  get resizer() {
    return this.editor.resizer;
  }
  get selectionBox() {
    if (this.startSelectionPoint && this.endSelectionPoint) return Box.createFromPoints([this.startSelectionPoint, this.endSelectionPoint]);
  }
  attach(i) {
    this.removeSelectedGroup(), this.grabber.attach(i);
  }
  detach() {
    this.removeSelectedGroup(), this.grabber.detach();
  }
  drawSelectingRect(i) {
    this.clearSelectingRect();
    const r = {
      id: this.#l,
      fill: "transparent",
      stroke: "grey",
      opacity: "0.25"
    };
    this.renderer.appendElement(SVGBuilder.createRect(i, r));
  }
  clearSelectingRect() {
    this.renderer.clearElements({
      attrs: {
        id: this.#l
      }
    });
  }
  getPoint(i) {
    const {
        clientLeft: r,
        scrollLeft: s,
        clientTop: n,
        scrollTop: a
      } = this.renderer.parent,
      l = this.renderer.parent.getBoundingClientRect();
    return {
      x: i.clientX - l.left - r + s,
      y: i.clientY - l.top - n + a
    };
  }
  createTranslateRect(i) {
    const r = {
        role: s.Translate,
        style: "cursor:move",
        fill: "transparent",
        stroke: "transparent"
      },
      n = {
        height: i.height,
        width: i.width,
        x: i.x,
        y: i.y
      },
      a = SVGBuilder.createRect(n, r),
      handler = i => {
        i.preventDefault(), i.stopPropagation(), this.translator.continue(this.getPoint(i));
      },
      endHandler = i => {
        i.preventDefault(), i.stopPropagation(), this.translator.end(this.getPoint(i)), this.renderer.layer.removeEventListener("pointermove", handler), this.renderer.layer.removeEventListener("pointercancel", endHandler), this.renderer.layer.removeEventListener("pointerleave", endHandler), this.renderer.layer.removeEventListener("pointerup", endHandler), this.renderer.layer.style.cursor = "", this.resetSelectedGroup(this.model.symbolsSelected);
      };
    return a.addEventListener("pointerdown", i => {
      0 === i.button && 1 === i.buttons && (i.preventDefault(), i.stopPropagation(), this.hideInteractElements(), this.translator.start(i.target, this.getPoint(i)), this.renderer.layer.addEventListener("pointermove", handler), this.renderer.layer.addEventListener("pointercancel", endHandler), this.renderer.layer.addEventListener("pointerleave", endHandler), this.renderer.layer.addEventListener("pointerup", endHandler), this.renderer.layer.style.cursor = "move");
    }), a;
  }
  createRotateGroup(i) {
    const r = SVGBuilder.createGroup({
        role: s.Rotate,
        "vector-effect": "non-scaling-size",
        style: "cursor:pointer;",
        opacity: "1"
      }),
      n = {
        x: i.x + i.width / 2,
        y: i.y - 40
      },
      l = {
        role: s.Rotate,
        "stroke-width": "2",
        stroke: "black",
        fill: "white"
      };
    r.appendChild(SVGBuilder.createCircle(n, 8, l));
    const d = {
      role: s.Rotate,
      fill: "black"
    };
    r.appendChild(SVGBuilder.createCircle(n, 4, d));
    const h = {
      role: s.Rotate,
      stroke: "black",
      "stroke-width": "2"
    };
    r.appendChild(SVGBuilder.createLine({
      x: n.x,
      y: n.y + 8
    }, {
      x: n.x,
      y: i.y - a
    }, h));
    const handler = i => {
        i.preventDefault(), i.stopPropagation(), this.rotator.continue(this.getPoint(i));
      },
      endHandler = i => {
        i.preventDefault(), i.stopPropagation(), this.rotator.end(this.getPoint(i)), this.renderer.layer.removeEventListener("pointermove", handler), this.renderer.layer.removeEventListener("pointercancel", endHandler), this.renderer.layer.removeEventListener("pointerleave", endHandler), this.renderer.layer.removeEventListener("pointerup", endHandler), this.resetSelectedGroup(this.model.symbolsSelected);
      };
    return r.addEventListener("pointerdown", i => {
      0 === i.button && 1 === i.buttons && (i.preventDefault(), i.stopPropagation(), this.hideInteractElements(), this.rotator.start(i.target, this.getPoint(i)), this.renderer.layer.addEventListener("pointermove", handler), this.renderer.layer.addEventListener("pointercancel", endHandler), this.renderer.layer.addEventListener("pointerleave", endHandler), this.renderer.layer.addEventListener("pointerup", endHandler));
    }), r;
  }
  createResizeGroup(i) {
    const r = SVGBuilder.createGroup({
        role: s.Resize,
        "vector-effect": "non-scaling-size",
        "stroke-width": "4",
        stroke: "#3e68ff"
      }),
      n = {
        x: i.x - a,
        y: i.y - a
      },
      l = {
        x: i.x + i.width + a,
        y: i.y - a
      },
      d = {
        x: i.x + i.width + a,
        y: i.y + i.height + a
      },
      h = {
        x: i.x - a,
        y: i.y + i.height + a
      },
      bindEl = (i, r, s) => {
        const handler = i => {
            i.preventDefault(), i.stopPropagation(), this.resizer.continue(this.getPoint(i));
          },
          endHandler = i => {
            i.preventDefault(), i.stopPropagation(), this.resizer.end(this.getPoint(i)), this.renderer.layer.removeEventListener("pointermove", handler), this.renderer.layer.removeEventListener("pointercancel", endHandler), this.renderer.layer.removeEventListener("pointerleave", endHandler), this.renderer.layer.removeEventListener("pointerup", endHandler), this.renderer.layer.style.cursor = "", this.resetSelectedGroup(this.model.symbolsSelected);
          };
        i.addEventListener("pointerdown", i => {
          0 === i.button && 1 === i.buttons && (i.preventDefault(), i.stopPropagation(), this.hideInteractElements(), this.renderer.layer.style.cursor = s, this.resizer.start(i.target, r), this.renderer.layer.addEventListener("pointermove", handler), this.renderer.layer.addEventListener("pointercancel", endHandler), this.renderer.layer.addEventListener("pointerleave", endHandler), this.renderer.layer.addEventListener("pointerup", endHandler));
        });
      };
    [{
      direction: "n-resize",
      p1: n,
      p2: l,
      transformOrigin: {
        x: i.x + i.width / 2,
        y: i.y + i.height
      }
    }, {
      direction: "e-resize",
      p1: l,
      p2: d,
      transformOrigin: {
        x: i.x,
        y: i.y + i.height / 2
      }
    }, {
      direction: "s-resize",
      p1: h,
      p2: d,
      transformOrigin: {
        x: i.x + i.width / 2,
        y: i.y
      }
    }, {
      direction: "w-resize",
      p1: n,
      p2: h,
      transformOrigin: {
        x: i.x + i.width,
        y: i.y + i.height / 2
      }
    }].forEach(i => {
      const n = {
          role: s.Resize,
          "resize-direction": i.direction,
          "transform-origin": JSON.stringify(i.transformOrigin),
          style: `cursor:${i.direction};`
        },
        a = SVGBuilder.createLine(i.p1, i.p2, n);
      bindEl(a, i.transformOrigin, i.direction), r.appendChild(a);
    });
    return [{
      direction: "nw-resize",
      p: n,
      transformOrigin: {
        x: i.x + i.width,
        y: i.y + i.height
      }
    }, {
      direction: "ne-resize",
      p: l,
      transformOrigin: {
        x: i.x,
        y: i.y + i.height
      }
    }, {
      direction: "se-resize",
      p: d,
      transformOrigin: {
        x: i.x,
        y: i.y
      }
    }, {
      direction: "sw-resize",
      p: h,
      transformOrigin: {
        x: i.x + i.width,
        y: i.y
      }
    }].forEach(i => {
      const n = {
          "stroke-width": "4",
          role: s.Resize,
          "resize-direction": i.direction,
          "transform-origin": JSON.stringify(i.transformOrigin),
          transform: "scale(1, 1)",
          fill: "white",
          style: `cursor:${i.direction};`
        },
        a = SVGBuilder.createCircle(i.p, 5, n);
      bindEl(a, i.transformOrigin, i.direction), r.appendChild(a);
    }), r;
  }
  createInteractElementsGroup(i) {
    if (this.#t.info("createInteractElementsGroup", {
      symbols: i
    }), !i.length) return;
    const r = i.map(i => ({
        symbol: i,
        element: this.renderer.getElementById(i.id)
      })),
      n = Box.createFromBoxes(i.map(i => ({
        x: i.bounds.x - (i.style.width || 1),
        y: i.bounds.y - (i.style.width || 1),
        height: i.bounds.height + 2 * (i.style.width || 1),
        width: i.bounds.width + 2 * (i.style.width || 1)
      }))),
      a = Box.createFromPoints(i.flatMap(i => i.vertices)),
      l = Box.createFromBoxes([n, a]),
      d = {
        id: `selected-${Date.now()}`,
        role: s.InteractElementsGroup
      },
      h = SVGBuilder.createGroup(d);
    h.appendChild(this.createTranslateRect(l)), h.appendChild(this.createResizeGroup(l)), h.appendChild(this.createRotateGroup(l));
    const c = {
      style: "pointer-events: none",
      fill: "transparent",
      stroke: "#3e68ff",
      "stroke-width": "1",
      "stroke-dasharray": "4",
      "vector-effect": "non-scaling-size",
      transform: "rotate(0, 0, 0)"
    };
    return r.forEach(i => {
      if (i.element) {
        const r = {
          x: i.symbol.bounds.x - (i.symbol.style.width || 1),
          y: i.symbol.bounds.y - (i.symbol.style.width || 1),
          height: i.symbol.bounds.height + 2 * (i.symbol.style.width || 1),
          width: i.symbol.bounds.width + 2 * (i.symbol.style.width || 1)
        };
        if (i.symbol.type === E.Text) {
          const r = i.symbol;
          c.transform = `rotate(${r.rotation?.degree || 0}, ${r.rotation?.center.x || 0}, ${r.rotation?.center.y || 0})`;
        } else c.transform = "rotate(0, 0, 0)";
        h.prepend(SVGBuilder.createRect(r, c));
      }
    }), h;
  }
  createEdgeResizeGroup(i) {
    const r = SVGBuilder.createGroup({
        role: s.Resize,
        "vector-effect": "non-scaling-size",
        "stroke-width": "4",
        stroke: "#3e68ff"
      }),
      n = {
        role: s.Resize,
        "stroke-width": "4",
        stroke: "#3e68ff",
        fill: "white",
        style: "cursor:grab;"
      },
      bindEl = (r, s) => {
        const handler = r => {
            r.preventDefault(), r.stopPropagation();
            const n = this.getPoint(r),
              {
                x: a,
                y: l
              } = this.editor.snaps.snapResize(n);
            i.vertices[s].x = a, i.vertices[s].y = l, this.model.updateSymbol(i), this.renderer.drawSymbol(i);
          },
          endHandler = r => {
            r.preventDefault(), r.stopPropagation();
            const n = this.getPoint(r),
              {
                x: a,
                y: l
              } = this.editor.snaps.snapResize(n);
            i.vertices[s].x = a, i.vertices[s].y = l, this.renderer.layer.style.cursor = "", this.editor.updateSymbol(i), this.renderer.layer.removeEventListener("pointermove", handler), this.renderer.layer.removeEventListener("pointercancel", endHandler), this.renderer.layer.removeEventListener("pointerleave", endHandler), this.renderer.layer.removeEventListener("pointerup", endHandler), this.editor.snaps.clearSnapToElementLines(), this.resetSelectedGroup(this.model.symbolsSelected);
          };
        r.addEventListener("pointerdown", i => {
          0 === i.button && 1 === i.buttons && (this.renderer.layer.style.cursor = "grabbing", this.hideInteractElements(), i.preventDefault(), i.stopPropagation(), this.renderer.layer.addEventListener("pointermove", handler), this.renderer.layer.addEventListener("pointercancel", endHandler), this.renderer.layer.addEventListener("pointerleave", endHandler), this.renderer.layer.addEventListener("pointerup", endHandler));
        });
      };
    return i.vertices.forEach((i, s) => {
      const a = SVGBuilder.createCircle(i, 5, n);
      bindEl(a, s), r.appendChild(a);
    }), r;
  }
  createInteractEdgeGroup(i) {
    this.#t.info("createInteractEdgeGroup", {
      edge: i
    });
    const r = {
        id: `selected-${Date.now()}`,
        role: s.InteractElementsGroup
      },
      n = SVGBuilder.createGroup(r);
    return n.appendChild(this.createTranslateRect(i.bounds)), n.appendChild(this.createEdgeResizeGroup(i.clone())), n;
  }
  drawSelectedGroup(i) {
    if (i.length) {
      if (1 === i.length && i[0].type === E.Edge ? this.selectedGroup = this.createInteractEdgeGroup(i[0]) : this.selectedGroup = this.createInteractElementsGroup(i), this.selectedGroup) {
        this.renderer.layer.appendChild(this.selectedGroup);
        const i = this.selectedGroup.getBBox();
        this.editor.menu.context.position.x = i.x + i.width / 2 - this.renderer.parent.clientLeft, this.editor.menu.context.position.y = i.y + i.height - this.renderer.parent.clientTop, this.editor.menu.context.show();
      }
      this.editor.menu.update();
    }
  }
  resetSelectedGroup(i) {
    this.#t.info("resetSelectedGroup", {
      symbols: i
    }), this.removeSelectedGroup(), this.drawSelectedGroup(i);
  }
  removeSelectedGroup() {
    this.#t.info("removeSelectedGroup"), this.editor.menu.context.hide(), this.selectedGroup?.remove(), this.selectedGroup = void 0;
  }
  hideInteractElements() {
    this.editor.menu.context.hide();
    const i = `[role=${s.Resize}],[role=${s.Rotate}],[role=${s.Translate}]`;
    this.selectedGroup?.querySelectorAll(i).forEach(i => {
      i.setAttribute("visibility", "hidden");
    });
  }
  start(i) {
    this.removeSelectedGroup(), this.startSelectionPoint = i.pointer, this.endSelectionPoint = i.pointer, this.drawSelectingRect(this.selectionBox);
  }
  continue(i) {
    if (!this.startSelectionPoint) throw new Error("You need to call startSelectionByBox before");
    this.endSelectionPoint = i.pointer;
    const r = [];
    return this.model.symbols.forEach(i => {
      i.selected !== i.overlaps(this.selectionBox) && (i.selected = i.overlaps(this.selectionBox), r.push(i), this.renderer.drawSymbol(i));
    }), this.drawSelectingRect(this.selectionBox), r;
  }
  end(i) {
    const r = this.continue(i);
    return this.startSelectionPoint = void 0, this.endSelectionPoint = void 0, this.clearSelectingRect(), this.drawSelectedGroup(this.model.symbolsSelected), this.editor.event.emitSelected(this.model.symbolsSelected), this.editor.menu.style.update(), r;
  }
  async onContextMenu(i) {
    let r = !1,
      s = i.target;
    const n = [E.Edge.toString(), E.Shape.toString(), E.Stroke.toString(), E.Text.toString()];
    for (; s && "svg" !== s.tagName && !r;) n.includes(s.getAttribute("type")) ? r = !0 : s = s.parentElement;
    this.editor.unselectAll(), s?.id ? (this.model.selectSymbol(s.id), this.renderer.drawSymbol(this.model.symbolsSelected[0]), this.drawSelectedGroup(this.model.symbolsSelected), this.editor.updateLayerUI()) : (this.editor.menu.context.position.x = i.pointer.x + this.renderer.parent.clientLeft, this.editor.menu.context.position.y = i.pointer.y + this.renderer.parent.clientTop, this.editor.menu.context.show());
  }
}
class IITextManager {
  #t = LoggerManager.getLogger(d.CONVERTER);
  editor;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i;
  }
  get renderer() {
    return this.editor.renderer;
  }
  get rowHeight() {
    return this.editor.configuration.rendering.guides.gap;
  }
  get model() {
    return this.editor.model;
  }
  drawSymbolHidden(i) {
    const r = i.clone();
    r.id = "text-to-measure", r.chars.forEach(i => i.id += "-to-measure"), r.decorators = [], this.renderer.layer.querySelector(`#${r.id}`)?.remove();
    const s = this.renderer.buildElementFromSymbol(r);
    return s.setAttribute("visibility", "hidden"), this.renderer.prependElement(s), s;
  }
  setCharsBounds(i, r) {
    const s = r.querySelector("text");
    if (s) for (let r = 0; r < s.getNumberOfChars(); r++) {
      const n = i.chars.at(r);
      if (n) {
        const i = s.getExtentOfChar(r);
        n.bounds = new Box(i);
      }
    }
    return i;
  }
  setBounds(i) {
    const r = this.drawSymbolHidden(i);
    i.bounds = this.getElementBoundingBox(r), this.setCharsBounds(i, r);
  }
  getElementBoundingBox(i) {
    return new Box(i.querySelector("text").getBBox({
      stroke: !0,
      markers: !0,
      clipped: !0,
      fill: !0
    }));
  }
  getBoundingBox(i) {
    const r = this.drawSymbolHidden(i);
    return this.getElementBoundingBox(r);
  }
  getSpaceWidth(i) {
    const r = new Box({
        height: 0,
        width: 0,
        x: 0,
        y: 0
      }),
      s = {
        id: "text-char-space",
        label: "-",
        color: "",
        fontSize: i,
        fontWeight: "normal",
        bounds: r
      };
    return this.getBoundingBox(new IIText([s], {
      x: 0,
      y: 0
    }, r))?.width;
  }
  updateBounds(i) {
    return this.setBounds(i), this.model.updateSymbol(i), i;
  }
  moveTextAfter(i, r) {
    const s = this.model.getSymbolsByRowOrdered().find(r => r.rowIndex === this.model.getSymbolRowIndex(i));
    if (s) {
      const n = s.symbols.filter(r => r.type === E.Text && r.bounds.xMid > i.bounds.xMid);
      return n.forEach(i => {
        i.point.x += r, this.updateBounds(i), this.model.updateSymbol(i), this.renderer.drawSymbol(i);
      }), n;
    }
  }
}
class IITranslateManager {
  #t = LoggerManager.getLogger(d.TRANSFORMER);
  editor;
  interactElementsGroup;
  transformOrigin;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i;
  }
  get model() {
    return this.editor.model;
  }
  applyToStroke(i, r, s) {
    return i.pointers.forEach(i => {
      i.x += r, i.y += s;
    }), i;
  }
  applyToShape(i, r, s) {
    switch (i.kind) {
      case M.Ellipse:
      case M.Circle:
        return i.center.x += r, i.center.y += s, i;
      case M.Polygon:
        return i.points.forEach(i => {
          i.x += r, i.y += s;
        }), i;
      default:
        throw new Error(`Can't apply translate on shape, kind unknow: ${JSON.stringify(i)}`);
    }
  }
  applyToEdge(i, r, s) {
    switch (i.kind) {
      case I.Arc:
        return i.center.x += r, i.center.y += s, i;
      case I.Line:
        return i.start.x += r, i.start.y += s, i.end.x += r, i.end.y += s, i;
      case I.PolyEdge:
        return i.points.forEach(i => {
          i.x += r, i.y += s;
        }), i;
    }
    return i;
  }
  applyOnText(i, r, s) {
    return i.rotation && (i.rotation.center = {
      x: i.rotation.center.x + r,
      y: i.rotation.center.y + s
    }), i.point.x += r, i.point.y += s, this.editor.texter.updateBounds(i);
  }
  applyOnGroup(i, r, s) {
    return i.children.forEach(i => this.applyToSymbol(i, r, s)), i;
  }
  applyOnRecognizedSymbol(i, r, s) {
    return i.strokes.forEach(i => this.applyToStroke(i, r, s)), i.kind === T.Text && (i.baseline += s), i;
  }
  applyToSymbol(i, r, s) {
    switch (this.#t.info("applyToSymbol", {
      symbol: i,
      tx: r,
      ty: s
    }), i.type) {
      case E.Stroke:
        return this.applyToStroke(i, r, s);
      case E.Shape:
        return this.applyToShape(i, r, s);
      case E.Edge:
        return this.applyToEdge(i, r, s);
      case E.Text:
        return this.applyOnText(i, r, s);
      case E.Group:
        return this.applyOnGroup(i, r, s);
      case E.Recognized:
        return this.applyOnRecognizedSymbol(i, r, s);
      default:
        throw new Error(`Can't apply translate on symbol, type unknow: ${JSON.stringify(i)}`);
    }
  }
  translate(i, r, s, n = !0) {
    this.#t.info("translate", {
      symbols: i,
      tx: r,
      ty: s
    }), i.forEach(i => {
      this.applyToSymbol(i, r, s), this.model.updateSymbol(i), this.editor.renderer.drawSymbol(i);
    }), n && this.editor.history.push(this.model, {
      translate: [{
        symbols: this.model.symbolsSelected,
        tx: r,
        ty: s
      }]
    });
    const a = this.editor.extractStrokesFromSymbols(i);
    return this.editor.recognizer.transformTranslate(a.map(i => i.id), r, s);
  }
  translateElement(i, r, s) {
    this.#t.info("translateElement", {
      id: i,
      tx: r,
      ty: s
    }), this.editor.renderer.setAttribute(i, "transform", `translate(${r},${s})`);
  }
  start(i, r) {
    this.#t.info("start", {
      origin: r
    }), this.interactElementsGroup = i.closest(`[role=${s.InteractElementsGroup}]`), this.transformOrigin = r;
  }
  continue(i) {
    if (this.#t.info("continue", {
      point: i
    }), !this.interactElementsGroup) throw new Error("Can't translate, you must call start before");
    let r = i.x - this.transformOrigin.x,
      s = i.y - this.transformOrigin.y;
    const n = this.editor.snaps.snapTranslate(r, s);
    return r = n.x, s = n.y, this.translateElement(this.interactElementsGroup.id, r, s), this.model.symbolsSelected.forEach(i => {
      this.translateElement(i.id, r, s);
    }), {
      tx: r,
      ty: s
    };
  }
  async end(i) {
    this.#t.info("end", {
      point: i
    });
    const {
      tx: r,
      ty: s
    } = this.continue(i);
    this.editor.snaps.clearSnapToElementLines(), this.translate(this.model.symbolsSelected, r, s), this.interactElementsGroup = void 0, this.editor.svgDebugger.apply();
  }
}
class IIWriteManager {
  #t = LoggerManager.getLogger(d.WRITE);
  grabber;
  editor;
  #d = r.Pencil;
  detectGesture = !0;
  currentSymbolOrigin;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i, this.grabber = new PointerEventGrabber(i.configuration.grabber);
  }
  get tool() {
    return this.#d;
  }
  set tool(i) {
    this.#d = i, i !== r.Pencil ? this.editor.layers.root.classList.add("shape") : this.editor.layers.root.classList.remove("shape"), this.editor.unselectAll();
  }
  get model() {
    return this.editor.model;
  }
  get renderer() {
    return this.editor.renderer;
  }
  get history() {
    return this.editor.history;
  }
  get gestureManager() {
    return this.editor.gesture;
  }
  get snaps() {
    return this.editor.snaps;
  }
  get recognizer() {
    return this.editor.recognizer;
  }
  attach(i) {
    this.grabber.attach(i), this.grabber.onPointerDown = this.start.bind(this), this.grabber.onPointerMove = this.continue.bind(this), this.grabber.onPointerUp = this.end.bind(this);
  }
  detach() {
    this.grabber.detach();
  }
  needContextLessGesture(i) {
    const r = this.editor.getSymbolsBounds([i], 20);
    return this.detectGesture && this.model.symbols.some(i => {
      switch (i.type) {
        case E.Recognized:
        case E.Stroke:
          return !1;
        case E.Group:
          return !i.containsOnlyStroke() && i.bounds.overlaps(r);
        default:
          return i.bounds.overlaps(r);
      }
    });
  }
  createCurrentSymbol(i, s, n) {
    switch (this.#t.debug("createCurrentSymbol", {
      pointer: i,
      style: s,
      pointerType: n
    }), this.tool) {
      case r.Pencil:
        this.model.currentSymbol = new IIStroke(s, n);
        break;
      case r.Rectangle:
        this.model.currentSymbol = IIShapePolygon.createRectangleBetweenPoints(i, i, s);
        break;
      case r.Triangle:
        this.model.currentSymbol = IIShapePolygon.createTriangleBetweenPoints(i, i, s);
        break;
      case r.Parallelogram:
        this.model.currentSymbol = IIShapePolygon.createParallelogramBetweenPoints(i, i, s);
        break;
      case r.Rhombus:
        this.model.currentSymbol = IIShapePolygon.createRhombusBetweenPoints(i, i, s);
        break;
      case r.Circle:
        this.model.currentSymbol = IIShapeCircle.createBetweenPoints(i, i, s);
        break;
      case r.Ellipse:
        this.model.currentSymbol = IIShapeEllipse.createBetweenPoints(i, i, s);
        break;
      case r.Line:
      case r.Arrow:
      case r.DoubleArrow:
        {
          let n, a;
          this.tool === r.Arrow ? a = C.Arrow : this.tool === r.DoubleArrow && (n = C.Arrow, a = C.Arrow), this.model.currentSymbol = new IIEdgeLine(i, i, n, a, s);
          break;
        }
      default:
        throw new Error(`Can't create symbol, tool is unknow: "${this.tool}"`);
    }
    return this.updateCurrentSymbol(i);
  }
  updateCurrentSymbolShape(i) {
    switch (this.tool) {
      case r.Rectangle:
        IIShapePolygon.updateRectangleBetweenPoints(this.model.currentSymbol, this.currentSymbolOrigin, i);
        break;
      case r.Triangle:
        IIShapePolygon.updateTriangleBetweenPoints(this.model.currentSymbol, this.currentSymbolOrigin, i);
        break;
      case r.Parallelogram:
        IIShapePolygon.updateParallelogramBetweenPoints(this.model.currentSymbol, this.currentSymbolOrigin, i);
        break;
      case r.Rhombus:
        IIShapePolygon.updateRhombusBetweenPoints(this.model.currentSymbol, this.currentSymbolOrigin, i);
        break;
      case r.Circle:
        IIShapeCircle.updateBetweenPoints(this.model.currentSymbol, this.currentSymbolOrigin, i);
        break;
      case r.Ellipse:
        IIShapeEllipse.updateBetweenPoints(this.model.currentSymbol, this.currentSymbolOrigin, i);
    }
  }
  updateCurrentSymbolEdge(i) {
    const r = this.model.currentSymbol;
    if (r.kind === I.Line) r.end = i;
  }
  updateCurrentSymbol(i) {
    if (this.#t.debug("updateCurrentSymbol", {
      pointer: i
    }), !this.model.currentSymbol) throw new Error("Can't update current symbol because currentSymbol is undefined");
    switch (this.model.currentSymbol.type) {
      case E.Stroke:
        this.model.currentSymbol.addPointer(i);
        break;
      case E.Shape:
        this.updateCurrentSymbolShape(i);
        break;
      case E.Edge:
        this.updateCurrentSymbolEdge(i);
    }
    return this.model.currentSymbol;
  }
  start(i) {
    this.#t.info("startWriting", {
      info: i
    });
    const s = i.pointer;
    if (this.tool !== r.Pencil) {
      const {
        x: i,
        y: r
      } = this.snaps.snapResize(s);
      s.x = i, s.y = r;
    }
    this.currentSymbolOrigin = s, this.createCurrentSymbol(s, this.editor.penStyle, i.pointerType), this.renderer.drawSymbol(this.model.currentSymbol);
  }
  continue(i) {
    this.#t.info("continueWriting", {
      info: i
    });
    const s = i.pointer;
    if (this.tool !== r.Pencil) {
      const {
        x: i,
        y: r
      } = this.snaps.snapResize(s);
      s.x = i, s.y = r;
    }
    this.updateCurrentSymbol(s), this.renderer.drawSymbol(this.model.currentSymbol);
  }
  async interactWithBackend(i) {
    const r = i.clone();
    let s;
    if (this.needContextLessGesture(i) && (s = await this.gestureManager.getGestureFromContextLess(r)), s) this.history.pop(), this.recognizer.addStrokes([r], this.detectGesture), await this.gestureManager.apply(r, s);else {
      const i = await this.recognizer.addStrokes([r], this.detectGesture);
      i && (this.history.pop(), await this.gestureManager.apply(r, i));
    }
  }
  async end(i) {
    this.#t.info("finishWriting", {
      info: i
    });
    const s = i.pointer;
    if (this.tool !== r.Pencil) {
      const {
        x: i,
        y: r
      } = this.snaps.snapResize(s);
      s.x = i, s.y = r;
    }
    const n = this.updateCurrentSymbol(s);
    this.model.currentSymbol = void 0, this.currentSymbolOrigin = void 0, this.snaps.clearSnapToElementLines(), this.renderer.drawSymbol(n), this.model.addSymbol(n), this.history.push(this.model, {
      added: [n]
    }), n.type === E.Stroke && (await this.interactWithBackend(n));
  }
}
class IIEraseManager {
  #t = LoggerManager.getLogger(d.WRITE);
  grabber;
  editor;
  currentEraser;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i, this.grabber = new PointerEventGrabber(i.configuration.grabber);
  }
  get model() {
    return this.editor.model;
  }
  get renderer() {
    return this.editor.renderer;
  }
  attach(i) {
    this.grabber.attach(i), this.grabber.onPointerDown = this.start.bind(this), this.grabber.onPointerMove = this.continue.bind(this), this.grabber.onPointerUp = this.end.bind(this);
  }
  detach() {
    this.grabber.detach();
  }
  start(i) {
    this.#t.info("startErase", {
      info: i
    }), this.currentEraser = new IIEraser(), this.currentEraser.pointers.push(i.pointer), this.renderer.drawSymbol(this.currentEraser);
  }
  continue(i) {
    if (this.#t.info("continueErase", {
      info: i
    }), !this.currentEraser) throw new Error("Can't update current eraser because currentEraser is undefined");
    this.currentEraser.pointers.push(i.pointer), this.renderer.drawSymbol(this.currentEraser);
    const r = {
      p1: this.currentEraser.pointers.at(-1),
      p2: this.currentEraser.pointers.at(-2)
    };
    this.model.symbols.forEach(i => {
      i.isIntersected(r) && (i.deleting = !0);
    }), this.model.symbolsToDelete.map(i => this.renderer.drawSymbol(i));
  }
  async end(i) {
    this.#t.info("finishErasing", {
      info: i
    }), this.continue(i), this.renderer.removeSymbol(this.currentEraser.id), this.editor.removeSymbols(this.model.symbolsToDelete.map(i => i.id)), this.currentEraser = void 0;
  }
}
class IIDebugSVGManager {
  #t = LoggerManager.getLogger(d.SVGDEBUG);
  #h = !1;
  #c = !1;
  #u = !1;
  #p = !1;
  #g = !1;
  editor;
  constructor(i) {
    this.#t.info("constructor"), this.editor = i;
  }
  get model() {
    return this.editor.model;
  }
  get renderer() {
    return this.editor.renderer;
  }
  get snapPointsVisibility() {
    return this.#h;
  }
  set snapPointsVisibility(i) {
    this.#h = i, this.debugSnapPoints();
  }
  get verticesVisibility() {
    return this.#c;
  }
  set verticesVisibility(i) {
    this.#c = i, this.debugVertices();
  }
  get boundingBoxVisibility() {
    return this.#u;
  }
  set boundingBoxVisibility(i) {
    this.#u = i, this.#u ? this.showBoundingBox() : this.hideBoundingBox();
  }
  get recognitionBoxVisibility() {
    return this.#p;
  }
  set recognitionBoxVisibility(i) {
    this.#p = i, this.debugRecognitionBox();
  }
  get recognitionItemBoxVisibility() {
    return this.#g;
  }
  set recognitionItemBoxVisibility(i) {
    this.#g = i, this.debugRecognitionItemBox();
  }
  showSnapPoints() {
    this.#t.info("showSnapPoints"), this.model.currentSymbol && this.model.currentSymbol.snapPoints.forEach(i => this.renderer.drawCircle(i, 2, {
      fill: "blue",
      debug: "snap-points"
    })), this.model.symbols.forEach(i => i.snapPoints.forEach(i => this.renderer.drawCircle(i, 2, {
      fill: "blue",
      debug: "snap-points"
    })));
  }
  hideSnapPoints() {
    this.#t.info("hideSnapPoints"), this.renderer.clearElements({
      attrs: {
        debug: "snap-points"
      }
    });
  }
  debugSnapPoints() {
    this.hideSnapPoints(), this.snapPointsVisibility && this.showSnapPoints();
  }
  showVertices() {
    this.#t.info("showVertices"), this.model.currentSymbol && this.model.currentSymbol.vertices.forEach(i => this.renderer.drawCircle(i, 2, {
      fill: "red",
      debug: "vertices"
    })), this.model.symbols.forEach(i => i.vertices.forEach(i => this.renderer.drawCircle(i, 2, {
      fill: "red",
      debug: "vertices"
    })));
  }
  hideVertices() {
    this.#t.info("hideVertices"), this.renderer.clearElements({
      attrs: {
        debug: "vertices"
      }
    });
  }
  debugVertices() {
    this.hideVertices(), this.verticesVisibility && this.showVertices();
  }
  drawBoundingBox(i) {
    const r = {
        style: "pointer-events: none",
        fill: "transparent",
        stroke: "red",
        "stroke-width": "1",
        "stroke-dasharray": "5 5",
        "vector-effect": "non-scaling-stroke",
        debug: "bounding-box"
      },
      s = {
        style: "pointer-events: none",
        fill: "transparent",
        stroke: "orange",
        "stroke-width": "1",
        "stroke-dasharray": "0 5 0",
        "vector-effect": "non-scaling-stroke",
        debug: "bounding-box"
      };
    i.forEach(i => {
      const n = this.renderer.getElementById(i.id);
      if (n) if (i.type === E.Text) {
        const a = i;
        let l = "";
        a.rotation && (l = `rotate(${a.rotation.degree}, ${a.rotation.center.x}, ${a.rotation.center.y})`), a.chars.forEach(i => {
          const r = {
            ...s,
            char: i.label,
            transform: l
          };
          n.insertAdjacentElement("beforebegin", SVGBuilder.createRect(i.bounds, r));
        });
        const d = {
          ...r,
          symbol: i.id,
          transform: l
        };
        n.insertAdjacentElement("beforebegin", SVGBuilder.createRect(i.bounds, d));
      } else {
        const s = {
          ...r,
          symbol: i.id
        };
        n.insertAdjacentElement("beforebegin", SVGBuilder.createRect(i.bounds, s));
      }
    });
  }
  showBoundingBox() {
    this.#t.info("showBoundingBox"), this.model.currentSymbol && this.drawBoundingBox([this.model.currentSymbol]), this.drawBoundingBox(this.model.symbols);
  }
  hideBoundingBox() {
    this.#t.info("hideBoundingBox"), this.renderer.clearElements({
      attrs: {
        debug: "bounding-box"
      }
    });
  }
  debugBoundingBox() {
    this.hideBoundingBox(), this.boundingBoxVisibility && this.showBoundingBox();
  }
  drawRecognitionBox(i, r) {
    const s = "green",
      n = SVGBuilder.createGroup({
        debug: "recognition-box"
      }),
      a = SVGBuilder.createRect(i, {
        fill: "transparent",
        stroke: s,
        style: pe.noSelection
      });
    n.appendChild(a);
    const l = SVGBuilder.createGroup({
        id: `infos-group-${createUUID()}`
      }),
      d = i.x + i.width;
    let h = i.y + 10;
    r?.forEach(i => {
      l.appendChild(SVGBuilder.createText({
        x: d,
        y: h
      }, i, {
        stroke: s,
        style: pe.noSelection
      })), h += 20;
    }), n.appendChild(l), this.renderer.layer.appendChild(n);
    const c = l.getBBox(),
      u = {
        width: c.width + 10,
        height: c.height + 10,
        x: c.x - 5,
        y: c.y - 5
      },
      p = SVGBuilder.createRect(u, {
        fill: "white",
        style: "cursor:move",
        stroke: s
      });
    l.prepend(p);
    const translateEl = r => {
      r.preventDefault(), r.stopPropagation();
      const n = Number(this.renderer.getAttribute(l.id, "originX")),
        a = Number(this.renderer.getAttribute(l.id, "originY")),
        d = r.clientX - n,
        h = r.clientY - a;
      this.renderer.setAttribute(l.id, "transform", `translate(${d},${h})`);
      const c = {
        width: u.width,
        height: u.height,
        x: u.x + d,
        y: u.y + h
      };
      this.renderer.removeSymbol(`connection-${l.id}`), this.renderer.drawConnectionBetweenBox(`connection-${l.id}`, i, c, {
        stroke: s,
        debug: "recognition-box-link"
      });
    };
    p.addEventListener("pointerdown", i => {
      i.preventDefault(), i.stopPropagation(), this.renderer.getAttribute(l.id, "originX") || (this.renderer.setAttribute(l.id, "originX", i.clientX.toString()), this.renderer.setAttribute(l.id, "originY", i.clientY.toString())), this.renderer.layer.addEventListener("pointermove", translateEl), this.renderer.layer.addEventListener("pointerup", () => this.renderer.layer.removeEventListener("pointermove", translateEl)), this.renderer.layer.addEventListener("pointerleave", () => this.renderer.layer.removeEventListener("pointermove", translateEl)), this.renderer.layer.addEventListener("pointercancel", () => this.renderer.layer.removeEventListener("pointermove", translateEl));
    });
  }
  async showRecognitionBox() {
    this.#t.info("showRecognitionBox"), await this.editor.export(["application/vnd.myscript.jiix"]);
    const i = this.model.exports?.["application/vnd.myscript.jiix"];
    if (this.#t.debug("showRecognitionBox", {
      jiix: i
    }), i) {
      if (!i["bounding-box"]) return void this.#t.warn("drawRecognitionBox", 'You must to enabled configuration.recognition.exports["bounding-box"]');
      i.elements?.forEach(i => {
        switch (i.type) {
          case "Node":
            if (i["bounding-box"]) {
              const r = convertBoundingBoxMillimeterToPixel(i["bounding-box"]),
                s = ["bounding-box", "items", "id"],
                n = Object.keys(i).filter(i => !s.includes(i)).map(r => `${r}: ${JSON.stringify(i[r])}`);
              this.drawRecognitionBox(r, n);
            }
            break;
          case "Text":
            i.words?.forEach(r => {
              if (r?.["bounding-box"]) {
                const s = convertBoundingBoxMillimeterToPixel(r["bounding-box"]);
                this.drawRecognitionBox(s, [`type: ${i.type}`, `candidates: ${JSON.stringify(r.candidates || [])}`]);
              }
            });
            break;
          case "Edge":
            if (i.kind === m.PolyEdge) {
              const r = [`type: ${i.type}`, `kind: ${i.kind}`];
              i.edges.forEach((i, s) => {
                let n = `edge-${s}: [{ x1: ${i.x1}, y2: ${i.y1} },{ x2: ${i.x2}, y2: ${i.y2} }]`;
                i.p1Decoration && (n += `, p1Decoration: ${i.p1Decoration}`), i.p2Decoration && (n += `, p2Decoration: ${i.p2Decoration}`), r.push(n);
              });
              const s = convertBoundingBoxMillimeterToPixel(Box.createFromBoxes(i.edges.map(i => i["bounding-box"])));
              this.drawRecognitionBox(s, r);
            } else if (i["bounding-box"]) {
              const r = convertBoundingBoxMillimeterToPixel(i["bounding-box"]),
                s = ["bounding-box", "items", "id", "ports", "connected"],
                n = Object.keys(i).filter(i => !s.includes(i)).map(r => `${r}: ${JSON.stringify(i[r])}`);
              this.drawRecognitionBox(r, n);
            }
            break;
          default:
            this.#t.warn("drawRecognitionBox", `Unknow jiix element type: ${i.type}`);
        }
      });
    }
  }
  clearRecognitionBox() {
    this.#t.info("clearRecognitionBox"), this.renderer.clearElements({
      attrs: {
        debug: "recognition-box"
      }
    }), this.renderer.clearElements({
      attrs: {
        debug: "recognition-box-link"
      }
    });
  }
  async debugRecognitionBox() {
    this.clearRecognitionBox(), this.#p && this.showRecognitionBox();
  }
  drawRecognitionItemBox(i, r, s) {
    const n = "blue",
      a = SVGBuilder.createGroup({
        debug: "recognition-item-box"
      }),
      l = SVGBuilder.createRect(i, {
        fill: "transparent",
        stroke: n,
        style: pe.noSelection
      });
    a.appendChild(l);
    const d = i.x;
    let h = i.y - 14;
    const c = SVGBuilder.createGroup({
      id: `chars-group-${createUUID()}`
    });
    r && c.appendChild(SVGBuilder.createText({
      x: d,
      y: h
    }, `label: ${r}`, {
      fill: n,
      "font-size": 14..toString(),
      style: pe.noSelection
    })), s?.length && (h += 14, c.appendChild(SVGBuilder.createText({
      x: d,
      y: h
    }, `[${s.join(", ")}]`, {
      fill: n,
      "font-size": 14..toString(),
      style: pe.noSelection
    }))), a.appendChild(c), this.renderer.layer.appendChild(a);
    const u = c.getBBox(),
      p = {
        width: u.width + 10,
        height: u.height + 10,
        x: u.x - 5,
        y: u.y - 5
      },
      g = SVGBuilder.createRect(p, {
        fill: "white",
        style: "cursor:move",
        stroke: n
      });
    c.prepend(g);
    const translateEl = r => {
      r.preventDefault(), r.stopPropagation();
      const s = Number(this.renderer.getAttribute(c.id, "originX")),
        a = Number(this.renderer.getAttribute(c.id, "originY")),
        l = r.clientX - s,
        d = r.clientY - a;
      this.renderer.setAttribute(c.id, "transform", `translate(${l},${d})`);
      const h = {
        width: p.width,
        height: p.height,
        x: p.x + l,
        y: p.y + d
      };
      this.renderer.removeSymbol(`connection-${c.id}`), this.renderer.drawConnectionBetweenBox(`connection-${c.id}`, i, h, {
        stroke: n,
        debug: "recognition-item-box-link"
      });
    };
    g.addEventListener("pointerdown", i => {
      i.preventDefault(), i.stopPropagation(), this.renderer.getAttribute(c.id, "originX") || (this.renderer.setAttribute(c.id, "originX", i.clientX.toString()), this.renderer.setAttribute(c.id, "originY", i.clientY.toString())), this.renderer.layer.addEventListener("pointermove", translateEl);
    }), this.renderer.layer.addEventListener("pointerup", () => this.renderer.layer.removeEventListener("pointermove", translateEl)), this.renderer.layer.addEventListener("pointerleave", () => this.renderer.layer.removeEventListener("pointermove", translateEl)), this.renderer.layer.addEventListener("pointercancel", () => this.renderer.layer.removeEventListener("pointermove", translateEl));
  }
  async showRecognitionItemBox() {
    this.#t.info("showRecognitionBoxItem"), await this.editor.export(["application/vnd.myscript.jiix"]);
    const i = this.model.exports?.["application/vnd.myscript.jiix"];
    this.#t.debug("showRecognitionBoxItem", {
      jiix: i
    }), i && i.elements?.forEach(i => {
      switch (i.type) {
        case "Text":
          i.chars?.forEach(i => {
            if (i?.["bounding-box"]) {
              const r = convertBoundingBoxMillimeterToPixel(i["bounding-box"]);
              this.drawRecognitionItemBox(r, i.label, i.candidates);
            }
          });
          break;
        case "Node":
          if (i?.["bounding-box"]) {
            const r = convertBoundingBoxMillimeterToPixel(i["bounding-box"]);
            this.drawRecognitionItemBox(r, i.kind);
          }
          break;
        case "Edge":
          if (i.kind === m.PolyEdge) i.edges.forEach(i => {
            const r = convertBoundingBoxMillimeterToPixel(i["bounding-box"]);
            this.drawRecognitionItemBox(r, i.kind);
          });else if (i["bounding-box"]) {
            const r = convertBoundingBoxMillimeterToPixel(i["bounding-box"]);
            this.drawRecognitionItemBox(r, i.kind);
          }
          break;
        default:
          this.#t.warn("drawRecognitionBoxItem", `Unknow jiix element type: ${i.type}`);
      }
    });
  }
  clearRecognitionItemBox() {
    this.#t.info("clearRecognitionBoxItem"), this.renderer.clearElements({
      attrs: {
        debug: "recognition-item-box"
      }
    }), this.renderer.clearElements({
      attrs: {
        debug: "recognition-item-box-link"
      }
    });
  }
  async debugRecognitionItemBox() {
    this.clearRecognitionItemBox(), this.#g && this.showRecognitionItemBox();
  }
  apply() {
    this.debugBoundingBox(), this.debugVertices(), this.debugSnapPoints(), this.debugRecognitionBox(), this.debugRecognitionItemBox();
  }
}
class IIMoveManager {
  grabber;
  editor;
  origin;
  constructor(i) {
    this.editor = i, this.grabber = new PointerEventGrabber(i.configuration.grabber);
  }
  get renderer() {
    return this.editor.renderer;
  }
  attach(i) {
    this.grabber.attach(i), this.grabber.onPointerDown = this.start.bind(this), this.grabber.onPointerMove = this.continue.bind(this), this.grabber.onPointerUp = this.end.bind(this);
  }
  detach() {
    this.grabber.detach();
  }
  start(i) {
    this.origin = {
      left: this.renderer.parent.scrollLeft,
      top: this.renderer.parent.scrollTop,
      x: i.clientX,
      y: i.clientY
    };
  }
  continue(i) {
    if (!this.origin) throw new Error("Can't move cause origin is undefined");
    const r = i.clientX - this.origin.x,
      s = i.clientY - this.origin.y;
    this.renderer.parent.scrollTop = this.origin.top - s, this.renderer.parent.scrollLeft = this.origin.left - r;
  }
  end(i) {
    this.continue(i), this.origin = void 0;
  }
}
const getInitialHistoryContext = () => ({
  stackIndex: 0,
  possibleUndoCount: 0,
  canRedo: !1,
  canUndo: !1,
  empty: !0
});
class HistoryManager {
  #t = LoggerManager.getLogger(d.HISTORY);
  configuration;
  event;
  context;
  stack;
  constructor(i, r) {
    this.#t.info("constructor", {
      configuration: i
    }), this.configuration = i, this.event = r, this.context = {
      stackIndex: 0,
      possibleUndoCount: 0,
      canRedo: !1,
      canUndo: !1,
      empty: !0
    }, this.stack = [];
  }
  updateContext() {
    this.context.canRedo = this.stack.length - 1 > this.context.stackIndex, this.context.canUndo = this.context.stackIndex > 0, this.context.empty = 0 === this.stack[this.context.stackIndex].symbols.length;
  }
  push(i) {
    this.#t.info("push", {
      model: i
    }), this.context.stackIndex + 1 < this.stack.length && this.stack.splice(this.context.stackIndex + 1), this.stack.push(i.clone()), this.context.stackIndex = this.stack.length - 1, this.stack.length > this.configuration.maxStackSize && (this.stack.shift(), this.context.stackIndex--), this.updateContext(), this.event.emitChanged(this.context);
  }
  updateStack(i) {
    this.#t.info("updateStack", {
      model: i
    });
    const r = this.stack.findIndex(r => r.modificationDate === i.modificationDate);
    r > -1 && this.stack.splice(r, 1, i.clone()), this.updateContext(), this.event.emitChanged(this.context);
  }
  undo() {
    this.#t.info("undo"), this.context.canUndo && (this.context.stackIndex--, this.updateContext(), this.event.emitChanged(this.context));
    const i = this.stack[this.context.stackIndex].clone();
    return this.#t.debug("undo", i), i;
  }
  redo() {
    this.#t.info("redo"), this.context.canRedo && (this.context.stackIndex++, this.updateContext(), this.event.emitChanged(this.context));
    const i = this.stack[this.context.stackIndex].clone();
    return this.#t.debug("redo", i), i;
  }
}
class IIHistoryManager {
  #t = LoggerManager.getLogger(d.HISTORY);
  configuration;
  event;
  context;
  stack;
  constructor(i, r) {
    this.#t.info("constructor", {
      configuration: i
    }), this.configuration = i, this.event = r, this.context = {
      stackIndex: 0,
      possibleUndoCount: 0,
      canRedo: !1,
      canUndo: !1,
      empty: !0
    }, this.stack = [];
  }
  updateContext() {
    this.context.canRedo = this.stack.length - 1 > this.context.stackIndex, this.context.canUndo = this.context.stackIndex > 0, this.context.empty = 0 === this.stack[this.context.stackIndex].model.symbols.length;
  }
  isChangesEmpty(i) {
    return !(i.added?.length || i.updated?.length || i.erased?.length || i.replaced?.oldSymbols.length || i.matrix?.symbols.length || i.translate?.length || i.rotate?.length || i.scale?.length || i.style?.symbols?.length || i.order?.symbols?.length || i.decorator?.length || i.group?.symbols.length || i.ungroup?.group);
  }
  init(i) {
    this.stack.push({
      model: i.clone(),
      changes: {}
    }), this.event.emitChanged(this.context);
  }
  push(i, r) {
    this.#t.info("push", {
      model: i,
      changes: r
    }), this.isChangesEmpty(r) || (this.context.stackIndex + 1 < this.stack.length && this.stack.splice(this.context.stackIndex + 1), this.stack.push({
      model: i.clone(),
      changes: r
    }), this.context.stackIndex = this.stack.length - 1, this.stack.length > this.configuration.maxStackSize && (this.stack.shift(), this.context.stackIndex--), this.updateContext(), this.event.emitChanged(this.context));
  }
  update(i) {
    this.#t.info("pop");
    const r = this.stack.findIndex(r => r.model.modificationDate === i.modificationDate);
    r > -1 && (this.stack[r].model = i, this.updateContext());
  }
  pop() {
    this.#t.info("pop"), this.stack.pop(), this.context.stackIndex = this.stack.length - 1, this.updateContext();
  }
  reverseChanges(i) {
    const r = {};
    return i.added && (r.erased = i.added), i.erased && (r.added = i.erased), i.replaced && (r.replaced = {
      newSymbols: i.replaced.oldSymbols,
      oldSymbols: i.replaced.newSymbols
    }), i.matrix && (r.matrix = {
      symbols: i.matrix.symbols,
      matrix: new MatrixTransform(i.matrix.matrix.xx, i.matrix.matrix.yx, i.matrix.matrix.xy, i.matrix.matrix.yy, i.matrix.matrix.tx, i.matrix.matrix.ty).invert()
    }), i.translate?.length && (r.translate = i.translate.map(i => ({
      symbols: i.symbols,
      tx: -i.tx,
      ty: -i.ty
    }))), i.rotate?.length && (r.rotate = i.rotate.map(i => ({
      symbols: i.symbols,
      angle: 2 * Math.PI - i.angle,
      center: i.center
    }))), i.scale?.length && (r.scale = i.scale.map(i => ({
      symbols: i.symbols,
      origin: i.origin,
      scaleX: 1 / i.scaleX,
      scaleY: 1 / i.scaleY
    }))), r;
  }
  undo() {
    this.#t.info("undo");
    const i = this.stack[this.context.stackIndex];
    this.context.canUndo && (this.context.stackIndex--, this.updateContext(), this.event.emitChanged(this.context));
    const r = this.stack[this.context.stackIndex];
    return this.#t.debug("undo", r), {
      model: r.model,
      changes: this.reverseChanges(i.changes)
    };
  }
  redo() {
    this.#t.info("redo"), this.context.canRedo && (this.context.stackIndex++, this.updateContext(), this.event.emitChanged(this.context));
    const i = this.stack[this.context.stackIndex];
    return this.#t.debug("redo", i), i;
  }
  clear() {
    this.context = {
      stackIndex: 0,
      possibleUndoCount: 0,
      canRedo: !1,
      canUndo: !1,
      empty: !0
    }, this.stack = [];
  }
}
const Se = {
  maxStackSize: 100
};
var we = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
class IIMenu {
  thicknessList = [{
    label: "S",
    value: 1
  }, {
    label: "M",
    value: 2
  }, {
    label: "L",
    value: 4
  }, {
    label: "XL",
    value: 8
  }];
  fontSizeList = [{
    label: "Auto",
    value: "auto"
  }, {
    label: "S",
    value: .5
  }, {
    label: "M",
    value: .75
  }, {
    label: "L",
    value: 1
  }];
  fontWeightList = [{
    label: "Auto",
    value: "auto"
  }, {
    label: "Normal",
    value: "normal"
  }, {
    label: "Bold",
    value: "bold"
  }];
  colors = ["#000000", "#808080", "#ffffff", "transparent", "#ff0000", "#ff6400", "#ffc800", "#ffff00", "#0000ff", "#0064ff", "#00c8ff", "#00ffff", "#008000", "#00af00", "#00e100", "#00ff00"];
  createWrapCollapsible(i, r) {
    const s = document.createElement("div");
    s.classList.add("collapsible-wrapper");
    const n = document.createElement("div");
    n.classList.add("collapsible-header"), n.textContent = r;
    const a = document.createElement("span");
    a.classList.add("collapsible-header-icon"), a.innerHTML = we, n.appendChild(a), n.style.setProperty("pointer", "cursor");
    const l = document.createElement("div");
    return l.classList.add("collapsible-content"), n.addEventListener("pointerup", () => s.classList.toggle("active")), s.appendChild(n), l.appendChild(i), s.appendChild(l), s;
  }
  createMenuItemBoolean(i) {
    const r = document.createElement("div");
    r.classList.add("ms-menu-item", i.type);
    const s = document.createElement("span");
    s.textContent = i.label, r.appendChild(s);
    const n = document.createElement("input");
    return n.id = i.id, n.setAttribute("type", "checkbox"), i.disabled && (n.disabled = !0), "indeterminate" === i.initValue ? n.indeterminate = !0 : n.checked = i.initValue, n.addEventListener("change", r => i.callback(r.target.checked)), r.appendChild(n), r;
  }
  createMenuItemSelect(i) {
    const r = document.createElement("div");
    r.classList.add("ms-menu-item", i.type);
    const s = document.createElement("span");
    s.textContent = i.label, r.appendChild(s);
    const n = document.createElement("select");
    return n.id = i.id, i.disabled && (n.disabled = !0), i.values.forEach(r => {
      const s = r.value === i.initValue,
        a = new Option(r.label, r.value.toString(), s, s);
      n.appendChild(a);
    }), n.addEventListener("change", r => i.callback(r.target.value)), r.appendChild(n), r;
  }
  createMenuItemButton(i) {
    const r = document.createElement("button");
    return r.classList.add("ms-menu-item", "ms-menu-button"), r.innerHTML = i.icon || i.label, r.addEventListener("pointerup", i.callback), r;
  }
  createMenuItemButtonList(i) {
    const r = document.createElement("div");
    r.classList.add("ms-menu-item", i.type), r.id = i.id;
    const s = document.createElement("span");
    return s.textContent = i.label, r.appendChild(s), i.values.forEach(s => {
      const n = document.createElement("button");
      i.disabled && (n.disabled = !0), n.id = `${i.id}-${s.value}-btn`, i.initValue === s.value && n.classList.add("active"), n.textContent = s.label, n.addEventListener("pointerup", () => {
        i.callback(s.value), r.querySelectorAll("*").forEach(i => i.classList.remove("active")), n.classList.add("active");
      }), r.appendChild(n);
    }), r;
  }
  createMenuItemColorList(i) {
    const r = document.createElement("div");
    r.classList.add("ms-menu-item", i.type), r.id = i.id;
    const s = document.createElement("span");
    return s.textContent = i.label, r.appendChild(s), r.appendChild(this.createColorList(i)), r;
  }
  createColorList(i) {
    const r = document.createElement("div");
    return r.id = `${i.id}-list`, r.classList.add("ms-menu-row", "color-list"), i.values.forEach(s => {
      const n = document.createElement("button");
      i.disabled && (n.disabled = !0), n.id = `${i.id}-${s.replace("#", "")}-btn`, n.classList.add("ms-menu-button", "square");
      const a = document.createElement("div");
      a.classList.add("color"), i.fill ? (a.style.setProperty("background-color", s), a.style.setProperty("border", "1px solid lightgrey")) : (a.style.setProperty("background-color", "transparent"), a.style.setProperty("border", `3px solid ${s}`)), "#ffffff" === s && a.style.setProperty("border", "1px solid black"), "transparent" === s && a.style.setProperty("background-image", "linear-gradient(45deg, #AAA 10%, transparent 20%, #AAA 30%, transparent 40%, #AAA 50%, transparent 60%, #AAA 70%, transparent 80%, #AAA 90%, transparent 100%)"), i.initValue === s && n.classList.add("active"), n.appendChild(a), n.addEventListener("pointerup", a => {
        a.preventDefault(), a.stopPropagation(), i.callback(s), r.querySelectorAll("*").forEach(i => i.classList.remove("active")), n.classList.add("active");
      }), r.appendChild(n);
    }), r;
  }
  createMenuItem(i) {
    switch (i.type) {
      case "checkbox":
        return this.createMenuItemBoolean(i);
      case "select":
        return this.createMenuItemSelect(i);
      case "list":
        return this.createMenuItemButtonList(i);
      case "colors":
        return this.createMenuItemColorList(i);
      default:
        return this.createMenuItemButton(i);
    }
  }
}
var ve, ke, Ee;
!function (i) {
  i.Select = "select", i.Surround = "surround", i.Highlight = "highlight";
}(ve || (ve = {})), function (i) {
  i.Erase = "erase", i.Draw = "draw";
}(ke || (ke = {})), function (i) {
  i.LineBreak = "line-break", i.Insert = "insert";
}(Ee || (Ee = {}));
const Ie = {
  surround: ve.Select,
  strikeThrough: ke.Draw,
  insert: Ee.LineBreak
};
class IIGestureManager {
  #t = LoggerManager.getLogger(d.GESTURE);
  insertAction = Ee.LineBreak;
  surroundAction = ve.Select;
  strikeThroughAction = ke.Draw;
  editor;
  constructor(i, r) {
    this.#t.info("constructor"), this.editor = i, this.surroundAction = r?.surround || Ie.surround, this.strikeThroughAction = r?.strikeThrough || Ie.strikeThrough, this.insertAction = r?.insert || Ie.insert;
  }
  get renderer() {
    return this.editor.renderer;
  }
  get recognizer() {
    return this.editor.recognizer;
  }
  get translator() {
    return this.editor.translator;
  }
  get texter() {
    return this.editor.texter;
  }
  get model() {
    return this.editor.model;
  }
  get history() {
    return this.editor.history;
  }
  get rowHeight() {
    return this.editor.configuration.rendering.guides.gap;
  }
  get strokeSpaceWidth() {
    return 2 * this.editor.configuration.rendering.guides.gap;
  }
  async applySurroundGesture(r, s) {
    this.#t.info("applySurroundGesture", {
      gestureStroke: r,
      gesture: s
    });
    const n = {},
      a = this.model.symbols.filter(i => r.bounds.contains(i.bounds)).map(i => i.id);
    switch (this.surroundAction) {
      case ve.Select:
        a.length && (this.editor.tool = i.Select, this.editor.select(a));
        break;
      case ve.Highlight:
        {
          const i = [];
          n.decorator = [], a.forEach(r => {
            const s = this.model.getRootSymbol(r);
            if (s && [E.Group, E.Stroke, E.Text, E.Recognized].includes(s.type) && !i.includes(s.id)) {
              const r = s,
                a = new IIDecorator(k.Highlight, this.editor.penStyle),
                l = r.decorators.findIndex(i => i.kind === k.Highlight),
                d = -1 === l;
              d ? r.decorators.push(a) : r.decorators.splice(l, 1), this.model.updateSymbol(r), this.renderer.drawSymbol(r), i.push(r.id), n.decorator.push({
                symbol: r,
                decorator: a,
                added: d
              });
            }
          }), n.decorator.length && this.history.push(this.model, n);
          break;
        }
      case ve.Surround:
        {
          const i = [];
          n.decorator = [], a.forEach(r => {
            const s = this.model.getRootSymbol(r);
            if (s && [E.Group, E.Stroke, E.Text, E.Recognized].includes(s.type) && !i.includes(s.id)) {
              const r = s,
                a = new IIDecorator(k.Surround, this.editor.penStyle),
                l = r.decorators.findIndex(i => i.kind === k.Surround),
                d = -1 === l;
              d ? r.decorators.push(a) : r.decorators.splice(l, 1), this.model.updateSymbol(r), this.renderer.drawSymbol(r), n.decorator.push({
                symbol: r,
                decorator: a,
                added: d
              }), i.push(r.id);
            }
          }), this.history.push(this.model, n);
          break;
        }
      default:
        this.#t.error("applySurroundGesture", `Unknow surroundAction: ${this.surroundAction}, values allowed are: ${ve.Highlight}, ${ve.Select}, ${ve.Surround}`);
    }
  }
  computeScratchOnStrokes(i, r) {
    const s = [],
      n = i.subStrokes?.find(i => i.fullStrokeId === r.id);
    if (n) {
      const i = new IIStroke();
      n.x.forEach((r, s) => i.addPointer({
        x: r,
        y: n.y[s],
        p: 1,
        t: 1
      }));
      const a = IIStroke.substract(r, i);
      a.before && a.before.pointers.length > 1 && s.push(a.before), a.after && a.after.pointers.length > 1 && s.push(a.after);
    }
    return s;
  }
  computeScratchOnText(i, r) {
    const s = r.getCharsOverlaps(i.pointers);
    return r.chars.length == s.length ? void 0 : (s.forEach(i => {
      const s = r.chars.findIndex(r => r.id === i.id);
      r.chars.splice(s, 1);
    }), this.texter.updateBounds(r), r);
  }
  computeScratchOnSymbol(i, r, s) {
    switch (s.type) {
      case E.Stroke:
        {
          const i = this.computeScratchOnStrokes(r, s);
          return i.length ? {
            replaced: i
          } : {
            erased: !0
          };
        }
      case E.Recognized:
        if (s.kind === T.Text) {
          const n = s.strokes.filter(r => !i.bounds.overlaps(r.bounds)),
            a = s.strokes.filter(r => i.bounds.overlaps(r.bounds)).map(i => ({
              symbol: i,
              result: this.computeScratchOnStrokes(r, i)
            }));
          if (0 === n.length && a.every(i => 0 === i.result.length)) return {
            erased: !0
          };
          {
            const i = n.concat(...a.flatMap(i => i.result)),
              r = new IIRecognizedText(i, {
                baseline: s.baseline,
                xHeight: s.xHeight
              }, s.style);
            return r.decorators = s.decorators, {
              replaced: [r]
            };
          }
        }
        return {};
      case E.Group:
        {
          const n = s.children.filter(r => !i.bounds.overlaps(r.bounds)),
            a = s.children.filter(r => i.bounds.overlaps(r.bounds)).map(s => ({
              symbol: s,
              result: this.computeScratchOnSymbol(i, r, s)
            }));
          if (0 === n.length && a.every(i => i.result.erased)) return {
            erased: !0
          };
          {
            const i = n;
            a.forEach(r => {
              r.result.replaced && i.push(...r.result.replaced);
            });
            const r = new IISymbolGroup(i, s.style);
            return r.decorators = s.decorators, {
              replaced: [r]
            };
          }
        }
      case E.Text:
        {
          const r = this.computeScratchOnText(i, s);
          return r ? {
            replaced: [r]
          } : {
            erased: !0
          };
        }
      case E.Shape:
      case E.Edge:
        return {
          erased: !0
        };
    }
  }
  async applyScratch(i, r) {
    if (this.#t.debug("applyScratchGesture", {
      gestureStroke: i,
      gesture: r
    }), !r.strokeIds.length) return void this.#t.warn("applyScratchGesture", "Unable to apply underline because there are no strokes");
    const s = [],
      n = [],
      a = {
        oldSymbols: [],
        newSymbols: []
      };
    r.strokeIds.forEach(s => {
      const l = this.model.getRootSymbol(s);
      if (l && !n.some(i => i.id === l.id) && !a.oldSymbols.some(i => i.id === l.id)) {
        const s = this.computeScratchOnSymbol(i, r, l);
        s.erased ? n.push(l) : s.replaced && (a.newSymbols.push(...s.replaced), a.oldSymbols.push(l));
      }
    });
    const l = [],
      d = {};
    s.length && (l.push(this.editor.updateSymbols(s, !1)), d.updated = s), n.length && (l.push(this.editor.removeSymbols(n.map(i => i.id), !1)), d.erased = n), a.newSymbols.length && (d.replaced = a, l.push(this.editor.replaceSymbols(a.oldSymbols, a.newSymbols, !1))), this.history.push(this.model, d), await Promise.all(l);
  }
  async applyJoinGesture(i, r) {
    this.#t.debug("applyJoinGesture", {
      gestureStroke: i,
      gesture: r
    });
    const s = this.model.symbols.filter(r => this.model.isSymbolAbove(i, r)),
      n = this.model.symbols.filter(r => i.id !== r.id && this.model.isSymbolInRow(i, r)),
      a = n.filter(r => r.bounds.xMax <= i.bounds.xMid),
      l = n.filter(r => r.bounds.xMax > i.bounds.xMid && r.bounds.xMin <= i.bounds.xMid),
      d = n.filter(r => r.bounds.xMin > i.bounds.xMid),
      h = this.model.symbols.filter(r => this.model.isSymbolBelow(i, r)),
      c = {},
      u = [];
    if (l.length) {
      const r = l[0];
      if (r?.type === E.Group) {
        const s = r.children.map(i => i.clone()),
          n = s.filter(r => r.bounds.xMid <= i.bounds.xMid),
          a = s.filter(r => r.bounds.xMid > i.bounds.xMid);
        if (n.length && a.length) {
          const i = Math.max(...n.map(i => i.bounds.xMax)) - Math.min(...a.map(i => i.bounds.xMin));
          a.forEach(r => this.translator.applyToSymbol(r, i, 0));
          const l = new IISymbolGroup(s, r.style);
          l.decorators = r.decorators.map(i => i.clone()), c.replaced = {
            oldSymbols: [r],
            newSymbols: [l]
          }, d.length && u.push({
            symbols: d,
            tx: i,
            ty: 0
          });
        } else if (d.length) {
          const i = r.bounds.xMax - Math.min(...d.map(i => i.bounds.xMin));
          u.push({
            symbols: d,
            tx: i,
            ty: 0
          });
        }
      } else if (r?.type === E.Recognized) {
        const s = r.clone(),
          n = s.strokes.filter(r => r.bounds.xMid <= i.bounds.xMid),
          a = s.strokes.filter(r => r.bounds.xMid > i.bounds.xMid);
        if (n.length && a.length) {
          const i = Math.max(...n.map(i => i.bounds.xMax)) - Math.min(...a.map(i => i.bounds.xMin));
          a.forEach(r => this.translator.applyToSymbol(r, i, 0)), c.replaced = {
            oldSymbols: [r],
            newSymbols: [s]
          }, d.length && u.push({
            symbols: d,
            tx: i,
            ty: 0
          });
        } else if (d.length) {
          const i = r.bounds.xMax - Math.min(...d.map(i => i.bounds.xMin));
          u.push({
            symbols: d,
            tx: i,
            ty: 0
          });
        }
      }
    } else if (a.length && d.length) {
      const i = this.model.getLastSymbol(a),
        r = this.model.getFirstSymbol(d),
        s = Math.max(...a.map(i => i.bounds.xMax)) - Math.min(...d.map(i => i.bounds.xMin)),
        n = i.clone(),
        l = r.clone();
      this.translator.applyToSymbol(l, s, 0);
      const h = i.type === E.Group ? n.children : [n];
      if (h.push(...(l.type === E.Group ? l.children : [l])), h.every(i => i.type === E.Text)) {
        const s = h,
          n = new IIText(s.flatMap(i => i.chars), s[0].point, Box.createFromBoxes(s.map(i => i.bounds)));
        this.texter.setBounds(n), c.replaced = {
          oldSymbols: [i, r],
          newSymbols: [n]
        };
      } else if (h.every(i => i.type === E.Recognized)) {
        const s = h,
          n = new IIRecognizedText(s.flatMap(i => i.strokes), s[0], s[0].style);
        c.replaced = {
          oldSymbols: [i, r],
          newSymbols: [n]
        };
      } else {
        const s = new IISymbolGroup(h, i.style);
        [E.Group, E.Stroke, E.Text, E.Recognized].includes(i.type) && i.decorators.forEach(i => {
          s.decorators.push(new IIDecorator(i.kind, i.style));
        }), [E.Group, E.Stroke, E.Text, E.Recognized].includes(r.type) && r.decorators.forEach(i => {
          s.decorators.some(r => r.kind == i.kind) || s.decorators.push(new IIDecorator(i.kind, i.style));
        }), c.replaced = {
          oldSymbols: [i, r],
          newSymbols: [s]
        };
      }
      const p = d.filter(i => i.id !== r.id);
      p.length && u.push({
        symbols: p,
        tx: s,
        ty: 0
      });
    } else if (a.length) {
      const i = this.model.getLastSymbol(a),
        r = this.model.getFirstSymbol(h);
      if (r) {
        if (this.model.roundToLineGuide(i.bounds.yMid) >= this.model.roundToLineGuide(r.bounds.yMid - this.rowHeight)) {
          const s = h.filter(i => this.model.isSymbolInRow(r, i));
          if (s.length) {
            const n = i.bounds.xMax + this.strokeSpaceWidth - r.bounds.xMin;
            u.push({
              symbols: s,
              tx: n,
              ty: -this.rowHeight
            });
          }
          const n = h.filter(i => this.model.isSymbolBelow(r, i));
          n.length && u.push({
            symbols: n,
            tx: 0,
            ty: -this.rowHeight
          });
        }
      } else u.push({
        symbols: h,
        tx: 0,
        ty: -this.rowHeight
      });
    } else if (d.length) {
      const i = this.model.getFirstSymbol(d),
        r = this.model.getLastSymbol(s);
      if (r) {
        if (this.model.roundToLineGuide(r.bounds.yMid) >= this.model.roundToLineGuide(i.bounds.yMid - this.rowHeight)) {
          const s = r.bounds.xMax + this.strokeSpaceWidth - i.bounds.xMin;
          u.push({
            symbols: d,
            tx: s,
            ty: -this.rowHeight
          });
        } else u.push({
          symbols: d,
          tx: 0,
          ty: -this.rowHeight
        });
        h.length && u.push({
          symbols: h,
          tx: 0,
          ty: -this.rowHeight
        });
      } else u.push({
        symbols: d.concat(...h),
        tx: 0,
        ty: -this.rowHeight
      });
    }
    c.replaced?.oldSymbols.length && this.editor.replaceSymbols(c.replaced.oldSymbols, c.replaced.newSymbols, !1), u.length && (c.translate = u, Promise.all(u.map(i => this.translator.translate(i.symbols, i.tx, i.ty, !1)))), this.history.push(this.model, c);
  }
  createStrokesFromGestureSubStroke(i, r) {
    const s = [];
    if (r[0]) {
      const n = new IIStroke(i.style);
      r[0].x.forEach((s, a) => {
        n.pointers.push({
          x: s,
          y: r[0].y[a],
          p: i.pointers.at(a)?.p || 1,
          t: i.pointers.at(a)?.t || Math.max(...n.pointers.map(i => i.t + 20))
        });
      }), s.push(n);
    }
    if (r[1]) {
      const n = new IIStroke(i.style);
      r[1].x.forEach((s, a) => {
        n.pointers.push({
          x: s,
          y: r[1].y[a],
          p: i.pointers.at(n.pointers.length + a)?.p || 1,
          t: i.pointers.at(n.pointers.length + a)?.t || Math.max(...n.pointers.map(i => i.t + 20))
        });
      }), s.push(n);
    }
    return s;
  }
  computeSplitStroke(i, r) {
    let s;
    const n = this.createStrokesFromGestureSubStroke(i, r);
    return n[1] && (s = n[1], this.translator.applyToSymbol(s, this.strokeSpaceWidth, 0)), {
      before: n[0],
      after: s
    };
  }
  computeSplitStrokeInGroup(i, r, s) {
    const n = [],
      a = [],
      l = [],
      d = s[0].fullStrokeId;
    return r.children.forEach(r => {
      if (r.id === d) {
        const i = this.computeSplitStroke(r, s);
        i.before && a.push(i.before), i.after && l.push(i.after);
      } else r.bounds.xMid < i.bounds.xMid ? a.push(r) : r.bounds.xMid > i.bounds.xMid && (this.translator.applyToSymbol(r, this.strokeSpaceWidth, 0), l.push(r));
    }), a.length && n.push(new IISymbolGroup(a, r.style)), l.length && n.push(new IISymbolGroup(l, r.style)), n;
  }
  computeChangesOnSplitStroke(i, r, s) {
    const n = [],
      a = {
        oldSymbols: [],
        newSymbols: []
      },
      l = this.model.symbols.filter(r => i.id !== r.id && this.model.isSymbolInRow(i, r) && i.bounds.xMid < r.bounds.xMin),
      d = this.model.getRootSymbol(r);
    if (d?.type === E.Group) {
      const r = this.computeSplitStrokeInGroup(i, d, s);
      a.newSymbols.push(...r), a.oldSymbols.push(d);
    } else if (d?.type === E.Stroke) {
      const i = this.computeSplitStroke(d, s);
      i.before && a.newSymbols.push(i.before), i.after && a.newSymbols.push(i.after), a.oldSymbols.push(d);
    } else if (d?.type === E.Recognized) {
      const n = d.strokes.find(i => i.id === r),
        l = d.strokes.filter(s => s.id !== r && s.bounds.xMid < i.bounds.xMid),
        h = d.strokes.filter(s => s.id !== r && s.bounds.xMid > i.bounds.xMid),
        c = this.computeSplitStroke(n, s);
      c.before && a.newSymbols.push(...l, c.before), c.after && a.newSymbols.push(c.after, ...h), a.oldSymbols.push(d);
    }
    return l.length && n.push({
      symbols: l,
      tx: this.strokeSpaceWidth,
      ty: 0
    }), {
      translate: n,
      replaced: a
    };
  }
  computeChangesOnSplitGroup(i, r) {
    const s = [],
      n = {
        oldSymbols: [],
        newSymbols: []
      },
      a = this.model.symbols.filter(r => i.id !== r.id && this.model.isSymbolInRow(i, r) && i.bounds.xMid < r.bounds.xMin),
      l = r.children.filter(r => r.bounds.xMid <= i.bounds.xMid),
      d = r.children.filter(r => r.bounds.xMid > i.bounds.xMid);
    if (n.oldSymbols.push(r), l.length) {
      const i = new IISymbolGroup(l.map(i => i.clone()), r.style);
      i.decorators = r.decorators.map(i => new IIDecorator(i.kind, i.style)), n.newSymbols.push(i);
    }
    if (d.length) {
      const i = new IISymbolGroup(d.map(i => i.clone()), r.style);
      i.decorators = r.decorators.map(i => new IIDecorator(i.kind, i.style)), this.translator.applyToSymbol(i, this.strokeSpaceWidth, 0), n.newSymbols.push(i);
    }
    return a?.length && s.push({
      symbols: a.filter(i => i.id !== r.id),
      tx: this.strokeSpaceWidth,
      ty: 0
    }), {
      translate: s,
      replaced: n
    };
  }
  computeChangesOnSplitStrokeText(i, r) {
    const s = [],
      n = {
        oldSymbols: [],
        newSymbols: []
      },
      a = this.model.symbols.filter(r => i.id !== r.id && this.model.isSymbolInRow(i, r) && i.bounds.xMid < r.bounds.xMin),
      l = r.strokes.filter(r => r.bounds.xMid <= i.bounds.xMid),
      d = r.strokes.filter(r => r.bounds.xMid > i.bounds.xMid);
    if (n.oldSymbols.push(r), l.length) {
      const i = new IIRecognizedText(l.map(i => i.clone()), r, r.style);
      i.decorators = r.decorators.map(i => new IIDecorator(i.kind, i.style)), n.newSymbols.push(i);
    }
    if (d.length) {
      const i = new IIRecognizedText(d.map(i => i.clone()), r, r.style);
      i.decorators = r.decorators.map(i => new IIDecorator(i.kind, i.style)), this.translator.applyToSymbol(i, this.strokeSpaceWidth, 0), n.newSymbols.push(i);
    }
    return a?.length && s.push({
      symbols: a.filter(i => i.id !== r.id),
      tx: this.strokeSpaceWidth,
      ty: 0
    }), {
      translate: s,
      replaced: n
    };
  }
  computeChangesOnSplitText(i, r) {
    const s = [],
      n = {
        oldSymbols: [],
        newSymbols: []
      },
      a = this.model.symbols.filter(r => i.id !== r.id && this.model.isSymbolInRow(i, r) && i.bounds.xMid < r.bounds.xMin),
      l = r.chars.filter(r => r.bounds.x + r.bounds.width / 2 <= i.bounds.xMid),
      d = r.chars.filter(r => r.bounds.x + r.bounds.width / 2 > i.bounds.xMid),
      h = [];
    if (l.length && d.length) {
      const i = new IIText(l, r.point, Box.createFromBoxes(l.map(i => i.bounds)));
      this.texter.setBounds(i), h.push(i);
      const s = {
          x: i.point.x + i.bounds.width + this.texter.getSpaceWidth(computeAverage(i.chars.map(i => i.fontSize))),
          y: i.point.y
        },
        a = new IIText(d, s, Box.createFromBoxes(d.map(i => i.bounds)));
      this.texter.setBounds(a), h.push(a), n.newSymbols = h, n.oldSymbols = [r];
    }
    return a?.length && s.push({
      symbols: a.filter(r => r.id !== i.id),
      tx: this.strokeSpaceWidth,
      ty: 0
    }), {
      translate: s,
      replaced: n
    };
  }
  async applyInsertGesture(i, r) {
    this.#t.debug("applyInsertGesture", {
      gestureStroke: i,
      gesture: r
    });
    const s = this.model.symbols.filter(r => i.id !== r.id && this.model.isSymbolInRow(i, r)),
      n = s.find(r => r.type === E.Text && isBetween(i.bounds.xMid, r.bounds.xMin, r.bounds.xMax)),
      a = s.find(r => r.type === E.Group && isBetween(i.bounds.xMid, r.bounds.xMin, r.bounds.xMax)),
      l = s.find(r => r.type === E.Recognized && isBetween(i.bounds.xMid, r.bounds.xMin, r.bounds.xMax)),
      d = s.filter(r => i.bounds.xMid > r.bounds.xMax),
      h = s.filter(r => i.bounds.xMid < r.bounds.xMin),
      c = this.model.symbols.filter(r => this.model.isSymbolBelow(i, r));
    let u;
    if (r.strokeIds.length && r.subStrokes?.length) u = this.computeChangesOnSplitStroke(i, r.strokeIds[0], r.subStrokes);else if (a) u = this.computeChangesOnSplitGroup(i, a);else if (n) u = this.computeChangesOnSplitText(i, n);else if (l) u = this.computeChangesOnSplitStrokeText(i, l);else if (h.length) {
      const i = [];
      let r = 0;
      switch (d.length && (r = Math.min(...d.map(i => i.bounds.xMin)) - Math.min(...h.map(i => i.bounds.xMin))), this.insertAction) {
        case Ee.LineBreak:
          i.push({
            symbols: h,
            tx: r,
            ty: this.rowHeight
          }), c.length && i.push({
            symbols: c,
            tx: 0,
            ty: this.rowHeight
          });
          break;
        case Ee.Insert:
          i.push({
            symbols: h,
            tx: 2 * this.strokeSpaceWidth,
            ty: 0
          });
      }
      u = {
        translate: i
      };
    } else d.length && c.length && this.insertAction === Ee.LineBreak && (u = {
      translate: [{
        symbols: c,
        tx: 0,
        ty: this.rowHeight
      }]
    });
    if (u) {
      const i = [];
      u.translate?.length && i.push(...u.translate.map(i => this.translator.translate(i.symbols, i.tx, i.ty, !1))), u.replaced?.newSymbols.length && i.push(this.editor.replaceSymbols(u.replaced.oldSymbols, u.replaced.newSymbols, !1)), this.history.push(this.model, u), await Promise.all(i);
    }
  }
  async applyUnderlineGesture(i, r) {
    if (this.#t.debug("applyUnderlineGesture", {
      gestureStroke: i,
      gesture: r
    }), !r.strokeIds.length) return void this.#t.warn("applyUnderlineGesture", "Unable to apply underline because there are no strokes");
    const s = {
        decorator: []
      },
      n = [];
    r.strokeIds.forEach(i => {
      const r = this.model.getRootSymbol(i);
      if (r && [E.Group, E.Stroke, E.Text, E.Recognized].includes(r.type) && !n.includes(r.id)) {
        const i = r,
          a = new IIDecorator(k.Underline, this.editor.penStyle),
          l = i.decorators.findIndex(i => i.kind === k.Underline),
          d = -1 === l;
        d ? i.decorators.push(a) : i.decorators.splice(l, 1), this.model.updateSymbol(i), this.renderer.drawSymbol(i), s.decorator?.push({
          symbol: i,
          decorator: a,
          added: d
        }), n.push(i.id);
      }
    }), s.decorator?.length && this.history.push(this.model, s);
  }
  async applyStrikeThroughGesture(i, r) {
    if (this.#t.debug("applyStrikeThroughGesture", {
      gestureStroke: i,
      gesture: r
    }), r.strokeIds.length) switch (this.strikeThroughAction) {
      case ke.Draw:
        {
          const i = {
              decorator: []
            },
            s = [];
          r.strokeIds.forEach(r => {
            const n = this.model.getRootSymbol(r);
            if (n && [E.Group, E.Stroke, E.Text, E.Recognized].includes(n.type) && !s.includes(n.id)) {
              const r = n,
                a = new IIDecorator(k.Strikethrough, this.editor.penStyle),
                l = r.decorators.findIndex(i => i.kind === k.Strikethrough),
                d = -1 === l;
              d ? r.decorators.push(a) : r.decorators.splice(l, 1), this.model.updateSymbol(r), this.renderer.drawSymbol(r), i.decorator?.push({
                symbol: r,
                decorator: a,
                added: d
              }), s.push(r.id);
            }
          }), i.decorator?.length && this.history.push(this.model, i);
          break;
        }
      case ke.Erase:
        return this.editor.removeSymbols(r.strokeIds);
      default:
        this.#t.warn("#applyStrikeThroughGesture", `Unknow OnStrikeThrough: ${this.strikeThroughAction}, values allowed are: ${ke.Draw}, ${ke.Erase}`);
    } else this.#t.warn("applyStrikeThroughGesture", "Unable to apply strikethrough because there are no strokes");
  }
  async apply(i, r) {
    switch (this.#t.info("apply", {
      gestureStroke: i,
      gesture: r
    }), this.editor.updateSymbolsStyle([i.id], {
      opacity: (i.style.opacity || 1) / 2
    }, !1), await this.editor.removeSymbol(i.id, !1), await this.editor.synchronizeStrokesWithJIIX(), r.gestureType) {
      case "UNDERLINE":
        await this.applyUnderlineGesture(i, r);
        break;
      case "SCRATCH":
        await this.applyScratch(i, r);
        break;
      case "JOIN":
        await this.applyJoinGesture(i, r);
        break;
      case "INSERT":
        await this.applyInsertGesture(i, r);
        break;
      case "STRIKETHROUGH":
        await this.applyStrikeThroughGesture(i, r);
        break;
      case "SURROUND":
        await this.applySurroundGesture(i, r);
        break;
      default:
        this.#t.warn("apply", `Gesture unknow: ${r.gestureType}`);
    }
    return this.editor.event.emitGestured({
      gestureType: r.gestureType,
      stroke: i
    }), this.editor.svgDebugger.apply(), Promise.resolve();
  }
  async getGestureFromContextLess(i) {
    const r = await this.recognizer.recognizeGesture(i);
    if (r) switch (r.gestureType) {
      case "surround":
        return this.model.symbols.some(r => !(r.id === i.id || !i.bounds.contains(r.bounds)) && (this.surroundAction === ve.Select || [E.Group, E.Stroke, E.Text].includes(r.type))) ? {
          gestureType: "SURROUND",
          gestureStrokeId: i.id,
          strokeAfterIds: [],
          strokeBeforeIds: [],
          strokeIds: []
        } : void 0;
      case "left-right":
      case "right-left":
        {
          const r = this.model.symbols.filter(r => r.id !== i.id && [E.Text, E.Stroke, E.Group].includes(r.type) && isBetween(r.bounds.xMid, i.bounds.xMin, i.bounds.xMax) && isBetween(i.bounds.yMid, r.bounds.y + 3 * r.bounds.height / 4, r.bounds.y + 5 * r.bounds.height / 4));
          if (r.length) return {
            gestureType: "UNDERLINE",
            gestureStrokeId: i.id,
            strokeAfterIds: [],
            strokeBeforeIds: [],
            strokeIds: r.map(i => i.id)
          };
          const s = this.model.symbols.filter(r => r.id !== i.id && [E.Text, E.Stroke, E.Group].includes(r.type) && isBetween(r.bounds.xMid, i.bounds.xMin, i.bounds.xMax) && isBetween(i.bounds.yMid, r.bounds.y + r.bounds.height / 4, r.bounds.y + 3 * r.bounds.height / 4));
          return s.length ? {
            gestureType: "STRIKETHROUGH",
            gestureStrokeId: i.id,
            strokeAfterIds: [],
            strokeBeforeIds: [],
            strokeIds: s.map(i => i.id)
          } : void 0;
        }
      case "scratch":
        {
          const r = this.model.symbols.filter(r => r.id !== i.id && (i.bounds.overlaps(r.bounds) && [E.Stroke, E.Text, E.Group].includes(r.type) || i.bounds.contains(r.bounds) && [E.Shape, E.Edge].includes(r.type)));
          return r.length ? {
            gestureType: "SCRATCH",
            gestureStrokeId: i.id,
            strokeAfterIds: [],
            strokeBeforeIds: [],
            strokeIds: r.map(i => i.id)
          } : void 0;
        }
      case "bottom-top":
        return this.model.symbols.some(r => r.id !== i.id && [E.Text, E.Stroke, E.Group].includes(r.type) && isBetween(r.bounds.yMid, i.bounds.yMin, i.bounds.yMax)) ? {
          gestureType: "JOIN",
          gestureStrokeId: i.id,
          strokeAfterIds: [],
          strokeBeforeIds: [],
          strokeIds: []
        } : void 0;
      case "top-bottom":
        return this.model.symbols.some(r => r.id !== i.id && [E.Text, E.Stroke, E.Group].includes(r.type) && isBetween(r.bounds.yMid, i.bounds.yMin, i.bounds.yMax)) ? {
          gestureType: "INSERT",
          gestureStrokeId: i.id,
          strokeAfterIds: [],
          strokeBeforeIds: [],
          strokeIds: []
        } : void 0;
      default:
        return;
    }
  }
}
class IIMenuSub {
  element;
  content;
  constructor(i) {
    if (this.element = document.createElement("div"), this.element.classList.add("sub-menu"), this.element.appendChild(i.trigger), this.content = document.createElement("div"), i.menuTitle) {
      const r = document.createElement("h3");
      r.classList.add("ms-menu-title"), r.textContent = i.menuTitle, this.content.appendChild(r);
    }
    this.content.classList.add("sub-menu-content", i.position), this.content.appendChild(i.subMenu), this.element.appendChild(this.content), i.trigger.addEventListener("pointerdown", () => this.toggle()), document.addEventListener("pointerdown", i => {
      this.element.contains(i.target) || this.close();
    });
  }
  open() {
    this.content.classList.add("open");
  }
  close() {
    this.content.classList.remove("open");
  }
  toggle() {
    this.content.classList.toggle("open");
  }
  unwrap() {
    this.content.classList.remove("sub-menu-content"), this.element.insertAdjacentElement("beforebegin", this.content), this.element.style.display = "none";
  }
  wrap() {
    this.content.classList.add("sub-menu-content"), this.element.appendChild(this.content), this.element.style.display = "block";
  }
}
class IIMenuAction extends IIMenu {
  #t = LoggerManager.getLogger(d.MENU);
  editor;
  id;
  wrapper;
  menuLanguage;
  menuClear;
  menuUndo;
  menuRedo;
  menuConvert;
  guideGaps = [{
    label: "S",
    value: "25"
  }, {
    label: "M",
    value: "50"
  }, {
    label: "L",
    value: "100"
  }, {
    label: "XL",
    value: "150"
  }];
  constructor(i, r = "ms-menu-action") {
    super(), this.id = r, this.editor = i;
  }
  get model() {
    return this.editor.model;
  }
  get isMobile() {
    return this.editor.renderer.parent.clientWidth < 700;
  }
  createMenuClear() {
    return this.menuClear = document.createElement("button"), this.menuClear.id = `${this.id}-clear`, this.menuClear.classList.add("ms-menu-button", "square"), this.menuClear.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M20 9L18.005 20.3463C17.8369 21.3026 17.0062 22 16.0353 22H7.96474C6.99379 22 6.1631 21.3026 5.99496 20.3463L4 9"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M21 6L15.375 6M3 6L8.625 6M8.625 6V4C8.625 2.89543 9.52043 2 10.625 2H13.375C14.4796 2 15.375 2.89543 15.375 4V6M8.625 6L15.375 6"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.menuClear.addEventListener("pointerup", () => {
      this.#t.info(`${this.id}.clear`), this.editor.clear();
    }), this.menuClear;
  }
  createMenuLanguage() {
    const i = document.createElement("button");
    i.id = `${this.id}-language-trigger`, i.classList.add("ms-menu-button", "square"), i.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  stroke-width="1"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M13 2.04932C13 2.04932 16 5.99994 16 11.9999C16 17.9999 13 21.9506 13 21.9506"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M11 21.9506C11 21.9506 8 17.9999 8 11.9999C8 5.99994 11 2.04932 11 2.04932"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path d="M2.62964 15.5H21.3704" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M2.62964 8.5H21.3704" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
    const r = document.createElement("select");
    r.classList.add("select-language"), r.id = `${this.id}-language`, getAvailableLanguageList(this.editor.configuration).then(i => {
      const s = i.result;
      Object.keys(s).forEach(i => {
        const n = i === this.editor.configuration.recognition.lang,
          a = new Option(s[i], i, n, n);
        r.appendChild(a);
      });
    }), r.addEventListener("change", i => {
      this.#t.info(`${this.id}.selectLanguage`);
      const r = i.target.value;
      this.editor.changeLanguage(r);
    });
    const s = {
      trigger: i,
      subMenu: r,
      position: "bottom-right"
    };
    return this.menuLanguage = new IIMenuSub(s), this.menuLanguage.element;
  }
  createMenuUndo() {
    return this.menuUndo = document.createElement("button"), this.menuUndo.id = `${this.id}-undo`, this.menuUndo.classList.add("ms-menu-button", "square"), this.menuUndo.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M4.5 8C8.5 8 11 8 15 8C15 8 15 8 15 8C15 8 20 8 20 12.7059C20 18 15 18 15 18C11.5714 18 9.71429 18 6.28571 18"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M7.5 11.5C6.13317 10.1332 5.36683 9.36683 4 8C5.36683 6.63317 6.13317 5.86683 7.5 4.5"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.menuUndo.addEventListener("pointerup", async () => {
      this.#t.info(`${this.id}.undo`), await this.editor.undo();
    }), this.menuUndo;
  }
  createMenuRedo() {
    return this.menuRedo = document.createElement("button"), this.menuRedo.id = `${this.id}-redo`, this.menuRedo.classList.add("ms-menu-button", "square"), this.menuRedo.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M19.5 8C15.5 8 13 8 9 8C9 8 9 8 9 8C9 8 4 8 4 12.7059C4 18 9 18 9 18C12.4286 18 14.2857 18 17.7143 18"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M16.5 11.5C17.8668 10.1332 18.6332 9.36683 20 8C18.6332 6.63317 17.8668 5.86683 16.5 4.5"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.menuRedo.addEventListener("pointerup", async () => {
      this.#t.info(`${this.id}.redo`), await this.editor.redo();
    }), this.menuRedo;
  }
  createMenuConvert() {
    return this.menuConvert = document.createElement("button"), this.menuConvert.id = `${this.id}-convert`, this.menuConvert.classList.add("ms-menu-button", "square"), this.menuConvert.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M2 5H9M16 5H13.5M9 5L13.5 5M9 5V3M13.5 5C12.6795 7.73513 10.9612 10.3206 9 12.5929M4 17.5C5.58541 16.1411 7.376 14.4744 9 12.5929M9 12.5929C8 11.5 6.4 9.3 6 8.5M9 12.5929L12 15.5"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M13.5 21L14.6429 18M21.5 21L20.3571 18M14.6429 18L17.5 10.5L20.3571 18M14.6429 18H20.3571"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.menuConvert.addEventListener("pointerup", () => {
      this.#t.info(`${this.id}.convert`), this.editor.convert();
    }), this.menuConvert;
  }
  createMenuGesture() {
    const s = document.createElement("button");
    s.id = `${this.id}-gesture`, s.classList.add("ms-menu-button", "square"), s.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M18 7.5L18.9187 7.65312C20.0497 7.84162 20.791 8.94046 20.5423 10.0598L20.0143 12.4357C20.0048 12.4784 20 12.5223 20 12.5661C20 15.1904 20 17.5 20 17.5C20 17.5 20 17.5 20 17.5C20 19.5 18.4 21.5 16 21.5C14.1259 21.5 11.0119 21.5 9.41979 21.5C8.83594 21.5 8.28132 21.2449 7.90136 20.8016L3.35288 15.495C2.85811 14.9178 2.84375 14.0703 3.31868 13.4767V13.4767C3.93438 12.707 5.09624 12.6814 5.74526 13.4231L8 16V12.5"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M9 5L8.20966 5.13172C7.03189 5.32802 6.28739 6.50588 6.61542 7.65395L8 12.5"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M11 12.5L8.92263 4.60598C8.69579 3.744 9.25886 2.87352 10.1381 2.72699V2.72699C10.9097 2.59838 11.6523 3.07873 11.8514 3.83526L14 12"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M17 12.5L18 7.5L18.2475 6.01515C18.3869 5.17836 17.8216 4.38694 16.9848 4.24747V4.24747C16.16 4.11 15.3767 4.65763 15.2226 5.47955L14 12"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n';
    const n = document.createElement("div");
    n.classList.add("ms-menu-colmun");
    const a = [];
    for (const i in ve) {
      const r = ve[i];
      a.push({
        label: i,
        value: r
      });
    }
    const l = [];
    for (const i in ke) {
      const r = ke[i];
      l.push({
        label: i,
        value: r
      });
    }
    const d = [];
    for (const i in Ee) {
      const r = Ee[i];
      d.push({
        label: i,
        value: r
      });
    }
    [{
      type: "checkbox",
      id: `${this.id}-gesture-detect`,
      label: "Detect gesture",
      initValue: this.editor.writer.detectGesture,
      callback: s => {
        this.#t.info(`${this.id}.gesture-detect`, {
          value: s
        }), this.editor.writer.detectGesture = s, this.editor.tool = i.Write, this.editor.writer.tool = r.Pencil;
      }
    }, {
      type: "select",
      id: `${this.id}-gesture-surround`,
      label: "On surround",
      values: a,
      initValue: this.editor.gesture.surroundAction,
      callback: s => {
        this.#t.info(`${this.id}.gesture-surround`, {
          value: s
        }), this.editor.gesture.surroundAction = s, this.editor.tool = i.Write, this.editor.writer.tool = r.Pencil;
      }
    }, {
      type: "select",
      id: `${this.id}-gesture-strikethrough`,
      label: "On strikethrough",
      values: l,
      initValue: this.editor.gesture.strikeThroughAction,
      callback: s => {
        this.#t.info(`${this.id}.gesture-strikethrough`, {
          value: s
        }), this.editor.gesture.strikeThroughAction = s, this.editor.tool = i.Write, this.editor.writer.tool = r.Pencil;
      }
    }, {
      type: "select",
      id: `${this.id}-gesture-insert`,
      label: "On insert",
      values: d,
      initValue: this.editor.gesture.insertAction,
      callback: s => {
        this.#t.info(`${this.id}.gesture-InsertAction`, {
          value: s
        }), this.editor.gesture.insertAction = s, this.editor.tool = i.Write, this.editor.writer.tool = r.Pencil;
      }
    }].forEach(i => {
      n.appendChild(this.createMenuItem(i));
    });
    return new IIMenuSub({
      trigger: s,
      menuTitle: "Gesture",
      subMenu: n,
      position: "right-top"
    }).element;
  }
  createMenuGuide() {
    const i = document.createElement("button");
    i.id = `${this.id}-guide`, i.classList.add("ms-menu-button", "square"), i.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  stroke-width="1"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path d="M3 21V3H21V21H3Z" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M3 16.5H12H21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M3 12H21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M3 7.5H21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M16.5 3V12V21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M12 3V21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M7.5 3V21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
    const r = document.createElement("div");
    r.classList.add("ms-menu-colmun");
    [{
      type: "checkbox",
      id: `${this.id}-guide-enable`,
      label: "Show guide",
      initValue: this.editor.configuration.rendering.guides.enable,
      callback: i => {
        this.#t.info(`${this.id}.guide-enable`, {
          value: i
        }), this.editor.configuration.rendering.guides.enable = i, this.editor.renderingConfiguration = this.editor.configuration.rendering;
      }
    }, {
      type: "select",
      id: `${this.id}-guide-type`,
      label: "Guide style",
      values: [{
        label: "Line",
        value: "line"
      }, {
        label: "Grid",
        value: "grid"
      }, {
        label: "Point",
        value: "point"
      }],
      initValue: this.editor.configuration.rendering.guides.type,
      callback: i => {
        this.#t.info(`${this.id}.guide-type`, {
          value: i
        }), this.editor.configuration.rendering.guides.type = i, this.editor.renderingConfiguration = this.editor.configuration.rendering;
      }
    }, {
      type: "list",
      id: `${this.id}-guide-size`,
      label: "Guide style",
      values: this.guideGaps,
      initValue: this.editor.configuration.rendering.guides.gap.toString(),
      callback: i => {
        this.#t.info(`${this.id}.guide-size`, {
          value: i
        }), this.editor.configuration.rendering.guides.gap = +i, this.editor.renderingConfiguration = this.editor.configuration.rendering;
      }
    }].forEach(i => {
      r.appendChild(this.createMenuItem(i));
    });
    return new IIMenuSub({
      trigger: i,
      menuTitle: "Guide",
      subMenu: r,
      position: "right-top"
    }).element;
  }
  createMenuSnap() {
    const i = document.createElement("button");
    i.id = `${this.id}-snap`, i.classList.add("ms-menu-button", "square"), i.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M 19 14 C 17.8954 14 17 13.1046 17 12 C 17 10.8954 17.8954 10 19 10 C 20.1046 10 21 10.8954 21 12 C 21 13.1046 20.1046 14 19 14 Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path d="M 4 12 H 17 M 17 12 L 14 9 M 17 12 L 14 15" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
    const r = document.createElement("div");
    r.classList.add("ms-menu-colmun");
    [{
      type: "checkbox",
      id: `${this.id}-snap-to-guide`,
      label: "Snap to guide",
      initValue: this.editor.snaps.configuration.guide,
      callback: i => this.editor.snaps.configuration.guide = i
    }, {
      type: "checkbox",
      id: `${this.id}-snap-to-element`,
      label: "Snap to element",
      initValue: this.editor.snaps.configuration.symbol,
      callback: i => this.editor.snaps.configuration.symbol = i
    }, {
      type: "select",
      id: `${this.id}-snap-angle`,
      label: "Snap angle",
      values: [{
        label: "None",
        value: "0"
      }, {
        label: "10°",
        value: "10"
      }, {
        label: "30°",
        value: "30"
      }, {
        label: "45°",
        value: "45"
      }, {
        label: "90°",
        value: "90"
      }, {
        label: "180°",
        value: "180"
      }],
      initValue: this.editor.snaps.configuration.angle.toString(),
      callback: i => this.editor.snaps.configuration.angle = +i
    }].forEach(i => {
      r.appendChild(this.createMenuItem(i));
    });
    return new IIMenuSub({
      trigger: i,
      menuTitle: "Snap",
      subMenu: r,
      position: "right-top"
    }).element;
  }
  createMenuDebug() {
    const i = document.createElement("button");
    i.id = `${this.id}-debug`, i.classList.add("ms-menu-button", "square"), i.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  stroke-width="1"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M5.81249 7C5.81249 7 5.35861 7.62759 4.81552 8.66667M18.1875 7C18.1875 7 18.6414 7.62759 19.1845 8.66667M4.81552 8.66667C4.0067 10.2142 3 12.6743 3 15.3333C5.8125 15.3333 7.49999 17 7.49999 17C7.49999 17 8.62499 22 12 22C15.375 22 16.5 17 16.5 17C16.5 17 18.1875 15.3333 21 15.3333C21 12.6743 19.9933 10.2142 19.1845 8.66667M4.81552 8.66667C4.81552 8.66667 1.875 6.44436 4.81552 2C5.81249 2.55556 8.625 4.77778 8.625 4.77778C8.625 4.77778 10.3125 3.66667 12 3.66667C13.6875 3.66667 15.375 4.77778 15.375 4.77778C15.375 4.77778 18.1875 2.55556 19.3125 2C22.125 6.44456 19.1845 8.66667 19.1845 8.66667"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path d="M11 18L12 18M13 18L12 18M12 18L12 19" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M8.5 12.5L10 14" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M15.5 12.5L14 14" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
    const r = [{
        type: "checkbox",
        id: `${this.id}-debug-bounding-box`,
        label: "Show bounding box",
        initValue: this.editor.svgDebugger.boundingBoxVisibility,
        callback: i => this.editor.svgDebugger.boundingBoxVisibility = i
      }, {
        type: "checkbox",
        id: `${this.id}-debug-recognition-box`,
        label: "Show recognition box",
        initValue: this.editor.svgDebugger.recognitionBoxVisibility,
        callback: i => this.editor.svgDebugger.recognitionBoxVisibility = i
      }, {
        type: "checkbox",
        id: `${this.id}-debug-bounding-item-box`,
        label: "Show recognition item box",
        initValue: this.editor.svgDebugger.recognitionItemBoxVisibility,
        callback: i => this.editor.svgDebugger.recognitionItemBoxVisibility = i
      }, {
        type: "checkbox",
        id: `${this.id}-debug-snap-points`,
        label: "Show snap points",
        initValue: this.editor.svgDebugger.snapPointsVisibility,
        callback: i => this.editor.svgDebugger.snapPointsVisibility = i
      }, {
        type: "checkbox",
        id: `${this.id}-debug-vertices`,
        label: "Show vertices",
        initValue: this.editor.svgDebugger.verticesVisibility,
        callback: i => this.editor.svgDebugger.verticesVisibility = i
      }],
      s = document.createElement("div");
    s.classList.add("ms-menu-colmun"), r.forEach(i => {
      s.appendChild(this.createMenuItem(i));
    });
    return new IIMenuSub({
      trigger: i,
      menuTitle: "Debug",
      subMenu: s,
      position: "right-top"
    }).element;
  }
  createMenuExport() {
    const i = document.createElement("button");
    i.id = `${this.id}-export`, i.classList.add("ms-menu-button", "square"), i.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  stroke-width="1"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="#000000"\n>\n  <path d="M6 20L18 20" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M12 4V16M12 16L15.5 12.5M12 16L8.5 12.5" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
    const r = [{
        type: "button",
        id: `${this.id}-export-json`,
        label: "json",
        callback: () => {
          this.editor.downloadAsJson();
        }
      }, {
        type: "button",
        id: `${this.id}-export-svg`,
        label: "svg",
        callback: () => {
          this.editor.downloadAsSVG();
        }
      }, {
        type: "button",
        id: `${this.id}-export-png`,
        label: "png",
        callback: () => {
          this.editor.downloadAsPNG();
        }
      }],
      s = document.createElement("div");
    s.classList.add("ms-menu-colmun"), r.forEach(i => {
      s.appendChild(this.createMenuItem(i));
    });
    return new IIMenuSub({
      trigger: i,
      menuTitle: "Export",
      subMenu: s,
      position: "right-top"
    }).element;
  }
  async readFileAsText(i) {
    return new Promise((r, s) => {
      const n = new FileReader();
      n.onerror = s, n.onload = () => {
        r(n.result);
      }, i && n.readAsText(i);
    });
  }
  createMenuImport() {
    const i = document.createElement("button");
    i.id = `${this.id}-import`, i.classList.add("ms-menu-button", "square"), i.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  stroke-width="1"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="#000000"\n>\n  <path d="M6 20L18 20" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M12 16V4M12 4L15.5 7.5M12 4L8.5 7.5" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
    const r = document.createElement("div");
    r.classList.add("ms-menu-colmun");
    const s = document.createElement("input");
    s.type = "file", s.accept = ".json", s.multiple = !1, s.addEventListener("change", () => {
      n.disabled = !s.files?.length;
    }), r.appendChild(s);
    const n = document.createElement("button");
    n.classList.add("ms-menu-button"), n.innerText = "Import", n.disabled = !0, r.appendChild(n), n.addEventListener("pointerup", async i => {
      if (i.preventDefault(), i.stopPropagation(), s.files?.length) {
        const i = await this.readFileAsText(s.files[0]),
          r = JSON.parse(i);
        await this.editor.createSymbols(r), s.value = "", n.disabled = !0;
      }
    });
    return new IIMenuSub({
      trigger: i,
      menuTitle: "Import",
      subMenu: r,
      position: "right-top"
    }).element;
  }
  unselectAll() {
    this.wrapper?.querySelectorAll("*").forEach(i => i.classList.remove("active"));
  }
  closeAllSubMenu() {
    this.wrapper?.querySelectorAll(".open").forEach(i => i.classList.remove("open"));
  }
  render(i) {
    if (this.editor.configuration.menu.action.enable) {
      const r = document.createElement("button");
      r.id = this.id, r.classList.add("ms-menu-button", "square"), r.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  stroke-width="1"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path d="M3 5H21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M3 12H21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M3 19H21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
      const s = document.createElement("div");
      s.classList.add("ms-menu-colmun"), s.appendChild(this.createMenuGesture()), s.appendChild(this.createMenuGuide()), s.appendChild(this.createMenuSnap()), s.appendChild(this.createMenuDebug()), s.appendChild(this.createMenuImport()), s.appendChild(this.createMenuExport()), this.wrapper = document.createElement("div"), this.wrapper.classList.add("ms-menu", "ms-menu-top-left", "ms-menu-row"), this.wrapper.appendChild(new IIMenuSub({
        trigger: r,
        subMenu: s,
        position: "bottom"
      }).element), this.wrapper.appendChild(this.createMenuLanguage()), this.wrapper.appendChild(this.createMenuClear()), this.wrapper.appendChild(this.createMenuUndo()), this.wrapper.appendChild(this.createMenuRedo()), this.wrapper.appendChild(this.createMenuConvert()), i.appendChild(this.wrapper), this.update(), this.show();
    }
  }
  update() {
    this.menuLanguage && (this.isMobile ? this.menuLanguage.wrap() : this.menuLanguage.unwrap()), this.menuClear && (this.menuClear.disabled = this.editor.history.context.empty), this.menuUndo && (this.menuUndo.disabled = !this.editor.history.context.canUndo), this.menuRedo && (this.menuRedo.disabled = !this.editor.history.context.canRedo), this.menuConvert && (this.menuConvert.disabled = !this.editor.extractStrokesFromSymbols(this.model.symbols).length);
  }
  show() {
    this.wrapper && (this.wrapper.style.visibility = "visible");
  }
  hide() {
    this.wrapper && (this.wrapper.style.visibility = "hidden");
  }
  destroy() {
    if (this.wrapper) {
      for (; this.wrapper.lastChild;) this.wrapper.removeChild(this.wrapper.lastChild);
      this.wrapper.remove(), this.wrapper = void 0, this.menuClear = void 0, this.menuUndo = void 0, this.menuRedo = void 0, this.menuConvert = void 0;
    }
  }
}
var Ce = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M 21 5 V 17.986 C 21 19 21 19 20 19 H 4 C 3 19 3 19 3.015 17.986 V 5 C 3 4 3 4 4 4 H 20.4 C 21 4 21 4 21 5 Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n',
  Me = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path d="M3 20L21 4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
class IIMenuTool extends IIMenu {
  #t = LoggerManager.getLogger(d.MENU);
  editor;
  id;
  wrapper;
  writeBtn;
  menuSelect;
  menuMove;
  menuErase;
  menuShape;
  subMenuShape;
  menuEdge;
  subMenuEdge;
  constructor(i, r = "ms-menu-tool") {
    super(), this.id = r, this.#t.info("constructor"), this.editor = i;
  }
  createMenuWrite() {
    return this.writeBtn = document.createElement("button"), this.writeBtn.id = `${this.id}-write-pencil`, this.writeBtn.classList.add("ms-menu-button", "square"), this.writeBtn.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M14.3632 5.65156L15.8431 4.17157C16.6242 3.39052 17.8905 3.39052 18.6716 4.17157L20.0858 5.58579C20.8668 6.36683 20.8668 7.63316 20.0858 8.41421L18.6058 9.8942M14.3632 5.65156L4.74749 15.2672C4.41542 15.5993 4.21079 16.0376 4.16947 16.5054L3.92738 19.2459C3.87261 19.8659 4.39148 20.3848 5.0115 20.33L7.75191 20.0879C8.21972 20.0466 8.65806 19.8419 8.99013 19.5099L18.6058 9.8942M14.3632 5.65156L18.6058 9.8942"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.writeBtn.addEventListener("pointerup", () => {
      this.unselectAll(), this.writeBtn.classList.add("active"), this.editor.tool = i.Write, this.editor.writer.tool = r.Pencil;
    }), this.writeBtn;
  }
  createMenuMove() {
    return this.menuMove = document.createElement("button"), this.menuMove.id = `${this.id}-move`, this.menuMove.classList.add("ms-menu-button", "square"), this.menuMove.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M7 10.5L4.99591 13.1721C4.41845 13.9421 4.47127 15.0141 5.1216 15.7236L8.9055 19.8515C9.28432 20.2647 9.81826 20.5 10.3789 20.5C11.4651 20.5 13.2415 20.5 15 20.5C17.4 20.5 19 19 19 16.5C19 16.5 19 16.5 19 16.5C19 16.5 19 9.64287 19 7.92859"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M16 8.49995C16 8.49995 16 8.37483 16 7.92852C16 5.6428 19 5.6428 19 7.92852"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M13 8.50008C13 8.50008 13 7.91978 13 7.02715M13 6.50008C13 6.50008 13 6.804 13 7.02715M16 8.50008C16 8.50008 16 8.37496 16 7.92865C16 7.70549 16 7.25031 16 7.02715C16 4.74144 13 4.74144 13 7.02715"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M13 8.50008C13 8.50008 13 7.91978 13 7.02715C13 4.74144 16 4.74144 16 7.02715C16 7.25031 16 7.70549 16 7.92865C16 8.37496 16 8.50008 16 8.50008"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M10 8.50005C10 8.50005 10 7.85719 10 6.50005C10 4.21434 13 4.21434 13 6.50005C13 6.50005 13 6.50005 13 6.50005C13 6.50005 13 6.80397 13 7.02713C13 7.91975 13 8.50005 13 8.50005"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M7 13.5001V6.50006C7 5.67164 7.67157 5.00006 8.5 5.00006V5.00006C9.32843 5.00006 10 5.55527 10 6.38369C10 6.42151 10 6.4603 10 6.50006C10 7.85721 10 8.50006 10 8.50006"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.menuMove.addEventListener("pointerup", () => {
      this.unselectAll(), this.menuMove.classList.add("active"), this.editor.tool = i.Move;
    }), this.menuMove;
  }
  createMenuSelect() {
    return this.menuSelect = document.createElement("button"), this.menuSelect.id = `${this.id}-select`, this.menuSelect.classList.add("ms-menu-button", "square"), this.menuSelect.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M4.9984 2H2V4.9984H4.9984V2Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-miterlimit="1.5"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M4.99854 3.50098H18.9987"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-miterlimit="1.5"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path d="M3.5 4.99854V19.0005" stroke="currentColor" stroke-width="1" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M20.4978 5V19.002" stroke="currentColor" stroke-width="1" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M4.99854 20.501H18.9987" stroke="currentColor" stroke-width="1" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path\n    d="M4.9984 19H2V21.9984H4.9984V19Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-miterlimit="1.5"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M21.9974 2.00195H18.999V5.00035H21.9974V2.00195Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-miterlimit="1.5"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    d="M21.9974 19.002H18.999V22.0004H21.9974V19.002Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-miterlimit="1.5"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M10.9966 15.002L7.99658 8.00195L14.9966 11.002L11.9986 12.0009L10.9966 15.002Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-miterlimit="1.5"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M11.999 12.002L14.997 15.002L11.999 12.002Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-miterlimit="1.5"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.menuSelect.addEventListener("pointerup", () => {
      this.unselectAll(), this.menuSelect.classList.add("active"), this.editor.tool = i.Select;
    }), this.menuSelect;
  }
  createMenuErase() {
    return this.menuErase = document.createElement("button"), this.menuErase.id = `${this.id}-erase`, this.menuErase.classList.add("ms-menu-button", "square"), this.menuErase.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path d="M21 21L9 21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M15.889 14.8891L8.46436 7.46448" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path\n    d="M2.8934 12.6066L12.0858 3.41421C12.8668 2.63317 14.1332 2.63317 14.9142 3.41421L19.864 8.36396C20.645 9.14501 20.645 10.4113 19.864 11.1924L10.6213 20.435C10.2596 20.7968 9.76894 21 9.25736 21C8.74577 21 8.25514 20.7968 7.8934 20.435L2.8934 15.435C2.11235 14.654 2.11235 13.3877 2.8934 12.6066Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', this.menuErase.addEventListener("pointerup", () => {
      this.unselectAll(), this.menuErase.classList.add("active"), this.editor.tool = i.Erase;
    }), this.menuErase;
  }
  createShapeSubMenu(r, s) {
    const n = document.createElement("button");
    return n.id = `${this.id}-write-shape-${s}`, n.classList.add("ms-menu-button", "square"), n.innerHTML = r, n.addEventListener("pointerup", () => {
      this.unselectAll(), this.editor.tool = i.Write, this.editor.writer.tool = s, n.classList.add("active"), this.menuShape.innerHTML = r, this.menuShape.classList.add("active");
      const a = this.menuShape.nextSibling;
      a && a.classList.remove("open");
    }), n;
  }
  createMenuShape() {
    this.menuShape = document.createElement("button"), this.menuShape.id = `${this.id}-write-shape`, this.menuShape.classList.add("ms-menu-button", "square"), this.menuShape.innerHTML = Ce, this.subMenuShape = {
      circle: this.createShapeSubMenu('<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', r.Circle),
      rectangle: this.createShapeSubMenu(Ce, r.Rectangle),
      triangle: this.createShapeSubMenu('<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M11.4752 2.94682C11.7037 2.53464 12.2963 2.53464 12.5248 2.94682L21.8985 19.8591C22.1202 20.259 21.831 20.75 21.3738 20.75H2.62625C2.16902 20.75 1.87981 20.259 2.10146 19.8591L11.4752 2.94682Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', r.Triangle),
      ellipse: this.createShapeSubMenu('<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M 12 19 C 18 19 22 17 22 12 C 22 7 18 5 12 5 C 6 5 2 7 2 12 C 2 17 6 19 12 19 Z"\n    stroke="currentColor"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', r.Ellipse),
      rhombus: this.createShapeSubMenu('<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M11.5757 1.42426C11.81 1.18995 12.1899 1.18995 12.4243 1.42426L22.5757 11.5757C22.81 11.81 22.8101 12.1899 22.5757 12.4243L12.4243 22.5757C12.19 22.81 11.8101 22.8101 11.5757 22.5757L1.42426 12.4243C1.18995 12.19 1.18995 11.8101 1.42426 11.5757L11.5757 1.42426Z"\n    stroke="#000000"\n    stroke-width="1"\n    stroke-linecap="round"\n    stroke-linejoin="round"\n  ></path>\n</svg>\n', r.Rhombus)
    };
    const i = document.createElement("div");
    i.id = `${this.id}-write-shape-list`, i.classList.add("ms-menu-row", "sub-menu-content-shape"), i.appendChild(this.subMenuShape.rectangle), i.appendChild(this.subMenuShape.circle), i.appendChild(this.subMenuShape.ellipse), i.appendChild(this.subMenuShape.triangle), i.appendChild(this.subMenuShape.rhombus);
    const s = {
      trigger: this.menuShape,
      subMenu: i,
      position: "top"
    };
    return new IIMenuSub(s).element;
  }
  createEdgeSubMenu(r, s) {
    const n = document.createElement("button");
    return n.id = `${this.id}-write-edge-${s}`, n.classList.add("ms-menu-button", "square"), n.innerHTML = r, n.addEventListener("pointerup", () => {
      this.unselectAll(), this.editor.tool = i.Write, this.editor.writer.tool = s, n.classList.add("active"), this.menuEdge.innerHTML = r, this.menuEdge.classList.add("active");
      const a = this.menuEdge.nextSibling;
      a && a.classList.remove("open");
    }), n;
  }
  createMenuEdge() {
    this.menuEdge = document.createElement("button"), this.menuEdge.id = `${this.id}-write-edge`, this.menuEdge.classList.add("ms-menu-button", "square"), this.menuEdge.innerHTML = Me, this.subMenuEdge = {
      line: this.createEdgeSubMenu(Me, r.Line),
      arrow: this.createEdgeSubMenu('<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path d="M3 20L21 4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M15 5L21 4L 20 10" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n', r.Arrow),
      doubleArrow: this.createEdgeSubMenu('<svg\n  width="24px"\n  height="24px"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path d="M3 20L21 4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M9 19L3 20L 4 14" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M15 5L21 4L 20 10" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n', r.DoubleArrow)
    };
    const i = document.createElement("div");
    i.id = `${this.id}-write-edge-list`, i.classList.add("ms-menu-row", "sub-menu-content-edge"), i.appendChild(this.subMenuEdge.line), i.appendChild(this.subMenuEdge.arrow), i.appendChild(this.subMenuEdge.doubleArrow);
    const s = {
      trigger: this.menuEdge,
      subMenu: i,
      position: "top"
    };
    return new IIMenuSub(s).element;
  }
  unselectAll() {
    this.wrapper?.querySelectorAll("*").forEach(i => i.classList.remove("active"));
  }
  update() {
    switch (this.unselectAll(), this.editor.tool) {
      case i.Erase:
        this.menuErase?.classList.add("active");
        break;
      case i.Move:
        this.menuMove?.classList.add("active");
        break;
      case i.Select:
        this.menuSelect?.classList.add("active");
        break;
      case i.Write:
        switch (this.editor.writer.tool) {
          case r.Circle:
            this.menuShape?.classList.add("active"), this.subMenuShape?.circle?.classList.add("active");
            break;
          case r.Ellipse:
            this.menuShape?.classList.add("active"), this.subMenuShape?.ellipse?.classList.add("active");
            break;
          case r.Triangle:
            this.menuShape?.classList.add("active"), this.subMenuShape?.triangle?.classList.add("active");
            break;
          case r.Rectangle:
            this.menuShape?.classList.add("active"), this.subMenuShape?.rectangle?.classList.add("active");
            break;
          case r.Line:
            this.menuEdge?.classList.add("active"), this.subMenuEdge?.line?.classList.add("active");
            break;
          case r.Arrow:
            this.menuEdge?.classList.add("active"), this.subMenuEdge?.arrow?.classList.add("active");
            break;
          case r.DoubleArrow:
            this.menuEdge?.classList.add("active"), this.subMenuEdge?.doubleArrow?.classList.add("active");
            break;
          default:
            this.writeBtn?.classList.add("active");
        }
    }
  }
  render(i) {
    this.editor.configuration.menu.tool.enable && (this.wrapper = document.createElement("div"), this.wrapper.classList.add("ms-menu", "ms-menu-bottom", "ms-menu-row"), this.wrapper.appendChild(this.createMenuWrite()), this.wrapper.appendChild(this.createMenuMove()), this.wrapper.appendChild(this.createMenuSelect()), this.wrapper.appendChild(this.createMenuErase()), this.wrapper.appendChild(this.createMenuEdge()), this.wrapper.appendChild(this.createMenuShape()), i.appendChild(this.wrapper), this.update(), this.show());
  }
  show() {
    this.wrapper && (this.wrapper.style.visibility = "visible");
  }
  hide() {
    this.wrapper && (this.wrapper.style.visibility = "hidden");
  }
  destroy() {
    if (this.wrapper) {
      for (; this.wrapper.lastChild;) this.wrapper.removeChild(this.wrapper.lastChild);
      this.wrapper.remove(), this.writeBtn = void 0, this.menuSelect = void 0, this.menuMove = void 0, this.menuErase = void 0, this.menuShape = void 0, this.subMenuShape = void 0, this.menuEdge = void 0, this.subMenuEdge = void 0, this.wrapper = void 0;
    }
  }
}
class IIMenuStyle extends IIMenu {
  #t = LoggerManager.getLogger(d.MENU);
  editor;
  id;
  wrapper;
  subMenu;
  triggerBtn;
  menuColorStroke;
  menuColorFill;
  menuThickness;
  menuFontSize;
  menuFontWeight;
  menuStrokeOpacity;
  constructor(i, r = "ms-menu-style") {
    super(), this.id = r, this.#t.info("constructor"), this.editor = i;
  }
  get model() {
    return this.editor.model;
  }
  get symbolsSelected() {
    return this.model.symbolsSelected;
  }
  get writeShape() {
    return ![r.Arrow, r.DoubleArrow, r.Line, r.Pencil].includes(this.editor.writer.tool);
  }
  get rowHeight() {
    return this.editor.configuration.rendering.guides.gap;
  }
  get isMobile() {
    return this.editor.renderer.parent.clientWidth < 700;
  }
  createMenuStroke() {
    const i = this.symbolsSelected.map(i => i.style),
      r = i.length && i.every(r => r.color === i[0]?.color) && i[0]?.color ? i[0]?.color : this.editor.penStyle.color,
      s = {
        type: "colors",
        label: "Colors",
        id: `${this.id}-color`,
        fill: !1,
        values: this.colors,
        initValue: r,
        callback: i => {
          this.editor.penStyle = {
            color: i
          }, this.editor.updateSymbolsStyle(this.symbolsSelected.map(i => i.id), {
            color: i
          });
        }
      },
      n = this.createColorList(s);
    return this.menuColorStroke = this.createWrapCollapsible(n, "Colors"), this.menuColorStroke.id = `${this.id}-color`, this.menuColorStroke;
  }
  createMenuColorFill() {
    const i = this.symbolsSelected.map(i => i.style),
      r = i.length && i.every(r => r.color === i[0]?.color) && i[0].color ? i[0].color : this.editor.penStyle.color,
      s = {
        type: "colors",
        label: "Fill",
        id: `${this.id}-fill`,
        fill: !0,
        values: this.colors,
        initValue: r,
        callback: i => {
          this.editor.penStyle = {
            fill: i
          }, this.editor.updateSymbolsStyle(this.symbolsSelected.map(i => i.id), {
            fill: i
          });
        }
      },
      n = this.createColorList(s);
    return this.menuColorFill = this.createWrapCollapsible(n, "Fill"), this.menuColorFill.id = `${this.id}-fill`, this.menuColorFill;
  }
  createMenuThickness() {
    const i = document.createElement("div");
    i.id = `${this.id}-thickness-list`, i.classList.add("ms-menu-row", "thickness-list");
    const r = this.symbolsSelected.map(i => i.style),
      s = r.length && r.every(i => i.width === r[0].width) ? r[0].width : this.editor.penStyle.width;
    return this.thicknessList.forEach(r => {
      const n = document.createElement("button");
      n.id = `${this.id}-thickness-${r.label}-btn`, n.classList.add("ms-menu-button", "square"), n.textContent = r.label, s === r.value && n.classList.add("active"), n.addEventListener("pointerup", s => {
        s.preventDefault(), s.stopPropagation(), this.editor.penStyle = {
          width: r.value
        }, i.querySelectorAll("*").forEach(i => i.classList.remove("active")), n.classList.add("active"), this.symbolsSelected.length && (this.editor.updateSymbolsStyle(this.symbolsSelected.map(i => i.id), {
          width: r.value
        }), this.editor.selector.resetSelectedGroup(this.symbolsSelected));
      }), i.appendChild(n);
    }), this.menuThickness = this.createWrapCollapsible(i, "Thickness"), this.menuThickness.id = `${this.id}-thickness`, this.menuThickness;
  }
  createMenuFontSize() {
    const i = document.createElement("div");
    return i.id = `${this.id}-font-size-list`, i.classList.add("ms-menu-row", "font-size-list"), this.fontSizeList.forEach(r => {
      const s = document.createElement("button");
      s.id = `${this.id}-font-size-${r.label}-btn`, s.classList.add("ms-menu-button", "square"), s.textContent = r.label, this.editor.configuration.fontStyle.size === r.value && s.classList.add("active"), s.addEventListener("pointerup", n => {
        if (n.preventDefault(), n.stopPropagation(), i.querySelectorAll("*").forEach(i => i.classList.remove("active")), s.classList.add("active"), "auto" === r.value) this.editor.configuration.fontStyle.size = "auto";else {
          const i = r.value;
          this.editor.configuration.fontStyle.size = i;
          const s = this.symbolsSelected.filter(i => i.type === E.Text || i.type === E.Group && i.extractText().length);
          this.editor.updateTextFontStyle(s.map(i => i.id), {
            fontSize: i * this.rowHeight
          }), this.editor.selector.resetSelectedGroup(this.symbolsSelected);
        }
      }), i.appendChild(s);
    }), this.menuFontSize = this.createWrapCollapsible(i, "Font size"), this.menuFontSize.id = `${this.id}-font-size`, this.menuFontSize;
  }
  createMenuFontWeight() {
    const i = document.createElement("div");
    return i.id = `${this.id}-font-weight-list`, i.classList.add("ms-menu-row", "font-weight-list"), this.fontWeightList.forEach(r => {
      const s = document.createElement("button");
      s.id = `${this.id}-font-weight-${r.label}-btn`, s.classList.add("ms-menu-button", "center"), s.textContent = r.label, this.editor.configuration.fontStyle.weight === r.value && s.classList.add("active"), s.addEventListener("pointerup", n => {
        if (n.preventDefault(), n.stopPropagation(), i.querySelectorAll("*").forEach(i => i.classList.remove("active")), s.classList.add("active"), this.editor.configuration.fontStyle.weight = r.value, "auto" !== this.editor.configuration.fontStyle.weight) {
          const i = this.symbolsSelected.filter(i => i.type === E.Text || i.type === E.Group && i.extractText().length);
          this.editor.updateTextFontStyle(i.map(i => i.id), {
            fontWeight: this.editor.configuration.fontStyle.weight
          }), this.editor.selector.resetSelectedGroup(this.symbolsSelected);
        }
      }), i.appendChild(s);
    }), this.menuFontWeight = this.createWrapCollapsible(i, "Font weight"), this.menuFontWeight.id = `${this.id}-font-weight`, this.menuFontWeight;
  }
  createMenuOpacity() {
    const i = this.symbolsSelected.map(i => i.style),
      r = 100 * (i.length && i.every(r => r.opacity === i[0]?.opacity) && i[0]?.opacity ? i[0]?.opacity : this.editor.penStyle.opacity || 1),
      s = document.createElement("div");
    s.id = `${this.id}-opacity-input-wrapper`;
    const n = document.createElement("input");
    n.id = `${this.id}-opacity-input`, n.setAttribute("name", "opacity"), n.setAttribute("type", "range"), n.setAttribute("step", "1"), n.setAttribute("min", "1"), n.setAttribute("max", "100"), s.appendChild(n);
    const a = document.createElement("output");
    return a.setAttribute("for", "opacity"), a.innerHTML = r ? `${r}` : "-", s.appendChild(a), r && n.setAttribute("value", r.toString()), n.addEventListener("input", i => {
      const r = i.target.value;
      a.innerHTML = `${r}%`, this.editor.penStyle = {
        opacity: r / 100
      }, this.symbolsSelected.length && this.editor.updateSymbolsStyle(this.symbolsSelected.map(i => i.id), {
        opacity: r / 100
      });
    }), this.menuStrokeOpacity = this.createWrapCollapsible(s, "Opacity"), this.menuStrokeOpacity.id = `${this.id}-opacity`, this.menuStrokeOpacity;
  }
  render(i) {
    if (this.editor.configuration.menu.style.enable) {
      this.triggerBtn = document.createElement("button"), this.triggerBtn.id = this.id, this.triggerBtn.classList.add("ms-menu-button", "square"), this.triggerBtn.innerHTML = '<svg\n  width="24px"\n  height="24px"\n  stroke-width="1"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n  color="currentColor"\n>\n  <path\n    d="M20.5096 9.54C20.4243 9.77932 20.2918 9.99909 20.12 10.1863C19.9483 10.3735 19.7407 10.5244 19.5096 10.63C18.2796 11.1806 17.2346 12.0745 16.5002 13.2045C15.7659 14.3345 15.3733 15.6524 15.3696 17C15.3711 17.4701 15.418 17.9389 15.5096 18.4C15.5707 18.6818 15.5747 18.973 15.5215 19.2564C15.4682 19.5397 15.3588 19.8096 15.1996 20.05C15.0649 20.2604 14.8877 20.4403 14.6793 20.5781C14.4709 20.7158 14.2359 20.8085 13.9896 20.85C13.4554 20.9504 12.9131 21.0006 12.3696 21C11.1638 21.0006 9.97011 20.7588 8.85952 20.2891C7.74893 19.8194 6.74405 19.1314 5.90455 18.2657C5.06506 17.4001 4.40807 16.3747 3.97261 15.2502C3.53714 14.1257 3.33208 12.9252 3.36959 11.72C3.4472 9.47279 4.3586 7.33495 5.92622 5.72296C7.49385 4.11097 9.60542 3.14028 11.8496 3H12.3596C14.0353 3.00042 15.6777 3.46869 17.1017 4.35207C18.5257 5.23544 19.6748 6.49885 20.4196 8C20.6488 8.47498 20.6812 9.02129 20.5096 9.52V9.54Z"\n    stroke="currentColor"\n    stroke-width="1"\n  ></path>\n  <path d="M8 16.01L8.01 15.9989" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M6 12.01L6.01 11.9989" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M8 8.01L8.01 7.99889" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M12 6.01L12.01 5.99889" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n  <path d="M16 8.01L16.01 7.99889" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>\n</svg>\n';
      const r = document.createElement("div");
      r.classList.add("ms-menu-colmun"), r.appendChild(this.createMenuStroke()), r.appendChild(this.createMenuColorFill()), r.appendChild(this.createMenuThickness()), r.appendChild(this.createMenuFontSize()), r.appendChild(this.createMenuFontWeight()), r.appendChild(this.createMenuOpacity());
      const s = {
        trigger: this.triggerBtn,
        subMenu: r,
        position: "bottom-left"
      };
      this.subMenu = new IIMenuSub(s), this.wrapper = document.createElement("div"), this.wrapper.classList.add("ms-menu", "ms-menu-top-right"), this.wrapper.appendChild(this.subMenu.element), i.appendChild(this.wrapper), this.update();
    }
  }
  update() {
    if (this.subMenu && (this.isMobile ? this.subMenu.wrap() : this.subMenu.unwrap()), this.editor.tool === i.Write) this.show(), this.menuColorStroke && (this.menuColorStroke.style.display = "block"), this.menuColorFill && (this.menuColorFill.style.display = this.writeShape ? "block" : "none"), this.menuThickness && (this.menuThickness.style.display = "block"), this.menuFontSize && (this.menuFontSize.style.display = "block"), this.menuFontWeight && (this.menuFontWeight.style.display = "block"), this.menuStrokeOpacity && (this.menuStrokeOpacity.style.display = "block");else if (this.editor.tool === i.Select) {
      if (this.show(), this.menuColorStroke && (this.menuColorStroke.style.display = "block"), this.menuColorFill) {
        const i = this.model.symbolsSelected.length && this.model.symbolsSelected.some(i => i.type === E.Shape);
        this.menuColorFill.style.display = i ? "block" : "none";
      }
      this.menuThickness && (this.menuThickness.style.display = "block"), this.menuFontSize && (this.menuFontSize.style.display = "block"), this.menuFontWeight && (this.menuFontWeight.style.display = "block"), this.menuStrokeOpacity && (this.menuStrokeOpacity.style.display = "block");
    } else this.hide();
  }
  show() {
    this.wrapper && (this.wrapper.style.visibility = "visible");
  }
  hide() {
    this.wrapper && (this.wrapper.style.visibility = "hidden");
  }
  destroy() {
    if (this.wrapper) {
      for (; this.wrapper.lastChild;) this.wrapper.removeChild(this.wrapper.lastChild);
      this.wrapper.remove(), this.wrapper = void 0, this.subMenu = void 0, this.triggerBtn = void 0, this.menuColorStroke = void 0, this.menuColorFill = void 0, this.menuThickness = void 0, this.menuFontSize = void 0, this.menuFontWeight = void 0, this.menuStrokeOpacity = void 0;
    }
  }
}
class IIMenuContext extends IIMenu {
  #t = LoggerManager.getLogger(d.MENU);
  editor;
  id;
  wrapper;
  editMenu;
  editInput;
  editSaveBtn;
  reorderMenu;
  decoratorMenu;
  menuExport;
  duplicateBtn;
  groupBtn;
  convertBtn;
  removeBtn;
  position;
  constructor(i, r = "ms-menu-context") {
    super(), this.id = r, this.#t.info("constructor"), this.editor = i, this.position = {
      x: 0,
      y: 0,
      scrollLeft: 0,
      scrollTop: 0
    };
  }
  get symbolsSelected() {
    return this.editor.model.symbolsSelected;
  }
  get haveSymbolsSelected() {
    return this.symbolsSelected.length > 0;
  }
  get symbolsDecorable() {
    return this.symbolsSelected.filter(i => [E.Stroke, E.Text, E.Group].includes(i.type) || i.type === E.Recognized && i.kind === T.Text);
  }
  get showDecorator() {
    return this.symbolsDecorable.length > 0;
  }
  createMenuEdit() {
    const i = document.createElement("button");
    i.id = `${this.id}-edit-trigger`, i.classList.add("ms-menu-button");
    const r = document.createElement("span");
    r.innerText = "Edit", i.appendChild(r);
    const s = document.createElement("span");
    s.style.setProperty("width", "32px"), s.style.setProperty("transform", "rotate(270deg)"), s.innerHTML = we, i.appendChild(s);
    const n = document.createElement("div");
    n.classList.add("ms-menu-colmun"), this.editInput = document.createElement("input"), n.appendChild(this.editInput), this.editSaveBtn = document.createElement("button"), this.editSaveBtn.classList.add("ms-menu-button"), this.editSaveBtn.innerText = "Save", n.appendChild(this.editSaveBtn), this.editSaveBtn.addEventListener("pointerdown", async i => {
      i.stopPropagation();
      const r = this.editor.model.symbolsSelected.find(i => i.type === E.Text);
      if (r) {
        const i = r.chars[0];
        r.chars = [];
        for (let s = 0; s < this.editInput.value.length; s++) r.chars.push({
          label: this.editInput.value.charAt(s),
          id: createUUID(),
          color: i.color,
          fontSize: i.fontSize,
          fontWeight: i.fontWeight,
          bounds: i.bounds
        });
        await this.editor.updateSymbol(r), this.editor.selector.resetSelectedGroup([r]);
      }
    });
    const a = {
      trigger: i,
      subMenu: n,
      position: "right"
    };
    return this.editMenu = new IIMenuSub(a).element, this.editMenu;
  }
  createMenuDuplicate() {
    return this.duplicateBtn = document.createElement("button"), this.duplicateBtn.id = `${this.id}-duplicate`, this.duplicateBtn.textContent = "Duplicate", this.duplicateBtn.classList.add("ms-menu-button"), this.duplicateBtn.addEventListener("pointerup", async () => {
      const i = this.symbolsSelected,
        updateDeepIdInGroup = i => {
          i.children.forEach(i => {
            switch (i.id = i.id.slice(0, -36) + `-${createUUID()}`, i.type) {
              case E.Group:
                updateDeepIdInGroup(i);
                break;
              case E.Recognized:
                i.strokes.forEach(i => i.id = i.id.slice(0, -36) + `-${createUUID()}`);
            }
          });
        },
        r = i.map(i => {
          const r = i.clone();
          for (; this.editor.model.symbols.find(i => i.id === r.id);) r.id = r.id.slice(0, -36) + `-${createUUID()}`, r.type === E.Group ? updateDeepIdInGroup(r) : r.type === E.Recognized && r.strokes.forEach(i => i.id = i.id.slice(0, -36) + `-${createUUID()}`);
          return r.selected = !0, this.editor.translator.applyToSymbol(r, a, a), r;
        });
      this.editor.unselectAll(), await this.editor.addSymbols(r), this.editor.selector.drawSelectedGroup(r);
    }), this.duplicateBtn;
  }
  createMenuGroup() {
    return this.groupBtn = document.createElement("button"), this.groupBtn.id = `${this.id}-duplicate`, this.groupBtn.textContent = "Group", this.groupBtn.classList.add("ms-menu-button"), this.groupBtn.addEventListener("pointerup", async () => {
      if (1 === this.symbolsSelected.length && this.symbolsSelected[0].type === E.Group) {
        const i = this.editor.ungroupSymbol(this.symbolsSelected[0]);
        this.editor.select(i.map(i => i.id));
      } else {
        const i = this.symbolsSelected.slice();
        this.editor.unselectAll();
        const r = this.editor.groupSymbols(i);
        r.selected = !0, this.editor.select([r.id]);
      }
    }), this.groupBtn;
  }
  createMenuConvert() {
    return this.convertBtn = document.createElement("button"), this.convertBtn.id = `${this.id}-convert`, this.convertBtn.textContent = "Convert", this.convertBtn.classList.add("ms-menu-button"), this.convertBtn.addEventListener("pointerup", () => this.editor.convertSymbols(this.symbolsSelected)), this.convertBtn;
  }
  createMenuRemove() {
    return this.removeBtn = document.createElement("button"), this.removeBtn.id = `${this.id}-remove`, this.removeBtn.textContent = "Remove", this.removeBtn.classList.add("ms-menu-button"), this.removeBtn.addEventListener("pointerup", async () => {
      this.editor.selector.removeSelectedGroup(), await this.editor.removeSymbols(this.symbolsSelected.map(i => i.id));
    }), this.removeBtn;
  }
  createMenuReorder() {
    const i = document.createElement("button");
    i.id = `${this.id}-reorder`, i.classList.add("ms-menu-button");
    const r = document.createElement("span");
    r.innerText = "Reorder", i.appendChild(r);
    const s = document.createElement("span");
    s.style.setProperty("width", "32px"), s.style.setProperty("transform", "rotate(270deg)"), s.innerHTML = we, i.appendChild(s);
    const n = [{
        type: "button",
        id: `${this.id}-reorder-first`,
        label: "Bring to front",
        callback: () => {
          this.editor.changeOrderSymbols(this.symbolsSelected, "last"), this.editor.selector.resetSelectedGroup(this.symbolsSelected);
        }
      }, {
        type: "button",
        id: `${this.id}-reorder-forward`,
        label: "Bring forward",
        callback: () => {
          this.editor.changeOrderSymbols(this.symbolsSelected, "forward"), this.editor.selector.resetSelectedGroup(this.symbolsSelected);
        }
      }, {
        type: "button",
        id: `${this.id}-reorder-backward`,
        label: "Send backward",
        callback: () => {
          this.editor.changeOrderSymbols(this.symbolsSelected, "backward"), this.editor.selector.resetSelectedGroup(this.symbolsSelected);
        }
      }, {
        type: "button",
        id: `${this.id}-reorder-last`,
        label: "Send to back",
        callback: () => {
          this.editor.changeOrderSymbols(this.symbolsSelected.slice().reverse(), "first"), this.editor.selector.resetSelectedGroup(this.symbolsSelected);
        }
      }],
      a = document.createElement("div");
    a.classList.add("ms-menu-colmun"), n.forEach(i => {
      a.appendChild(this.createMenuItem(i));
    });
    const l = {
      trigger: i,
      subMenu: a,
      position: "right"
    };
    return this.reorderMenu = new IIMenuSub(l).element, this.reorderMenu;
  }
  createDecoratorSubMenu(i, r) {
    const s = document.createElement("button");
    s.id = `${this.id}-decorator-${r}`, s.classList.add("ms-menu-button");
    const n = document.createElement("span");
    n.innerText = i, s.appendChild(n);
    const a = document.createElement("span");
    a.style.setProperty("width", "32px"), a.style.setProperty("transform", "rotate(270deg)"), a.innerHTML = we, s.appendChild(a);
    const l = [{
        type: "checkbox",
        id: `${this.id}-decorator-${r}-enable`,
        label: "Enable",
        initValue: !1,
        callback: i => {
          this.symbolsDecorable.forEach(s => {
            if (i) s.decorators.some(i => i.kind === r) || s.decorators.push(new IIDecorator(r, this.editor.penStyle));else {
              const i = s.decorators.findIndex(i => i.kind === r);
              i > -1 && s.decorators.splice(i, 1);
            }
            this.editor.model.updateSymbol(s), this.editor.renderer.drawSymbol(s);
          }), document.querySelectorAll(`#${this.id}-decorator-${r}-color button`).forEach(r => {
            r.disabled = !i, r.classList.remove("active");
          }), i && document.querySelector(`#${this.id}-decorator-${r}-color button`)?.classList.add("active");
        }
      }, {
        type: "colors",
        label: "Colors",
        id: `${this.id}-decorator-${r}-color`,
        fill: !1,
        values: this.colors.filter((i, r) => !(r % 4)),
        initValue: this.colors[0],
        disabled: !0,
        callback: i => {
          this.symbolsDecorable.forEach(s => {
            const n = s.decorators.find(i => i.kind === r);
            n && (n.style.color = i, this.editor.model.updateSymbol(s), this.editor.renderer.drawSymbol(s));
          });
        }
      }],
      d = document.createElement("div");
    d.classList.add("ms-menu-colmun"), l.forEach(i => {
      d.appendChild(this.createMenuItem(i));
    });
    const h = {
      trigger: s,
      subMenu: d,
      position: "right"
    };
    return this.decoratorMenu = new IIMenuSub(h).element;
  }
  createMenuDecorator() {
    const i = document.createElement("button");
    i.id = `${this.id}-decorator`, i.classList.add("ms-menu-button");
    const r = document.createElement("span");
    r.innerText = "Decorator", i.appendChild(r);
    const s = document.createElement("span");
    s.style.setProperty("width", "32px"), s.style.setProperty("transform", "rotate(270deg)"), s.innerHTML = we, i.appendChild(s);
    const n = document.createElement("div");
    n.classList.add("ms-menu-colmun"), n.appendChild(this.createDecoratorSubMenu("Hightlight", k.Highlight)), n.appendChild(this.createDecoratorSubMenu("Surround", k.Surround)), n.appendChild(this.createDecoratorSubMenu("Underline", k.Underline)), n.appendChild(this.createDecoratorSubMenu("Strikethrough", k.Strikethrough));
    const a = {
      trigger: i,
      subMenu: n,
      position: "right"
    };
    return this.decoratorMenu = new IIMenuSub(a).element, this.decoratorMenu;
  }
  createMenuExport() {
    const i = document.createElement("button");
    i.id = `${this.id}-export`, i.classList.add("ms-menu-button");
    const r = document.createElement("span");
    r.innerText = "Export", i.appendChild(r);
    const s = document.createElement("span");
    s.style.setProperty("width", "32px"), s.style.setProperty("transform", "rotate(270deg)"), s.innerHTML = we, i.appendChild(s);
    const n = [{
        type: "button",
        id: `${this.id}-export-json`,
        label: "json",
        callback: () => this.editor.downloadAsJson(this.haveSymbolsSelected)
      }, {
        type: "button",
        id: `${this.id}-export-svg`,
        label: "svg",
        callback: () => this.editor.downloadAsSVG(this.haveSymbolsSelected)
      }, {
        type: "button",
        id: `${this.id}-export-png`,
        label: "png",
        callback: () => this.editor.downloadAsPNG(this.haveSymbolsSelected)
      }],
      a = document.createElement("div");
    a.classList.add("ms-menu-colmun"), n.forEach(i => {
      a.appendChild(this.createMenuItem(i));
    });
    const l = {
      trigger: i,
      subMenu: a,
      position: "right"
    };
    return this.menuExport = new IIMenuSub(l).element, this.menuExport;
  }
  createMenuSelectAll() {
    const i = document.createElement("button");
    return i.id = `${this.id}-duplicate`, i.textContent = "Select all", i.classList.add("ms-menu-button"), i.addEventListener("pointerup", async () => this.editor.selectAll()), i;
  }
  updateDecoratorSubMenu() {
    this.showDecorator ? (this.decoratorMenu?.style.removeProperty("display"), Object.values(k).forEach(i => {
      const r = document.getElementById(`${this.id}-decorator-${i}-enable`);
      if (r) {
        document.querySelectorAll(`#${this.id}-decorator-${i}-color button`).forEach(i => i.classList.remove("active"));
        const s = this.symbolsDecorable.flatMap(i => i.decorators).filter(r => r.kind === i);
        if (s.length && s.every(i => i.style.color === s[0].style.color)) {
          const r = document.getElementById(`${this.id}-decorator-${i}-color-${s[0].style.color?.replace("#", "")}-btn`);
          r?.classList.add("active");
        }
        this.symbolsDecorable.filter(r => r.decorators.some(r => r.kind === i)).length === this.symbolsDecorable.length ? (r.checked = !0, document.querySelectorAll(`#${this.id}-decorator-${i}-color button`).forEach(i => {
          i.disabled = !1;
        }), r.indeterminate = !1) : this.symbolsDecorable.filter(r => !r.decorators.some(r => r.kind === i)).length === this.symbolsDecorable.length ? (r.checked = !1, document.querySelectorAll(`#${this.id}-decorator-${i}-color button`).forEach(i => {
          i.disabled = !0;
        }), r.indeterminate = !1) : (r.setAttribute("indeterminate", "true"), r.indeterminate = !0, document.querySelectorAll(`#${this.id}-decorator-${i}-color button`).forEach(i => {
          i.disabled = !1;
        }));
      }
    })) : this.decoratorMenu?.style.setProperty("display", "none");
  }
  updateGroupMenu() {
    this.groupBtn && this.haveSymbolsSelected ? (this.groupBtn.style.removeProperty("display"), 1 === this.symbolsSelected.length && this.symbolsSelected[0].type === E.Group ? this.groupBtn.textContent = "UnGroup" : this.groupBtn.textContent = "Group") : this.groupBtn?.style.setProperty("display", "none");
  }
  update() {
    if (this.wrapper?.style.setProperty("left", this.position.x - this.position.scrollLeft + "px"), this.wrapper?.style.setProperty("top", this.position.y - this.position.scrollTop + "px"), this.haveSymbolsSelected) {
      const i = this.editor.model.symbolsSelected.find(i => i.type === E.Text);
      this.editMenu && this.editInput && 1 === this.editor.model.symbolsSelected.length && i ? (this.editMenu.style.removeProperty("display"), this.editInput.value = i.label) : this.editMenu?.style.setProperty("display", "none"), this.editor.extractStrokesFromSymbols(this.symbolsSelected).length ? this.convertBtn?.style.removeProperty("display") : this.convertBtn?.style.setProperty("display", "none"), this.reorderMenu?.style.removeProperty("display"), this.duplicateBtn?.style.removeProperty("display"), this.removeBtn?.style.removeProperty("display"), this.menuExport?.style.removeProperty("display");
    } else this.editMenu?.style.setProperty("display", "none"), this.convertBtn?.style.setProperty("display", "none"), this.reorderMenu?.style.setProperty("display", "none"), this.duplicateBtn?.style.setProperty("display", "none"), this.removeBtn?.style.setProperty("display", "none"), this.menuExport?.style.setProperty("display", "none");
    this.updateDecoratorSubMenu(), this.updateGroupMenu();
  }
  render(i) {
    this.wrapper = document.createElement("div"), this.wrapper.id = `${this.id}-wrapper`, this.wrapper.classList.add("ms-menu", "ms-menu-context"), this.wrapper.appendChild(this.createMenuEdit()), this.wrapper.appendChild(this.createMenuDecorator()), this.wrapper.appendChild(this.createMenuReorder()), this.wrapper.appendChild(this.createMenuExport()), this.wrapper.appendChild(this.createMenuConvert()), this.wrapper.appendChild(this.createMenuGroup()), this.wrapper.appendChild(this.createMenuDuplicate()), this.wrapper.appendChild(this.createMenuRemove()), this.wrapper.appendChild(this.createMenuSelectAll()), this.wrapper.style.setProperty("display", "none"), i.appendChild(this.wrapper), this.editor.layers.rendering.addEventListener("scroll", () => {
      this.position.scrollLeft = this.editor.layers.rendering.scrollLeft || 0, this.position.scrollTop = this.editor.layers.rendering.scrollTop || 0, this.update();
    });
  }
  show() {
    this.update(), this.wrapper?.style.setProperty("display", "block");
  }
  hide() {
    this.wrapper?.style.setProperty("display", "none");
  }
  destroy() {
    for (; this.wrapper?.lastChild;) this.wrapper.removeChild(this.wrapper.lastChild);
    this.wrapper?.remove();
  }
}
const Te = {
  enable: !0,
  style: {
    enable: !0
  },
  tool: {
    enable: !0
  },
  action: {
    enable: !0
  },
  context: {
    enable: !0
  }
};
class IIMenuManager {
  #t = LoggerManager.getLogger(d.MENU);
  editor;
  layer;
  action;
  tool;
  context;
  style;
  constructor(i, r) {
    if (this.#t.info("constructor"), this.editor = i, r?.style) {
      const i = r.style;
      this.style = new i(this.editor);
    } else this.style = new IIMenuStyle(this.editor);
    if (r?.tool) {
      const i = r.tool;
      this.tool = new i(this.editor);
    } else this.tool = new IIMenuTool(this.editor);
    if (r?.action) {
      const i = r.action;
      this.action = new i(this.editor);
    } else this.action = new IIMenuAction(this.editor);
    if (r?.context) {
      const i = r.context;
      this.context = new i(this.editor);
    } else this.context = new IIMenuContext(this.editor);
  }
  render(i) {
    if (this.editor.configuration.menu.enable) {
      this.layer = i;
      const r = document.createElement("style");
      r.appendChild(document.createTextNode(".ms-editor .ms-menu{background-color:#fff;box-shadow:1px 1px 5px rgba(0,0,0,.25),-1px -1px 5px rgba(0,0,0,.25);cursor:auto;padding:5px;pointer-events:all;z-index:99}.ms-editor .ms-menu-top-left{border-radius:0 0 5px 5px;left:5px;position:absolute;top:0}.ms-editor .ms-menu-bottom{border-radius:5px;bottom:8px;left:50%;position:absolute;transform:translateX(-50%)}.ms-editor .ms-menu-top-right{border-radius:0 0 5px 5px;position:absolute;right:5px;top:0}.ms-editor .ms-menu .ms-menu-title{background-color:#b3dfff;border-radius:5px 5px 0 0;font-size:16px;font-weight:700;margin-bottom:8px;margin-top:0;padding:2px;text-align:center}.ms-editor .ms-menu-colmun{display:flex;flex-direction:column;justify-content:center}.ms-editor .ms-menu-row{display:flex;flex-direction:row;justify-content:center}.ms-editor .ms-menu-item{align-items:center;display:flex;gap:5px;justify-content:space-between;padding:5px;width:100%}.ms-editor .ms-menu .select-language{height:32px;padding:0 8px;width:auto}.ms-editor .ms-menu-item.list button{align-items:center;background-color:#fff;border:none;border-radius:4px;cursor:pointer;display:flex;font-size:inherit;height:32px;justify-content:center;padding:0;position:relative;width:32px}.ms-editor .ms-menu-item.list button:hover{background-color:#efefef}.ms-editor .ms-menu-item.list button.active{border:1px solid #1a9fff}.ms-editor .ms-menu .color-list{cursor:pointer;flex-wrap:wrap;gap:2px;margin:auto;max-width:150px;min-width:150px;padding:4px}.ms-editor .ms-menu .font-size-list,.ms-editor .ms-menu .thickness-list{cursor:pointer;flex-wrap:wrap;gap:2px;margin:auto;max-width:150px;min-width:150px;padding:0}.ms-editor .ms-menu .ms-menu-button{-webkit-touch-callout:none;align-items:center;background-color:#fff;border:none;border-radius:4px;color:#000;cursor:pointer;display:flex;font-size:inherit;height:32px;justify-content:space-between;padding:4px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.ms-editor .ms-menu svg{height:20px;position:relative;width:20px}.ms-editor .ms-menu .ms-menu-button.center{justify-content:center}.ms-editor .ms-menu .ms-menu-button.square{justify-content:center;width:32px}.ms-editor .ms-menu .ms-menu-button .color{border-radius:100%;height:75%;margin:auto;width:75%}.ms-editor .ms-menu .ms-menu-button:hover{background-color:#efefef}.ms-editor .ms-menu .ms-menu-button:disabled{background-color:hsla(0,0%,100%,.4);color:rgba(0,0,0,.4);opacity:.5;pointer-events:none}.ms-editor .ms-menu .ms-menu-button:active,.ms-editor .ms-menu .ms-menu-button:focus{background-color:#1aa0ff55;outline:none}.ms-editor .ms-menu .ms-menu-button.active{border:1px solid #1a9fff;color:#1a9fff}.ms-editor .sub-menu{overflow:visible;position:relative}.ms-editor .sub-menu .sub-menu-content{background-color:#fff;border-radius:5px;box-shadow:1px 1px 5px rgba(0,0,0,.25),-1px -1px 5px rgba(0,0,0,.25);color:#000;display:none;padding:5px;position:absolute;white-space:nowrap;width:auto;z-index:100}.ms-editor .sub-menu .sub-menu-content.open{display:block}.ms-editor .sub-menu .sub-menu-content.top{left:50%;top:-8px;transform:translate(-50%,-100%)}.ms-editor .sub-menu .sub-menu-content.bottom{bottom:-8px;left:50%;transform:translate(-50%,100%)}.ms-editor .sub-menu .sub-menu-content.bottom-left{bottom:-8px;right:0;transform:translateY(100%)}.ms-editor .sub-menu .sub-menu-content.right-top{right:-8px;top:0;transform:translate(100%)}.ms-editor .sub-menu .sub-menu-content.right{right:-8px;top:50%;transform:translate(100%,-50%)}.ms-editor .ms-menu-context{position:absolute}.ms-editor .ms-menu output{background-color:#fff;border-radius:5px;box-shadow:0 2px 5px 0 rgba(0,0,0,.225);color:#000;display:none;font-weight:700;left:50%;padding:5px;position:absolute;transform:translate(-50%,-250%);white-space:nowrap;width:auto}.ms-editor .ms-menu input:focus+output,.ms-editor .ms-menu input:focus-visible+output,.ms-editor .ms-menu input:hover+output{display:block}.ms-editor .ms-menu input:not([type=checkbox]):not([type=color]):not([type=range]),.ms-editor .ms-menu select{-webkit-tap-highlight-color:transparent;-webkit-appearance:none;appearance:none;border:1px solid #ced5d9;border-radius:3px;color:#131f26;font:600 14px Source Sans Pro,sans-serif;height:2rem;padding:0 10px}.ms-editor .ms-menu input[type=file]{border:none!important}.ms-editor .ms-menu input[type=file]:focus{border:none!important;box-shadow:none!important}.ms-editor .ms-menu input[type=file]:focus::file-selector-button{border:1px solid #1a9fff!important}.ms-editor .ms-menu input[type=file]::file-selector-button{background-color:#fff;border:1px solid rgba(0,0,0,.16);border-radius:4px;box-shadow:0 1px 0 rgba(0,0,0,.05);cursor:pointer;height:2rem;margin:0 auto 0 8px;padding:0 16px;transition:background-color .2s}.ms-editor .ms-menu input[type=file]::file-selector-button:hover{background-color:#f3f4f6}.ms-editor .ms-menu input[type=file]::file-selector-button:active{background-color:#e5e7eb}.ms-editor .ms-menu select{background:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQuNDIyLjI2Yy0uMjMzLS4zMzctLjYxLS4zMzctLjg0NCAwTC4xNzUgNS4xN0MtLjE0MiA1LjYyOC4wNDggNiAuNjEgNmg2Ljc4Yy41NTggMCAuNzU0LS4zNy40MzUtLjgzTDQuNDIyLjI2em0uMDIgMTMuNDdjLS4yMzYuMzQyLS42MTguMzQ3LS44NS4wMUwuMTY3IDguODE4Qy0uMTQ2IDguMzY3LjA0OCA4IC42MDggOGg2Ljc4M2MuNTU4IDAgLjc1NS4zNy40MzcuODNsLTMuMzg1IDQuOXoiIGZpbGw9IiMxMzFGMjYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==) 100% no-repeat #fff;padding:0 25px 0 10px}.ms-editor .ms-menu input:not([type=checkbox]):not([type=color]):not([type=range]):not([type=file]):focus,.ms-editor .ms-menu select:focus{border:1px solid #1a9fff;box-shadow:0 1px 1px 0 rgba(0,0,0,.16);outline:0}")), this.layer.prepend(r), this.editor.configuration.menu.action.enable && this.action.render(this.layer), this.editor.configuration.menu.style.enable && this.style.render(this.layer), this.editor.configuration.menu.tool.enable && this.tool.render(this.layer), this.editor.configuration.menu.context.enable && this.context.render(this.layer);
    }
  }
  update() {
    this.action.update(), this.tool.update(), this.style.update();
  }
  show() {
    this.action.show(), this.tool.show(), this.style.show();
  }
  hide() {
    this.action.hide(), this.tool.hide(), this.style.hide();
  }
  destroy() {
    this.action.destroy(), this.tool.destroy(), this.style.destroy();
  }
}
const Le = {
  guide: !0,
  symbol: !0,
  angle: 0
};
class SnapConfiguration {
  guide;
  symbol;
  angle;
  constructor(i) {
    this.symbol = void 0 !== i?.symbol ? i.symbol : Le.symbol, this.guide = void 0 !== i?.guide ? i.guide : Le.guide, this.angle = void 0 !== i?.angle ? i.angle : Le.angle;
  }
}
class IISnapManager {
  #t = LoggerManager.getLogger(d.CONVERTER);
  editor;
  configuration;
  constructor(i, r) {
    this.#t.info("constructor"), this.editor = i, this.configuration = new SnapConfiguration(r);
  }
  get model() {
    return this.editor.model;
  }
  get renderer() {
    return this.editor.renderer;
  }
  get selectionSnapPoints() {
    return Box.createFromPoints(this.model.symbolsSelected.flatMap(i => i.snapPoints)).snapPoints;
  }
  get otherSnapPoints() {
    const i = this.model.symbolsSelected.map(i => i.id);
    return this.model.symbols.filter(r => !i.includes(r.id)).flatMap(i => i.snapPoints);
  }
  get snapThreshold() {
    return this.editor.configuration.rendering.guides.gap / 2;
  }
  getNearestVerticalGuide(i) {
    return this.renderer.verticalGuides.length ? this.renderer.verticalGuides.reduce((r, s) => Math.abs(s - i) < Math.abs(r - i) ? s : r) : i;
  }
  getNearestHorizontalGuide(i) {
    return this.renderer.horizontalGuides.length ? this.renderer.horizontalGuides.reduce((r, s) => Math.abs(s - i) < Math.abs(r - i) ? s : r) : i;
  }
  getGuidePointToSnap(i) {
    return {
      x: this.getNearestVerticalGuide(i.x),
      y: this.getNearestHorizontalGuide(i.y)
    };
  }
  drawSnapToElementLines(i) {
    const r = {
      role: "snap-to-element",
      fill: "transparent",
      stroke: "blue",
      "stroke-width": "2",
      style: pe.noSelection,
      "marker-start": `url(#${pe.crossMarker})`,
      "marker-end": `url(#${pe.crossMarker})`
    };
    i.forEach(i => {
      this.renderer.drawLine(i.p1, i.p2, r);
    });
  }
  clearSnapToElementLines() {
    this.renderer.clearElements({
      attrs: {
        role: "snap-to-element"
      }
    });
  }
  getSnapLinesInfos(i, r) {
    const s = {
      nudge: {
        x: 1 / 0,
        y: 1 / 0
      },
      verticales: [],
      horizontales: []
    };
    return i.length && r.length ? (i.forEach(i => {
      r.forEach(r => {
        this.snapThreshold > Math.abs(r.x - i.x) && (Math.abs(s.nudge.x) > Math.abs(r.x - i.x) ? (s.nudge.x = r.x - i.x, s.verticales = [{
          p1: {
            ...i
          },
          p2: r
        }]) : s.nudge.x === r.x - i.x && s.verticales.push({
          p1: {
            ...i
          },
          p2: r
        })), this.snapThreshold > Math.abs(r.y - i.y) && (Math.abs(s.nudge.y) > Math.abs(r.y - i.y) ? (s.nudge.y = r.y - i.y, s.horizontales = [{
          p1: {
            ...i
          },
          p2: r
        }]) : s.nudge.y === r.y - i.y && s.horizontales.push({
          p1: {
            ...i
          },
          p2: r
        }));
      });
    }), s) : s;
  }
  snapResize(i, r = !0, s = !0) {
    if (this.clearSnapToElementLines(), !this.configuration.symbol && !this.configuration.guide) return i;
    let n = {
      x: 1 / 0,
      y: 1 / 0
    };
    this.configuration.guide && (n = this.getGuidePointToSnap(i));
    const a = [];
    if (this.configuration.symbol) {
      const l = this.getSnapLinesInfos([i], this.otherSnapPoints);
      r && Math.abs(l.nudge.x) <= Math.abs(i.x - n.x) && (n.x = i.x + l.nudge.x, a.push(...l.verticales)), s && Math.abs(l.nudge.y) <= Math.abs(i.y - n.y) && (n.y = i.y + l.nudge.y, a.push(...l.horizontales));
    }
    return n.x === 1 / 0 && (n.x = i.x), n.y === 1 / 0 && (n.y = i.y), a.forEach(i => i.p1 = n), this.drawSnapToElementLines(a), n;
  }
  snapTranslate(i, r) {
    this.clearSnapToElementLines();
    const s = {
      x: i,
      y: r
    };
    if (!this.configuration.symbol && !this.configuration.guide) return s;
    const n = this.selectionSnapPoints.map(s => ({
      x: s.x + i,
      y: s.y + r
    }));
    let a = 1 / 0,
      l = 1 / 0;
    this.configuration.guide && n.forEach(n => {
      const d = this.getGuidePointToSnap(n);
      a > Math.abs(d.x - n.x) && (s.x = d.x - n.x + i, a = Math.abs(d.x - n.x)), l > Math.abs(d.y - n.y) && (s.y = d.y - n.y + r, l = Math.abs(d.y - n.y));
    });
    const d = [];
    if (this.configuration.symbol) {
      const h = this.getSnapLinesInfos(n, this.otherSnapPoints);
      a >= Math.abs(h.nudge.x) && h.verticales.length && (s.x = h.nudge.x + i, d.push(...h.verticales)), l >= Math.abs(h.nudge.y) && h.horizontales.length && (s.y = h.nudge.y + r, d.push(...h.horizontales));
    }
    return d.length && (d.forEach(n => {
      n.p1.x += s.x - i, n.p1.y += s.y - r;
    }), this.drawSnapToElementLines(d)), s;
  }
  snapRotation(i) {
    return this.configuration.angle > 0 ? this.configuration.angle * Math.round(i / this.configuration.angle) : i;
  }
}
const Pe = {
  server: he.server,
  recognition: he.recognition,
  menu: Te,
  rendering: be,
  logger: h,
  grabber: xe,
  "undo-redo": Se,
  penStyle: y,
  fontStyle: {
    size: "auto",
    weight: "auto"
  },
  gesture: Ie,
  snap: Le
};
class InteractiveInkEditorConfiguration {
  grabber;
  logger;
  server;
  recognition;
  rendering;
  "undo-redo";
  menu;
  penStyle;
  fontStyle;
  gesture;
  snap;
  constructor(i) {
    const {
      server: r,
      recognition: s
    } = new RecognizerWebSocketConfiguration(i);
    this.recognition = s, this.server = r, this.grabber = mergeDeep({}, Pe.grabber, i?.grabber), this.logger = mergeDeep({}, Pe.logger, i?.logger), this.rendering = mergeDeep({}, Pe.rendering, i?.rendering), this["undo-redo"] = mergeDeep({}, Pe["undo-redo"], i?.["undo-redo"]), this.menu = mergeDeep({}, Pe.menu, i?.menu), this.gesture = mergeDeep({}, Pe.gesture, i?.gesture), this.snap = new SnapConfiguration(i?.snap), this.penStyle = mergeDeep({}, Pe.penStyle, i?.penStyle), this.fontStyle = mergeDeep({}, Pe.fontStyle, i?.fontStyle);
  }
}
class InteractiveInkEditor extends AbstractEditor {
  #m;
  #y;
  #d = i.Write;
  #b;
  #f;
  renderer;
  recognizer;
  #r;
  history;
  writer;
  eraser;
  gesture;
  resizer;
  rotator;
  translator;
  converter;
  texter;
  selector;
  svgDebugger;
  snaps;
  move;
  menu;
  constructor(i, r) {
    if (super(i, r), this.#m = new InteractiveInkEditorConfiguration(r?.configuration), this.#r = Object.assign({}, this.#m.penStyle), r?.override?.recognizer) {
      const i = r?.override.recognizer;
      this.recognizer = new i(this.#m);
    } else this.recognizer = new RecognizerWebSocket(this.#m);
    this.recognizer.event.addErrorListener(this.manageError.bind(this)), this.recognizer.event.addExportedListener(this.event.emitExported.bind(this.event)), this.recognizer.event.addContentChangedListener(this.onContentChanged.bind(this)), this.recognizer.event.addSessionOpenedListener(this.event.emitSessionOpened.bind(this.event)), this.recognizer.event.addEndInitialization(this.layers.hideMessageModal.bind(this.layers)), this.recognizer.event.addIdleListener(this.updateLayerState.bind(this)), this.renderer = new IISVGRenderer(this.#m.rendering), this.history = new IIHistoryManager(this.#m["undo-redo"], this.event), this.writer = new IIWriteManager(this), this.eraser = new IIEraseManager(this), this.selector = new IISelectionManager(this), this.move = new IIMoveManager(this), this.gesture = new IIGestureManager(this, this.#m.gesture), this.resizer = new IIResizeManager(this), this.rotator = new IIRotationManager(this), this.translator = new IITranslateManager(this), this.converter = new IIConversionManager(this), this.texter = new IITextManager(this), this.svgDebugger = new IIDebugSVGManager(this), this.snaps = new IISnapManager(this, this.#m.snap), this.menu = new IIMenuManager(this, r?.override?.menu), this.#y = new IIModel(this.#m.rendering.minWidth, this.#m.rendering.minHeight, this.configuration.rendering.guides.gap);
  }
  get initializationPromise() {
    return this.recognizer.initialized.promise;
  }
  get tool() {
    return this.#d;
  }
  set tool(r) {
    switch (this.#d = r, this.menu.tool.update(), this.setCursorStyle(), this.unselectAll(), this.eraser.detach(), this.selector.detach(), this.move.detach(), this.writer.detach(), this.#d) {
      case i.Erase:
        this.eraser.attach(this.layers.rendering);
        break;
      case i.Select:
        this.selector.attach(this.layers.rendering);
        break;
      case i.Move:
        this.move.attach(this.layers.rendering);
        break;
      default:
        this.writer.attach(this.layers.rendering);
    }
    this.event.emitToolChanged(r);
  }
  get model() {
    return this.#y;
  }
  get configuration() {
    return this.#m;
  }
  set renderingConfiguration(i) {
    this.configuration.rendering = mergeDeep(this.configuration.rendering, i);
    const r = Math.max(this.renderer.parent.clientHeight, this.configuration.rendering.minHeight),
      s = Math.max(this.renderer.parent.clientWidth, this.configuration.rendering.minWidth);
    this.renderer.resize(r, s), this.model.rowHeight = this.configuration.rendering.guides.gap, this.history.stack.forEach(i => i.model.rowHeight = this.model.rowHeight), this.event.emitUIpdated();
  }
  get penStyle() {
    return this.#r;
  }
  set penStyle(i) {
    this.logger.info("set penStyle", {
      penStyle: i
    }), this.#r = Object.assign({}, this.#r, i);
  }
  updateLayerState(i) {
    this.event.emitIdle(i), this.layers.updateState(i);
  }
  updateLayerUI(i = 500) {
    clearTimeout(this.#b), this.#b = setTimeout(() => {
      this.menu.update(), this.svgDebugger.apply(), this.waitForIdle(), this.event.emitUIpdated();
    }, i);
  }
  manageError(i) {
    this.layers.showMessageError(i), this.event.emitError(i);
  }
  setCursorStyle() {
    switch (this.#d) {
      case i.Erase:
        this.layers.root.classList.remove("draw"), this.layers.root.classList.add("erase"), this.layers.root.classList.remove("select"), this.layers.root.classList.remove("move");
        break;
      case i.Select:
        this.layers.root.classList.remove("draw"), this.layers.root.classList.remove("erase"), this.layers.root.classList.add("select"), this.layers.root.classList.remove("move");
        break;
      case i.Move:
        this.layers.root.classList.remove("draw"), this.layers.root.classList.remove("erase"), this.layers.root.classList.remove("select"), this.layers.root.classList.add("move");
        break;
      default:
        this.layers.root.classList.add("draw"), this.layers.root.classList.remove("erase"), this.layers.root.classList.remove("select"), this.layers.root.classList.remove("move");
    }
  }
  async onContentChanged(i) {
    clearTimeout(this.#f), this.#f = setTimeout(async () => {
      await this.synchronizeStrokesWithJIIX(), this.updateLayerUI(0), this.event.emitChanged(i);
    }, 500);
  }
  async initialize() {
    try {
      this.logger.info("initialize"), this.layers.render(), this.layers.showLoader(), this.tool = i.Write, this.renderer.init(this.layers.rendering), this.menu.render(this.layers.ui.root);
      const r = window.getComputedStyle(this.layers.root);
      this.model.width = Math.max(parseInt(r.width.replace("px", "")), this.#m.rendering.minWidth), this.model.height = Math.max(parseInt(r.height.replace("px", "")), this.#m.rendering.minHeight), this.model.rowHeight = this.configuration.rendering.guides.gap, this.history.init(this.model), this.recognizer.configuration.server.version || (await this.loadInfo(this.configuration.server), this.recognizer.configuration.server.version = this.info.version), await this.recognizer.init();
    } catch (i) {
      throw this.logger.error("initialize", i), this.layers.showMessageError(i), i;
    } finally {
      this.logger.debug("initialize", "finally"), this.layers.hideLoader(), this.layers.updateState(!0);
    }
  }
  async changeLanguage(i) {
    try {
      this.logger.info("changeLanguage", {
        code: i
      }), this.updateLayerState(!1), this.configuration.recognition.lang = i, await this.recognizer.newSession(this.configuration), this.recognizer.addStrokes(this.extractStrokesFromSymbols(this.model.symbols), !1), await this.synchronizeStrokesWithJIIX(!0), this.layers.hideLoader(), this.event.emitLoaded();
    } catch (i) {
      throw this.logger.error("changeLanguage", i), this.manageError(i), i;
    } finally {
      this.updateLayerUI();
    }
  }
  buildShape(i) {
    switch (i.kind) {
      case M.Circle:
        return IIShapeCircle.create(i);
      case M.Ellipse:
        return IIShapeEllipse.create(i);
      case M.Polygon:
        return IIShapePolygon.create(i);
      default:
        throw new Error(`Unable to create shape, kind: "${i.kind}" is unknown`);
    }
  }
  buildEdge(i) {
    switch (i.kind) {
      case I.Arc:
        return IIEdgeArc.create(i);
      case I.Line:
        return IIEdgeLine.create(i);
      case I.PolyEdge:
        return IIEdgePolyLine.create(i);
      default:
        throw new Error(`Unable to create edge, kind: "${i.kind}" is unknown`);
    }
  }
  buildRecognized(i) {
    switch (i.kind) {
      case T.Text:
        return IIRecognizedText.create(i);
      case T.Arc:
        return IIRecognizedArc.create(i);
      case T.Circle:
        return IIRecognizedCircle.create(i);
      case T.Ellipse:
        return IIRecognizedEllipse.create(i);
      case T.Polygone:
        return IIRecognizedPolygon.create(i);
      case T.Line:
        return IIRecognizedLine.create(i);
      case T.PolyEdge:
        return IIRecognizedPolyLine.create(i);
      default:
        throw new Error(`Unable to create recognized, symbol type '${JSON.stringify(i)} is unknow`);
    }
  }
  buildGroup(i) {
    if (!i.children?.length) throw new Error("Unable to create group, no children");
    const r = i.children.map(i => {
        switch (i?.type) {
          case E.Stroke:
            return IIStroke.create(i);
          case E.Shape:
            return this.buildShape(i);
          case E.Edge:
            return this.buildEdge(i);
          case E.Text:
            return IIText.create(i);
          case E.Group:
            return this.buildGroup(i);
          case E.Recognized:
            return this.buildRecognized(i);
          default:
            throw new Error(`Unable to create group, symbol type '${JSON.stringify(i)} is unknow`);
        }
      }),
      s = new IISymbolGroup(r, i.style);
    return i.id && (s.id = i.id), i.decorators && (s.decorators = i.decorators.map(i => new IIDecorator(i.kind, i.style))), s;
  }
  buildStroke(i) {
    return IIStroke.create(i);
  }
  buildStrokeText(i) {
    return IIRecognizedText.create(i);
  }
  buildText(i) {
    return IIText.create(i);
  }
  buildSymbol(i) {
    try {
      switch (i.type) {
        case E.Stroke:
          return this.buildStroke(i);
        case E.Shape:
          return this.buildShape(i);
        case E.Edge:
          return this.buildEdge(i);
        case E.Text:
          return this.buildText(i);
        case E.Group:
          return this.buildGroup(i);
        case E.Recognized:
          return this.buildRecognized(i);
        default:
          throw new Error(`Unable to build symbol, type: "${i.type}" is unknown`);
      }
    } catch (i) {
      throw this.logger.error("createSymbol", i), this.manageError(i), i;
    }
  }
  async createSymbol(i) {
    try {
      return await this.addSymbol(this.buildSymbol(i));
    } catch (i) {
      throw this.logger.error("createSymbol", i), this.manageError(i), i;
    } finally {
      this.updateLayerUI();
    }
  }
  async createSymbols(i) {
    try {
      const r = [],
        s = [];
      if (i.forEach(i => {
        try {
          s.push(this.buildSymbol(i));
        } catch (i) {
          r.push(i.message || i);
        }
      }), r.length) throw new Error(r.join("\n"));
      return await this.addSymbols(s);
    } catch (i) {
      throw this.logger.error("createSymbols", i), this.manageError(i), i;
    }
  }
  updateTextBounds(i) {
    i.type === E.Text ? this.texter.updateBounds(i) : i.type === E.Group && i.extractText().forEach(i => this.texter.updateBounds(i));
  }
  async addSymbol(i, r = !0) {
    this.logger.info("addSymbol", {
      sym: i
    }), this.updateLayerState(!1), this.updateTextBounds(i), this.model.addSymbol(i), this.renderer.drawSymbol(i);
    const s = this.extractStrokesFromSymbols([i]);
    return this.recognizer.addStrokes(s, !1), r && this.history.push(this.model, {
      added: [i]
    }), this.updateLayerUI(), i;
  }
  async addSymbols(i, r = !0) {
    this.logger.info("addSymbol", {
      symList: i
    }), this.updateLayerState(!1), i.forEach(i => {
      this.updateTextBounds(i), this.model.addSymbol(i), this.renderer.drawSymbol(i);
    });
    const s = this.extractStrokesFromSymbols(i);
    return this.recognizer.addStrokes(s, !1), r && this.history.push(this.model, {
      added: i
    }), this.updateLayerUI(), i;
  }
  async updateSymbol(i, r = !0) {
    this.logger.info("updateSymbol", {
      sym: i
    }), this.updateLayerState(!1), this.updateTextBounds(i), this.model.updateSymbol(i), this.renderer.drawSymbol(i);
    const s = this.extractStrokesFromSymbols([i]);
    return this.recognizer.replaceStrokes(s.map(i => i.id), s), r && this.history.push(this.model, {
      updated: [i]
    }), this.updateLayerUI(), i;
  }
  async updateSymbols(i, r = !0) {
    this.logger.info("updateSymbol", {
      symList: i
    }), this.updateLayerState(!1), i.forEach(i => {
      this.updateTextBounds(i), this.model.updateSymbol(i), this.renderer.drawSymbol(i);
    });
    const s = this.extractStrokesFromSymbols(i);
    return this.recognizer.replaceStrokes(s.map(i => i.id), s), r && this.history.push(this.model, {
      updated: i
    }), this.updateLayerUI(), i;
  }
  updateSymbolsStyle(i, r, s = !0) {
    this.logger.info("updateSymbolsStyle", {
      symbolIds: i,
      style: r
    });
    const n = [];
    this.model.symbols.forEach(s => {
      i.includes(s.id) && (s.style = Object.assign({}, s.style, r), E.Text !== s.type && E.Group !== s.type && E.Recognized !== s.type || s.updateChildrenStyle(), this.renderer.drawSymbol(s), this.model.updateSymbol(s), s.modificationDate = Date.now(), n.push(s));
    }), n.length && n.forEach(i => {
      if (i.type === E.Text) {
        const r = i.bounds.width;
        this.texter.updateBounds(i);
        const s = i.bounds.width - r;
        0 !== s && this.texter.moveTextAfter(i, s);
      }
    }), s && n.length && this.history.push(this.model, {
      style: {
        symbols: n,
        style: r
      }
    });
  }
  updateTextFontStyle(i, {
    fontSize: r,
    fontWeight: s
  }) {
    this.logger.info("updateTextFontStyle", {
      textIds: i,
      fontSize: r,
      fontWeight: s
    });
    const n = [],
      a = [];
    this.model.symbols.forEach(l => {
      if (i.includes(l.id)) if (l.type === E.Text) {
        l.updateChildrenFont({
          fontSize: r,
          fontWeight: "auto" === s ? void 0 : s
        });
        const i = l.bounds.width;
        this.texter.updateBounds(l), this.renderer.drawSymbol(l);
        const d = l.bounds.width - i;
        if (0 !== d) {
          const i = this.texter.moveTextAfter(l, d);
          i?.length && a.push({
            symbols: i,
            tx: d,
            ty: 0
          });
        }
        l.modificationDate = Date.now(), n.push(l);
      } else if (l.type === E.Group) {
        const i = l.extractText();
        i.length && (i.forEach(i => {
          i.updateChildrenFont({
            fontSize: r,
            fontWeight: "auto" === s ? void 0 : s
          });
          const n = l.bounds.width;
          this.texter.updateBounds(i);
          const d = l.bounds.width - n,
            h = this.texter.moveTextAfter(i, d);
          h?.length && a.push({
            symbols: h,
            tx: d,
            ty: 0
          });
        }), l.modificationDate = Date.now(), this.renderer.drawSymbol(l), n.push(l));
      }
    }), n.length && this.history.push(this.model, {
      style: {
        symbols: n,
        fontSize: r
      },
      translate: a
    });
  }
  async replaceSymbols(i, r, s = !0) {
    this.logger.info("replaceSymbol", {
      oldSymbols: i,
      newSymbols: r
    }), this.updateLayerState(!1);
    const n = this.extractStrokesFromSymbols(i),
      a = this.extractStrokesFromSymbols(r),
      l = i.shift();
    l && (i.forEach(i => {
      this.renderer.removeSymbol(i.id), this.model.removeSymbol(i.id);
    }), this.model.replaceSymbol(l.id, r), this.renderer.replaceSymbol(l.id, r), n.length && a.length ? this.recognizer.replaceStrokes(n.map(i => i.id), a) : n.length ? this.recognizer.eraseStrokes(n.map(i => i.id)) : this.recognizer.addStrokes(a, !1), s && this.history.push(this.model, {
      replaced: {
        oldSymbols: i,
        newSymbols: r
      }
    }), this.updateLayerUI());
  }
  changeOrderSymbol(i, r) {
    this.model.changeOrderSymbol(i.id, r), this.renderer.changeOrderSymbol(i, r), this.history.push(this.model, {
      order: {
        symbols: [i],
        position: r
      }
    });
  }
  changeOrderSymbols(i, r) {
    i.forEach(i => {
      this.model.changeOrderSymbol(i.id, r), this.renderer.changeOrderSymbol(i, r);
    }), this.history.push(this.model, {
      order: {
        symbols: i,
        position: r
      }
    });
  }
  groupSymbols(i) {
    const r = this.buildGroup({
      children: i
    });
    return i.forEach(i => {
      this.model.removeSymbol(i.id), this.renderer.removeSymbol(i.id);
    }), this.model.addSymbol(r), this.history.push(this.model, {
      group: {
        symbols: i
      }
    }), r;
  }
  ungroupSymbol(i) {
    return i.children.forEach(i => this.renderer.drawSymbol(i)), this.renderer.removeSymbol(i.id), this.model.replaceSymbol(i.id, i.children), this.history.push(this.model, {
      ungroup: {
        group: i
      }
    }), i.children;
  }
  async synchronizeStrokesWithJIIX(i = !1) {
    const r = this.model.symbols.filter(i => i.type === E.Stroke);
    if (!i && !r.length) return void this.event.emitSynchronized();
    await this.export(["application/vnd.myscript.jiix"]);
    const getSymbolsAndStrokesAssociatedFromJIIXStrokeItems = (i = []) => {
        const r = [],
          s = [],
          n = [];
        return i.forEach(i => {
          const a = i["full-id"];
          if (n.includes(a)) return;
          n.push(a);
          const l = this.model.getRootSymbol(a);
          if (l) {
            if (l?.type === E.Recognized) s.push(l.strokes.find(r => r.id === i["full-id"]));else s.push(l);
            const n = r.findIndex(i => i.id === l.id);
            n < 0 ? r.push(l) : r[n] = l;
          }
        }), {
          symbols: r,
          strokes: s
        };
      },
      s = this.model.exports?.["application/vnd.myscript.jiix"];
    s?.elements?.forEach(i => {
      switch (i.type) {
        case p.Text:
          i.words?.forEach(r => {
            const s = getSymbolsAndStrokesAssociatedFromJIIXStrokeItems(r.items);
            if (s.strokes.length) {
              if (1 === s.symbols.length) {
                const i = s.symbols[0];
                if (i.type === E.Recognized && i.kind === T.Text && i.label === r.label && i.strokes.length == i.strokes.length) return;
              }
              const n = i.lines.find(i => i["first-char"] <= r["first-char"] && i["last-char"] >= r["last-char"]),
                a = new IIRecognizedText(s.strokes, {
                  baseline: convertMillimeterToPixel(n["baseline-y"]),
                  xHeight: convertMillimeterToPixel(n["x-height"])
                });
              a.label = r.label, s.symbols.forEach(i => {
                i.type === E.Recognized && i.kind === T.Text && i.decorators.forEach(i => {
                  a.decorators.some(r => r.kind === i.kind) || a.decorators.push(i);
                }), this.model.removeSymbol(i.id), this.renderer.removeSymbol(i.id);
              }), this.model.addSymbol(a), this.renderer.drawSymbol(a);
            }
          });
          break;
        case p.Node:
          {
            let r;
            const s = getSymbolsAndStrokesAssociatedFromJIIXStrokeItems(i.items);
            if (s.strokes.length) {
              if (1 === s.symbols.length) {
                const i = s.symbols[0];
                if (i.type === E.Recognized && i.strokes.length === s.strokes.length) return;
              }
              switch (i.kind) {
                case g.Circle:
                  r = new IIRecognizedCircle(s.strokes);
                  break;
                case g.Ellipse:
                  r = new IIRecognizedEllipse(s.strokes);
                  break;
                case g.Rectangle:
                case g.Triangle:
                case g.Parallelogram:
                case g.Polygon:
                case g.Rhombus:
                  r = new IIRecognizedPolygon(s.strokes);
                  break;
                default:
                  this.logger.warn("synchronizeStrokesWithJIIX", `Can not create recognized shape symbol, kind unknow: ${i}`);
              }
              r && (s.symbols.forEach(i => {
                this.model.removeSymbol(i.id), this.renderer.removeSymbol(i.id);
              }), this.model.addSymbol(r), this.renderer.drawSymbol(r));
            }
            break;
          }
        case p.Edge:
          {
            let r;
            const s = getSymbolsAndStrokesAssociatedFromJIIXStrokeItems(i.kind === m.PolyEdge ? i.edges.flatMap(i => i.items) : i.items);
            if (s.strokes.length) {
              if (1 === s.symbols.length) {
                const i = s.symbols[0];
                if (i.type === E.Recognized && i.strokes.length === s.strokes.length) return;
              }
              switch (i.kind) {
                case m.Line:
                  r = new IIRecognizedLine(s.strokes);
                  break;
                case m.PolyEdge:
                  r = new IIRecognizedPolyLine(s.strokes);
                  break;
                case m.Arc:
                  r = new IIRecognizedArc(s.strokes);
                  break;
                default:
                  this.logger.warn("synchronizeStrokesWithJIIX", `Can not create recognized edge symbol, kind unknow: ${i}`);
              }
              r && (s.symbols.forEach(i => {
                this.model.removeSymbol(i.id), this.renderer.removeSymbol(i.id);
              }), this.model.addSymbol(r), this.renderer.drawSymbol(r));
            }
            break;
          }
        default:
          this.logger.warn("synchronizeStrokesWithJIIX", `Can not create recognized symbol, type unknow: ${i}`);
      }
    }), this.model.mergeExport({
      "application/vnd.myscript.jiix": s
    }), this.history.update(this.model), this.event.emitSynchronized();
  }
  async removeSymbol(i, r = !0) {
    this.logger.info("removeSymbol", {
      id: i
    });
    const s = this.model.getRootSymbol(i);
    if (s) {
      if (this.updateLayerState(!1), s.type === E.Group) {
        const r = s.extractStrokes().map(i => i.id);
        s.removeChilds([i]), s.children.length ? (this.model.updateSymbol(s), this.renderer.drawSymbol(s), r.includes(i) && this.recognizer.eraseStrokes([i])) : (this.recognizer.eraseStrokes(r), this.model.removeSymbol(s.id), this.renderer.removeSymbol(s.id));
      } else this.recognizer.eraseStrokes([i]), this.model.removeSymbol(s.id), this.renderer.removeSymbol(s.id);
      r && this.history.push(this.model, {
        erased: [s]
      }), this.updateLayerUI();
    } else this.renderer.removeSymbol(i), this.recognizer.eraseStrokes([i]);
  }
  async removeSymbols(i, r = !0) {
    this.logger.info("removeSymbol", {
      ids: i
    });
    const s = [],
      n = [],
      a = [];
    if (i.forEach(r => {
      const l = this.model.getRootSymbol(r);
      if (l) if (l.id === r) switch (s.push(l), l.type) {
        case E.Stroke:
          a.push(l.id);
          break;
        case E.Recognized:
          a.push(...l.strokes.map(i => i.id));
          break;
        case E.Group:
          a.push(...l.extractStrokes().map(i => i.id));
      } else switch (l.type) {
        case E.Group:
          {
            const r = l.clone();
            a.push(...r.extractStrokes().map(i => i.id).filter(r => i.includes(r))), r.removeChilds(i), r.children.length ? n.push(r) : s.push(r);
            break;
          }
        case E.Recognized:
          {
            a.push(r);
            const d = l.clone();
            d.removeStrokes(i), d.strokes.length ? n.push(d) : s.push(d);
            break;
          }
      }
    }), this.recognizer.eraseStrokes(a), s.forEach(i => {
      this.model.removeSymbol(i.id), this.renderer.removeSymbol(i.id);
    }), n.forEach(i => {
      this.model.updateSymbol(i), this.renderer.drawSymbol(i);
    }), r) {
      const i = {};
      (s.length || n.length) && (s.length && (i.erased = s), n.length && (i.updated = n), this.history.push(this.model, i), this.updateLayerUI());
    }
    return this.updateLayerState(!1), s;
  }
  select(i) {
    this.selector.removeSelectedGroup(), this.model.symbols.forEach(r => {
      r.selected = i.includes(r.id), this.renderer.drawSymbol(r);
    }), this.selector.drawSelectedGroup(this.model.symbolsSelected), this.updateLayerUI(), this.event.emitSelected(this.model.symbolsSelected);
  }
  selectAll() {
    this.selector.removeSelectedGroup(), this.model.symbols.forEach(i => {
      i.selected = !0, this.renderer.drawSymbol(i);
    }), this.selector.drawSelectedGroup(this.model.symbolsSelected), this.updateLayerUI(), this.event.emitSelected(this.model.symbolsSelected);
  }
  unselectAll() {
    this.model.symbolsSelected.length && (this.model.symbolsSelected.forEach(i => {
      i.selected = !1, this.renderer.drawSymbol(i);
    }), this.selector.removeSelectedGroup(), this.updateLayerUI(), this.event.emitSelected(this.model.symbolsSelected));
  }
  async importPointEvents(i) {
    this.logger.info("importPointEvents", {
      partialStrokes: i
    }), this.updateLayerState(!1);
    const r = convertPartialStrokesToOIStrokes(i);
    return r.forEach(i => {
      this.model.addSymbol(i), this.renderer.drawSymbol(i);
    }), this.recognizer.addStrokes(r, !1), this.history.push(this.model, {
      added: r
    }), this.logger.debug("importPointEvents", this.model), this.updateLayerUI(), this.event.emitImported(this.model.exports), this.model;
  }
  triggerDownload(i, r) {
    const s = document.createElement("a");
    s.setAttribute("href", r), s.setAttribute("download", i), document.body.appendChild(s), s.click(), s.remove();
  }
  getSymbolsBounds(i, r = 10) {
    const s = Box.createFromBoxes(i.map(i => i.bounds));
    return s.x -= r, s.y -= r, s.width += 2 * r, s.height += 2 * r, s;
  }
  buildBlobFromSymbols(i, r) {
    const s = SVGBuilder.createLayer(r);
    i.forEach(i => {
      const r = this.renderer.getElementById(i.id)?.cloneNode(!0);
      r && s.appendChild(r);
    });
    const n = new XMLSerializer().serializeToString(s);
    return new Blob([n], {
      type: "image/svg+xml;charset=utf-8"
    });
  }
  getExportName(i) {
    const r = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    };
    try {
      return `iink-ts-${new Date().toLocaleDateString(navigator.language, r)}.${i}`;
    } catch {
      return `iink-ts-${new Date().toLocaleDateString("en-US", r)}.${i}`;
    }
  }
  downloadAsSVG(i = !1) {
    const r = i ? this.model.symbolsSelected : this.model.symbols,
      s = this.getSymbolsBounds(r),
      n = this.buildBlobFromSymbols(r, s),
      a = URL.createObjectURL(n);
    this.triggerDownload(this.getExportName("svg"), a);
  }
  downloadAsPNG(i = !1) {
    const r = i ? this.model.symbolsSelected : this.model.symbols,
      s = this.getSymbolsBounds(r),
      n = this.buildBlobFromSymbols(r, s),
      a = URL.createObjectURL(n),
      l = new Image(s.width, s.height);
    l.src = a, l.onload = () => {
      const i = document.createElement("canvas");
      i.width = l.width, i.height = l.height;
      i.getContext("2d").drawImage(l, 0, 0), URL.revokeObjectURL(a);
      const r = i.toDataURL("image/png").replace("image/png", "image/octet-stream");
      this.triggerDownload(this.getExportName("png"), r);
    };
  }
  downloadAsJson(i = !1) {
    const r = i ? this.model.symbolsSelected : this.model.symbols,
      s = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(r, null, 2));
    this.triggerDownload(this.getExportName("json"), s);
  }
  extractStrokesFromSymbols(i) {
    if (!i?.length) return [];
    const r = [];
    return i.forEach(i => {
      switch (i.type) {
        case E.Stroke:
          r.push(i);
          break;
        case E.Recognized:
          r.push(...i.strokes);
          break;
        case E.Group:
          r.push(...i.extractStrokes());
      }
    }), r;
  }
  extractTextsFromSymbols(i) {
    if (!i?.length) return [];
    const r = [];
    return i.forEach(i => {
      switch (i.type) {
        case E.Text:
          r.push(i);
          break;
        case E.Group:
          r.push(...i.extractText());
      }
    }), r;
  }
  extractBackendChanges(i) {
    const r = {};
    r.added = this.extractStrokesFromSymbols(i.added), r.erased = this.extractStrokesFromSymbols(i.erased);
    const s = this.extractStrokesFromSymbols(i.updated),
      n = s.concat(this.extractStrokesFromSymbols(i.replaced?.oldSymbols)),
      a = s.concat(this.extractStrokesFromSymbols(i.replaced?.newSymbols));
    return n.length && a.length ? r.replaced = {
      oldStrokes: n,
      newStrokes: a
    } : (r.added.push(...a), r.erased.push(...n)), i.matrix && (r.matrix = {
      strokes: this.extractStrokesFromSymbols(i.matrix.symbols),
      matrix: i.matrix.matrix
    }), i.translate?.length && (r.translate = [], i.translate.forEach(i => {
      const s = this.extractStrokesFromSymbols(i.symbols);
      s.length && r.translate.push({
        strokes: s,
        tx: i.tx,
        ty: i.ty
      });
    })), i.scale?.length && (r.scale = [], i.scale.forEach(i => {
      const s = this.extractStrokesFromSymbols(i.symbols);
      s.length && r.scale.push({
        strokes: s,
        origin: i.origin,
        scaleX: i.scaleX,
        scaleY: i.scaleY
      });
    })), i.rotate?.length && (r.rotate = [], i.rotate.forEach(i => {
      const s = this.extractStrokesFromSymbols(i.symbols);
      s.length && r.rotate.push({
        strokes: s,
        center: i.center,
        angle: i.angle
      });
    })), r;
  }
  async undo() {
    if (this.logger.info("undo"), this.history.context.canUndo) {
      this.updateLayerState(!1), this.unselectAll();
      const i = this.history.undo(),
        r = i.model.extractDifferenceSymbols(this.model);
      this.#y = i.model.clone(), this.logger.debug("undo", {
        previousStackItem: i
      });
      const s = this.extractBackendChanges(i.changes);
      r.removed.forEach(i => this.renderer.removeSymbol(i.id)), r.added.forEach(i => this.renderer.drawSymbol(i)), (s.added?.length || s.erased?.length || s.replaced || s.matrix || s.translate?.length || s.scale?.length || s.rotate?.length) && (await this.recognizer.undo(s)), this.updateLayerUI();
    }
    return this.model;
  }
  async redo() {
    if (this.logger.info("redo"), this.history.context.canRedo) {
      this.updateLayerState(!1), this.unselectAll();
      const i = this.history.redo(),
        r = i.model.extractDifferenceSymbols(this.model);
      this.#y = i.model.clone(), this.logger.debug("redo", {
        modifications: r
      });
      const s = this.extractBackendChanges(i.changes);
      r.removed.forEach(i => this.renderer.removeSymbol(i.id)), r.added.forEach(i => this.renderer.drawSymbol(i)), (s.added?.length || s.erased?.length || s.replaced || s.matrix || s.translate?.length || s.scale?.length || s.rotate?.length) && (await this.recognizer.redo(s)), this.updateLayerUI();
    }
    return this.model;
  }
  async export(i) {
    try {
      this.logger.info("export", {
        mimeTypes: i
      });
      const r = await this.recognizer.export(i);
      this.model.mergeExport(r);
    } catch (i) {
      throw this.logger.error("export", {
        error: i
      }), this.manageError(i), i;
    }
    return this.model;
  }
  async convert() {
    await this.convertSymbols();
  }
  async convertSymbols(i) {
    try {
      this.updateLayerState(!1), await this.converter.apply(i), this.event.emitConverted(this.model.converts);
    } catch (i) {
      throw this.logger.error("convert", i), this.manageError(i), i;
    } finally {
      this.updateLayerUI();
    }
  }
  async waitForIdle() {
    return this.recognizer.waitForIdle();
  }
  async resize({
    height: i,
    width: r
  } = {}) {
    try {
      this.logger.info("resize", {
        height: i,
        width: r
      });
      const s = window.getComputedStyle(this.layers.root);
      i = i || Math.max(parseInt(s.height.replace("px", "")), this.configuration.rendering.minHeight), r = r || Math.max(parseInt(s.width.replace("px", "")), this.configuration.rendering.minWidth), this.updateLayerState(!1), this.model.height = i, this.model.width = r, this.renderer.resize(i, r), this.updateLayerUI(50), this.updateLayerState(!0);
    } catch (i) {
      this.manageError(i);
    }
  }
  async clear() {
    try {
      if (this.logger.info("clear"), this.updateLayerState(!1), this.model.symbols.length) {
        this.selector.removeSelectedGroup();
        const i = this.model.symbols;
        this.renderer.clear(), this.model.clear(), this.history.push(this.model, {
          erased: i
        }), this.recognizer.clear(), this.event.emitSelected(this.model.symbolsSelected);
      }
      this.updateLayerUI(), this.event.emitCleared();
    } catch (i) {
      this.manageError(i);
    }
  }
  async destroy() {
    return this.logger.info("destroy"), this.eraser.detach(), this.selector.detach(), this.move.detach(), this.writer.detach(), this.renderer.destroy(), this.menu.destroy(), this.recognizer.destroy(), this.model.clear(), this.history.clear(), Promise.resolve();
  }
}
const Re = {
    exportContent: "POINTER_UP",
    exportContentDelay: 1e3,
    resizeTriggerDelay: 100
  },
  De = {
    server: te.server,
    recognition: te.recognition,
    rendering: ye,
    grabber: xe,
    triggers: Re,
    "undo-redo": Se,
    logger: h,
    penStyle: {},
    theme: f
  };
class InkEditorDeprecatedConfiguration {
  server;
  recognition;
  rendering;
  "undo-redo";
  grabber;
  triggers;
  logger;
  penStyle;
  penStyleClasses;
  theme;
  constructor(i) {
    const {
      server: r,
      recognition: s
    } = new RecognizerHTTPV1Configuration(i);
    this.server = r, this.recognition = s, this.rendering = mergeDeep({}, De.rendering, i?.rendering), this.grabber = mergeDeep({}, De.grabber, i?.grabber), this["undo-redo"] = mergeDeep({}, De["undo-redo"], i?.["undo-redo"]), this.triggers = mergeDeep({}, De.triggers, i?.triggers), this.logger = mergeDeep({}, De.logger, i?.logger), this.penStyle = mergeDeep({}, De.penStyle, i?.penStyle), this.penStyleClasses = i?.penStyleClasses || this.penStyleClasses, this.theme = mergeDeep({}, De.theme, i?.theme);
  }
}
class InkEditorDeprecated extends AbstractEditor {
  #m;
  #y;
  #x;
  #S;
  grabber;
  renderer;
  recognizer;
  history;
  styleManager;
  #d = i.Write;
  constructor(r, s) {
    if (super(r, s), this.#m = new InkEditorDeprecatedConfiguration(s?.configuration), this.styleManager = new StyleManager(s?.configuration?.penStyle, s?.configuration?.theme), s?.override?.grabber) {
      const i = s.override.grabber;
      this.grabber = new i(this.#m.grabber);
    } else this.grabber = new PointerEventGrabber(this.#m.grabber);
    if (this.grabber.onPointerDown = this.onPointerDown.bind(this), this.grabber.onPointerMove = this.onPointerMove.bind(this), this.grabber.onPointerUp = this.onPointerUp.bind(this), s?.override?.recognizer) {
      const i = s.override.recognizer;
      this.recognizer = new i(this.#m);
    } else this.recognizer = new RecognizerHTTPV1(this.#m);
    this.renderer = new CanvasRenderer(this.#m.rendering), this.tool = i.Write, this.#y = new Model(), this.history = new HistoryManager(this.#m["undo-redo"], this.event);
  }
  onPointerDown(r) {
    this.logger.info("onPointerDown", {
      tool: this.tool,
      info: r
    });
    const s = Object.assign({}, this.theme?.ink, this.currentPenStyle);
    switch (this.tool) {
      case i.Erase:
        this.model.removeStrokesFromPoint(r.pointer).length > 0 && this.renderer.drawModel(this.model);
        break;
      case i.Write:
        this.model.initCurrentStroke(r.pointer, r.pointerType, s), this.drawCurrentStroke();
        break;
      default:
        this.logger.warn("#onPointerDown", `onPointerDown tool unknow: "${this.tool}"`);
    }
  }
  onPointerMove(r) {
    switch (this.logger.info("onPointerMove", {
      tool: this.tool,
      info: r
    }), this.tool) {
      case i.Erase:
        this.model.removeStrokesFromPoint(r.pointer).length > 0 && this.renderer.drawModel(this.model);
        break;
      case i.Write:
        this.model.appendToCurrentStroke(r.pointer), this.drawCurrentStroke();
        break;
      default:
        this.logger.warn("#onPointerMove", `onPointerMove tool unknow: "${this.tool}"`);
    }
  }
  async onPointerUp(r) {
    try {
      switch (this.logger.info("onPointerUp", {
        tool: this.tool,
        info: r
      }), this.tool) {
        case i.Erase:
          this.model.removeStrokesFromPoint(r.pointer), this.history.stack.at(-1)?.modificationDate !== this.model.modificationDate && (await this.updateModelRendering());
          break;
        case i.Write:
          this.model.endCurrentStroke(r.pointer), await this.updateModelRendering();
          break;
        default:
          this.logger.warn("#onPointerUp", `onPointerUp tool unknow: "${this.tool}"`);
      }
    } catch (i) {
      throw this.layers.showMessageError(i), this.event.emitError(i), i;
    }
  }
  get initializationPromise() {
    return Promise.resolve();
  }
  get tool() {
    return this.#d;
  }
  set tool(i) {
    this.#d = i, this.setCursorStyle();
  }
  setCursorStyle() {
    if (this.tool === i.Erase) this.layers.root.classList.remove("draw"), this.layers.root.classList.add("erase");else this.layers.root.classList.add("draw"), this.layers.root.classList.remove("erase");
  }
  get model() {
    return this.#y;
  }
  get currentPenStyle() {
    return this.styleManager.currentPenStyle;
  }
  get penStyle() {
    return this.styleManager.penStyle;
  }
  set penStyle(i) {
    this.logger.info("setPenStyle", {
      penStyle: i
    }), this.styleManager.setPenStyle(i);
  }
  get penStyleClasses() {
    return this.styleManager.penStyleClasses;
  }
  set penStyleClasses(i) {
    this.logger.info("setPenStyleClasses", {
      penStyleClasses: i
    }), this.styleManager.setPenStyleClasses(i);
  }
  get theme() {
    return this.styleManager.theme;
  }
  set theme(i) {
    this.logger.info("setTheme", {
      theme: i
    }), this.styleManager.setTheme(i);
  }
  get configuration() {
    return this.#m;
  }
  async initialize() {
    try {
      this.logger.info("initialize"), this.layers.render(), this.layers.showLoader();
      const i = window.getComputedStyle(this.layers.root);
      this.model.width = Math.max(parseInt(i.width.replace("px", "")), this.#m.rendering.minWidth), this.model.height = Math.max(parseInt(i.height.replace("px", "")), this.#m.rendering.minHeight), this.history.push(this.model), this.layers.rendering.classList.add(this.configuration.recognition.type.toLowerCase().replace(" ", "-")), this.renderer.init(this.layers.rendering, {
        x: 50,
        y: 50
      }), this.grabber.attach(this.layers.rendering);
    } catch (i) {
      throw this.logger.error("initialize", i), this.layers.showMessageError(i), i;
    } finally {
      this.logger.debug("initialize", "finally"), this.layers.hideLoader(), this.layers.updateState(!0);
    }
  }
  drawCurrentStroke() {
    this.logger.debug("drawCurrentStroke", {
      stroke: this.model.currentSymbol
    }), this.renderer.drawPendingStroke(this.model.currentSymbol);
  }
  async updateModelRendering() {
    this.logger.info("updateModelRendering"), this.renderer.drawModel(this.model);
    const i = new DeferredPromise();
    if (this.history.push(this.model), "DEMAND" !== this.#m.triggers.exportContent) {
      clearTimeout(this.#S);
      let r = this.model.clone();
      this.#S = setTimeout(async () => {
        try {
          r = await this.recognizer.export(r), this.history.updateStack(r), this.model.modificationDate === r.modificationDate && (this.model.exports = r.exports), i.resolve(this.model);
        } catch (r) {
          this.logger.error("updateModelRendering", {
            error: r
          }), this.event.emitError(r), i.reject(r);
        }
      }, "QUIET_PERIOD" === this.#m.triggers.exportContent ? this.#m.triggers.exportContentDelay : 0);
    } else i.resolve(this.model);
    return await i.promise, this.event.emitExported(this.model.exports), this.logger.debug("updateModelRendering", this.model.exports), i.promise;
  }
  async export(i) {
    this.logger.info("export", {
      mimeTypes: i
    });
    const r = await this.recognizer.export(this.model.clone(), i);
    return this.model.modificationDate === r.modificationDate && this.model.mergeExport(r.exports), this.history.updateStack(r), this.event.emitExported(this.model.exports), this.logger.debug("export", this.model), this.model;
  }
  async convert(i) {
    this.logger.info("convert", {
      params: i
    });
    const r = await this.recognizer.convert(this.model, i?.conversionState, i?.mimeTypes);
    return Object.assign(this.#y, r), this.event.emitConverted(this.model.converts), this.logger.debug("convert", this.model), this.model;
  }
  async importPointEvents(i) {
    const r = [];
    i.forEach((i, s) => {
      let n = !0;
      const a = new Stroke(i.style || b, i.pointerType);
      if (i.id && (a.id = i.id), !i.pointers?.length) return r.push(`stroke ${s + 1} has not pointers`), void (n = !1);
      i.pointers?.forEach((i, l) => {
        if (!i) return r.push(`stroke ${s + 1} has no pointer at ${l}`), void (n = !1);
        const d = {
          p: i.p || 1,
          t: i.t || l,
          x: 0,
          y: 0
        };
        return null == i?.x || null == i?.x ? (r.push(`stroke ${s + 1} has no x at pointer at ${l}`), void (n = !1)) : (d.x = i.x, null == i?.y || null == i?.y ? (r.push(`stroke ${s + 1} has no y at pointer at ${l}`), void (n = !1)) : (d.y = i.y, void (n && a.pointers.push(d))));
      }), n && this.model.addStroke(a);
    }), r.length && this.event.emitError(new Error(r.join("\n")));
    try {
      const i = await this.updateModelRendering();
      return Object.assign(this.#y, i), this.event.emitImported(this.model.exports), this.model;
    } catch (i) {
      throw this.event.emitError(i), i;
    }
  }
  async resize({
    height: i,
    width: r
  } = {}) {
    this.logger.info("resize", {
      height: i,
      width: r
    });
    const s = new DeferredPromise(),
      n = window.getComputedStyle(this.layers.root);
    this.model.height = i || Math.max(parseInt(n.height.replace("px", "")), this.configuration.rendering.minHeight), this.model.width = r || Math.max(parseInt(n.width.replace("px", "")), this.configuration.rendering.minWidth), this.renderer.resize(this.model), this.model.symbols.length ? (clearTimeout(this.#x), this.#x = setTimeout(async () => {
      const i = await this.recognizer.resize(this.model);
      s.resolve(i);
    }, this.#m.triggers.resizeTriggerDelay)) : s.resolve(this.model), this.#y = await s.promise, this.logger.debug("resize", {
      model: this.model
    }), this.event.emitExported(this.model.exports);
  }
  async undo() {
    this.logger.info("undo"), this.#y = this.history.undo(), this.renderer.drawModel(this.#y), this.#y = await this.recognizer.export(this.#y), this.history.updateStack(this.#y), this.event.emitExported(this.#y.exports), this.logger.debug("undo", this.#y);
  }
  async redo() {
    this.logger.info("redo"), this.#y = this.history.redo(), this.renderer.drawModel(this.#y), this.#y = await this.recognizer.export(this.#y), this.history.updateStack(this.#y), this.event.emitExported(this.#y.exports), this.logger.debug("redo", this.#y);
  }
  async clear() {
    this.logger.info("clear"), this.model.clear(), this.history.push(this.model), this.renderer.drawModel(this.model), this.event.emitExported(this.model.exports), this.event.emitCleared(), this.logger.debug("clear", this.model);
  }
  async destroy() {
    return this.logger.info("destroy"), this.event.removeAllListeners(), this.grabber.detach(), this.layers.destroy(), this.renderer.destroy(), Promise.resolve();
  }
}
class InteractiveInkSSRSmartGuide {
  uuid;
  #w;
  #v;
  #k;
  #E;
  #I;
  #C;
  #M;
  #T;
  #L;
  #P;
  #R;
  #D;
  editor;
  margin;
  jiix;
  lastWord;
  wordToChange;
  #t = LoggerManager.getLogger(d.SMARTGUIDE);
  constructor(i) {
    this.#t.info("constructor"), this.uuid = createUUID(), this.editor = i, this.margin = {
      bottom: 0,
      left: 0,
      right: 0,
      top: 0
    }, this.#A(), this.#z(), this.#G(), this.#B(), this.#O(), this.#N(), this.#$(), this.#j(), this.#V(), this.#U(), this.#H();
  }
  #A() {
    this.#w = document.createElement("div"), this.#w.id = `smartguide-${this.uuid}`, this.#w.classList.add("smartguide"), this.#w.addEventListener("pointerdown", i => {
      i.preventDefault(), i.stopPropagation();
    });
  }
  #z() {
    this.#v = document.createElement("div"), this.#v.id = `smartguide-wrapper-${this.uuid}`, this.#v.classList.add("smartguide-wrapper");
  }
  #G() {
    this.#k = document.createElement("div"), this.#k.id = `prompter-container-${this.uuid}`, this.#k.classList.add("prompter-container");
  }
  #B() {
    this.#E = document.createElement("div"), this.#E.id = `prompter-text-${this.uuid}`, this.#E.classList.add("prompter-text"), this.#E.setAttribute("touch-action", "none");
  }
  #O() {
    this.#I = document.createElement("div"), this.#I.id = `ellipsis-${this.uuid}`, this.#I.classList.add("ellipsis"), this.#I.innerHTML = "...";
  }
  #N() {
    this.#C = document.createElement("div"), this.#C.id = `tag-icon-${this.uuid}`, this.#C.classList.add("tag-icon"), this.#C.innerHTML = "&#182;";
  }
  #$() {
    this.#M = document.createElement("div"), this.#M.id = `candidates-${this.uuid}`, this.#M.classList.add("candidates");
  }
  #j() {
    this.#T = document.createElement("div"), this.#T.id = `more-menu-${this.uuid}`, this.#T.classList.add("more-menu");
  }
  #V() {
    this.#L = document.createElement("button"), this.#L.id = `convert-${this.uuid}`, this.#L.classList.add("options-label-button"), this.#L.innerHTML = "Convert";
  }
  #U() {
    this.#P = document.createElement("button"), this.#P.id = `copy-${this.uuid}`, this.#P.classList.add("options-label-button"), this.#P.innerHTML = "Copy";
  }
  #H() {
    this.#R = document.createElement("button"), this.#R.id = `delete-${this.uuid}`, this.#R.classList.add("options-label-button"), this.#R.innerHTML = "Delete";
  }
  init(i, r) {
    this.#t.info("init", {
      domElement: i,
      margin: r
    });
    const s = document.createElement("style");
    s.appendChild(document.createTextNode(".ms-editor .smartguide{background-color:#fff;box-shadow:2px 2px 12px #bdbdbd;cursor:default;font-size:16px;left:0;line-height:48px;padding-bottom:12px;padding-top:12px;position:absolute;top:0;width:100%;z-index:40}.ms-editor .smartguide .smartguide-wrapper{border-bottom:1px solid #959da6;display:flex}.ms-editor .smartguide .tag-icon{background-color:hsla(0,0%,100%,.9);border-left:1px solid #959da6;border-right:1px solid #959da6;border-top:1px solid #959da6;font-size:large;height:100%;line-height:48px;padding:0 18px;z-index:31}.ms-editor .smartguide .ellipsis,.ms-editor .smartguide .tag-icon{color:#959da6;font-weight:700;height:48px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;width:48px}.ms-editor .smartguide .ellipsis{-webkit-tap-highlight-color:transparent;cursor:pointer;font-size:x-large;line-height:38px;padding:0 8px}.ms-editor .smartguide .ellipsis:active{background-color:#e0e0e0}.ms-editor .smartguide .prompter-container{-webkit-tap-highlight-color:transparent;color:#bfbfbf;display:block;height:48px;line-height:48px;overflow:hidden;text-align:left;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;width:calc(100% - 96px)}.ms-editor .smartguide .prompter-container>div>span{cursor:pointer;display:inline-block}.ms-editor .smartguide .prompter-container .prompter-text{margin-left:12px}.ms-editor .smartguide .prompter-container .prompter-text .added-word{animation:word-added .1s linear,color-input 3s ease-in-out}.ms-editor .smartguide .prompter-container .prompter-text .modified-word{animation:word-modified .1s linear,color-input 3s ease-in-out}.ms-editor .smartguide .candidates{-webkit-tap-highlight-color:transparent;background-color:#f5f5f5;border-radius:3px;box-shadow:2px 2px 12px #bdbdbd,-2px 2px 12px #bdbdbd;color:#000;flex-direction:column;line-height:30px;position:absolute;text-align:center;z-index:100}.ms-editor .smartguide .candidates>span{cursor:pointer;padding:2px 20px}.ms-editor .smartguide .candidates>span:hover{background-color:#eee}.ms-editor .smartguide .candidates>span:active{background-color:#e0e0e0}.ms-editor .smartguide .candidates .selected-word{background-color:#e0e0e0;font-weight:700}.ms-editor .smartguide .more-menu{background-color:#f5f5f5;border-radius:3px;bottom:0;box-shadow:2px 2px 12px #bdbdbd;display:flex;flex-direction:column;line-height:30px;margin-right:12px;overflow:hidden;position:absolute;right:0;transform:translateY(100%);transition:max-height 1s ease-out,opacity 1s,visibility .5s linear;z-index:100}.ms-editor .smartguide .more-menu.open{max-height:500px;opacity:1;visibility:visible}.ms-editor .smartguide .more-menu.close{max-height:0;opacity:0;visibility:hidden}.ms-editor .smartguide .more-menu .options-label-button{-webkit-tap-highlight-color:transparent;background:transparent;border:none;box-sizing:border-box;color:#000;cursor:pointer;font-size:16px;height:40px;margin:0;outline:none;padding:0 24px}.ms-editor .smartguide .more-menu .options-label-button:hover{background-color:#eee;padding:4px}.ms-editor .smartguide .more-menu .options-label-button:active{background-color:#e0e0e0}@keyframes color-input{0%{color:#000}to{color:#bfbfbf}}@keyframes word-added{0%{transform:translate(5px)}to{transform:none}}@keyframes word-modified{0%{transform:translateY(5px)}to{transform:none}}")), i.appendChild(s), i.appendChild(this.#w), this.#w.appendChild(this.#v), this.#v.appendChild(this.#C), this.#k.appendChild(this.#E), this.#v.appendChild(this.#k), this.#v.appendChild(this.#I), this.#T.appendChild(this.#L), this.#T.appendChild(this.#P), this.#T.appendChild(this.#R), this.#T.classList.add("close"), this.#v.appendChild(this.#T), this.#D = !1, this.#M.style.display = "none", this.#v.appendChild(this.#M), this.margin = r, this.#F(), this.resize();
  }
  #W = i => {
    this.#t.info("showCandidates", {
      target: i
    });
    const r = parseInt(i.id.replace("word-", "").replace(this.uuid, "")),
      s = this.jiix?.words;
    this.wordToChange = s[r], this.wordToChange && (this.wordToChange.id = r.toString(), this.#M.innerHTML = "", this.wordToChange?.candidates && (this.#M.style.display = "flex", this.wordToChange.candidates.forEach((i, r) => {
      this.wordToChange?.label === i ? this.#M.innerHTML += `<span id="cdt-${r}${this.uuid}" class="selected-word">${i}</span>` : this.#M.innerHTML += `<span id="cdt-${r}${this.uuid}">${i}</span>`;
    }), i.appendChild(this.#M)));
  };
  #_() {
    this.#M.style.display = "none";
  }
  #Y() {
    this.#T.classList.add("open"), this.#T.classList.remove("close"), this.#D = !0;
  }
  #X() {
    this.#T.classList.add("close"), this.#T.classList.remove("open"), this.#D = !1;
  }
  #J = i => {
    this.#t.info("onClickEllipsis", {
      evt: i
    }), i.preventDefault(), i.stopPropagation(), this.#D ? this.#X() : this.#Y(), this.#_();
  };
  #q = i => {
    this.#t.info("onClickConvert", {
      evt: i
    }), i.preventDefault(), i.stopPropagation(), this.editor.convert(), this.#X();
  };
  #Z(i) {
    const r = "rtl" === document.documentElement.getAttribute("dir"),
      s = document.createElement("textarea");
    s.style.fontSize = "12pt", s.style.display = "absolute", s.style[r ? "right" : "left"] = "-9999px";
    const n = window.pageYOffset || document.documentElement.scrollTop;
    return s.style.top = `${n}px`, s.setAttribute("readonly", ""), s.value = i, s;
  }
  #K(i) {
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      const r = document.createRange();
      r.selectNodeContents(i);
      const s = window.getSelection();
      s && (s.removeAllRanges(), s.addRange(r), i.setSelectionRange(0, 999999));
    } else i.select();
  }
  #Q = async i => {
    this.#t.info("onClickCopy", {
      evt: i
    }), i.preventDefault(), i.stopPropagation();
    try {
      this.#X();
      let i = "Nothing to copy";
      if (this.#E.innerText) {
        i = `"${this.#E.innerText}" copied to clipboard`;
        const r = this.#Z(this.#E.innerText);
        this.#k.appendChild(r), this.#K(r), document.execCommand("copy"), r.remove();
      }
      this.editor.event.emitNotif({
        message: i,
        timeout: 1500
      });
    } catch (i) {
      this.#t.error("onClickCopy", i), this.editor.event.emitError(i);
    }
  };
  #ee = i => {
    this.#t.info("onClickDelete", {
      evt: i
    }), i.preventDefault(), i.stopPropagation(), this.editor.clear(), this.#X();
  };
  #te = i => {
    this.#t.info("onClickCandidate", {
      evt: i
    }), i.preventDefault(), i.stopPropagation();
    const r = i.target.innerText;
    this.jiix?.words && r !== this.wordToChange?.label && this.wordToChange?.candidates?.includes(r) && (this.jiix.words[parseInt(this.wordToChange?.id)].label = r, this.editor.import(new Blob([JSON.stringify(this.jiix)], {
      type: u.JIIX
    }), u.JIIX)), this.#M.style.display = "none";
  };
  #ie = i => {
    this.#t.info("onClickPrompter", {
      evt: i
    }), i.preventDefault(), i.stopPropagation(), this.#X();
    const r = i.target;
    r.id !== this.#E.id ? this.#W(r) : this.#_();
  };
  #re = i => {
    i.preventDefault(), i.stopPropagation();
  };
  #oe = () => {
    this.#_(), this.#X();
  };
  #F() {
    this.#w.addEventListener("pointerdown", this.#re.bind(this)), this.#I.addEventListener("pointerdown", this.#J.bind(this)), this.#L.addEventListener("pointerdown", this.#q.bind(this)), this.#P.addEventListener("pointerdown", this.#Q.bind(this)), this.#R.addEventListener("pointerdown", this.#ee.bind(this)), this.#E.addEventListener("pointerdown", this.#ie.bind(this)), this.#M.addEventListener("pointerdown", this.#te.bind(this)), document.addEventListener("pointerdown", this.#oe.bind(this));
  }
  #se() {
    this.#w.addEventListener("pointerdown", this.#re), this.#I.removeEventListener("pointerdown", this.#J), this.#L.removeEventListener("pointerdown", this.#q), this.#P.removeEventListener("pointerdown", this.#Q), this.#R.removeEventListener("pointerdown", this.#ee), this.#E.removeEventListener("pointerdown", this.#ie), this.#M.removeEventListener("pointerdown", this.#te), document.removeEventListener("pointerdown", this.#oe);
  }
  resize() {
    this.#t.info("resize");
    const i = convertMillimeterToPixel(this.margin.left),
      r = convertMillimeterToPixel(this.margin.right);
    this.#v.style.marginLeft = `${i}px`, this.#v.style.marginRight = `${r}px`;
  }
  update(i) {
    this.#t.info("update", {
      exports: i
    }), this.jiix = i;
    const createWordSpan = (i, r) => {
      const s = document.createElement("span");
      return s.id = `word-${i}${this.uuid}`, r ? s.textContent = r.label : s.innerHTML = "&nbsp;", this.#t.debug("update", {
        span: s
      }), s;
    };
    (() => {
      if (this.#t.info("populatePrompter"), this.#E.innerHTML = "", this.jiix?.words) {
        const i = this.jiix.words,
          r = document.createDocumentFragment();
        i.forEach((s, n) => {
          if (" " === s.label || s.label.includes("\n")) r.appendChild(createWordSpan(n));else if (n !== i.length - 1) r.appendChild(createWordSpan(n, s));else {
            this.#E.appendChild(r), this.lastWord && (this.lastWord = s);
            const i = createWordSpan(n, s);
            this.lastWord?.candidates !== s.candidates && this.lastWord?.label !== s.label && (this.lastWord = s), this.wordToChange?.id === n.toString() ? (i.classList.add("modified-word"), this.wordToChange = void 0) : i.classList.add("added-word"), this.#E.appendChild(i), this.#k.scrollLeft = i.offsetLeft, this.#t.debug("update => populatePrompter", {
              span: i,
              lastWord: this.lastWord
            });
          }
        });
      }
    })(), this.jiix?.words?.length ? this.#I.style.setProperty("pointer-events", "auto") : this.#I.style.setProperty("pointer-events", "none");
  }
  clear() {
    this.#t.info("clear"), this.#E.innerHTML = "", this.#M.innerHTML = "";
  }
  destroy() {
    this.#t.info("destroy"), this.#se(), this.#w.remove();
  }
}
const Ae = {
  server: ue.server,
  recognition: ue.recognition,
  rendering: ye,
  smartGuide: {
    enable: !0
  },
  grabber: xe,
  triggers: Re,
  "undo-redo": Se,
  logger: h,
  penStyle: {},
  theme: f
};
class InteractiveInkSSREditorConfiguration {
  server;
  recognition;
  rendering;
  smartGuide;
  "undo-redo";
  grabber;
  triggers;
  logger;
  penStyle;
  penStyleClasses;
  theme;
  constructor(i) {
    const {
      server: r,
      recognition: s
    } = new RecognizerWebSocketSSRConfiguration(i);
    this.server = r, this.recognition = s, this.rendering = mergeDeep({}, Ae.rendering, i?.rendering), this.smartGuide = mergeDeep({}, Ae.smartGuide, i?.smartGuide), this["undo-redo"] = mergeDeep({}, Ae["undo-redo"], i?.["undo-redo"]), this.grabber = mergeDeep({}, Ae.grabber, i?.grabber), this.triggers = mergeDeep({}, Ae.triggers, i?.triggers), this.logger = mergeDeep({}, Ae.logger, i?.logger), this.penStyle = mergeDeep({}, Ae.penStyle, i?.penStyle), this.penStyleClasses = i?.penStyleClasses || this.penStyleClasses, this.theme = mergeDeep({}, Ae.theme, i?.theme), "TEXT" !== this.recognition.type && (this.smartGuide.enable = !1), this.smartGuide.enable && !this.recognition.text.mimeTypes.includes("application/vnd.myscript.jiix") && this.recognition.text.mimeTypes.push("application/vnd.myscript.jiix");
  }
}
class InteractiveInkSSREditor extends AbstractEditor {
  #m;
  #y;
  #x;
  smartGuide;
  grabber;
  renderer;
  recognizer;
  history;
  styleManager;
  #d = i.Write;
  constructor(r, s) {
    if (super(r, s), this.#m = new InteractiveInkSSREditorConfiguration(s?.configuration), this.styleManager = new StyleManager(s?.configuration?.penStyle, s?.configuration?.theme), s?.override?.grabber) {
      const i = s.override.grabber;
      this.grabber = new i(this.#m.grabber);
    } else this.grabber = new PointerEventGrabber(this.#m.grabber);
    if (s?.override?.recognizer) {
      const i = s.override.recognizer;
      this.recognizer = new i(this.#m);
    } else this.recognizer = new RecognizerWebSocketSSR(this.#m);
    this.renderer = new InteractiveInkSSRSVGRenderer(this.#m.rendering), this.tool = i.Write, this.#y = new Model(), this.history = new HistoryManager(this.#m["undo-redo"], this.event);
  }
  get initializationPromise() {
    return this.recognizer.initialized.promise;
  }
  get tool() {
    return this.#d;
  }
  set tool(i) {
    this.#d = i, this.setCursorStyle();
  }
  setCursorStyle() {
    if (this.tool === i.Erase) this.layers.root.classList.remove("draw"), this.layers.root.classList.add("erase");else this.layers.root.classList.add("draw"), this.layers.root.classList.remove("erase");
  }
  get model() {
    return this.#y;
  }
  get configuration() {
    return this.#m;
  }
  get currentPenStyle() {
    return this.styleManager.currentPenStyle;
  }
  get penStyle() {
    return this.styleManager.penStyle;
  }
  set penStyle(i) {
    this.logger.info("setPenStyle", {
      penStyle: i
    }), this.styleManager.setPenStyle(i), this.logger.debug("setPenStyle", this.styleManager.penStyle), this.recognizer.setPenStyle(this.styleManager.penStyle);
  }
  get penStyleClasses() {
    return this.styleManager.penStyleClasses;
  }
  set penStyleClasses(i) {
    this.logger.info("setPenStyleClasses", {
      penClass: i
    }), this.styleManager.setPenStyleClasses(i), this.logger.debug("setPenStyleClasses", this.styleManager.penStyleClasses), this.recognizer.setPenStyleClasses(this.styleManager.penStyleClasses);
  }
  get theme() {
    return this.styleManager.theme;
  }
  set theme(i) {
    this.logger.info("setTheme", {
      theme: i
    }), this.styleManager.setTheme(i), this.logger.debug("setTheme", this.styleManager.theme), this.recognizer.setTheme(this.styleManager.theme);
  }
  async syncStyle() {
    await Promise.all([this.recognizer.setPenStyle(this.styleManager.penStyle), this.recognizer.setPenStyleClasses(this.styleManager.penStyleClasses), this.recognizer.setTheme(this.styleManager.theme)]);
  }
  onExport(i) {
    if (this.logger.debug("onExport", {
      exports: i
    }), this.smartGuide && i?.["application/vnd.myscript.jiix"]) {
      const r = i["application/vnd.myscript.jiix"];
      this.smartGuide.update(r);
    }
    this.model.mergeExport(i), this.event.emitExported(i);
  }
  onPointerDown(r) {
    this.logger.info("onPointerDown", {
      tool: this.tool,
      info: r
    });
    const s = Object.assign({}, this.theme?.ink, this.currentPenStyle);
    this.model.initCurrentStroke(r.pointer, this.tool === i.Erase ? "eraser" : r.pointerType, s), this.drawCurrentStroke();
  }
  onPointerMove(i) {
    this.logger.info("onPointerMove", {
      tool: this.tool,
      info: i
    }), this.model.appendToCurrentStroke(i.pointer), this.drawCurrentStroke();
  }
  async onPointerUp(i) {
    try {
      this.logger.info("onPointerUp", {
        tool: this.tool,
        info: i
      }), this.model.endCurrentStroke(i.pointer), await this.synchronizeModelWithBackend();
    } catch (i) {
      this.event.emitError(i);
    }
  }
  onSVGPatch(i) {
    this.logger.info("onSVGPatch", {
      evt: i
    }), this.renderer.updatesLayer(i.layer, i.updates);
  }
  initializeSmartGuide() {
    if (this.smartGuide?.destroy(), this.logger.info("initializeSmartGuide", {
      smartGuide: this.configuration.smartGuide
    }), this.configuration.smartGuide.enable) {
      this.smartGuide = new InteractiveInkSSRSmartGuide(this);
      let i = O;
      switch (this.configuration.recognition.type) {
        case "TEXT":
          i = this.configuration.recognition.text.margin;
          break;
        case "MATH":
          i = this.configuration.recognition.math.margin;
      }
      this.smartGuide.init(this.layers.ui.root, i);
    }
  }
  onContetChaned(i) {
    this.history.context = i, this.event.emitChanged(i);
  }
  onError(i) {
    this.layers.showMessageError(i), this.event.emitError(i);
  }
  async initialize() {
    try {
      this.logger.info("initialize"), this.layers.render(), this.layers.showLoader();
      const i = window.getComputedStyle(this.layers.root);
      this.model.width = Math.max(parseInt(i.width.replace("px", "")), this.#m.rendering.minWidth), this.model.height = Math.max(parseInt(i.height.replace("px", "")), this.#m.rendering.minHeight), this.history.push(this.model), this.renderer.init(this.layers.rendering), this.grabber.attach(this.layers.rendering), this.grabber.onPointerDown = this.onPointerDown.bind(this), this.grabber.onPointerMove = this.onPointerMove.bind(this), this.grabber.onPointerUp = this.onPointerUp.bind(this), this.initializeSmartGuide(), this.recognizer.configuration.server.version || (await this.loadInfo(this.configuration.server), this.recognizer.configuration.server.version = this.info.version), await this.recognizer.init(this.model.height, this.model.width), this.recognizer.event.addExportedListener(this.onExport.bind(this)), this.recognizer.event.addSVGPatchListener(this.onSVGPatch.bind(this)), this.recognizer.event.addContentChangedListener(this.onContetChaned.bind(this)), this.recognizer.event.addIdleListener(this.event.emitIdle.bind(this.event)), this.recognizer.event.addErrorListener(this.onError.bind(this)), await this.syncStyle();
    } catch (i) {
      throw this.logger.error("initialize", i), this.layers.showMessageError(i), i;
    } finally {
      this.logger.debug("initialize", "finally"), this.layers.hideLoader(), this.layers.updateState(!0);
    }
  }
  drawCurrentStroke() {
    this.logger.debug("drawCurrentStroke", {
      stroke: this.model.currentSymbol
    });
    const i = this.model.currentSymbol;
    i && this.renderer.drawPendingStroke(i);
  }
  async synchronizeModelWithBackend() {
    if (this.logger.info("synchronizeModelWithBackend"), "DEMAND" !== this.#m.triggers.exportContent) {
      const i = this.model.extractUnsentStrokes();
      this.model.updatePositionSent(), this.history.push(this.model), this.renderer.clearErasingStrokes();
      const r = await this.recognizer.addStrokes(i);
      this.model.mergeExport(r), this.history.updateStack(this.model);
    }
    return this.logger.debug("synchronizeModelWithBackend", this.model), this.model;
  }
  async waitForIdle() {
    return this.recognizer.waitForIdle();
  }
  async export(i) {
    this.logger.info("export", {
      mimeTypes: i
    });
    try {
      if ("DEMAND" !== this.#m.triggers.exportContent) return await this.recognizer.export(this.model, i);
      {
        const i = this.model.extractUnsentStrokes();
        this.history.push(this.model), this.history.stack.push(this.model.clone()), this.model.updatePositionSent();
        const r = await this.recognizer.addStrokes(i);
        this.model.updatePositionReceived(), this.model.mergeExport(r), this.logger.debug("export", this.model);
      }
    } catch (i) {
      return this.logger.error("export", {
        error: i
      }), this.event.emitError(i), Promise.reject(i);
    }
    return this.model;
  }
  async convert(i) {
    return this.logger.info("convert", {
      params: i
    }), this.history.push(this.model), this.history.stack.push(this.model.clone()), this.#y = await this.recognizer.convert(this.model, i?.conversionState), this.logger.debug("convert", this.model), this.history.push(this.model), this.event.emitConverted(this.model.converts), this.model;
  }
  async import(i, r) {
    let s;
    return s = i instanceof Blob ? i : "string" == typeof i ? new Blob([i]) : new Blob([JSON.stringify(i)]), this.logger.info("import", {
      data: i,
      mimeType: r
    }), this.history.stack.push(this.model.clone()), this.#y = await this.recognizer.import(this.model, s, r), this.history.push(this.model), this.event.emitImported(this.model.exports), this.model;
  }
  async importPointEvents(i) {
    this.logger.info("importPointEvents", {
      strokes: i
    });
    const r = [],
      s = i.map((i, s) => {
        const n = new Stroke(i.style || b, i.pointerType);
        i.id && (n.id = i.id), i.pointerType && (n.pointerType = i.pointerType), i.pointers?.length || r.push(`stroke ${s + 1} has not pointers`);
        let a = !0;
        return i.pointers?.forEach((i, l) => {
          if (a = !0, !i) return void r.push(`stroke ${s + 1} has no pointer at ${l}`);
          const d = {
            p: i.p || 1,
            t: i.t || l,
            x: 0,
            y: 0
          };
          null == i?.x || null == i?.x ? (r.push(`stroke ${s + 1} has no x at pointer at ${l}`), a = !1) : d.x = i.x, null == i?.y || null == i?.y ? (r.push(`stroke ${s + 1} has no y at pointer at ${l}`), a = !1) : d.y = i.y, a && n.pointers.push(d);
        }), n;
      });
    r.length && this.event.emitError(new Error(r.join("\n"))), s.map(i => this.model.addStroke(i));
    const n = await this.recognizer.importPointEvents(s);
    return this.model.mergeExport(n), this.event.emitImported(this.model.exports), this.logger.debug("importPointEvents", this.model), this.model;
  }
  async resize({
    height: i,
    width: r
  } = {}) {
    this.logger.info("resize", {
      height: i,
      width: r
    });
    const s = new DeferredPromise(),
      n = window.getComputedStyle(this.layers.root);
    this.model.height = i || Math.max(parseInt(n.height.replace("px", "")), this.configuration.rendering.minHeight), this.model.width = r || Math.max(parseInt(n.width.replace("px", "")), this.configuration.rendering.minWidth);
    const a = this.model.clone();
    this.renderer.resize(a), clearTimeout(this.#x), this.#x = setTimeout(async () => {
      try {
        const i = await this.recognizer.resize(a);
        s.resolve(i);
      } catch (n) {
        this.logger.error("resize", {
          height: i,
          width: r,
          error: n
        }), s.reject(n);
      }
    }, this.#m.triggers.resizeTriggerDelay), this.#y = await s.promise, this.smartGuide?.resize(), this.event.emitExported(this.model.exports), this.logger.debug("resize", this.model);
  }
  async undo() {
    if (this.logger.info("undo"), this.history.context.canUndo) return this.#y = this.history.undo(), this.recognizer.undo(this.model);
    throw new Error("Undo not allowed");
  }
  async redo() {
    if (this.logger.info("redo"), this.history.context.canRedo) return this.#y = this.history.redo(), this.logger.debug("undo", this.#y), this.recognizer.redo(this.model);
    throw new Error("Redo not allowed");
  }
  async clear() {
    this.logger.info("clear"), this.model.clear(), this.history.push(this.model), await this.recognizer.clear(this.model), this.event.emitCleared();
  }
  async destroy() {
    return this.logger.info("destroy"), this.event.removeAllListeners(), this.grabber.detach(), this.layers.destroy(), this.renderer.destroy(), this.recognizer.destroy(), this.smartGuide?.destroy(), Promise.resolve();
  }
}
const ze = {
  server: re.server,
  recognition: re.recognition,
  renderer: ye,
  grabber: xe,
  triggers: Re,
  "undo-redo": Se,
  logger: h,
  penStyle: y
};
class InkEditorConfiguration {
  server;
  recognition;
  renderer;
  "undo-redo";
  grabber;
  triggers;
  logger;
  penStyle;
  constructor(i) {
    const {
      server: r,
      recognition: s
    } = new RecognizerHTTPV2Configuration(i);
    this.server = r, this.recognition = s, this.renderer = mergeDeep({}, ze.renderer, i?.renderer), this.recognition.text.guides.enable = this.renderer.guides.enable, this.renderer.guides.enable && (this.recognition.text.guides["line-gap-mm"] = convertPixelToMillimeter(this.renderer.guides.gap)), this.grabber = mergeDeep({}, ze.grabber, i?.grabber), this["undo-redo"] = mergeDeep({}, ze["undo-redo"], i?.["undo-redo"]), this.triggers = mergeDeep({}, ze.triggers, i?.triggers), this.logger = mergeDeep({}, ze.logger, i?.logger), this.penStyle = mergeDeep({}, ze.penStyle, i?.penStyle);
  }
}
class InkEditor extends AbstractEditor {
  #m;
  #y;
  #S;
  #r;
  grabber;
  renderer;
  recognizer;
  history;
  #d = i.Write;
  constructor(r, s) {
    if (super(r, s), this.#m = new InkEditorConfiguration(s?.configuration), this.#r = Object.assign({}, this.#m.penStyle), s?.override?.grabber) {
      const i = s.override.grabber;
      this.grabber = new i(this.#m.grabber);
    } else this.grabber = new PointerEventGrabber(this.#m.grabber);
    if (this.grabber.onPointerDown = this.onPointerDown.bind(this), this.grabber.onPointerMove = this.onPointerMove.bind(this), this.grabber.onPointerUp = this.onPointerUp.bind(this), s?.override?.recognizer) {
      const i = s.override.recognizer;
      this.recognizer = new i(this.#m);
    } else this.recognizer = new RecognizerHTTPV2(this.#m);
    this.renderer = new CanvasRenderer(this.#m.renderer), this.tool = i.Write, this.#y = new Model(), this.history = new HistoryManager(this.#m["undo-redo"], this.event);
  }
  onPointerDown(r) {
    switch (this.logger.info("onPointerDown", {
      tool: this.tool,
      info: r
    }), this.tool) {
      case i.Erase:
        this.model.removeStrokesFromPoint(r.pointer).length > 0 && this.renderer.drawModel(this.model);
        break;
      case i.Write:
        this.model.initCurrentStroke(r.pointer, r.pointerType, this.penStyle), this.drawCurrentStroke();
        break;
      default:
        this.logger.warn("#onPointerDown", `onPointerDown tool unknow: "${this.tool}"`);
    }
  }
  onPointerMove(r) {
    switch (this.logger.info("onPointerMove", {
      tool: this.tool,
      info: r
    }), this.tool) {
      case i.Erase:
        this.model.removeStrokesFromPoint(r.pointer).length > 0 && this.renderer.drawModel(this.model);
        break;
      case i.Write:
        this.model.appendToCurrentStroke(r.pointer), this.drawCurrentStroke();
        break;
      default:
        this.logger.warn("#onPointerMove", `onPointerMove tool unknow: "${this.tool}"`);
    }
  }
  async onPointerUp(r) {
    switch (this.logger.info("onPointerUp", {
      tool: this.tool,
      info: r
    }), this.tool) {
      case i.Erase:
        this.model.removeStrokesFromPoint(r.pointer), this.history.stack.at(-1)?.modificationDate !== this.model.modificationDate && (await this.updateModelRendering());
        break;
      case i.Write:
        this.model.endCurrentStroke(r.pointer), await this.updateModelRendering();
        break;
      default:
        this.logger.warn("#onPointerUp", `onPointerUp tool unknow: "${this.tool}"`);
    }
  }
  get penStyle() {
    return this.#r;
  }
  set penStyle(i) {
    this.logger.info("set penStyle", {
      penStyle: i
    }), this.#r = Object.assign({}, this.#r, i);
  }
  get initializationPromise() {
    return Promise.resolve();
  }
  get tool() {
    return this.#d;
  }
  set tool(i) {
    this.#d = i, this.setCursorStyle();
  }
  setCursorStyle() {
    if (this.tool === i.Erase) this.layers.root.classList.remove("draw"), this.layers.root.classList.add("erase");else this.layers.root.classList.add("draw"), this.layers.root.classList.remove("erase");
  }
  get model() {
    return this.#y;
  }
  get configuration() {
    return this.#m;
  }
  async initialize() {
    try {
      this.logger.info("initialize"), this.layers.render(), this.layers.showLoader();
      const i = window.getComputedStyle(this.layers.root);
      this.model.width = Math.max(parseInt(i.width.replace("px", "")), this.#m.renderer.minWidth), this.model.height = Math.max(parseInt(i.height.replace("px", "")), this.#m.renderer.minHeight), this.history.push(this.model), this.layers.rendering.classList.add(this.configuration.recognition.type.toLowerCase().replace(" ", "-")), this.renderer.init(this.layers.rendering, this.#m.renderer.guides.enable ? {
        x: this.#m.renderer.guides.gap,
        y: this.#m.renderer.guides.gap
      } : void 0), this.grabber.attach(this.layers.rendering);
    } catch (i) {
      throw this.logger.error("initialize", i), this.layers.showMessageError(i), i;
    } finally {
      this.logger.debug("initialize", "finally"), this.layers.hideLoader(), this.layers.updateState(!0);
    }
  }
  drawCurrentStroke() {
    this.logger.debug("drawCurrentStroke", {
      stroke: this.model.currentSymbol
    }), this.renderer.drawPendingStroke(this.model.currentSymbol);
  }
  async updateModelRendering() {
    this.logger.info("updateModelRendering"), this.renderer.drawModel(this.model);
    const i = new DeferredPromise();
    if (this.history.push(this.model), "DEMAND" !== this.#m.triggers.exportContent) {
      clearTimeout(this.#S);
      const r = this.model.clone();
      this.#S = setTimeout(async () => {
        try {
          r.mergeExport(await this.recognizer.send(r.symbols)), this.history.updateStack(r), this.model.modificationDate === r.modificationDate && (this.model.exports = r.exports), i.resolve(this.model);
        } catch (r) {
          this.logger.error("updateModelRendering", {
            error: r
          }), this.layers.showMessageError(r), this.event.emitError(r), i.reject(r);
        }
      }, "QUIET_PERIOD" === this.#m.triggers.exportContent ? this.#m.triggers.exportContentDelay : 0);
    } else i.resolve(this.model);
    return await i.promise, this.event.emitExported(this.model.exports), this.logger.debug("updateModelRendering", this.model.exports), i.promise;
  }
  async importPointEvents(i) {
    try {
      convertPartialStrokesToStrokes(i).forEach(i => {
        this.model.addStroke(i);
      });
      const r = await this.updateModelRendering();
      return Object.assign(this.#y, r), this.event.emitImported(this.model.exports), this.model;
    } catch (i) {
      throw this.layers.showMessageError(i), this.event.emitError(i), i;
    }
  }
  async resize({
    height: i,
    width: r
  } = {}) {
    this.logger.info("resize", {
      height: i,
      width: r
    });
    const s = window.getComputedStyle(this.layers.root);
    this.model.height = i || Math.max(parseInt(s.height.replace("px", "")), this.configuration.renderer.minHeight), this.model.width = r || Math.max(parseInt(s.width.replace("px", "")), this.configuration.renderer.minWidth), this.renderer.resize(this.model), this.logger.debug("resize", {
      model: this.model
    }), this.event.emitExported(this.model.exports);
  }
  async undo() {
    this.logger.info("undo"), this.#y = this.history.undo(), this.renderer.drawModel(this.#y), this.history.updateStack(this.#y), this.event.emitExported(this.#y.exports), this.logger.debug("undo", this.#y);
  }
  async redo() {
    this.logger.info("redo"), this.#y = this.history.redo(), this.renderer.drawModel(this.#y), this.history.updateStack(this.#y), this.event.emitExported(this.#y.exports), this.logger.debug("redo", this.#y);
  }
  async clear() {
    this.logger.info("clear"), this.model.clear(), this.history.push(this.model), this.renderer.drawModel(this.model), this.event.emitExported(this.model.exports), this.event.emitCleared(), this.logger.debug("clear", this.model);
  }
  async destroy() {
    return this.logger.info("destroy"), this.event.removeAllListeners(), this.grabber.detach(), this.layers.destroy(), this.renderer.destroy(), Promise.resolve();
  }
}
class Editor {
  static logger = LoggerManager.getLogger(d.EDITOR);
  static instance;
  static async load(i, r, s) {
    if (Editor.logger.info("load", {
      type: r,
      options: s
    }), !s) throw new Error("Param 'options' missing");
    switch (Editor.instance && (await Editor.instance.destroy()), r) {
      case "INTERACTIVEINK":
        Editor.instance = new InteractiveInkEditor(i, s);
        break;
      case "INKV1":
        Editor.instance = new InkEditorDeprecated(i, s);
        break;
      case "INKV2":
        Editor.instance = new InkEditor(i, s);
        break;
      default:
        Editor.instance = new InteractiveInkSSREditor(i, s);
    }
    return await Editor.instance.initialize(), Editor.instance;
  }
  static getInstance() {
    return Editor.instance;
  }
}
export { AbstractEditor, Box, CanvasRenderer, CanvasRendererShape, CanvasRendererStroke, CanvasRendererText, k as DecoratorKind, ee as DefaulRecognitionHTTPV1ConfigurationConfiguration, X as DefaultConvertionConfiguration, U as DefaultDebugConfiguration, z as DefaultDiagramConfiguration, A as DefaultDiagramConvertConfiguration, Re as DefaultEditorTriggerConfiguration, D as DefaultEraserConfiguration, B as DefaultExportConfiguration, Ie as DefaultGestureConfiguration, xe as DefaultGrabberConfiguration, me as DefaultGuidesConfiguration, Se as DefaultHistoryConfiguration, be as DefaultIIRendererConfiguration, ze as DefaultInkEditorConfiguration, De as DefaultInkEditorDeprecatedConfiguration, Pe as DefaultInteractiveInkEditorConfiguration, Ae as DefaultInteractiveInkSSREditorConfiguration, G as DefaultJiixConfiguration, fe as DefaultListenerConfiguration, h as DefaultLoggerConfiguration, O as DefaultMarginConfiguration, j as DefaultMathConfiguration, $ as DefaultMathUndoRedoConfiguration, Te as DefaultMenuConfiguration, b as DefaultPenStyle, V as DefaultRawContentConfiguration, H as DefaultRecognitionRendererConfiguration, de as DefaultRecognitionWebSocketConfiguration, te as DefaultRecognizerHTTPV1Configuration, re as DefaultRecognizerHTTPV2Configuration, ie as DefaultRecognizerHTTPV2RecognitionConfiguration, he as DefaultRecognizerWebSocketConfiguration, ue as DefaultRecognizerWebSocketSSRConfiguration, ce as DefaultRecognizerWebSocketSSRRecognitionConfiguration, ye as DefaultRendererConfiguration, P as DefaultServerHTTPConfiguration, R as DefaultServerWebsocketConfiguration, q as DefaultShapeBeautificationConfiguration, Z as DefaultShapeConfiguration, J as DefaultShapeConvertConfiguration, Le as DefaultSnapConfiguration, N as DefaultSolverConfiguration, y as DefaultStyle, Y as DefaultTexConfigurationV2, W as DefaultTextConfiguration, F as DefaultTextGuidesConfiguration, _ as DefaultTextGuidesConfigurationV2, f as DefaultTheme, DeferredPromise, C as EdgeDecoration, I as EdgeKind, Editor, EditorEvent, c as EditorEventName, EditorLayer, i as EditorTool, r as EditorWriteTool, u as ExportType, HistoryManager, IIConversionManager, IIDebugSVGManager, IIDecorator, IIEdgeArc, IIEdgeLine, IIEdgePolyLine, IIEraseManager, IIEraser, IIGestureManager, IIHistoryManager, IIMenu, IIMenuAction, IIMenuContext, IIMenuManager, IIMenuStyle, IIMenuSub, IIMenuTool, IIModel, IIMoveManager, IIRecognizedArc, IIRecognizedBase, IIRecognizedCircle, IIRecognizedEllipse, IIRecognizedLine, IIRecognizedPolyLine, IIRecognizedPolygon, IIRecognizedText, IIResizeManager, IIRotationManager, IISVGRenderer, pe as IISVGRendererConst, IISVGRendererDecoratorUtil, IISVGRendererEdgeUtil, IISVGRendererEraserUtil, IISVGRendererGroupUtil, IISVGRendererRecognizedUtil, IISVGRendererShapeUtil, IISVGRendererStrokeUtil, IISVGRendererTextUtil, IISelectionManager, IIShapeCircle, IIShapeEllipse, IIShapePolygon, IISnapManager, IIStroke, IISymbolBase, IISymbolGroup, IIText, IITextManager, IITranslateManager, IIWriteManager, InkEditor, InkEditorConfiguration, InkEditorDeprecated, InkEditorDeprecatedConfiguration, Ee as InsertAction, InteractiveInkEditor, InteractiveInkEditorConfiguration, InteractiveInkSSREditor, InteractiveInkSSREditorConfiguration, InteractiveInkSSRSVGRenderer, InteractiveInkSSRSmartGuide, p as JIIXELementType, m as JIIXEdgeKind, g as JIIXNodeKind, Logger, d as LoggerCategory, l as LoggerLevel, LoggerManager, MatrixTransform, Model, OIEdgeBase, OIShapeBase, PointerEventGrabber, T as RecognizedKind, Q as RecognizerError, RecognizerEvent, K as RecognizerEventName, RecognizerHTTPV1, RecognizerHTTPV1Configuration, RecognizerHTTPV2, RecognizerHTTPV2Configuration, RecognizerWebSocket, RecognizerWebSocketConfiguration, RecognizerWebSocketSSR, RecognizerWebSocketSSRConfiguration, n as ResizeDirection, a as SELECTION_MARGIN, SVGBuilder, SVGStroker, M as ShapeKind, SnapConfiguration, ke as StrikeThroughAction, Stroke, v as StyleHelper, StyleManager, ve as SurroundAction, s as SvgElementRole, E as SymbolType, oe as TRecognizerWebSocketMessageType, computeAngleAxeRadian, computeAngleRadian, computeAverage, computeDistance, computeDistanceBetweenPointAndSegment, computeHmac, computeLinksPointers, computeMiddlePointer, computeNearestPointOnSegment, computePointOnEllipse, computeRotatedPoint, convertBoundingBoxMillimeterToPixel, convertDegreeToRadian, convertMillimeterToPixel, convertPartialStrokesToOIStrokes, convertPartialStrokesToStrokes, convertPixelToMillimeter, convertRadianToDegree, createPointsOnSegment, createUUID, findIntersectBetweenSegmentAndCircle, findIntersectionBetween2Segment, getApiInfos, getAvailableFontList, getAvailableLanguageList, getClosestPoint, getClosestPoints, getInitialHistoryContext, isBetween, isDeepEqual, isPointInsideBox, isPointInsidePolygon, isValidNumber, isValidPoint, isVersionSuperiorOrEqual, mergeDeep, scalaire };
//# sourceMappingURL=iink.esm.js.map